import { Language } from '../types/language';

export const translations: Record<Exclude<Language, 'en'>, Record<string, string>> = {
  as: {
    'This Week': 'এই সপ্তাহত',
    'Last Month': 'যোৱা মাহ',
    'Sensor Dropout': 'চেন্সৰ বিচ্ছিন্নতা',
    'Approaching Overload': 'অতিভাৰৰ ওচৰত',
    'Frequency Deviation': 'কম্পাংক বিচ্যুতি',
    'High Voltage THD': 'উচ্চ ভল্টেজ THD',
    'High Current THD': 'উচ্চ কাৰেণ্ট THD',
    'In-app': 'এপ্‌ৰ ভিতৰত',
    'SMS': 'এছএমএছ',
    'WhatsApp': 'হোৱাটছএপ',
    'Min. chargeable demand': 'নূন্যতম চাৰ্জযোগ্য চাহিদা',
    'Demand charge — Normal': 'চাহিদাৰ চাৰ্জ — স্বাভাৱিক',
    'Demand charge — Penal': 'চাহিদাৰ চাৰ্জ — শাস্তিমূলক',
    'Electricity duty': 'বিদ্যুৎ শুল্ক',
    'Late payment surcharge': 'পলম পৰিশোধ অতিৰিক্ত মাচুল',
    'Demand charge (up to CD)': 'ডিমাণ্ড চাৰ্জ (CD লৈকে)',
    'Generating': 'সৃষ্টি কৰি থকা হৈছে',
    'Bill PDF…': 'বিল PDF…',
    'What is the Power Analysis Dashboard?': 'পাৱাৰ এনালাইছিছ ডেছব\'ৰ্ড কি?',
    'It monitors real-time electrical metrics (voltage, current, power factor, demand, active/reactive energy) collected from Raspberry Pi edge nodes installed at the site.': 'ই ছাইটত ইনষ্টল কৰা Raspberry Pi এজ নোডসমূহৰ পৰা সংগ্ৰহ কৰা ৰিয়েল-টাইম বৈদ্যুতিক মেট্ৰিক্স (ভল্টেজ, কাৰেণ্ট, শক্তি কাৰক, চাহিদা, একটিভ/ৰিএক্টিভ শক্তি) নিৰীক্ষণ কৰে।',
    'What do the green/orange/red indicators mean?': 'সেউজ/কমলা/ৰঙা সূচকসমূহে কি বুজায়?',
    'Green means the Raspberry Pi edge node is online and reporting health telemetry normally. Orange/red indicate potential communication delays or high temperature/resource throttling.': 'সেউজ মানে Raspberry Pi এজ নোড অনলাইনত আছে আৰু স্বাভাৱিকভাৱে স্বাস্থ্য টেলিমেট্ৰি প্ৰতিবেদন কৰি আছে। কমলা/ৰঙাই সম্ভাৱ্য যোগাযোগৰ বিলম্ব বা উচ্চ তাপমাত্ৰা/সম্পদৰ থ্ৰটলিং সূচায়।',
    'How are billing demand charges calculated?': 'বিলিং চাহিদাৰ চাৰ্জ কেনেকৈ গণনা কৰা হয়?',
    'Demand charges are based on the Maximum Demand (MD) recorded in 15-minute integration windows, calculated according to the active tariff structure (e.g., TGSPDCL HT or WBSEDCL B-IDIT).': 'চাহিদাৰ চাৰ্জ ১৫-মিনিটৰ ইন্টিগ্ৰেচন উইণ্ড\'ত ৰেকৰ্ড কৰা সৰ্বোচ্চ চাহিদা (MD)ৰ ওপৰত ভিত্তি কৰি, সক্ৰিয় শুল্ক গাঁথনি (যেনে TGSPDCL HT বা WBSEDCL B-IDIT) অনুসৰি গণনা কৰা হয়।',
    'What should I do if the dashboard shows "No data"?': 'ডেছব\'ৰ্ডত "তথ্য নাই" দেখুৱালে মই কি কৰিব লাগে?',
    'Verify that the edge node (Raspberry Pi gateway) is powered on and connected to the internet. If the issue persists, contact technical support immediately.': 'এজ নোড (Raspberry Pi গেটৱে) অন থকা আৰু ইণ্টাৰনেটৰ সৈতে সংযুক্ত থকা নিশ্চিত কৰক। সমস্যা অব্যাহত থাকিলে, তৎক্ষণাৎ কাৰিকৰী সহায়ৰ সৈতে যোগাযোগ কৰক।',
    '% of readings': '% পঢ়া',
    '/month': '/মাহ',
    '0.4 kV supply': '০.৪ কেভি যোগান',
    '12 AM – 12 AM': 'ৰাতি ১২ - ৰাতি ১২',
    '1st 12 AM → now': '১ তারিখ ৰাতি ১২ → এতিয়া',
    '2x penalty': '২x পেনাল্টি',
    '33 kV supply': '৩৩ কেভি যোগান',
    'About': 'সম্পৰ্কে',
    'Above': 'ওপৰত',
    'Across': 'সিপাৰে',
    'Active (kW)': 'সক্ৰিয় (কিলোৱাট)',
    'Active Power & Apparent Power': 'সক্ৰিয় শক্তি আৰু আপাত শক্তি',
    'Active power on Phase B': 'ফেজ বিত সক্ৰিয় শক্তি',
    'Active power on Phase R': 'ফেজ R ত সক্ৰিয় শক্তি',
    'Active power on Phase Y': 'ফেজ Y ত সক্ৰিয় শক্তি',
    'Active tariff': 'সক্ৰিয় ট্যারিফ',
    'Add custom variable alert': 'স্বনিৰ্বাচিত চলক সতৰ্কবাণী যোগ কৰক',
    'Additional demand charge': 'অতিৰিক্ত চাহিদা চাৰ্জ',
    'Alert History': 'ইতিহাস',
    'Alert Rules': 'সতৰ্কতা নিয়ম',
    'Alerts': 'সতৰ্কবাণী',
    'All energy/PF/LF values computed by the Cortex Pi gateway per VARIABLES.pdf §2.3 & §3. Demand, ED, rental, and TPR computed in the browser from WBSEDCL tariff constants.': 'VARIABLES.pdf §2.3 & §3 অনুসৰি কৰ্টেক্স পাই গেটৱেৰ দ্বাৰা গণনা কৰা সকলো শক্তি/PF/LF মান। WBSEDCL শুল্ক ধ্ৰুৱকসমূহৰ পৰা ব্ৰাউজাৰত গণনা কৰা চাহিদা, ইডি, ভাড়া, আৰু TPR।',
    'All systems normal': 'সকলো ব্যৱস্থা স্বাভাৱিক',
    'Anomalies': 'বিজুতি',
    'Anomaly': 'ব্যতিক্রম',
    'Apparent': 'আপাত শক্তি',
    'Apparent (kVA)': 'আপাত (কেভিএ)',
    'Approaching Contracted Demand': 'চুক্তিবদ্ধ চাহিদাৰ কাষ চাপি অহা',
    'Auto-refreshes every': 'প্ৰতিটো অটো-ৰিফ্ৰেছ কৰে',
    'Average Power Factor': 'গড় পাৱাৰ ফেক্টৰ',
    'Average power factor across': 'গড় শক্তি কাৰক ওপৰেৰে',
    'Avg': 'গড়',
    'Avg Active Power': 'গড় সক্ৰিয় শক্তি',
    'Avg Apparent Power': 'গড় আপাত শক্তি',
    'Base Energy Charge': 'ভিত্তি শক্তি চাৰ্জ',
    'Based on': 'ৰ ওপৰত ভিত্তি কৰি',
    'Below': 'তলত',
    'Between': 'মাজত',
    'Billing': 'বিলিং',
    'Billing Cycle Peak': 'বিলিং চাইকেল পিক',
    'Billing Overview': 'বিলিং অৱলোকন',
    'Both levels disabled': 'দুয়োটা স্তৰ নিষ্ক্ৰিয় কৰা হৈছে',
    'Building PDF…': 'বিল্ডিং PDF...',
    'CD': 'CD',
    'CD 100%': 'CD 100%',
    'CORTEX by Vireon': 'কৰ্টেক্স - ভায়াৰনৰ দ্বাৰা',
    'CRIT': 'CRIT',
    'Call Now': 'এতিয়াই ফোন কৰক',
    'Call Support': 'সমৰ্থন কল কৰক',
    'Carbon (CO₂)': 'কাৰ্বন (CO2)',
    'Chargeable demand': 'চাৰ্জযোগ্য চাহিদা',
    'Chargeable min:': 'চাৰ্জযোগ্য নূন্যতম:',
    'Chat on WhatsApp': 'হোৱাটছএপত আড্ডা দিব',
    'Check back when more data is synced.': 'অধিক তথ্য সিঙ্ক হ\'লে পুনৰ পৰীক্ষা কৰক।',
    'Check your network or sheet sharing settings (Anyone with the link → Viewer).': 'আপোনাৰ নে\'টৱৰ্ক বা শ্বীট অংশীদাৰী সংহতিসমূহ পৰীক্ষা কৰক (লিংক → দৰ্শকৰ সৈতে যিকোনো ব্যক্তি)।',
    'Choose a variable': 'এটা চলক বাছক',
    'Close': 'বন্ধ কৰক',
    'Close Help and Support Modal': 'সহায় আৰু সমৰ্থন মডাল বন্ধ কৰক',
    'Connecting…': 'সংযোগ...',
    'Consumer': 'গ্ৰাহক',
    'Contact Tech Support': 'টেক সমৰ্থনৰ সৈতে যোগাযোগ কৰক',
    'Contact your administrator if you do not have one.': 'যদি আপোনাৰ প্ৰশাসকৰ নাই তেন্তে আপোনাৰ প্ৰশাসকৰ সৈতে যোগাযোগ কৰক।',
    'Contract': 'চুক্তিবদ্ধ',
    'Contract Demand (CD)': 'চুক্তিভিত্তিক চাহিদা (CD)',
    'Contract Demand Utilisation': 'চুক্তিৰ চাহিদা ব্যৱহাৰ',
    'Contract demand:': 'চুক্তিৰ চাহিদা:',
    'Contract limit': 'চুক্তিৰ সীমা',
    'Copy Number': 'নম্বৰ কপি কৰক',
    'Cost': 'খৰচ',
    'Cost breakdown': 'খৰচৰ বিভাজন',
    'Couldn\'t reach the data sheet': 'ডাটা শ্বীটত উপনীত হ’ব পৰা নাই',
    'Couldn\'t refresh just now.': 'এতিয়াই ৰিফ্ৰেছ কৰিব পৰা নাই।',
    'Crit': 'Crit',
    'Critical': 'সমালোচনাত্মক',
    'Critical above': 'ওপৰত সমালোচনাত্মক',
    'Critical below': 'তলত সমালোচনাত্মক',
    'Critical · peak': 'জটিল · শিখৰ',
    'Current': 'কাৰেণ্ট',
    'Current Imbalance': 'কাৰেণ্ট অসন্তুলন',
    'Current K-Factor': 'বৰ্তমানৰ কে-ফেক্টৰ',
    'Current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'বৰ্তমানৰ K-ফেক্টৰে গুৰুতৰ হাৰমনিক লোডিং সূচায় — ট্ৰেন্সফৰ্মাৰ ডিৰেট কৰিব লাগিব বা K-ৰেটিং ইউনিটৰ সৈতে সলনি কৰিব লাগিব।',
    'Current status': 'বৰ্তমানৰ অৱস্থা',
    'Custom': 'কাষ্টম',
    'Custom Alerts': 'স্বনিৰ্বাচিত সতৰ্কবাণীসমূহ',
    'Custom range': 'কাষ্টম ৰেঞ্জ',
    'Customer charges': 'গ্ৰাহকৰ চাৰ্জ',
    'Daily Cost': 'দৈনিক খৰচ',
    'Dashboard': 'ডেচব\'ৰ্ড',
    'Deep dive': 'ডিপ ডাইভ',
    'Demand Penalty Applied': 'চাহিদা শাস্তি প্ৰয়োগ কৰা হৈছে',
    'Demand charge (billing-cycle peak)': 'চাহিদাৰ চাৰ্জ (বিলিং-চক্ৰৰ শীৰ্ষ)',
    'Demand charge is fixed from the billing cycle peak. PF rebate and LF rebate/surcharge are projected at current rates.': 'বিলিং চক্ৰৰ শীৰ্ষৰ পৰাই চাহিদা চাৰ্জ নিৰ্ধাৰণ কৰা হয়। পি এফ ৰেহাই আৰু এল এফ ৰেহাই/চাৰ্চাৰ্জ বৰ্তমানৰ হাৰত প্ৰক্ষেপ কৰা হৈছে।',
    'Demand charges — when Maximum Demand (MD) exceeds Contract Demand (CD)': 'চাহিদা চাৰ্জ — যেতিয়া সৰ্বোচ্চ চাহিদা (MD) চুক্তিৰ চাহিদা (CD) অতিক্ৰম কৰে',
    'Demands under CD pay standard rates on chargeable kVA. Exceeding CD triggers a': 'চিডিৰ অধীনত চাহিদাই চাৰ্জযোগ্য কেভিএৰ ওপৰত মানক হাৰ প্ৰদান কৰে। চিডি অতিক্ৰম কৰিলে a',
    'Detected on most recent reading': 'শেহতীয়া পঢ়াত ধৰা পৰিছে',
    'Disabled — no notifications': 'নিষ্ক্ৰিয় — কোনো জাননী নাই',
    'Download Bill': 'বিল ডাউনলোড কৰক',
    'Download Bill PDF': 'বিল পিডিএফ ডাউনলোড কৰক',
    'Download Log': 'ডাউনলোড লগ',
    'Download PDF': 'PDF ডাউনলোড কৰক',
    'Download a printable daily log · Accumulated kWh, Power Factor per hour': 'এটা প্ৰিন্টযোগ্য দৈনিক লগ ডাউনলোড কৰক · সঞ্চিত কিলোৱাট ঘন্টা, প্ৰতি ঘণ্টাত শক্তি কাৰক',
    'Edge Node · Raspberry Pi Health': 'এজ ন\'ড · ৰাস্পবেৰী পাই স্বাস্থ্য',
    'Electricity Duty (projected)': 'বিদ্যুৎ শুল্ক (প্ৰকল্পিত)',
    'Elevated current THD — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress and overheating.': 'উচ্চ কাৰেণ্ট THD — ই ট্ৰেন্সফৰ্মাৰৰ চাপ আৰু অতি উত্তাপৰ কাৰণ হোৱা অৰৈখিক লোড (VFDs, UPS, ড্ৰাইভ) সূচায়।',
    'Elevated voltage THD — can damage capacitors, transformers, and sensitive equipment. IEEE 519 limit is 8%.': 'উচ্চ ভল্টেজ THD — কেপাচিটৰ, ট্ৰেন্সফৰ্মাৰ, আৰু সংবেদনশীল সঁজুলিৰ ক্ষতি কৰিব পাৰে। IEEE 519 সীমা ৮%।',
    'Email Support': 'ইমেইল সমৰ্থন',
    'Energy': 'শক্তি',
    'Energy Charges · Time-of-Day Split': 'শক্তিৰ চাৰ্জ · দিনৰ সময় বিভাজন',
    'Energy by Time-of-Day': 'দিনটোৰ সময় অনুসৰি শক্তি',
    'Energy charges + Demand charges + Electricity Duty + Customer charges · accumulated till date': 'শক্তিৰ চাৰ্জ + চাহিদাৰ চাৰ্জ + বিদ্যুতৰ শুল্ক + গ্ৰাহকৰ চাৰ্জ · আজিলৈকে জমা হৈছে',
    'Energy charges + Power Factor adjustment + Load Factor rebates + Demand charges + Electricity Duty + Meter rental · accumulated till date': 'শক্তিৰ চাৰ্জ + শক্তি কাৰক সামঞ্জস্য + লোড কাৰক ৰেহাই + চাহিদাৰ চাৰ্জ + বিদ্যুতৰ শুল্ক + মিটাৰ ভাড়া · আজিলৈকে জমা হৈছে',
    'Energy charges accumulated by tariff period': 'শুল্ক সময়সীমা অনুসৰি জমা হোৱা শক্তিৰ চাৰ্জ',
    'Energy delivered': 'শক্তি প্ৰদান কৰা হয়',
    'Enter the access password for your site.': 'আপোনাৰ চাইটৰ বাবে অভিগম গুপ্তশব্দ সুমুৱাওক।',
    'Enter your access password': 'আপোনাৰ অভিগম পাছৱৰ্ড দিয়ক',
    'Failed to copy phone number.': 'ফোন নম্বৰ কপি কৰাত ব্যৰ্থ।',
    'Fires when PF drops below threshold — attracts utility penalty.': 'PF থ্ৰেছহ\'ল্ডৰ তললৈ নামিলে ট্ৰিগাৰ হয় — ইউটিলিটি পেনাল্টি আকৰ্ষণ কৰে।',
    'Fires when current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'ট্ৰিগাৰ হয় যেতিয়া কাৰেণ্ট K-ফেক্টৰে গুৰুতৰ হাৰমনিক লোডিং সূচায় — ট্ৰেন্সফৰ্মাৰ ডিৰেট কৰিব লাগিব বা K-ৰেটিং ইউনিটৰ সৈতে সলনি কৰিব লাগিব।',
    'Fires when current THD exceeds safe levels — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress.': 'ট্ৰিগাৰ হয় যেতিয়া বিদ্যুৎ প্ৰবাহ THD নিৰাপদ স্তৰ অতিক্ৰম কৰে — ট্ৰেন্সফৰ্মাৰৰ চাপৰ সৃষ্টি কৰা অৰৈখিক লোড (VFDs, UPS, ড্ৰাইভ) সূচায়।',
    'Fires when load % nears or exceeds the contracted demand limit.': 'লোড % চুক্তিবদ্ধ চাহিদাৰ সীমাৰ ওচৰ পালে বা অতিক্ৰম কৰিলে ট্ৰিগাৰ হয়।',
    'Fires when neutral conductor carries excess current — fire risk.': 'নিৰপেক্ষ পৰিবাহীয়ে অতিৰিক্ত বিদ্যুৎ প্ৰবাহ কঢ়িয়াই নিলে ট্ৰিগাৰ হয় — জুইৰ আশংকা।',
    'Fires when phase current imbalance exceeds threshold.': 'ফেজ কাৰেণ্টৰ ভাৰসাম্যহীনতাই থ্ৰেছহ’ল্ড অতিক্ৰম কৰিলে ট্ৰিগাৰ হয়।',
    'Fires when voltage K-Factor exceeds transformer derating limits — K>4 requires K-rated transformer.': 'ভল্টেজ K-ফেক্টৰে ট্ৰেন্সফৰ্মাৰৰ ডিৰেটিং সীমা অতিক্ৰম কৰিলে ট্ৰিগাৰ হয় — K>4 ৰ বাবে K-ৰেটিং ট্ৰেন্সফৰ্মাৰৰ প্ৰয়োজন হয়।',
    'Fires when voltage THD exceeds safe levels — can damage capacitors, transformers, and sensitive equipment.': 'ভল্টেজ THD নিৰাপদ স্তৰ অতিক্ৰম কৰিলে ট্ৰিগাৰ হয় — কেপাচিটৰ, ট্ৰেন্সফৰ্মাৰ, আৰু সংবেদনশীল সঁজুলিৰ ক্ষতি কৰিব পাৰে।',
    'Frequency': 'কম্পাঙ্ক',
    'Frequently asked questions & tech support': 'সঘনাই সোধা প্ৰশ্ন & টেক চাপৰ্ট',
    'Full': 'সম্পূৰ্ণ',
    'Get support directly on WhatsApp chat': 'WhatsApp chat ত পোনপটীয়াকৈ সমৰ্থন লাভ কৰক',
    'Help & Support': 'সহায় আৰু সমৰ্থন',
    'Hide code': 'ক\'ড লুকুৱাওক',
    'High': 'উচ্চ',
    'High Current Harmonic Distortion': 'উচ্চ কাৰেণ্ট হাৰমনিক বিকৃতি',
    'High Current K-Factor': 'উচ্চ কাৰেণ্ট কে-ফেক্টৰ',
    'High Voltage Harmonic Distortion': 'উচ্চ ভল্টেজ হাৰমনিক বিকৃতি',
    'High Voltage K-Factor': 'হাই ভল্টেজ কে-ফেক্টৰ',
    'High neutral current — possible fire risk from unbalanced phases or loose neutral.': 'উচ্চ নিৰপেক্ষ কাৰেণ্ট — অসন্তুলিত পৰ্যায় বা ঢিলা নিৰপেক্ষৰ পৰা সম্ভাৱ্য জুইৰ আশংকা।',
    'Hourly Power Log · PDF': 'ঘণ্টাৰ পিছত ঘণ্টা শক্তি লগ · পিডিএফ',
    'Insufficient data': 'অপৰ্যাপ্ত তথ্য',
    'Intraday Bill': 'ইন্ট্ৰাডে বিল',
    'K-Factor': 'কে-ফেক্টৰ',
    'K-Factor distribution · sample count per unit band': 'কে-ফেক্টৰ বিতৰণ · প্ৰতি ইউনিট বেণ্ডত নমুনাৰ সংখ্যা',
    'LF Adjustment (projected)': 'LF সমন্বয় (প্ৰকল্পিত)',
    'LF Penalty (projected)': 'এল এফ পেনাল্টি (প্ৰকল্পিত)',
    'LF Rebate (projected)': 'LF ৰেহাই (প্ৰকল্পিত)',
    'Last 24 hours': 'যোৱা ২৪ ঘণ্টা',
    'Last 24 hours · kW (active) and kVA (apparent)': 'যোৱা ২৪ ঘণ্টা · কিলোৱাট (সক্ৰিয়) আৰু কিলোৱাট (স্পষ্ট)',
    'Last 30 days': 'যোৱা ৩০ দিন',
    'Last 5 instances · all time': 'যোৱা ৫ টা দৃষ্টান্ত · সকলো সময়তে',
    'Last refresh': 'শেষ ৰিফ্ৰেছ',
    'Live': 'লাইভ',
    'Live Power Factor': 'লাইভ পাৱাৰ ফেক্টৰ',
    'Live status, risk indicators and threshold breach density.': 'লাইভ ষ্টেটাছ, ৰিস্ক ইনডিকেটৰ আৰু থ্ৰেছহ’ল্ড ভংগ ঘনত্ব।',
    'Load Factor': 'লোড ফ্যাক্টৰ',
    'Load Factor (LF) rebate / surcharge — applied per kWh consumed': 'লোড ফেক্টৰ (LF) ৰেহাই / চাৰ্চাৰ্জ — প্ৰতি কিলোৱাট ঘণ্টাত প্ৰয়োগ কৰা হয়',
    'Load Factor Adjustment': 'লোড ফ্যাক্টৰ এডজাষ্টমেণ্ট',
    'Load Factor Penalty': 'লোড ফেক্টৰ পেনাল্টি',
    'Load Factor Rebate': 'লোড ফ্যাক্টৰ ৰেহাই',
    'Load Factor Utilisation': 'লোড ফ্যাক্টৰ ব্যৱহাৰ',
    'Load Factor adjustment MTD': 'লোড ফ্যাক্টৰ এডজাষ্টমেণ্ট এমটিডি',
    'Load percentage nearing or exceeding contracted demand limit.': 'চুক্তিবদ্ধ চাহিদা সীমাৰ ওচৰত বা অতিক্ৰম কৰা লোডৰ শতাংশ।',
    'Loading…': 'লোড হচ্ছে...',
    'Low Power Factor': 'কম শক্তি কাৰক',
    'MD Peak': 'এম ডি পিক',
    'Max': 'সৰ্বোচ্চ',
    'Max Demand Analysis': 'সৰ্বোচ্চ চাহিদা বিশ্লেষণ',
    'Max Demand by Time-of-Day Period': 'দিনটোৰ সময় অনুসৰি সৰ্বোচ্চ চাহিদা',
    'Max current K-Factor across phases — rates transformer derating for harmonic loads': 'ফেজসমূহৰ মাজেৰে সৰ্বোচ্চ কাৰেণ্ট K-ফেক্টৰ — হাৰমনিক লোডৰ বাবে ট্ৰেন্সফৰ্মাৰৰ ডিৰেটিঙৰ হাৰ',
    'Max voltage K-Factor across phases — rates transformer derating for harmonic loads': 'ফেজসমূহৰ মাজেৰে সৰ্বোচ্চ ভল্টেজ K-ফেক্টৰ — হাৰমনিক লোডৰ বাবে ট্ৰেন্সফৰ্মাৰৰ ডিৰেটিঙৰ হাৰ',
    'Maximum demand': 'সৰ্বোচ্চ চাহিদা',
    'Meter overview': 'মিটাৰ অৱলোকন',
    'Meter rental': 'মিটাৰ ভাড়া',
    'Metered': 'মিটাৰযুক্ত',
    'Meters discovered': 'আৱিষ্কৃত মিটাৰ',
    'Metrics · last 5 alerts': 'মেট্ৰিক্স · শেষৰ ৫টা সতৰ্কবাণী',
    'Min': 'নূন্যতম',
    'Mon-Sat. 9:00 AM - 6:00 PM IST': 'সোম-শনি। পুৱা ৯:০০ বজাৰ পৰা সন্ধিয়া ৬:০০ বজালৈ',
    'Month-to-Date': 'মাহৰ পৰা তাৰিখলৈ',
    'Month-to-Date Cost': 'মাহৰ পৰা আজিলৈকে খৰচ',
    'Month-to-date bill for': 'মাহৰ পৰা আজিলৈকে বিলৰ বাবে...',
    'Most recent 5 breach events · reflects your current thresholds': 'শেহতীয়া ৫টা ভংগ ইভেন্ট · আপোনাৰ বৰ্তমানৰ থ্ৰেছহোল্ডসমূহ প্ৰতিফলিত কৰে',
    'Must stay': 'থাকিব লাগিব',
    'Near limit': 'সীমাৰ ওচৰত',
    'Net cost today': 'আজিৰ নিকা খৰচ',
    'Neutral Current': 'নিৰপেক্ষ কাৰেণ্ট',
    'Neutral zone': 'নিৰপেক্ষ অঞ্চল',
    'No adj.': 'No adj.',
    'No adjustment': 'কোনো সালসলনি নাই',
    'No alerts found': 'কোনো সতৰ্কবাণী পোৱা নগ’ল',
    'No breach events with current thresholds': 'বৰ্তমানৰ থ্ৰেছহোল্ডৰ সৈতে কোনো ভংগ ইভেণ্ট নহয়',
    'No breaches on latest reading': 'শেহতীয়া পঢ়াত কোনো ভংগ নহয়',
    'No data': 'কোনো তথ্য নাই',
    'No data available yet.': 'এতিয়ালৈকে কোনো তথ্য উপলব্ধ নহয়।',
    'No data for': 'ৰ বাবে কোনো তথ্য নাই',
    'No data for this day': 'আজিৰ দিনটোৰ কোনো তথ্য নাই',
    'No data for this meter yet': 'এই মিটাৰৰ বাবে এতিয়াও কোনো তথ্য নাই',
    'No data for this window': 'এই উইণ্ড\'ৰ বাবে কোনো তথ্য নাই',
    'No data in the last 24 hours': 'যোৱা ২৪ ঘণ্টাত কোনো তথ্য নাই',
    'No rebate': 'কোনো ৰেহাই নাই',
    'No samples in': 'কোনো নমুনা নাই',
    'No variables match your search.': 'কোনো চলক আপোনাৰ সন্ধানৰ সৈতে মিল নাই।',
    'None (WBSEDCL B-IDIT)': 'কোনো নাই (WBSEDCL B-IDIT)',
    'Normal': 'স্বাভাৱিক',
    'Normal demand charge': 'সাধাৰণ চাহিদা চাৰ্জ',
    'Normal · peak': 'স্বাভাৱিক · শিখৰ',
    'Notify via': 'মাধ্যমেৰে অৱগত কৰক',
    'Off-Peak': 'অফ-পিক',
    'Open dashboard': 'ডেচব\'ৰ্ড খোলক',
    'PDF BI': 'পিডিএফ বিআই',
    'PDF columns BE / BF / BG · max of all 15-min averaged blocks per period': 'PDF স্তম্ভ BE / BF / BG · প্ৰতি সময়ছোৱাত সকলো ১৫ মিনিটৰ গড় ব্লকৰ সৰ্বোচ্চ',
    'PF Adjustment (projected)': 'পি এফ সমন্বয় (প্ৰকল্পিত)',
    'PF Penalty (projected)': 'পি এফ পেনাল্টি (প্ৰকল্পিত)',
    'PF Penalty / Rebate': 'পি এফ পেনাল্টি / ৰেহাই',
    'PF Rebate (projected)': 'পি এফ ৰেহাই (প্ৰকল্পিত)',
    'PF rebate / penalty MTD': 'পি এফ ৰেহাই / পেনাল্টি এম টি ডি',
    'Password': 'পাছৱৰ্ড',
    'Peak': 'শিখৰ',
    'Peak clipped': 'পিক ক্লিপ কৰা হৈছে',
    'Peak kVA': 'শিখৰ kVA',
    'Penalty': 'শাস্তি',
    'Penalty <': 'শাস্তি <',
    'Penalty likely': 'শাস্তিৰ সম্ভাৱনা',
    'Penalty zone': 'পেনাল্টি জ’ন',
    'Per-phase': 'প্ৰতি পৰ্যায়ত',
    'Phase': 'পৰ্যায়',
    'Phase B Current': 'ফেজ বি কাৰেণ্ট',
    'Phase B Power': 'ফেজ বি শক্তি',
    'Phase B line current': 'ফেজ বি লাইন কাৰেণ্ট',
    'Phase R Current': 'ফেজ আৰ কাৰেণ্ট',
    'Phase R Power': 'ফেজ আৰ শক্তি',
    'Phase R line current': 'ফেজ R লাইন কাৰেণ্ট',
    'Phase Y Current': 'ফেজ Y কাৰেণ্ট',
    'Phase Y Power': 'ফেজ Y শক্তি',
    'Phase Y line current': 'ফেজ Y লাইন কাৰেণ্ট',
    'Phase current': 'ফেজ কাৰেণ্ট',
    'Phase current imbalance — indicates uneven load distribution across phases.': 'ফেজ কাৰেণ্টৰ ভাৰসাম্যহীনতা — ফেজসমূহৰ মাজত অসমান লোড বিতৰণক সূচায়।',
    'Phase voltage (L-N)': 'ফেজ ভল্টেজ (L-N)',
    'Phase voltage imbalance — can damage motors and reduce equipment life.': 'ফেজ ভল্টেজৰ ভাৰসাম্যহীনতাই — মটৰৰ ক্ষতি কৰিব পাৰে আৰু সঁজুলিৰ আয়ুস হ্ৰাস কৰিব পাৰে।',
    'Phone number copied to clipboard.': 'ফোন নম্বৰ ক্লিপবৰ্ডলৈ কপি কৰা হৈছে।',
    'Pi CPU Usage': 'Pi CPU ব্যৱহাৰ',
    'Pi Memory Usage': 'পাই মেমৰি ব্যৱহাৰ',
    'Pi Temperature': 'পাই তাপমাত্ৰা',
    'Pi Temperature · Last 24 h': 'Pi তাপমাত্ৰা · শেষৰ ২৪ ঘন্টা',
    'Power': 'বিদ্যুৎ',
    'Power Analysis': 'বিদ্যুৎ বিশ্লেষণ',
    'Power Factor': 'শক্তি কাৰক',
    'Power Factor (Month-to-Date)': 'শক্তি কাৰক (মাহৰ পৰা আজিলৈকে)',
    'Power Factor (PF) adjustment — applied as % of energy charge per ToD period': 'শক্তি কাৰক (PF) সমন্বয় — প্ৰতি ToD সময়ছোৱাত শক্তি চাৰ্জৰ % হিচাপে প্ৰয়োগ কৰা হয়',
    'Power Factor Adjustment': 'শক্তি কাৰক সমন্বয়',
    'Power Factor Penalty': 'পাৱাৰ ফেক্টৰ পেনাল্টি',
    'Power Factor Rebate': 'শক্তি কাৰক ৰেহাই',
    'Power Factor rebate / penalty MTD': 'পাৱাৰ ফেক্টৰ ৰেহাই / পেনাল্টি এমটিডি',
    'Power factor below threshold — attracting TGSPDCL RKVAH penalty on energy bill.': 'থ্ৰেছহোল্ডৰ তলত শক্তি কাৰক — শক্তি বিলৰ ওপৰত TGSPDCL RKVAH জৰিমনা আকৰ্ষণ কৰা।',
    'Production build · v1.0': 'প্ৰডাকচন বিল্ড · v1.0',
    'Projected Bill': 'প্ৰক্ষেপিত বিধেয়ক',
    'Projected Bill · Month-End Estimate': 'প্ৰক্ষেপিত বিল · মাহৰ শেষৰ আনুমানিক হিচাপ',
    'Projected energy charge (gross)': 'প্ৰক্ষেপিত শক্তি চাৰ্জ (স্থূল)',
    'Projected net payable by due date': 'নিৰ্ধাৰিত তাৰিখৰ ভিতৰত প্ৰদান কৰিবলগীয়া প্ৰকল্পিত নিকা',
    'Projection uses a linear run-rate from': 'প্ৰজেকচনে ৰৈখিক ৰান-হাৰ ব্যৱহাৰ কৰে',
    'RAM Usage (%)': 'ৰেম ব্যৱহাৰ (%)',
    'Raspberry Pi CPU temperature': 'ৰাস্পবেৰী পাই চিপিইউ উষ্ণতা',
    'Raspberry Pi CPU utilisation': 'ৰাস্পবেৰী পাই চিপিইউ ব্যৱহাৰ',
    'Raspberry Pi Gateway': 'ৰাস্পবেৰী পাই গেটৱে',
    'Raspberry Pi memory utilisation': 'ৰাস্পবেৰী পাই মেমৰি ব্যৱহাৰ',
    'Rebate': 'ৰেহাই',
    'Rebate earned': 'ৰেহাই লাভ কৰা',
    'Rebate zone': 'ৰেহাই জ\'ন',
    'Refresh': 'সতেজ কৰক',
    'Refresh interval': 'অন্তৰাল',
    'Remove this rule': 'এই নিয়মটো আঁতৰাই পেলাওক',
    'Response time usually within 2 hours': 'সাধাৰণতে ২ ঘণ্টাৰ ভিতৰত সঁহাৰিৰ সময়',
    'Rules saved on this device. Production build routes notifications via SMS and WhatsApp.': 'এই ডিভাইচত সংৰক্ষণ কৰা নিয়মসমূহ। প্ৰডাকচন বিল্ড ৰুট এছএমএছ আৰু হোৱাটছএপৰ জৰিয়তে নোটিফিকেচন।',
    'Running daily energy cost (₹)': 'দৈনিক শক্তিৰ খৰচ (₹)',
    'Running maximum of kVA averaged over 15 minutes window': '15 মিনিটৰ ভিতৰত গড়ে kVA ৰ সৰ্বোচ্চ চলি থকা',
    'Running session energy (kWh)': 'চলি থকা অধিবেশন শক্তি (কিলোৱাট ঘন্টা)',
    'SAFE': 'SAFE',
    'Safe': 'নিৰাপদ',
    'Samples loaded': 'লোড কৰা নমুনা',
    'Save Alert Rules': 'সতৰ্কতা নিয়মসমূহ সংৰক্ষণ কৰক',
    'Search variables…': 'চলকসমূহ সন্ধান কৰক...',
    'Select Language': 'ভাষা নিৰ্বাচন কৰক',
    'Select a date range above': 'ওপৰত এটা তাৰিখ পৰিসীমা বাছক',
    'Select billing period': 'বিলিং সময়সীমা নিৰ্বাচন কৰক',
    'Select language': 'ভাষা নিৰ্বাচন কৰক',
    'Select meter': 'মিটাৰ বাছনি কৰক',
    'Send Email': 'ইমেইল প্ৰেৰণ কৰক',
    'Session Energy': 'অধিবেশন শক্তি',
    'Session carbon footprint (kg CO₂)': 'অধিবেশন কাৰ্বন ফুটপ্ৰিণ্ট (কিলোগ্ৰাম CO2)',
    'Settings': 'ছেটিংস',
    'Share': 'শ্বেয়াৰ কৰক',
    'Show code': 'ক\'ড দেখুৱাওক',
    'Showing': 'দেখুৱাইছে',
    'Showing cached data — we\'ll keep retrying automatically.': 'কেচ কৰা তথ্য দেখুৱাইছে — আমি স্বয়ংক্ৰিয়ভাৱে পুনৰ চেষ্টা কৰি থাকিম।',
    'Showing month-to-date charges': 'মাহৰ পৰা আজিলৈকে চাৰ্জ দেখুওৱা হৈছে',
    'Showing today\'s charges': 'আজিৰ চাৰ্জ দেখুৱাই',
    'Sign out': 'ছাইন আউট',
    'Similar to average': 'গড়ৰ দৰেই',
    'Similar to this week\'s average': 'এই সপ্তাহৰ গড়ৰ সৈতে একে',
    'Since midnight IST · updates every 5 min': 'মাজনিশাৰ পৰা IST · প্ৰতি ৫ মিনিটৰ মূৰে মূৰে আপডেট কৰা হয়',
    'Site': 'ছাইট',
    'Sum of all phase currents': 'সকলো ফেজ কাৰেণ্টৰ যোগফল',
    'Surcharge': 'চাৰ্চাৰ্জ',
    'THD distribution · sample count per 2% band': 'THD বিতৰণ · প্ৰতি ২% বেণ্ডত নমুনাৰ সংখ্যা',
    'Telangana': 'তেলেংগানা',
    'Temperature (°C)': 'তাপমাত্ৰা (°C)',
    'This Month': 'এই মাহত',
    'This week (Sun – yesterday)': 'এই সপ্তাহত (ৰবি – কালি)',
    'Threshold': 'থ্ৰেছহোল্ড',
    'Time distribution': 'সময়ৰ বিতৰণ',
    'Time-of-Day Split': 'দিনৰ সময় বিভাজন',
    'Timely Payment Rebate': 'সময়মতে পেমেন্ট ৰেহাই',
    'ToD Off-Peak Rebate': 'ToD অফ-পিক ৰেহাই',
    'ToD Peak Penalty': 'ToD শীৰ্ষ শাস্তি',
    'Today': 'আজি',
    'Today PF': 'আজি পি এফ',
    'Today is': 'আজিৰ দিনটো',
    'Today\'s Cost': 'আজিৰ খৰচ',
    'Today\'s Running Cost': 'আজিৰ Running Cost',
    'Total': 'মুঠ',
    'Total Active Power': 'মুঠ সক্ৰিয় শক্তি',
    'Total Apparent Power': 'মুঠ আপাত শক্তি',
    'Total Current': 'মুঠ বৰ্তমান',
    'Total Energy (kWh) consumed last month / (Peak kW observed last month times number of hours last month)': 'যোৱা মাহত ব্যৱহৃত মুঠ শক্তি (কিলোৱাট ঘন্টা) / (যোৱা মাহত পৰ্যবেক্ষণ কৰা শীৰ্ষ কিলোৱাট গুণ যোৱা মাহত ঘণ্টাৰ সংখ্যা)',
    'Total Energy (kWh) consumed this month / (Peak kW observed this month times number of hours this month)': 'এই মাহত ব্যৱহৃত মুঠ শক্তি (কিলোৱাট ঘন্টা) / (এই মাহত পৰ্যবেক্ষণ কৰা শীৰ্ষ কিলোৱাট আৰু এই মাহত ঘণ্টাৰ সংখ্যা)',
    'Total Energy (kWh) consumed this week / (Peak kW observed this week times number of hours this week)': 'এই সপ্তাহত ব্যৱহাৰ কৰা মুঠ শক্তি (কিলোৱাট ঘন্টা) / (এই সপ্তাহত পৰ্যবেক্ষণ কৰা শীৰ্ষ কিলোৱাট বাৰ এই সপ্তাহত ঘণ্টাৰ সংখ্যা)',
    'Total Energy (kWh) consumed today/ (Peak kW observed today times number of hours today)': 'আজি ব্যৱহৃত মুঠ শক্তি (কিলোৱাট ঘন্টা)/ (আজি পৰ্যবেক্ষণ কৰা শীৰ্ষ কিলোৱাট আৰু আজিৰ ঘণ্টাৰ সংখ্যা)',
    'Total Energy Charge': 'মুঠ শক্তি চাৰ্জ',
    'Total Harmonic Distortion (%)': 'মুঠ হাৰমনিক বিকৃতি (%)',
    'Total Watts': 'মুঠ ৱাট',
    'Total active power across all phases': 'সকলো পৰ্যায়তে মুঠ সক্ৰিয় শক্তি',
    'Total apparent power (kVA)': 'মুঠ আপাত শক্তি (kVA)',
    'Total demand cost': 'মুঠ চাহিদাৰ খৰচ',
    'Total instantaneous power in watts': 'ৱাটত মুঠ তৎক্ষণাত শক্তি',
    'Try again': 'আকৌ এবাৰ চেষ্টা কৰক',
    'Try another meter or wait for the next refresh.': 'আন এটা মিটাৰ চেষ্টা কৰক বা পৰৱৰ্তী সতেজতাৰ বাবে অপেক্ষা কৰক।',
    'Use one of the access codes provided for your site.': 'আপোনাৰ চাইটৰ বাবে প্ৰদান কৰা অভিগম ক\'ডসমূহৰ এটা ব্যৱহাৰ কৰক।',
    'Utilisation %': 'ব্যৱহাৰ %',
    'Voltage': 'ভল্টেজ',
    'Voltage Imbalance': 'ভল্টেজৰ ভাৰসাম্যহীনতা',
    'Voltage K-Factor': 'ভল্টেজ কে-ফেক্টৰ',
    'Voltage K-Factor exceeds transformer derating limit — K>4 requires a K-rated transformer.': 'ভল্টেজ K-ফেক্টৰে ট্ৰেন্সফৰ্মাৰৰ ডিৰেটিং সীমা অতিক্ৰম কৰে — K>4 ৰ বাবে এটা K-ৰেটিং ট্ৰেন্সফৰ্মাৰৰ প্ৰয়োজন।',
    'WARN': 'সতৰ্কবাণী',
    'Warn': 'সতৰ্ক কৰি দিয়ক',
    'Warning': 'সতৰ্কবাণী',
    'Warning above': 'ওপৰত সতৰ্কবাণী',
    'Warning below': 'তলত সতৰ্কবাণী',
    'Warning · peak': 'সতৰ্কবাণী · শিখৰ',
    'WhatsApp Support': 'হোৱাটছএপ সমৰ্থন',
    'Within Limit': 'সীমাৰ ভিতৰত',
    'Worst': 'আটাইতকৈ বেয়া',
    'Yesterday': 'কালি',
    'above': 'ওপৰত',
    'above CD': 'চিডিৰ ওপৰত',
    'above this week\'s avg': 'এই সপ্তাহৰ গড়ৰ ওপৰত',
    'above this week\'s avg — good day': 'এই সপ্তাহৰ গড়ৰ ওপৰত — ভাল দিন',
    'active': 'সক্ৰিয়',
    'active issue': 'সক্ৰিয় বিষয়',
    'active issues': 'সক্ৰিয় বিষয়সমূহ',
    'added to bill': 'বিলত যোগ কৰা হৈছে',
    'added to this month\'s bill': 'এই মাহৰ বিলত যোগ কৰা হৈছে',
    'adjustment': 'সমন্বয়',
    'all charges finalised.': 'সকলো অভিযোগ চূড়ান্ত কৰা হৈছে।',
    'and': 'আৰু...',
    'applied for Load Factor ≥ 65%': 'লোড ফ্যাক্টৰ ≥ 65% ৰ বাবে প্ৰয়োগ কৰা হৈছে',
    'average': 'গড়',
    'avg': 'গড়',
    'below': 'তলত',
    'below average': 'গড়ৰ তলত',
    'below min → charged on': 'তলত min → চাৰ্জ অন',
    'below this week\'s avg': 'এই সপ্তাহৰ গড়ৰ তলত',
    'below this week\'s avg — below average': 'এই সপ্তাহৰ গড়ৰ তলত — গড়ৰ তলত',
    'consumers under TOD Tariff (CD > 50 kVA); % of energy charge per ToD period': 'টিঅ’ডি শুল্কৰ অধীনত গ্ৰাহক (চিডি > ৫০ কেভিএ); প্ৰতি ToD সময়ছোৱাত শক্তি চাৰ্জৰ শতাংশ',
    'critical': 'সমালোচনাত্মক',
    'current': 'কাৰেণ্ট',
    'day bill for': 'দিনৰ বিলৰ বাবে',
    'day run rate': 'ডে ৰান ৰেট',
    'days': 'দিন',
    'days of actual data.': 'প্ৰকৃত তথ্যৰ দিন।',
    'days of meter data': 'মিটাৰৰ তথ্যৰ দিন',
    'days remaining': 'দিন বাকী আছে',
    'days required for': 'দিনৰ বাবে প্ৰয়োজনীয়',
    'deducted from bill': 'বিলৰ পৰা কৰ্তন কৰা হৈছে',
    'deducted from this month\'s bill': 'এই মাহৰ বিলৰ পৰা কৰ্তন কৰা হৈছে',
    'delivered': 'ডেলিভাৰী কৰা হৈছে',
    'energy charges, Power Factor & Load Factor adjustments, demand charge, duties, and projected net payable.': 'শক্তি চাৰ্জ, শক্তি কাৰক আৰু লোড কাৰক সালসলনি, চাহিদা চাৰ্জ, শুল্ক, আৰু প্ৰক্ষেপিত নেট প্ৰদানযোগ্য।',
    'energy per day': 'প্ৰতিদিনে শক্তি',
    'energy per hour': 'প্ৰতি ঘণ্টাত শক্তি',
    'excess above CD': 'চিডিৰ ওপৰত অতিৰিক্ত',
    'fires when <': 'ট্ৰিগাৰ হয় যেতিয়া <',
    'fires when >': 'ট্ৰিগাৰ হয় যেতিয়া >',
    'good day': 'ভাল দিন',
    'if paid after 15 days': 'যদি ১৫ দিনৰ পিছত ধন দিয়া হয়',
    'if paid by due date': 'যদি নিৰ্ধাৰিত তাৰিখৰ ভিতৰত পৰিশোধ কৰা হয়',
    'imbal': 'imbal',
    'invoice estimate': 'চালান অনুমান',
    'is above this week\'s avg': 'এই সপ্তাহৰ গড়ৰ ওপৰত',
    'is below this week\'s avg': 'এই সপ্তাহৰ গড়ৰ তলত আছে',
    'kVA/month': 'kVA/মাহ',
    'kVAh': 'kVAh',
    'kWh': 'কিলোৱাট ঘন্টা',
    'limit': 'সীমা',
    'meter': 'মিটাৰ',
    'meters': 'মিটাৰ',
    'min demand applies': 'নূন্যতম চাহিদা প্ৰযোজ্য',
    'month': 'মাহ',
    'month-to-date': 'মাহৰ পৰা আজিলৈকে',
    'net incl. all charges': 'নেট ইনক্ল. সকলো চাৰ্জ',
    'net today': 'নেট আজি',
    'never': 'কেতিয়াও নহয়',
    'no adj.': 'no adj.',
    'no adjustment': 'কোনো সামঞ্জস্য নাই',
    'no adjustment applicable': 'কোনো সালসলনি প্ৰযোজ্য নহয়',
    'no adjustment today': 'আজি কোনো সালসলনি নাই',
    'nom': 'nom',
    'not yet applicable today': 'আজিও প্ৰযোজ্য নহয়',
    'of': 'ৰ',
    'of 24 hours have data': '২৪ ঘণ্টাৰ তথ্য আছে',
    'of CD': 'চিডিৰ',
    'of bill': 'বিলৰ',
    'of gross bill': 'গ্ৰাছ বিলৰ',
    'of net bill': 'নেট বিলৰ',
    'off': 'বন্ধ',
    'on the excess kVA.': 'অতিৰিক্ত kVA ৰ ওপৰত।',
    'over-threshold': 'অভাৰ-থ্ৰেছহ\'ল্ড',
    'paise/kVAh  (6p flat)': 'paise/kVAh (৬পি সমতল)',
    'paise/kWh rebate': 'paise/kWh ৰেহাই',
    'paise/kWh surcharge': 'পইচা/কিলোৱাট ঘন্টা চাৰ্চাৰ্জ',
    'peak kVA': 'শিখৰ kVA',
    'peak kVA today': 'আজি শীৰ্ষ কেভিএ',
    'penalty': 'পেনাল্টি',
    'projected penalty': 'প্ৰক্ষেপিত শাস্তি',
    'projected rebate': 'প্ৰক্ষেপিত ৰেহাই',
    'projected surcharge': 'প্ৰক্ষেপিত চাৰ্চাৰ্জ',
    'readings': 'ৰিডিংছ',
    'readings · 3 phases': 'পঢ়া · ৩টা পৰ্যায়',
    'rebate': 'ৰেহাই',
    'rebate / kWh': 'ৰেহাই / কিলোৱাট ঘন্টা',
    'rebate earned': 'ৰেহাই লাভ কৰা',
    's': 'ছ',
    's when the tab is visible.': 's যেতিয়া টেব দৃশ্যমান হয়।',
    'samples': 'নমুনা',
    'surcharge': 'চাৰ্চাৰ্জ',
    'surcharge / kWh': 'চাৰ্চাৰ্জ / কিলোৱাট ঘন্টা',
    'surcharge added to bill': 'বিলত চাৰ্চাৰ্জ যোগ কৰা হৈছে',
    'surcharge applied': 'চাৰ্চাৰ্জ প্ৰয়োগ কৰা হৈছে',
    'threshold': 'থ্ৰেছহ\'ল্ড',
    'to': 'to',
    'units consumed so far': 'এতিয়ালৈকে ব্যৱহৃত ইউনিট',
    'updated every 5 min': 'প্ৰতি ৫ মিনিটৰ মূৰে মূৰে আপডেট কৰা হয়',
    'updating…': 'আপডেট কৰা হৈছে...',
    'warn': 'সতৰ্ক কৰি দিয়া',
    '· added to bill today': '· আজি বিলত যোগ কৰা হৈছে',
    '· saving deducted today': '· আজি সঞ্চয় কৰ্তন কৰা হৈছে',
    '· surcharge added today': '· আজি চাৰ্চাৰ্জ যোগ কৰা হৈছে',
    '— · awaiting data': '— · তথ্যলৈ অপেক্ষা কৰা হৈছে',
    '≥': '≥',
    '⚠ No Pi telemetry in current data — fields piTempC / piMemPct not populated': '⚠ বৰ্তমানৰ তথ্যত কোনো Pi টেলিমেট্ৰি নাই — piTempC / piMemPct ক্ষেত্ৰসমূহ জনবহুল কৰা হোৱা নাই',
    '⚠️ Thermal throttle active — Pi is running hot, performance reduced': '⚠️ থাৰ্মেল থ্ৰ\'টল সক্ৰিয় — পাই গৰম চলি আছে, পাৰফৰমেন্স হ্ৰাস পাইছে',
    '✓ Rules Saved Successfully': '✓ নিয়মসমূহ সফলতাৰে সংৰক্ষণ কৰা হৈছে',
  },
  bn: {
    'This Week': 'এই সপ্তাহ',
    'Last Month': 'গত মাস',
    'Sensor Dropout': 'সেন্সর ড্রপআউট',
    'Approaching Overload': 'ওভারলোডের কাছাকাছি',
    'Frequency Deviation': 'ফ্রিকোয়েন্সি বিচ্যুতি',
    'High Voltage THD': 'উচ্চ ভোল্টেজ THD',
    'High Current THD': 'উচ্চ কারেন্ট THD',
    'In-app': 'অ্যাপের মধ্যে',
    'SMS': 'এসএমএস',
    'WhatsApp': 'হোয়াটসঅ্যাপ',
    'Min. chargeable demand': 'ন্যূনতম চার্জযোগ্য চাহিদা',
    'Demand charge — Normal': 'ডিমান্ড চার্জ — স্বাভাবিক',
    'Demand charge — Penal': 'ডিমান্ড চার্জ — শাস্তিমূলক',
    'Electricity duty': 'বিদ্যুৎ শুল্ক',
    'Late payment surcharge': 'বিলম্বে পরিশোধের অতিরিক্ত মাশুল',
    'Demand charge (up to CD)': 'ডিমান্ড চার্জ (CD পর্যন্ত)',
    'Generating': 'তৈরি করা হচ্ছে',
    'Bill PDF…': 'বিল PDF…',
    'What is the Power Analysis Dashboard?': 'পাওয়ার অ্যানালাইসিস ড্যাশবোর্ড কী?',
    'It monitors real-time electrical metrics (voltage, current, power factor, demand, active/reactive energy) collected from Raspberry Pi edge nodes installed at the site.': 'এটি সাইটে ইনস্টল করা Raspberry Pi এজ নোড থেকে সংগৃহীত রিয়েল-টাইম বৈদ্যুতিক মেট্রিক্স (ভোল্টেজ, কারেন্ট, পাওয়ার ফ্যাক্টর, ডিমান্ড, অ্যাক্টিভ/রিঅ্যাক্টিভ এনার্জি) পর্যবেক্ষণ করে।',
    'What do the green/orange/red indicators mean?': 'সবুজ/কমলা/লাল সূচকগুলোর অর্থ কী?',
    'Green means the Raspberry Pi edge node is online and reporting health telemetry normally. Orange/red indicate potential communication delays or high temperature/resource throttling.': 'সবুজ মানে Raspberry Pi এজ নোড অনলাইনে আছে এবং স্বাভাবিকভাবে স্বাস্থ্য টেলিমেট্রি রিপোর্ট করছে। কমলা/লাল সম্ভাব্য যোগাযোগ বিলম্ব বা উচ্চ তাপমাত্রা/রিসোর্স থ্রটলিং নির্দেশ করে।',
    'How are billing demand charges calculated?': 'বিলিং ডিমান্ড চার্জ কীভাবে গণনা করা হয়?',
    'Demand charges are based on the Maximum Demand (MD) recorded in 15-minute integration windows, calculated according to the active tariff structure (e.g., TGSPDCL HT or WBSEDCL B-IDIT).': 'ডিমান্ড চার্জ ১৫-মিনিটের ইন্টিগ্রেশন উইন্ডোতে রেকর্ড করা সর্বোচ্চ ডিমান্ড (MD)-এর উপর ভিত্তি করে, সক্রিয় ট্যারিফ কাঠামো (যেমন TGSPDCL HT বা WBSEDCL B-IDIT) অনুযায়ী গণনা করা হয়।',
    'What should I do if the dashboard shows "No data"?': 'ড্যাশবোর্ডে "কোনো তথ্য নেই" দেখালে আমার কী করা উচিত?',
    'Verify that the edge node (Raspberry Pi gateway) is powered on and connected to the internet. If the issue persists, contact technical support immediately.': 'এজ নোড (Raspberry Pi গেটওয়ে) চালু এবং ইন্টারনেটের সাথে সংযুক্ত আছে কিনা যাচাই করুন। সমস্যা থেকে গেলে অবিলম্বে কারিগরি সহায়তার সাথে যোগাযোগ করুন।',
    '% of readings': 'পড়ার %',
    '/month': '/মাস',
    '0.4 kV supply': '0.4 কেভি সরবরাহ',
    '12 AM – 12 AM': 'রাত ১২ - রাত ১২',
    '1st 12 AM → now': '১ তারিখ রাত ১২ → এখন',
    '2x penalty': '2x পেনাল্টি',
    '33 kV supply': '33 কেভি সরবরাহ',
    'About': 'সম্পর্কে',
    'Above': 'উপরে',
    'Across': 'জুড়ে',
    'Active (kW)': 'সক্রিয় (kW)',
    'Active Power & Apparent Power': 'সক্রিয় শক্তি এবং আপাত শক্তি',
    'Active power on Phase B': 'বি ফেজ এ সক্রিয় শক্তি',
    'Active power on Phase R': 'ফেজ R-এ সক্রিয় শক্তি',
    'Active power on Phase Y': 'Y ফেজ এ সক্রিয় শক্তি',
    'Active tariff': 'সক্রিয় ট্যারিফ',
    'Add custom variable alert': 'কাস্টম পরিবর্তনশীল সতর্কতা যোগ করুন',
    'Additional demand charge': 'অতিরিক্ত চাহিদা চার্জ',
    'Alert History': 'সতর্কতার ইতিহাস',
    'Alert Rules': 'সতর্কতার নিয়ম',
    'Alerts': 'সতর্কতা',
    'All energy/PF/LF values computed by the Cortex Pi gateway per VARIABLES.pdf §2.3 & §3. Demand, ED, rental, and TPR computed in the browser from WBSEDCL tariff constants.': 'VARIABLES.pdf §2.3 এবং §3 প্রতি কর্টেক্স পাই গেটওয়ে দ্বারা গণনা করা সমস্ত শক্তি/PF/LF মান। WBSEDCL ট্যারিফ কনস্ট্যান্ট থেকে ব্রাউজারে ডিমান্ড, ED, ভাড়া, এবং TPR গণনা করা হয়।',
    'All systems normal': 'সমস্ত সিস্টেম স্বাভাবিক',
    'Anomalies': 'অসঙ্গতি',
    'Anomaly': 'ব্যতিক্রম',
    'Apparent': 'আপাত শক্তি',
    'Apparent (kVA)': 'স্পষ্ট (kVA)',
    'Approaching Contracted Demand': 'চুক্তিবদ্ধ চাহিদার কাছাকাছি',
    'Auto-refreshes every': 'স্বয়ংক্রিয় রিফ্রেশ প্রতিটি',
    'Average Power Factor': 'গড় পাওয়ার ফ্যাক্টর',
    'Average power factor across': 'জুড়ে গড় পাওয়ার ফ্যাক্টর',
    'Avg': 'গড়',
    'Avg Active Power': 'গড় সক্রিয় শক্তি',
    'Avg Apparent Power': 'গড় আপাত শক্তি',
    'Base Energy Charge': 'বেস এনার্জি চার্জ',
    'Based on': 'উপর ভিত্তি করে',
    'Below': 'নিচে',
    'Between': 'মধ্যে',
    'Billing': 'বিলিং',
    'Billing Cycle Peak': 'বিলিং সাইকেল পিক',
    'Billing Overview': 'বিলিং ওভারভিউ',
    'Both levels disabled': 'উভয় স্তর অক্ষম',
    'Building PDF…': 'পিডিএফ তৈরি করা হচ্ছে...',
    'CD': 'CD',
    'CD 100%': 'CD 100%',
    'CORTEX by Vireon': 'কোর্টেক্স - ভায়ারন দ্বারা',
    'CRIT': 'CRIT',
    'Call Now': 'এখনই কল করুন',
    'Call Support': 'কল সমর্থন',
    'Carbon (CO₂)': 'কার্বন (CO₂)',
    'Chargeable demand': 'চার্জযোগ্য চাহিদা',
    'Chargeable min:': 'চার্জযোগ্য ন্যূনতম:',
    'Chat on WhatsApp': 'হোয়াটসঅ্যাপে চ্যাট করুন',
    'Check back when more data is synced.': 'আরও ডেটা সিঙ্ক হলে আবার চেক করুন।',
    'Check your network or sheet sharing settings (Anyone with the link → Viewer).': 'আপনার নেটওয়ার্ক বা শীট শেয়ারিং সেটিংস পরীক্ষা করুন (লিঙ্ক সহ যে কেউ → দর্শক)।',
    'Choose a variable': 'একটি পরিবর্তনশীল চয়ন করুন',
    'Close': 'বন্ধ',
    'Close Help and Support Modal': 'সাহায্য এবং সমর্থন মডেল বন্ধ করুন',
    'Connecting…': 'সংযোগ করা হচ্ছে...',
    'Consumer': 'গ্রাহক',
    'Contact Tech Support': 'যোগাযোগ প্রযুক্তি সহায়তা',
    'Contact your administrator if you do not have one.': 'আপনার কাছে না থাকলে আপনার প্রশাসকের সাথে যোগাযোগ করুন৷',
    'Contract': 'চুক্তি',
    'Contract Demand (CD)': 'চুক্তিভিত্তিক চাহিদা (CD)',
    'Contract Demand Utilisation': 'চুক্তি চাহিদা ব্যবহার',
    'Contract demand:': 'চুক্তির চাহিদা:',
    'Contract limit': 'চুক্তির সীমা',
    'Copy Number': 'নম্বর কপি করুন',
    'Cost': 'খরচ',
    'Cost breakdown': 'খরচের বিভাজন',
    'Couldn\'t reach the data sheet': 'ডেটা শীটে পৌঁছানো যায়নি',
    'Couldn\'t refresh just now.': 'এইমাত্র রিফ্রেশ করা যায়নি.',
    'Crit': 'ক্রিট',
    'Critical': 'সমালোচনামূলক',
    'Critical above': 'উপরে সমালোচনামূলক',
    'Critical below': 'নিচে সমালোচনামূলক',
    'Critical · peak': 'সমালোচনামূলক · সর্বোচ্চ',
    'Current': 'কারেন্ট',
    'Current Imbalance': 'কারেন্ট ভারসাম্যহীনতা',
    'Current K-Factor': 'বর্তমান কে-ফ্যাক্টর',
    'Current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'বর্তমান কে-ফ্যাক্টর গুরুতর হারমোনিক লোডিং নির্দেশ করে — ট্রান্সফরমারকে অবশ্যই ডিরেটেড বা K-রেটেড ইউনিট দিয়ে প্রতিস্থাপন করতে হবে।',
    'Current status': 'বর্তমান অবস্থা',
    'Custom': 'কাস্টম',
    'Custom Alerts': 'কাস্টম সতর্কতা',
    'Custom range': 'কাস্টম পরিসীমা',
    'Customer charges': 'গ্রাহক চার্জ',
    'Daily Cost': 'দৈনিক খরচ',
    'Dashboard': 'ড্যাশবোর্ড',
    'Deep dive': 'বিস্তারিত বিশ্লেষণ',
    'Demand Penalty Applied': 'ডিমান্ড পেনাল্টি প্রযোজ্য',
    'Demand charge (billing-cycle peak)': 'চাহিদা চার্জ (বিলিং-সাইকেল সর্বোচ্চ)',
    'Demand charge is fixed from the billing cycle peak. PF rebate and LF rebate/surcharge are projected at current rates.': 'বিলিং সাইকেল পিক থেকে ডিমান্ড চার্জ নির্ধারণ করা হয়। পিএফ রিবেট এবং এলএফ রিবেট/সারচার্জ বর্তমান হারে অনুমান করা হয়।',
    'Demand charges — when Maximum Demand (MD) exceeds Contract Demand (CD)': 'ডিমান্ড চার্জ - যখন সর্বোচ্চ চাহিদা (MD) চুক্তির চাহিদা (CD) ছাড়িয়ে যায়',
    'Demands under CD pay standard rates on chargeable kVA. Exceeding CD triggers a': 'সিডির অধীনে চাহিদাগুলি চার্জযোগ্য কেভিএ-তে স্ট্যান্ডার্ড রেট প্রদান করে। সিডি ছাড়িয়ে যাওয়া a',
    'Detected on most recent reading': 'সবচেয়ে সাম্প্রতিক পড়া সনাক্ত',
    'Disabled — no notifications': 'অক্ষম - কোন বিজ্ঞপ্তি নেই',
    'Download Bill': 'বিল ডাউনলোড করুন',
    'Download Bill PDF': 'বিল PDF ডাউনলোড করুন',
    'Download Log': 'ডাউনলোড লগ',
    'Download PDF': 'পিডিএফ ডাউনলোড',
    'Download a printable daily log · Accumulated kWh, Power Factor per hour': 'একটি মুদ্রণযোগ্য দৈনিক লগ ডাউনলোড করুন · সঞ্চিত kWh, পাওয়ার ফ্যাক্টর প্রতি ঘন্টা',
    'Edge Node · Raspberry Pi Health': 'এজ নোড · রাস্পবেরি পাই স্বাস্থ্য',
    'Electricity Duty (projected)': 'বিদ্যুৎ শুল্ক (প্রকল্পিত)',
    'Elevated current THD — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress and overheating.': 'এলিভেটেড কারেন্ট THD — নন-লিনিয়ার লোড (ভিএফডি, ইউপিএস, ড্রাইভ) নির্দেশ করে যা ট্রান্সফরমার স্ট্রেস এবং অতিরিক্ত গরম করে।',
    'Elevated voltage THD — can damage capacitors, transformers, and sensitive equipment. IEEE 519 limit is 8%.': 'এলিভেটেড ভোল্টেজ THD — ক্যাপাসিটর, ট্রান্সফরমার এবং সংবেদনশীল সরঞ্জামের ক্ষতি করতে পারে। IEEE 519 সীমা 8%।',
    'Email Support': 'ইমেল সমর্থন',
    'Energy': 'শক্তি',
    'Energy Charges · Time-of-Day Split': 'এনার্জি চার্জ · দিনের সময় বিভাজন',
    'Energy by Time-of-Day': 'দিনের সময় অনুযায়ী শক্তি',
    'Energy charges + Demand charges + Electricity Duty + Customer charges · accumulated till date': 'এনার্জি চার্জ + ডিমান্ড চার্জ + ইলেকট্রিসিটি ডিউটি + কাস্টমার চার্জ · আজ পর্যন্ত জমা',
    'Energy charges + Power Factor adjustment + Load Factor rebates + Demand charges + Electricity Duty + Meter rental · accumulated till date': 'এনার্জি চার্জ + পাওয়ার ফ্যাক্টর অ্যাডজাস্টমেন্ট + লোড ফ্যাক্টর রিবেট + ডিমান্ড চার্জ + ইলেকট্রিসিটি ডিউটি + মিটার ভাড়া · আজ পর্যন্ত জমা',
    'Energy charges accumulated by tariff period': 'ট্যারিফ সময়কাল দ্বারা সঞ্চিত শক্তি চার্জ',
    'Energy delivered': 'শক্তি সরবরাহ করা হয়েছে',
    'Enter the access password for your site.': 'আপনার সাইটের জন্য অ্যাক্সেস পাসওয়ার্ড লিখুন.',
    'Enter your access password': 'আপনার অ্যাক্সেস পাসওয়ার্ড লিখুন',
    'Failed to copy phone number.': 'ফোন নম্বর কপি করতে ব্যর্থ হয়েছে.',
    'Fires when PF drops below threshold — attracts utility penalty.': 'PF থ্রেশহোল্ডের নিচে নেমে গেলে ট্রিগার হয় — ইউটিলিটি পেনাল্টি আকর্ষণ করে।',
    'Fires when current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'যখন বর্তমান কে-ফ্যাক্টর গুরুতর হারমোনিক লোডিং নির্দেশ করে তখন ট্রিগার হয় — ট্রান্সফরমারকে অবশ্যই ডিরেটেড বা K-রেটেড ইউনিট দিয়ে প্রতিস্থাপন করতে হবে।',
    'Fires when current THD exceeds safe levels — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress.': 'বর্তমান THD নিরাপদ মাত্রা ছাড়িয়ে গেলে ট্রিগার হয় — ট্রান্সফরমার স্ট্রেস সৃষ্টি করে নন-লিনিয়ার লোড (ভিএফডি, ইউপিএস, ড্রাইভ) নির্দেশ করে।',
    'Fires when load % nears or exceeds the contracted demand limit.': 'যখন লোড % চুক্তিকৃত চাহিদা সীমার কাছাকাছি বা অতিক্রম করে তখন ট্রিগার হয়।',
    'Fires when neutral conductor carries excess current — fire risk.': 'ট্রিগার হয় যখন নিরপেক্ষ পরিবাহী অতিরিক্ত কারেন্ট বহন করে — আগুনের ঝুঁকি।',
    'Fires when phase current imbalance exceeds threshold.': 'ফেজ কারেন্ট ভারসাম্যহীনতা থ্রেশহোল্ড অতিক্রম করলে ট্রিগার হয়।',
    'Fires when voltage K-Factor exceeds transformer derating limits — K>4 requires K-rated transformer.': 'ভোল্টেজ কে-ফ্যাক্টর ট্রান্সফরমার ডিরেটিং সীমা ছাড়িয়ে গেলে ট্রিগার হয় — K>4-এর জন্য K-রেটেড ট্রান্সফরমার প্রয়োজন।',
    'Fires when voltage THD exceeds safe levels — can damage capacitors, transformers, and sensitive equipment.': 'ভোল্টেজ THD নিরাপদ মাত্রা ছাড়িয়ে গেলে ট্রিগার হয় — ক্যাপাসিটর, ট্রান্সফরমার এবং সংবেদনশীল সরঞ্জামের ক্ষতি করতে পারে।',
    'Frequency': 'ফ্রিকোয়েন্সি',
    'Frequently asked questions & tech support': 'প্রায়শই জিজ্ঞাসিত প্রশ্ন এবং প্রযুক্তি সহায়তা',
    'Full': 'পূর্ণ',
    'Get support directly on WhatsApp chat': 'হোয়াটসঅ্যাপ চ্যাটে সরাসরি সমর্থন পান',
    'Help & Support': 'সাহায্য ও সমর্থন',
    'Hide code': 'কোড লুকান',
    'High': 'উচ্চ',
    'High Current Harmonic Distortion': 'উচ্চ বর্তমান হারমোনিক বিকৃতি',
    'High Current K-Factor': 'উচ্চ কারেন্ট কে-ফ্যাক্টর',
    'High Voltage Harmonic Distortion': 'উচ্চ ভোল্টেজ হারমোনিক বিকৃতি',
    'High Voltage K-Factor': 'উচ্চ ভোল্টেজ কে-ফ্যাক্টর',
    'High neutral current — possible fire risk from unbalanced phases or loose neutral.': 'উচ্চ নিরপেক্ষ কারেন্ট - ভারসাম্যহীন পর্যায় বা আলগা নিরপেক্ষ থেকে সম্ভাব্য আগুনের ঝুঁকি।',
    'Hourly Power Log · PDF': 'প্রতি ঘণ্টায় পাওয়ার লগ · পিডিএফ',
    'Insufficient data': 'অপর্যাপ্ত তথ্য',
    'Intraday Bill': 'ইন্ট্রাডে বিল',
    'K-Factor': 'কে-ফ্যাক্টর',
    'K-Factor distribution · sample count per unit band': 'কে-ফ্যাক্টর বিতরণ · ইউনিট ব্যান্ড প্রতি নমুনা গণনা',
    'LF Adjustment (projected)': 'এলএফ সামঞ্জস্য (প্রকল্পিত)',
    'LF Penalty (projected)': 'এলএফ পেনাল্টি (অনুমানিত)',
    'LF Rebate (projected)': 'এলএফ রিবেট (অনুমানিত)',
    'Last 24 hours': 'গত 24 ঘন্টা',
    'Last 24 hours · kW (active) and kVA (apparent)': 'গত 24 ঘন্টা · kW (সক্রিয়) এবং kVA (আপাত)',
    'Last 30 days': 'গত 30 দিন',
    'Last 5 instances · all time': 'শেষ ৫টি দৃষ্টান্ত · সব সময়',
    'Last refresh': 'শেষ রিফ্রেশ',
    'Live': 'লাইভ',
    'Live Power Factor': 'লাইভ পাওয়ার ফ্যাক্টর',
    'Live status, risk indicators and threshold breach density.': 'লাইভ স্ট্যাটাস, ঝুঁকি সূচক এবং থ্রেশহোল্ড লঙ্ঘনের ঘনত্ব।',
    'Load Factor': 'লোড ফ্যাক্টর',
    'Load Factor (LF) rebate / surcharge — applied per kWh consumed': 'লোড ফ্যাক্টর (LF) রিবেট / সারচার্জ — প্রতি kWh খরচ করা হয়',
    'Load Factor Adjustment': 'লোড ফ্যাক্টর অ্যাডজাস্টমেন্ট',
    'Load Factor Penalty': 'লোড ফ্যাক্টর পেনাল্টি',
    'Load Factor Rebate': 'লোড ফ্যাক্টর রিবেট',
    'Load Factor Utilisation': 'লোড ফ্যাক্টর ব্যবহার',
    'Load Factor adjustment MTD': 'লোড ফ্যাক্টর সমন্বয় MTD',
    'Load percentage nearing or exceeding contracted demand limit.': 'লোড শতাংশের কাছাকাছি বা চুক্তিকৃত চাহিদা সীমা অতিক্রম.',
    'Loading…': 'লোড হচ্ছে...',
    'Low Power Factor': 'লো পাওয়ার ফ্যাক্টর',
    'MD Peak': 'এমডি পিক',
    'Max': 'সর্বোচ্চ',
    'Max Demand Analysis': 'সর্বোচ্চ চাহিদা বিশ্লেষণ',
    'Max Demand by Time-of-Day Period': 'দিনের সময়কাল অনুসারে সর্বোচ্চ চাহিদা',
    'Max current K-Factor across phases — rates transformer derating for harmonic loads': 'পর্যায় জুড়ে সর্বাধিক বর্তমান কে-ফ্যাক্টর — হারমোনিক লোডের জন্য ট্রান্সফরমার ডিরেটিং করে',
    'Max voltage K-Factor across phases — rates transformer derating for harmonic loads': 'পর্যায় জুড়ে সর্বোচ্চ ভোল্টেজ কে-ফ্যাক্টর — হারমোনিক লোডের জন্য ট্রান্সফরমারের হার',
    'Maximum demand': 'সর্বোচ্চ চাহিদা',
    'Meter overview': 'মিটার ওভারভিউ',
    'Meter rental': 'মিটার ভাড়া',
    'Metered': 'মিটারযুক্ত',
    'Meters discovered': 'আবিষ্কৃত মিটার',
    'Metrics · last 5 alerts': 'মেট্রিক্স · শেষ ৫টি সতর্কতা',
    'Min': 'মিন',
    'Mon-Sat. 9:00 AM - 6:00 PM IST': 'সোম-শনি। 9:00 AM - 6:00 PM IST',
    'Month-to-Date': 'মাস থেকে তারিখ',
    'Month-to-Date Cost': 'মাস থেকে তারিখ খরচ',
    'Month-to-date bill for': 'মাসের জন্য তারিখ বিল',
    'Most recent 5 breach events · reflects your current thresholds': 'সাম্প্রতিক 5টি লঙ্ঘনের ঘটনা · আপনার বর্তমান থ্রেশহোল্ডগুলিকে প্রতিফলিত করে৷',
    'Must stay': 'থাকতেই হবে',
    'Near limit': 'সীমার কাছাকাছি',
    'Net cost today': 'আজ নেট খরচ',
    'Neutral Current': 'নিরপেক্ষ স্রোত',
    'Neutral zone': 'নিরপেক্ষ অঞ্চল',
    'No adj.': 'কোন adj.',
    'No adjustment': 'কোনো সমন্বয় নেই',
    'No alerts found': 'কোন সতর্কতা পাওয়া যায়নি',
    'No breach events with current thresholds': 'বর্তমান থ্রেশহোল্ডের সাথে কোন লঙ্ঘনের ঘটনা নেই',
    'No breaches on latest reading': 'সর্বশেষ পড়া উপর কোন লঙ্ঘন',
    'No data': 'কোন তথ্য নেই',
    'No data available yet.': 'এখনও কোন তথ্য উপলব্ধ.',
    'No data for': 'জন্য কোন তথ্য',
    'No data for this day': 'এই দিনের জন্য কোন তথ্য নেই',
    'No data for this meter yet': 'এই মিটারের জন্য এখনও কোন ডেটা নেই',
    'No data for this window': 'এই উইন্ডোর জন্য কোন ডেটা নেই',
    'No data in the last 24 hours': 'গত 24 ঘন্টার মধ্যে কোন তথ্য নেই',
    'No rebate': 'কোন ছাড় নেই',
    'No samples in': 'মধ্যে কোন নমুনা',
    'No variables match your search.': 'কোন ভেরিয়েবল আপনার অনুসন্ধান মেলে না.',
    'None (WBSEDCL B-IDIT)': 'কোনটিই নয় (WBSEDCL B-IDIT)',
    'Normal': 'স্বাভাবিক',
    'Normal demand charge': 'সাধারণ চাহিদা চার্জ',
    'Normal · peak': 'সাধারণ · সর্বোচ্চ',
    'Notify via': 'মাধ্যমে অবহিত করুন',
    'Off-Peak': 'অফ-পিক',
    'Open dashboard': 'ড্যাশবোর্ড খুলুন',
    'PDF BI': 'PDF BI',
    'PDF columns BE / BF / BG · max of all 15-min averaged blocks per period': 'পিডিএফ কলাম BE / BF / BG · প্রতি পিরিয়ডের 15 মিনিটের গড় ব্লকের সর্বাধিক',
    'PF Adjustment (projected)': 'পিএফ সামঞ্জস্য (প্রকল্পিত)',
    'PF Penalty (projected)': 'পিএফ পেনাল্টি (প্রকল্পিত)',
    'PF Penalty / Rebate': 'পিএফ পেনাল্টি/ রিবেট',
    'PF Rebate (projected)': 'পিএফ রিবেট (প্রকল্পিত)',
    'PF rebate / penalty MTD': 'PF রিবেট / পেনাল্টি MTD',
    'Password': 'পাসওয়ার্ড',
    'Peak': 'পিক',
    'Peak clipped': 'পিক ক্লিপড',
    'Peak kVA': 'পিক কেভিএ',
    'Penalty': 'পেনাল্টি',
    'Penalty <': 'শাস্তি <',
    'Penalty likely': 'শাস্তির সম্ভাবনা',
    'Penalty zone': 'পেনাল্টি জোন',
    'Per-phase': 'প্রতি-পর্যায়ে',
    'Phase': 'পর্যায়',
    'Phase B Current': 'ফেজ B বর্তমান',
    'Phase B Power': 'পর্যায় বি শক্তি',
    'Phase B line current': 'ফেজ বি লাইন কারেন্ট',
    'Phase R Current': 'ফেজ R বর্তমান',
    'Phase R Power': 'ফেজ আর পাওয়ার',
    'Phase R line current': 'ফেজ R লাইন বর্তমান',
    'Phase Y Current': 'ফেজ ওয়াই কারেন্ট',
    'Phase Y Power': 'ফেজ ওয়াই পাওয়ার',
    'Phase Y line current': 'ফেজ Y লাইন বর্তমান',
    'Phase current': 'ফেজ বর্তমান',
    'Phase current imbalance — indicates uneven load distribution across phases.': 'ফেজ বর্তমান ভারসাম্যহীনতা — পর্যায় জুড়ে অসম লোড বন্টন নির্দেশ করে।',
    'Phase voltage (L-N)': 'ফেজ ভোল্টেজ (L-N)',
    'Phase voltage imbalance — can damage motors and reduce equipment life.': 'ফেজ ভোল্টেজ ভারসাম্যহীনতা - মোটর ক্ষতি করতে পারে এবং সরঞ্জাম জীবন কমাতে পারে।',
    'Phone number copied to clipboard.': 'ক্লিপবোর্ডে ফোন নম্বর কপি করা হয়েছে।',
    'Pi CPU Usage': 'পাই সিপিইউ ব্যবহার',
    'Pi Memory Usage': 'পাই মেমরি ব্যবহার',
    'Pi Temperature': 'পাই তাপমাত্রা',
    'Pi Temperature · Last 24 h': 'পাই তাপমাত্রা · শেষ 24 ঘন্টা',
    'Power': 'বিদ্যুৎ',
    'Power Analysis': 'বিদ্যুৎ বিশ্লেষণ',
    'Power Factor': 'পাওয়ার ফ্যাক্টর',
    'Power Factor (Month-to-Date)': 'পাওয়ার ফ্যাক্টর (মাস থেকে তারিখ)',
    'Power Factor (PF) adjustment — applied as % of energy charge per ToD period': 'পাওয়ার ফ্যাক্টর (PF) সমন্বয় — প্রতি ToD সময়কালে শক্তি চার্জের % হিসাবে প্রয়োগ করা হয়',
    'Power Factor Adjustment': 'পাওয়ার ফ্যাক্টর অ্যাডজাস্টমেন্ট',
    'Power Factor Penalty': 'পাওয়ার ফ্যাক্টর পেনাল্টি',
    'Power Factor Rebate': 'পাওয়ার ফ্যাক্টর রিবেট',
    'Power Factor rebate / penalty MTD': 'পাওয়ার ফ্যাক্টর রিবেট / পেনাল্টি MTD',
    'Power factor below threshold — attracting TGSPDCL RKVAH penalty on energy bill.': 'থ্রেশহোল্ডের নিচে পাওয়ার ফ্যাক্টর — এনার্জি বিলে TGSPDCL RKVAH পেনাল্টি আকর্ষণ করছে।',
    'Production build · v1.0': 'উৎপাদন বিল্ড · v1.0',
    'Projected Bill': 'প্রজেক্টেড বিল',
    'Projected Bill · Month-End Estimate': 'প্রজেক্টেড বিল · মাস-শেষের অনুমান',
    'Projected energy charge (gross)': 'অভিক্ষিপ্ত শক্তি চার্জ (গ্রস)',
    'Projected net payable by due date': 'নির্ধারিত তারিখের মধ্যে প্রজেক্টেড নেট প্রদেয়',
    'Projection uses a linear run-rate from': 'অভিক্ষেপ থেকে একটি রৈখিক রান-রেট ব্যবহার করে',
    'RAM Usage (%)': 'RAM ব্যবহার (%)',
    'Raspberry Pi CPU temperature': 'রাস্পবেরি পাই সিপিইউ তাপমাত্রা',
    'Raspberry Pi CPU utilisation': 'রাস্পবেরি পাই সিপিইউ ব্যবহার',
    'Raspberry Pi Gateway': 'রাস্পবেরি পাই গেটওয়ে',
    'Raspberry Pi memory utilisation': 'রাস্পবেরি পাই মেমরি ব্যবহার',
    'Rebate': 'রিবেট',
    'Rebate earned': 'রিবেট অর্জিত',
    'Rebate zone': 'রিবেট জোন',
    'Refresh': 'রিফ্রেশ',
    'Refresh interval': 'রিফ্রেশ অন্তরাল',
    'Remove this rule': 'এই নিয়ম সরান',
    'Response time usually within 2 hours': 'প্রতিক্রিয়া সময় সাধারণত 2 ঘন্টার মধ্যে',
    'Rules saved on this device. Production build routes notifications via SMS and WhatsApp.': 'এই ডিভাইসে নিয়ম সংরক্ষিত. এসএমএস এবং হোয়াটসঅ্যাপের মাধ্যমে প্রোডাকশন বিল্ড রুট বিজ্ঞপ্তি।',
    'Running daily energy cost (₹)': 'চলমান দৈনিক শক্তি খরচ (₹)',
    'Running maximum of kVA averaged over 15 minutes window': 'সর্বোচ্চ kVA রানিং 15 মিনিটের বেশি উইন্ডো',
    'Running session energy (kWh)': 'চলমান সেশন শক্তি (kWh)',
    'SAFE': 'নিরাপদ',
    'Safe': 'নিরাপদ',
    'Samples loaded': 'লোড করা নমুনা',
    'Save Alert Rules': 'সতর্কতা নিয়ম সংরক্ষণ করুন',
    'Search variables…': 'ভেরিয়েবল অনুসন্ধান করুন...',
    'Select Language': 'ভাষা নির্বাচন করুন',
    'Select a date range above': 'উপরে একটি তারিখ পরিসীমা নির্বাচন করুন',
    'Select billing period': 'বিলিং সময়কাল নির্বাচন করুন',
    'Select language': 'ভাষা নির্বাচন করুন',
    'Select meter': 'মিটার নির্বাচন করুন',
    'Send Email': 'ইমেইল পাঠান',
    'Session Energy': 'সেশন এনার্জি',
    'Session carbon footprint (kg CO₂)': 'সেশন কার্বন ফুটপ্রিন্ট (কেজি CO₂)',
    'Settings': 'সেটিংস',
    'Share': 'শেয়ার করুন',
    'Show code': 'কোড দেখান',
    'Showing': 'দেখাচ্ছে',
    'Showing cached data — we\'ll keep retrying automatically.': 'ক্যাশে করা ডেটা দেখানো হচ্ছে — আমরা স্বয়ংক্রিয়ভাবে আবার চেষ্টা করতে থাকব।',
    'Showing month-to-date charges': 'মাস-টু-ডেট চার্জ দেখানো হচ্ছে',
    'Showing today\'s charges': 'আজকের চার্জ দেখানো হচ্ছে',
    'Sign out': 'সাইন আউট',
    'Similar to average': 'গড় অনুরূপ',
    'Similar to this week\'s average': 'এই সপ্তাহের গড় অনুরূপ',
    'Since midnight IST · updates every 5 min': 'মধ্যরাত থেকে IST · প্রতি 5 মিনিটে আপডেট হয়৷',
    'Site': 'সাইট',
    'Sum of all phase currents': 'সমস্ত ফেজ স্রোতের সমষ্টি',
    'Surcharge': 'সারচার্জ',
    'THD distribution · sample count per 2% band': 'THD বিতরণ · প্রতি 2% ব্যান্ডে নমুনা গণনা',
    'Telangana': 'তেলেঙ্গানা',
    'Temperature (°C)': 'তাপমাত্রা (°সে)',
    'This Month': 'এই মাস',
    'This week (Sun – yesterday)': 'এই সপ্তাহে (রবি - গতকাল)',
    'Threshold': 'থ্রেশহোল্ড',
    'Time distribution': 'সময় বন্টন',
    'Time-of-Day Split': 'টাইম-অফ-ডে স্প্লিট',
    'Timely Payment Rebate': 'সময়মত পেমেন্ট রিবেট',
    'ToD Off-Peak Rebate': 'ToD অফ-পিক রিবেট',
    'ToD Peak Penalty': 'ToD পিক পেনাল্টি',
    'Today': 'আজ',
    'Today PF': 'আজ পিএফ',
    'Today is': 'আজ হল',
    'Today\'s Cost': 'আজকের খরচ',
    'Today\'s Running Cost': 'আজকের চলমান খরচ',
    'Total': 'মোট',
    'Total Active Power': 'মোট সক্রিয় শক্তি',
    'Total Apparent Power': 'মোট আপাত শক্তি',
    'Total Current': 'মোট বর্তমান',
    'Total Energy (kWh) consumed last month / (Peak kW observed last month times number of hours last month)': 'গত মাসে খরচ করা মোট শক্তি (kWh)',
    'Total Energy (kWh) consumed this month / (Peak kW observed this month times number of hours this month)': 'এই মাসে খরচ হওয়া মোট শক্তি (kWh)',
    'Total Energy (kWh) consumed this week / (Peak kW observed this week times number of hours this week)': 'এই সপ্তাহে খরচ করা মোট শক্তি (kWh)',
    'Total Energy (kWh) consumed today/ (Peak kW observed today times number of hours today)': 'মোট শক্তি (kWh) আজ খরচ হয়েছে/ (আজকে সর্বোচ্চ কিলোওয়াট পর্যবেক্ষন করা হয়েছে, আজকের ঘণ্টার সংখ্যা)',
    'Total Energy Charge': 'মোট শক্তি চার্জ',
    'Total Harmonic Distortion (%)': 'মোট হারমোনিক বিকৃতি (%)',
    'Total Watts': 'মোট ওয়াট',
    'Total active power across all phases': 'সমস্ত পর্যায় জুড়ে মোট সক্রিয় শক্তি',
    'Total apparent power (kVA)': 'মোট আপাত শক্তি (kVA)',
    'Total demand cost': 'মোট চাহিদা খরচ',
    'Total instantaneous power in watts': 'ওয়াটে মোট তাৎক্ষণিক শক্তি',
    'Try again': 'আবার চেষ্টা করুন',
    'Try another meter or wait for the next refresh.': 'অন্য মিটার চেষ্টা করুন বা পরবর্তী রিফ্রেশের জন্য অপেক্ষা করুন।',
    'Use one of the access codes provided for your site.': 'আপনার সাইটের জন্য প্রদত্ত অ্যাক্সেস কোডগুলির একটি ব্যবহার করুন।',
    'Utilisation %': 'ব্যবহার %',
    'Voltage': 'ভোল্টেজ',
    'Voltage Imbalance': 'ভোল্টেজ ভারসাম্যহীনতা',
    'Voltage K-Factor': 'ভোল্টেজ কে-ফ্যাক্টর',
    'Voltage K-Factor exceeds transformer derating limit — K>4 requires a K-rated transformer.': 'ভোল্টেজ কে-ফ্যাক্টর ট্রান্সফরমার ডিরেটিং সীমা ছাড়িয়ে গেছে — K>4-এর জন্য K-রেটেড ট্রান্সফরমার প্রয়োজন।',
    'WARN': 'সতর্ক করুন',
    'Warn': 'সতর্ক করুন',
    'Warning': 'সতর্কতা',
    'Warning above': 'উপরে সতর্কতা',
    'Warning below': 'নীচে সতর্কতা',
    'Warning · peak': 'সতর্কতা · সর্বোচ্চ',
    'WhatsApp Support': 'হোয়াটসঅ্যাপ সমর্থন',
    'Within Limit': 'সীমার মধ্যে',
    'Worst': 'সবচেয়ে খারাপ',
    'Yesterday': 'গতকাল',
    'above': 'উপরে',
    'above CD': 'সিডির উপরে',
    'above this week\'s avg': 'এই সপ্তাহের গড় উপরে',
    'above this week\'s avg — good day': 'এই সপ্তাহের গড় উপরে — শুভ দিন',
    'active': 'সক্রিয়',
    'active issue': 'সক্রিয় সমস্যা',
    'active issues': 'সক্রিয় সমস্যা',
    'added to bill': 'বিলে যোগ করা হয়েছে',
    'added to this month\'s bill': 'এই মাসের বিলে যোগ করা হয়েছে',
    'adjustment': 'সমন্বয়',
    'all charges finalised.': 'সব চার্জ চূড়ান্ত।',
    'and': 'এবং',
    'applied for Load Factor ≥ 65%': 'লোড ফ্যাক্টরের জন্য আবেদন করা হয়েছে ≥ 65%',
    'average': 'গড়',
    'avg': 'গড়',
    'below': 'নীচে',
    'below average': 'গড়ের নিচে',
    'below min → charged on': 'মিনিটের নিচে → চার্জ করা হয়েছে',
    'below this week\'s avg': 'এই সপ্তাহের গড় নীচে',
    'below this week\'s avg — below average': 'এই সপ্তাহের গড় - গড়ের নিচে',
    'consumers under TOD Tariff (CD > 50 kVA); % of energy charge per ToD period': 'TOD ট্যারিফের অধীনে গ্রাহকরা (CD > 50 kVA); প্রতি ToD সময়কালে শক্তি চার্জের %',
    'critical': 'সমালোচনামূলক',
    'current': 'বর্তমান',
    'day bill for': 'জন্য দিনের বিল',
    'day run rate': 'দিনের রান রেট',
    'days': 'দিন',
    'days of actual data.': 'প্রকৃত তথ্য দিন।',
    'days of meter data': 'মিটার ডেটার দিন',
    'days remaining': 'দিন বাকি',
    'days required for': 'দিনের জন্য প্রয়োজনীয়',
    'deducted from bill': 'বিল থেকে কাটা',
    'deducted from this month\'s bill': 'এই মাসের বিল থেকে কাটা',
    'delivered': 'বিতরণ করা',
    'energy charges, Power Factor & Load Factor adjustments, demand charge, duties, and projected net payable.': 'এনার্জি চার্জ, পাওয়ার ফ্যাক্টর এবং লোড ফ্যাক্টর অ্যাডজাস্টমেন্ট, ডিমান্ড চার্জ, ডিউটি, এবং প্রজেক্টেড নেট প্রদেয়।',
    'energy per day': 'প্রতিদিন শক্তি',
    'energy per hour': 'প্রতি ঘন্টা শক্তি',
    'excess above CD': 'সিডির উপরে অতিরিক্ত',
    'fires when <': 'ট্রিগার হয় যখন <',
    'fires when >': 'ট্রিগার হয় যখন >',
    'good day': 'শুভ দিন',
    'if paid after 15 days': 'যদি 15 দিন পরে অর্থ প্রদান করা হয়',
    'if paid by due date': 'নির্ধারিত তারিখের মধ্যে পরিশোধ করা হলে',
    'imbal': 'imbal',
    'invoice estimate': 'চালান অনুমান',
    'is above this week\'s avg': 'এই সপ্তাহের গড় থেকে উপরে',
    'is below this week\'s avg': 'এই সপ্তাহের গড় থেকে নিচে',
    'kVA/month': 'kVA/মাস',
    'kVAh': 'kVAh',
    'kWh': 'kWh',
    'limit': 'সীমা',
    'meter': 'মিটার',
    'meters': 'মিটার',
    'min demand applies': 'ন্যূনতম চাহিদা প্রযোজ্য',
    'month': 'মাস',
    'month-to-date': 'মাস থেকে তারিখ',
    'net incl. all charges': 'নেট সহ সব চার্জ',
    'net today': 'নেট আজ',
    'never': 'কখনই',
    'no adj.': 'কোন adj',
    'no adjustment': 'কোন সমন্বয় না',
    'no adjustment applicable': 'কোন সমন্বয় প্রযোজ্য',
    'no adjustment today': 'আজ কোন সমন্বয় নেই',
    'nom': 'নাম',
    'not yet applicable today': 'আজ পর্যন্ত প্রযোজ্য নয়',
    'of': 'এর',
    'of 24 hours have data': '24 ঘন্টা তথ্য আছে',
    'of CD': 'CD এর',
    'of bill': 'বিলের',
    'of gross bill': 'স্থূল বিলের',
    'of net bill': 'নেট বিলের',
    'off': 'বন্ধ',
    'on the excess kVA.': 'অতিরিক্ত কেভিএ এর উপর।',
    'over-threshold': 'ওভার-থ্রেশহোল্ড',
    'paise/kVAh  (6p flat)': 'পয়সা/কেভিএএইচ (6p ফ্ল্যাট)',
    'paise/kWh rebate': 'পয়সা/কিলোওয়াট রিবেট',
    'paise/kWh surcharge': 'পয়সা/কিলোওয়াট সারচার্জ',
    'peak kVA': 'পিক কেভিএ',
    'peak kVA today': 'পিক কেভিএ আজ',
    'penalty': 'শাস্তি',
    'projected penalty': 'প্রত্যাশিত শাস্তি',
    'projected rebate': 'প্রক্ষিপ্ত রিবেট',
    'projected surcharge': 'অভিক্ষিপ্ত সারচার্জ',
    'readings': 'রিডিং',
    'readings · 3 phases': 'রিডিং · 3 পর্যায়',
    'rebate': 'রিবেট',
    'rebate / kWh': 'রিবেট / kWh',
    'rebate earned': 'রিবেট অর্জিত',
    's': 's',
    's when the tab is visible.': 's যখন ট্যাব দৃশ্যমান হয়।',
    'samples': 'নমুনা',
    'surcharge': 'সারচার্জ',
    'surcharge / kWh': 'সারচার্জ / kWh',
    'surcharge added to bill': 'সারচার্জ বিল যোগ করা হয়েছে',
    'surcharge applied': 'সারচার্জ প্রযোজ্য',
    'threshold': 'প্রান্তিক',
    'to': 'থেকে',
    'units consumed so far': 'এখনও পর্যন্ত ব্যবহৃত ইউনিট',
    'updated every 5 min': 'প্রতি 5 মিনিটে আপডেট করা হয়',
    'updating…': 'আপডেট হচ্ছে...',
    'warn': 'সতর্ক করা',
    '· added to bill today': 'আজ বিল যোগ করা হয়েছে',
    '· saving deducted today': '· সঞ্চয় আজ কাটা হয়েছে',
    '· surcharge added today': 'সারচার্জ আজ যোগ করা হয়েছে',
    '— · awaiting data': '— · তথ্যের অপেক্ষায়',
    '≥': '≥',
    '⚠ No Pi telemetry in current data — fields piTempC / piMemPct not populated': '⚠ বর্তমান ডেটাতে কোনও পাই টেলিমেট্রি নেই — ক্ষেত্রগুলি piTempC / piMemPct জনবহুল নয়',
    '⚠️ Thermal throttle active — Pi is running hot, performance reduced': '⚠️ থার্মাল থ্রটল সক্রিয় — পাই গরম চলছে, কর্মক্ষমতা কমে গেছে',
    '✓ Rules Saved Successfully': '✓ নিয়মগুলি সফলভাবে সংরক্ষিত হয়েছে৷',
  },
  gu: {
    'This Week': 'આ સપ્તાહે',
    'Last Month': 'ગયા મહિને',
    'Sensor Dropout': 'સેન્સર ડ્રોપઆઉટ',
    'Approaching Overload': 'ઓવરલોડની નજીક',
    'Frequency Deviation': 'આવર્તન વિચલન',
    'High Voltage THD': 'ઉચ્ચ વોલ્ટેજ THD',
    'High Current THD': 'ઉચ્ચ વર્તમાન THD',
    'In-app': 'એપની અંદર',
    'SMS': 'એસએમએસ',
    'WhatsApp': 'વોટ્સએપ',
    'Min. chargeable demand': 'ન્યૂનતમ ચાર્જેબલ માંગ',
    'Demand charge — Normal': 'ડિમાન્ડ ચાર્જ — સામાન્ય',
    'Demand charge — Penal': 'ડિમાન્ડ ચાર્જ — દંડનીય',
    'Electricity duty': 'વીજળી ડ્યુટી',
    'Late payment surcharge': 'મોડી ચુકવણી સરચાર્જ',
    'Demand charge (up to CD)': 'ડિમાન્ડ ચાર્જ (CD સુધી)',
    'Generating': 'બનાવી રહ્યાં છીએ',
    'Bill PDF…': 'બિલ PDF…',
    'What is the Power Analysis Dashboard?': 'પાવર એનાલિસિસ ડેશબોર્ડ શું છે?',
    'It monitors real-time electrical metrics (voltage, current, power factor, demand, active/reactive energy) collected from Raspberry Pi edge nodes installed at the site.': 'તે સાઇટ પર ઇન્સ્ટોલ કરેલા Raspberry Pi એજ નોડ્સમાંથી એકત્રિત કરેલા રીઅલ-ટાઇમ વિદ્યુત મેટ્રિક્સ (વોલ્ટેજ, વર્તમાન, પાવર ફેક્ટર, માંગ, એક્ટિવ/રિએક્ટિવ ઊર્જા) મોનિટર કરે છે.',
    'What do the green/orange/red indicators mean?': 'લીલા/નારંગી/લાલ સૂચકોનો અર્થ શું છે?',
    'Green means the Raspberry Pi edge node is online and reporting health telemetry normally. Orange/red indicate potential communication delays or high temperature/resource throttling.': 'લીલો રંગ સૂચવે છે કે Raspberry Pi એજ નોડ ઓનલાઇન છે અને સામાન્ય રીતે હેલ્થ ટેલિમેટ્રી રિપોર્ટ કરી રહ્યું છે. નારંગી/લાલ સંભવિત સંચાર વિલંબ અથવા ઉચ્ચ તાપમાન/સંસાધન થ્રોટલિંગ સૂચવે છે.',
    'How are billing demand charges calculated?': 'બિલિંગ ડિમાન્ડ ચાર્જની ગણતરી કેવી રીતે થાય છે?',
    'Demand charges are based on the Maximum Demand (MD) recorded in 15-minute integration windows, calculated according to the active tariff structure (e.g., TGSPDCL HT or WBSEDCL B-IDIT).': 'ડિમાન્ડ ચાર્જ 15-મિનિટના ઇન્ટિગ્રેશન વિન્ડોમાં નોંધાયેલ મહત્તમ માંગ (MD) પર આધારિત છે, જે સક્રિય ટેરિફ સ્ટ્રક્ચર (દા.ત., TGSPDCL HT અથવા WBSEDCL B-IDIT) અનુસાર ગણવામાં આવે છે.',
    'What should I do if the dashboard shows "No data"?': 'જો ડેશબોર્ડ "કોઈ ડેટા નથી" બતાવે તો મારે શું કરવું જોઈએ?',
    'Verify that the edge node (Raspberry Pi gateway) is powered on and connected to the internet. If the issue persists, contact technical support immediately.': 'ખાતરી કરો કે એજ નોડ (Raspberry Pi ગેટવે) ચાલુ છે અને ઇન્ટરનેટ સાથે જોડાયેલ છે. જો સમસ્યા ચાલુ રહે, તો તરત જ ટેકનિકલ સપોર્ટનો સંપર્ક કરો.',
    '% of readings': 'વાંચનનો %',
    '/month': '/મહિનો',
    '0.4 kV supply': '0.4 kV પુરવઠો',
    '12 AM – 12 AM': 'રાત્રે ૧૨ - રાત્રે ૧૨',
    '1st 12 AM → now': '૧ તારીખ રાત્રે ૧૨ → અત્યાર સુધી',
    '2x penalty': '2x દંડ',
    '33 kV supply': '33 kV પુરવઠો',
    'About': 'વિશે',
    'Above': 'ઉપર',
    'Across': 'પાર',
    'Active (kW)': 'સક્રિય (kW)',
    'Active Power & Apparent Power': 'સક્રિય શક્તિ અને દેખીતી શક્તિ',
    'Active power on Phase B': 'તબક્કા B પર સક્રિય શક્તિ',
    'Active power on Phase R': 'તબક્કો R પર સક્રિય શક્તિ',
    'Active power on Phase Y': 'તબક્કા Y પર સક્રિય શક્તિ',
    'Active tariff': 'સક્રિય ટેરિફ',
    'Add custom variable alert': 'કસ્ટમ ચલ ચેતવણી ઉમેરો',
    'Additional demand charge': 'વધારાની માંગ ચાર્જ',
    'Alert History': 'એલર્ટ ઇતિહાસ',
    'Alert Rules': 'ચેતવણી નિયમો',
    'Alerts': 'એલર્ટ્સ',
    'All energy/PF/LF values computed by the Cortex Pi gateway per VARIABLES.pdf §2.3 & §3. Demand, ED, rental, and TPR computed in the browser from WBSEDCL tariff constants.': 'VARIABLES.pdf §2.3 અને §3 દીઠ Cortex Pi ગેટવે દ્વારા ગણતરી કરાયેલ તમામ ઊર્જા/PF/LF મૂલ્યો. WBSEDCL ટેરિફ સ્થિરાંકોમાંથી બ્રાઉઝરમાં માંગ, ED, ભાડા અને TPRની ગણતરી કરવામાં આવે છે.',
    'All systems normal': 'બધી સિસ્ટમો સામાન્ય',
    'Anomalies': 'વિસંગતતાઓ',
    'Anomaly': 'વિસંગતતા',
    'Apparent': 'આભાસી ઊર્જા',
    'Apparent (kVA)': 'સ્પષ્ટ (kVA)',
    'Approaching Contracted Demand': 'કોન્ટ્રાક્ટેડ ડિમાન્ડનો સંપર્ક કરવો',
    'Auto-refreshes every': 'દરેક સ્વતઃ તાજું કરે છે',
    'Average Power Factor': 'સરેરાશ પાવર ફેક્ટર',
    'Average power factor across': 'સમગ્ર સરેરાશ પાવર પરિબળ',
    'Avg': 'સરેરાશ',
    'Avg Active Power': 'સરેરાશ સક્રિય શક્તિ',
    'Avg Apparent Power': 'સરેરાશ દેખીતી શક્તિ',
    'Base Energy Charge': 'બેઝ એનર્જી ચાર્જ',
    'Based on': 'પર આધારિત છે',
    'Below': 'નીચે',
    'Between': 'વચ્ચે',
    'Billing': 'બિલિંગ',
    'Billing Cycle Peak': 'બિલિંગ સાયકલ પીક',
    'Billing Overview': 'બિલિંગ વિહંગાવલોકન',
    'Both levels disabled': 'બંને સ્તરો અક્ષમ છે',
    'Building PDF…': 'PDF બનાવી રહ્યાં છીએ…',
    'CD': 'CD',
    'CD 100%': 'CD 100%',
    'CORTEX by Vireon': 'કોર્ટેક્સ - વાયરન દ્વારા',
    'CRIT': 'CRIT',
    'Call Now': 'હવે કૉલ કરો',
    'Call Support': 'સપોર્ટ પર કૉલ કરો',
    'Carbon (CO₂)': 'કાર્બન (CO₂)',
    'Chargeable demand': 'ચાર્જેબલ માંગ',
    'Chargeable min:': 'ચાર્જેબલ ન્યૂનતમ:',
    'Chat on WhatsApp': 'વોટ્સએપ પર ચેટ કરો',
    'Check back when more data is synced.': 'જ્યારે વધુ ડેટા સમન્વયિત થાય ત્યારે પાછા તપાસો.',
    'Check your network or sheet sharing settings (Anyone with the link → Viewer).': 'તમારું નેટવર્ક અથવા શીટ શેરિંગ સેટિંગ્સ તપાસો (લિંક ધરાવનાર કોઈપણ → દર્શક).',
    'Choose a variable': 'એક ચલ પસંદ કરો',
    'Close': 'બંધ કરો',
    'Close Help and Support Modal': 'મદદ અને સમર્થન મોડલ બંધ કરો',
    'Connecting…': 'કનેક્ટ કરી રહ્યું છે...',
    'Consumer': 'ગ્રાહક',
    'Contact Tech Support': 'ટેક સપોર્ટનો સંપર્ક કરો',
    'Contact your administrator if you do not have one.': 'જો તમારી પાસે ન હોય તો તમારા વ્યવસ્થાપકનો સંપર્ક કરો.',
    'Contract': 'કરાર',
    'Contract Demand (CD)': 'કરાર માંગ (CD)',
    'Contract Demand Utilisation': 'કરાર માંગ ઉપયોગ',
    'Contract demand:': 'કરારની માંગ:',
    'Contract limit': 'કરાર મર્યાદા',
    'Copy Number': 'નંબરની નકલ કરો',
    'Cost': 'ખર્ચ',
    'Cost breakdown': 'ખર્ચની વિગતો',
    'Couldn\'t reach the data sheet': 'ડેટા શીટ સુધી પહોંચી શકાયું નથી',
    'Couldn\'t refresh just now.': 'હમણાં જ રિફ્રેશ કરી શકાયું નથી.',
    'Crit': 'ક્રિટ',
    'Critical': 'ક્રિટિકલ',
    'Critical above': 'ઉપર જટિલ',
    'Critical below': 'નીચે જટિલ',
    'Critical · peak': 'જટિલ · ટોચ',
    'Current': 'કરંટ',
    'Current Imbalance': 'કરંટ અસંતુલન',
    'Current K-Factor': 'વર્તમાન K- પરિબળ',
    'Current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'વર્તમાન કે-ફેક્ટર ગંભીર હાર્મોનિક લોડિંગ સૂચવે છે — ટ્રાન્સફોર્મર ડિરેટેડ હોવું જોઈએ અથવા K-રેટેડ યુનિટ સાથે બદલવું જોઈએ.',
    'Current status': 'વર્તમાન સ્થિતિ',
    'Custom': 'કસ્ટમ',
    'Custom Alerts': 'કસ્ટમ ચેતવણીઓ',
    'Custom range': 'કસ્ટમ શ્રેણી',
    'Customer charges': 'ગ્રાહક શુલ્ક',
    'Daily Cost': 'દૈનિક ખર્ચ',
    'Dashboard': 'ડેશબોર્ડ',
    'Deep dive': 'ઊંડાણપૂર્વક વિશ્લેષણ',
    'Demand Penalty Applied': 'ડિમાન્ડ પેનલ્ટી લાગુ',
    'Demand charge (billing-cycle peak)': 'ડિમાન્ડ ચાર્જ (બિલિંગ-સાયકલ પીક)',
    'Demand charge is fixed from the billing cycle peak. PF rebate and LF rebate/surcharge are projected at current rates.': 'ડિમાન્ડ ચાર્જ બિલિંગ સાયકલ ટોચ પરથી નક્કી કરવામાં આવે છે. પીએફ રિબેટ અને એલએફ રિબેટ/સરચાર્જ વર્તમાન દરો પર અંદાજવામાં આવે છે.',
    'Demand charges — when Maximum Demand (MD) exceeds Contract Demand (CD)': 'ડિમાન્ડ ચાર્જ - જ્યારે મહત્તમ માંગ (MD) કોન્ટ્રાક્ટ ડિમાન્ડ (CD) કરતાં વધી જાય',
    'Demands under CD pay standard rates on chargeable kVA. Exceeding CD triggers a': 'સીડી હેઠળની માંગણીઓ ચાર્જેબલ kVA પર માનક દર ચૂકવે છે. સીડીને ઓળંગવાથી એ',
    'Detected on most recent reading': 'સૌથી તાજેતરના વાંચન પર શોધાયેલ',
    'Disabled — no notifications': 'અક્ષમ - કોઈ સૂચનાઓ નથી',
    'Download Bill': 'બિલ ડાઉનલોડ કરો',
    'Download Bill PDF': 'બિલ PDF ડાઉનલોડ કરો',
    'Download Log': 'લોગ ડાઉનલોડ કરો',
    'Download PDF': 'PDF ડાઉનલોડ કરો',
    'Download a printable daily log · Accumulated kWh, Power Factor per hour': 'છાપવા યોગ્ય દૈનિક લોગ ડાઉનલોડ કરો · સંચિત kWh, પાવર ફેક્ટર પ્રતિ કલાક',
    'Edge Node · Raspberry Pi Health': 'એજ નોડ · રાસ્પબેરી પી આરોગ્ય',
    'Electricity Duty (projected)': 'વીજળી ડ્યુટી (અનુમાનિત)',
    'Elevated current THD — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress and overheating.': 'એલિવેટેડ કરંટ THD — નોન-લીનિયર લોડ્સ (VFDs, UPS, ડ્રાઇવ્સ) સૂચવે છે જે ટ્રાન્સફોર્મર તણાવ અને ઓવરહિટીંગનું કારણ બને છે.',
    'Elevated voltage THD — can damage capacitors, transformers, and sensitive equipment. IEEE 519 limit is 8%.': 'એલિવેટેડ વોલ્ટેજ THD — કેપેસિટર્સ, ટ્રાન્સફોર્મર્સ અને સંવેદનશીલ સાધનોને નુકસાન પહોંચાડી શકે છે. IEEE 519 મર્યાદા 8% છે.',
    'Email Support': 'ઇમેઇલ આધાર',
    'Energy': 'ઊર્જા',
    'Energy Charges · Time-of-Day Split': 'એનર્જી ચાર્જીસ · સમય-ઓફ-ડે સ્પ્લિટ',
    'Energy by Time-of-Day': 'દિવસના સમય પ્રમાણે ઊર્જા',
    'Energy charges + Demand charges + Electricity Duty + Customer charges · accumulated till date': 'એનર્જી ચાર્જીસ + ડિમાન્ડ ચાર્જીસ + ઇલેક્ટ્રિસિટી ડ્યુટી + ગ્રાહક શુલ્ક · આજ સુધી સંચિત',
    'Energy charges + Power Factor adjustment + Load Factor rebates + Demand charges + Electricity Duty + Meter rental · accumulated till date': 'એનર્જી ચાર્જીસ + પાવર ફેક્ટર એડજસ્ટમેન્ટ + લોડ ફેક્ટર રિબેટ્સ + ડિમાન્ડ ચાર્જિસ + ઇલેક્ટ્રિસિટી ડ્યુટી + મીટર રેન્ટલ · આજ સુધી સંચિત',
    'Energy charges accumulated by tariff period': 'ટેરિફ સમયગાળા દ્વારા સંચિત ઊર્જા શુલ્ક',
    'Energy delivered': 'ઊર્જા વિતરિત',
    'Enter the access password for your site.': 'તમારી સાઇટ માટે ઍક્સેસ પાસવર્ડ દાખલ કરો.',
    'Enter your access password': 'તમારો ઍક્સેસ પાસવર્ડ દાખલ કરો',
    'Failed to copy phone number.': 'ફોન નંબરની નકલ કરવામાં નિષ્ફળ.',
    'Fires when PF drops below threshold — attracts utility penalty.': 'જ્યારે PF થ્રેશોલ્ડથી નીચે જાય ત્યારે ટ્રિગર થાય છે - યુટિલિટી પેનલ્ટી આકર્ષે છે.',
    'Fires when current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'જ્યારે વર્તમાન કે-ફેક્ટર ગંભીર હાર્મોનિક લોડિંગ સૂચવે છે ત્યારે ટ્રિગર થાય છે — ટ્રાન્સફોર્મર ડિરેટેડ હોવું જોઈએ અથવા K-રેટેડ યુનિટ સાથે બદલવું જોઈએ.',
    'Fires when current THD exceeds safe levels — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress.': 'જ્યારે વર્તમાન THD સલામત સ્તરને ઓળંગે ત્યારે ટ્રિગર થાય છે - બિન-રેખીય લોડ (VFDs, UPS, ડ્રાઇવ્સ) સૂચવે છે જે ટ્રાન્સફોર્મર તણાવનું કારણ બને છે.',
    'Fires when load % nears or exceeds the contracted demand limit.': 'જ્યારે લોડ % સંકુચિત માંગ મર્યાદાની નજીક અથવા ઓળંગે ત્યારે ટ્રિગર થાય છે.',
    'Fires when neutral conductor carries excess current — fire risk.': 'જ્યારે તટસ્થ વાહક વધારે પ્રવાહ વહન કરે છે ત્યારે ટ્રિગર થાય છે - આગનું જોખમ.',
    'Fires when phase current imbalance exceeds threshold.': 'જ્યારે તબક્કા વર્તમાન અસંતુલન થ્રેશોલ્ડ કરતાં વધી જાય ત્યારે ટ્રિગર થાય છે.',
    'Fires when voltage K-Factor exceeds transformer derating limits — K>4 requires K-rated transformer.': 'જ્યારે વોલ્ટેજ K-ફેક્ટર ટ્રાન્સફોર્મરની ડિરેટિંગ મર્યાદા કરતાં વધી જાય ત્યારે ટ્રિગર થાય છે — K>4 માટે K-રેટેડ ટ્રાન્સફોર્મરની જરૂર છે.',
    'Fires when voltage THD exceeds safe levels — can damage capacitors, transformers, and sensitive equipment.': 'જ્યારે વોલ્ટેજ THD સુરક્ષિત સ્તરો કરતાં વધી જાય ત્યારે ટ્રિગર થાય છે — કેપેસિટર, ટ્રાન્સફોર્મર્સ અને સંવેદનશીલ સાધનોને નુકસાન પહોંચાડી શકે છે.',
    'Frequency': 'આવર્તન',
    'Frequently asked questions & tech support': 'વારંવાર પૂછાતા પ્રશ્નો અને ટેક સપોર્ટ',
    'Full': 'સંપૂર્ણ',
    'Get support directly on WhatsApp chat': 'સીધા WhatsApp ચેટ પર આધાર મેળવો',
    'Help & Support': 'મદદ અને સપોર્ટ',
    'Hide code': 'કોડ છુપાવો',
    'High': 'ઉચ્ચ',
    'High Current Harmonic Distortion': 'ઉચ્ચ વર્તમાન હાર્મોનિક વિકૃતિ',
    'High Current K-Factor': 'ઉચ્ચ વર્તમાન K- પરિબળ',
    'High Voltage Harmonic Distortion': 'ઉચ્ચ વોલ્ટેજ હાર્મોનિક વિકૃતિ',
    'High Voltage K-Factor': 'ઉચ્ચ વોલ્ટેજ K- પરિબળ',
    'High neutral current — possible fire risk from unbalanced phases or loose neutral.': 'ઉચ્ચ તટસ્થ પ્રવાહ - અસંતુલિત તબક્કાઓ અથવા છૂટક તટસ્થથી સંભવિત આગનું જોખમ.',
    'Hourly Power Log · PDF': 'કલાકદીઠ પાવર લોગ · PDF',
    'Insufficient data': 'અપર્યાપ્ત ડેટા',
    'Intraday Bill': 'ઇન્ટ્રાડે બિલ',
    'K-Factor': 'કે-ફેક્ટર',
    'K-Factor distribution · sample count per unit band': 'કે-ફેક્ટર વિતરણ · યુનિટ બેન્ડ દીઠ નમૂના ગણતરી',
    'LF Adjustment (projected)': 'એલએફ એડજસ્ટમેન્ટ (અનુમાનિત)',
    'LF Penalty (projected)': 'LF દંડ (અનુમાનિત)',
    'LF Rebate (projected)': 'LF રિબેટ (અનુમાનિત)',
    'Last 24 hours': 'છેલ્લા 24 કલાક',
    'Last 24 hours · kW (active) and kVA (apparent)': 'છેલ્લા 24 કલાક · kW (સક્રિય) અને kVA (સ્પષ્ટ)',
    'Last 30 days': 'છેલ્લા 30 દિવસ',
    'Last 5 instances · all time': 'છેલ્લા 5 દાખલાઓ · બધા સમય',
    'Last refresh': 'છેલ્લું રિફ્રેશ',
    'Live': 'લાઇવ',
    'Live Power Factor': 'લાઈવ પાવર ફેક્ટર',
    'Live status, risk indicators and threshold breach density.': 'જીવંત સ્થિતિ, જોખમ સૂચકાંકો અને થ્રેશોલ્ડ ભંગ ઘનતા.',
    'Load Factor': 'લોડ ફેક્ટર',
    'Load Factor (LF) rebate / surcharge — applied per kWh consumed': 'લોડ ફેક્ટર (LF) રિબેટ / સરચાર્જ — વપરાશમાં લેવાયેલા kWh દીઠ લાગુ',
    'Load Factor Adjustment': 'લોડ ફેક્ટર એડજસ્ટમેન્ટ',
    'Load Factor Penalty': 'લોડ ફેક્ટર પેનલ્ટી',
    'Load Factor Rebate': 'લોડ ફેક્ટર રિબેટ',
    'Load Factor Utilisation': 'લોડ ફેક્ટર ઉપયોગ',
    'Load Factor adjustment MTD': 'લોડ ફેક્ટર એડજસ્ટમેન્ટ MTD',
    'Load percentage nearing or exceeding contracted demand limit.': 'લોડની ટકાવારી સંકુચિત માંગ મર્યાદાની નજીક છે અથવા તેનાથી વધુ છે.',
    'Loading…': 'લોડ કરી રહ્યું છે...',
    'Low Power Factor': 'લો પાવર ફેક્ટર',
    'MD Peak': 'એમડી પીક',
    'Max': 'મહત્તમ',
    'Max Demand Analysis': 'મહત્તમ માંગ વિશ્લેષણ',
    'Max Demand by Time-of-Day Period': 'દિવસના સમય દ્વારા મહત્તમ માંગ',
    'Max current K-Factor across phases — rates transformer derating for harmonic loads': 'તબક્કાવાર મહત્તમ વર્તમાન K- પરિબળ — હાર્મોનિક લોડ માટે ટ્રાન્સફોર્મરને રેટ કરે છે',
    'Max voltage K-Factor across phases — rates transformer derating for harmonic loads': 'મેક્સ વોલ્ટેજ K- ફેક્ટર સમગ્ર તબક્કામાં - હાર્મોનિક લોડ માટે ટ્રાન્સફોર્મર રેટ કરે છે',
    'Maximum demand': 'મહત્તમ માંગ',
    'Meter overview': 'મીટર વિહંગાવલોકન',
    'Meter rental': 'મીટર ભાડા',
    'Metered': 'મીટર કરેલ',
    'Meters discovered': 'શોધાયેલ મીટર',
    'Metrics · last 5 alerts': 'મેટ્રિક્સ · છેલ્લા 5 ચેતવણીઓ',
    'Min': 'મિનિ',
    'Mon-Sat. 9:00 AM - 6:00 PM IST': 'સોમ-શનિ. 9:00 AM - 6:00 PM IST',
    'Month-to-Date': 'મહિનાથી તારીખ',
    'Month-to-Date Cost': 'મહિનાથી તારીખની કિંમત',
    'Month-to-date bill for': 'માટે મહિનાથી તારીખનું બિલ',
    'Most recent 5 breach events · reflects your current thresholds': 'સૌથી તાજેતરની 5 ઉલ્લંઘનની ઘટનાઓ · તમારા વર્તમાન થ્રેશોલ્ડને પ્રતિબિંબિત કરે છે',
    'Must stay': 'રહેવું જ જોઈએ',
    'Near limit': 'મર્યાદાની નજીક',
    'Net cost today': 'આજે ચોખ્ખી કિંમત',
    'Neutral Current': 'તટસ્થ વર્તમાન',
    'Neutral zone': 'તટસ્થ ઝોન',
    'No adj.': 'કોઈ adj.',
    'No adjustment': 'કોઈ ગોઠવણ નથી',
    'No alerts found': 'કોઈ એલર્ટ મળ્યા નથી',
    'No breach events with current thresholds': 'વર્તમાન થ્રેશોલ્ડ સાથે કોઈ ભંગની ઘટનાઓ નથી',
    'No breaches on latest reading': 'નવીનતમ વાંચન પર કોઈ ઉલ્લંઘન નથી',
    'No data': 'કોઈ ડેટા નથી',
    'No data available yet.': 'હજુ સુધી કોઈ ડેટા ઉપલબ્ધ નથી.',
    'No data for': 'માટે કોઈ ડેટા નથી',
    'No data for this day': 'આ દિવસ માટે કોઈ ડેટા નથી',
    'No data for this meter yet': 'આ મીટર માટે હજુ સુધી કોઈ ડેટા નથી',
    'No data for this window': 'આ વિન્ડો માટે કોઈ ડેટા નથી',
    'No data in the last 24 hours': 'છેલ્લા 24 કલાકમાં કોઈ ડેટા નથી',
    'No rebate': 'રિબેટ નહીં',
    'No samples in': 'માં કોઈ નમૂના નથી',
    'No variables match your search.': 'કોઈ ચલો તમારી શોધ સાથે મેળ ખાતા નથી.',
    'None (WBSEDCL B-IDIT)': 'કોઈ નહીં (WBSEDCL B-IDIT)',
    'Normal': 'સામાન્ય',
    'Normal demand charge': 'સામાન્ય માંગ ચાર્જ',
    'Normal · peak': 'સામાન્ય · ટોચ',
    'Notify via': 'દ્વારા સૂચિત કરો',
    'Off-Peak': 'ઑફ-પીક',
    'Open dashboard': 'ડેશબોર્ડ ખોલો',
    'PDF BI': 'PDF BI',
    'PDF columns BE / BF / BG · max of all 15-min averaged blocks per period': 'પીડીએફ કૉલમ્સ BE / BF / BG · સમયગાળા દીઠ તમામ 15-મિનિટ સરેરાશ બ્લોક્સમાંથી મહત્તમ',
    'PF Adjustment (projected)': 'પીએફ એડજસ્ટમેન્ટ (અનુમાનિત)',
    'PF Penalty (projected)': 'પીએફ પેનલ્ટી (અનુમાનિત)',
    'PF Penalty / Rebate': 'પીએફ પેનલ્ટી/રિબેટ',
    'PF Rebate (projected)': 'પીએફ રિબેટ (અનુમાનિત)',
    'PF rebate / penalty MTD': 'પીએફ રિબેટ / પેનલ્ટી MTD',
    'Password': 'પાસવર્ડ',
    'Peak': 'પીક',
    'Peak clipped': 'પીક ક્લિપ્ડ',
    'Peak kVA': 'પીક kVA',
    'Penalty': 'દંડ',
    'Penalty <': 'દંડ <',
    'Penalty likely': 'દંડની શક્યતા',
    'Penalty zone': 'પેનલ્ટી ઝોન',
    'Per-phase': 'પ્રતિ-તબક્કા',
    'Phase': 'તબક્કો',
    'Phase B Current': 'તબક્કો B વર્તમાન',
    'Phase B Power': 'તબક્કો બી પાવર',
    'Phase B line current': 'તબક્કો B રેખા વર્તમાન',
    'Phase R Current': 'તબક્કો આર વર્તમાન',
    'Phase R Power': 'તબક્કો આર પાવર',
    'Phase R line current': 'તબક્કો R રેખા વર્તમાન',
    'Phase Y Current': 'તબક્કો Y વર્તમાન',
    'Phase Y Power': 'તબક્કો Y પાવર',
    'Phase Y line current': 'તબક્કો Y રેખા વર્તમાન',
    'Phase current': 'તબક્કો વર્તમાન',
    'Phase current imbalance — indicates uneven load distribution across phases.': 'તબક્કો વર્તમાન અસંતુલન — તબક્કાવાર અસમાન લોડ વિતરણ સૂચવે છે.',
    'Phase voltage (L-N)': 'તબક્કો વોલ્ટેજ (L-N)',
    'Phase voltage imbalance — can damage motors and reduce equipment life.': 'તબક્કો વોલ્ટેજ અસંતુલન - મોટર્સને નુકસાન પહોંચાડી શકે છે અને સાધનોનું જીવન ઘટાડી શકે છે.',
    'Phone number copied to clipboard.': 'ફોન નંબર ક્લિપબોર્ડ પર કૉપિ કર્યો.',
    'Pi CPU Usage': 'Pi CPU વપરાશ',
    'Pi Memory Usage': 'Pi મેમરી વપરાશ',
    'Pi Temperature': 'Pi તાપમાન',
    'Pi Temperature · Last 24 h': 'Pi તાપમાન · છેલ્લા 24 કલાક',
    'Power': 'પાવર',
    'Power Analysis': 'પાવર વિશ્લેષણ',
    'Power Factor': 'પાવર ફેક્ટર',
    'Power Factor (Month-to-Date)': 'પાવર ફેક્ટર (મહિનો-થી-તારીખ)',
    'Power Factor (PF) adjustment — applied as % of energy charge per ToD period': 'પાવર ફેક્ટર (PF) ગોઠવણ — ToD સમયગાળા દીઠ ઊર્જા ચાર્જના % તરીકે લાગુ',
    'Power Factor Adjustment': 'પાવર ફેક્ટર એડજસ્ટમેન્ટ',
    'Power Factor Penalty': 'પાવર ફેક્ટર પેનલ્ટી',
    'Power Factor Rebate': 'પાવર ફેક્ટર રિબેટ',
    'Power Factor rebate / penalty MTD': 'પાવર ફેક્ટર રિબેટ / પેનલ્ટી MTD',
    'Power factor below threshold — attracting TGSPDCL RKVAH penalty on energy bill.': 'થ્રેશોલ્ડની નીચે પાવર ફેક્ટર — એનર્જી બિલ પર TGSPDCL RKVAH પેનલ્ટી આકર્ષે છે.',
    'Production build · v1.0': 'ઉત્પાદન બિલ્ડ · v1.0',
    'Projected Bill': 'અંદાજિત બિલ',
    'Projected Bill · Month-End Estimate': 'અંદાજિત બિલ · મહિનાના અંતનો અંદાજ',
    'Projected energy charge (gross)': 'અંદાજિત ઊર્જા ચાર્જ (ગ્રોસ)',
    'Projected net payable by due date': 'નિયત તારીખ સુધીમાં ચૂકવવાપાત્ર અંદાજિત ચોખ્ખી',
    'Projection uses a linear run-rate from': 'પ્રોજેક્શન માંથી રેખીય રન-રેટનો ઉપયોગ કરે છે',
    'RAM Usage (%)': 'રેમ વપરાશ (%)',
    'Raspberry Pi CPU temperature': 'રાસ્પબેરી પી સીપીયુ તાપમાન',
    'Raspberry Pi CPU utilisation': 'રાસ્પબેરી પી સીપીયુ ઉપયોગ',
    'Raspberry Pi Gateway': 'રાસ્પબેરી પી ગેટવે',
    'Raspberry Pi memory utilisation': 'રાસ્પબેરી પી મેમરીનો ઉપયોગ',
    'Rebate': 'રિબેટ',
    'Rebate earned': 'રિબેટ મેળવ્યું',
    'Rebate zone': 'રિબેટ ઝોન',
    'Refresh': 'તાજું કરો',
    'Refresh interval': 'રિફ્રેશ અંતરાલ',
    'Remove this rule': 'આ નિયમ દૂર કરો',
    'Response time usually within 2 hours': 'પ્રતિભાવ સમય સામાન્ય રીતે 2 કલાકની અંદર',
    'Rules saved on this device. Production build routes notifications via SMS and WhatsApp.': 'આ ઉપકરણ પર નિયમો સાચવવામાં આવ્યા છે. એસએમએસ અને વોટ્સએપ દ્વારા પ્રોડક્શન બિલ્ડ રૂટ સૂચનાઓ.',
    'Running daily energy cost (₹)': 'ચાલી રહેલ દૈનિક ઊર્જા ખર્ચ (₹)',
    'Running maximum of kVA averaged over 15 minutes window': 'સરેરાશ 15 મિનિટની વિન્ડો કરતાં મહત્તમ kVA રનિંગ',
    'Running session energy (kWh)': 'ચાલી રહેલ સત્ર ઊર્જા (kWh)',
    'SAFE': 'સલામત',
    'Safe': 'સલામત',
    'Samples loaded': 'લોડ થયેલ સેમ્પલ્સ',
    'Save Alert Rules': 'ચેતવણી નિયમો સાચવો',
    'Search variables…': 'ચલ શોધો...',
    'Select Language': 'ભાષા પસંદ કરો',
    'Select a date range above': 'ઉપરની તારીખ શ્રેણી પસંદ કરો',
    'Select billing period': 'બિલિંગ અવધિ પસંદ કરો',
    'Select language': 'ભાષા પસંદ કરો',
    'Select meter': 'મીટર પસંદ કરો',
    'Send Email': 'ઈમેલ મોકલો',
    'Session Energy': 'સત્ર ઊર્જા',
    'Session carbon footprint (kg CO₂)': 'સેશન કાર્બન ફૂટપ્રિન્ટ (કિલો CO₂)',
    'Settings': 'સેટિંગ્સ',
    'Share': 'શેર કરો',
    'Show code': 'કોડ બતાવો',
    'Showing': 'દર્શાવે છે',
    'Showing cached data — we\'ll keep retrying automatically.': 'કેશ્ડ ડેટા બતાવી રહ્યાં છીએ — અમે આપમેળે ફરી પ્રયાસ કરતા રહીશું.',
    'Showing month-to-date charges': 'મહિનાથી તારીખના શુલ્ક બતાવી રહ્યાં છે',
    'Showing today\'s charges': 'આજના શુલ્ક બતાવી રહ્યા છીએ',
    'Sign out': 'સાઇન આઉટ',
    'Similar to average': 'સરેરાશ જેવું જ',
    'Similar to this week\'s average': 'આ સપ્તાહની સરેરાશની જેમ',
    'Since midnight IST · updates every 5 min': 'મધ્યરાત્રિથી IST · દર 5 મિનિટે અપડેટ થાય છે',
    'Site': 'સાઇટ',
    'Sum of all phase currents': 'તમામ તબક્કાના પ્રવાહોનો સરવાળો',
    'Surcharge': 'સરચાર્જ',
    'THD distribution · sample count per 2% band': 'THD વિતરણ · 2% બેન્ડ દીઠ નમૂનાની ગણતરી',
    'Telangana': 'તેલંગાણા',
    'Temperature (°C)': 'તાપમાન (°C)',
    'This Month': 'આ મહિને',
    'This week (Sun – yesterday)': 'આ અઠવાડિયે (રવિ - ગઈકાલે)',
    'Threshold': 'થ્રેશોલ્ડ',
    'Time distribution': 'સમય વિતરણ',
    'Time-of-Day Split': 'સમય-ઓફ-ડે સ્પ્લિટ',
    'Timely Payment Rebate': 'સમયસર ચુકવણી રિબેટ',
    'ToD Off-Peak Rebate': 'ToD ઑફ-પીક રિબેટ',
    'ToD Peak Penalty': 'ToD પીક પેનલ્ટી',
    'Today': 'આજે',
    'Today PF': 'આજે પી.એફ',
    'Today is': 'આજે છે',
    'Today\'s Cost': 'આજની કિંમત',
    'Today\'s Running Cost': 'આજની ચાલી રહેલ કિંમત',
    'Total': 'કુલ',
    'Total Active Power': 'કુલ સક્રિય શક્તિ',
    'Total Apparent Power': 'કુલ દેખીતી શક્તિ',
    'Total Current': 'કુલ વર્તમાન',
    'Total Energy (kWh) consumed last month / (Peak kW observed last month times number of hours last month)': 'ગયા મહિને વપરાશમાં લેવાયેલી કુલ ઊર્જા (kWh) / (છેલ્લા મહિને અવલોકન કરાયેલ પીક kW ગણા ગયા મહિને કલાકોની સંખ્યા)',
    'Total Energy (kWh) consumed this month / (Peak kW observed this month times number of hours this month)': 'આ મહિને વપરાશમાં લેવાયેલી કુલ ઊર્જા (kWh) / (આ મહિને અવલોકન કરાયેલ પીક kWh ગણા કલાકોની સંખ્યા)',
    'Total Energy (kWh) consumed this week / (Peak kW observed this week times number of hours this week)': 'આ અઠવાડિયે વપરાશમાં લેવાયેલી કુલ ઊર્જા (kWh) / (આ અઠવાડિયે અવલોકન કરાયેલ પીક kW ગણા આ અઠવાડિયે કલાકોની સંખ્યા)',
    'Total Energy (kWh) consumed today/ (Peak kW observed today times number of hours today)': 'આજે વપરાશમાં લેવાયેલ કુલ ઊર્જા (kWh)/ (આજે અવલોકન કરાયેલ પીક kWh)',
    'Total Energy Charge': 'કુલ એનર્જી ચાર્જ',
    'Total Harmonic Distortion (%)': 'કુલ હાર્મોનિક વિકૃતિ (%)',
    'Total Watts': 'કુલ વોટ્સ',
    'Total active power across all phases': 'તમામ તબક્કાઓમાં કુલ સક્રિય શક્તિ',
    'Total apparent power (kVA)': 'કુલ દેખીતી શક્તિ (kVA)',
    'Total demand cost': 'કુલ માંગ ખર્ચ',
    'Total instantaneous power in watts': 'વોટ્સમાં કુલ ત્વરિત શક્તિ',
    'Try again': 'ફરી પ્રયાસ કરો',
    'Try another meter or wait for the next refresh.': 'બીજું મીટર અજમાવો અથવા આગલા રિફ્રેશ માટે રાહ જુઓ.',
    'Use one of the access codes provided for your site.': 'તમારી સાઇટ માટે પ્રદાન કરેલ એક્સેસ કોડમાંથી એકનો ઉપયોગ કરો.',
    'Utilisation %': 'ઉપયોગ %',
    'Voltage': 'વોલ્ટેજ',
    'Voltage Imbalance': 'વોલ્ટેજ અસંતુલન',
    'Voltage K-Factor': 'વોલ્ટેજ કે-ફેક્ટર',
    'Voltage K-Factor exceeds transformer derating limit — K>4 requires a K-rated transformer.': 'વોલ્ટેજ K-ફેક્ટર ટ્રાન્સફોર્મર ડેરેટિંગ મર્યાદા કરતાં વધી જાય છે — K>4 માટે K-રેટેડ ટ્રાન્સફોર્મરની જરૂર છે.',
    'WARN': 'ચેતવણી',
    'Warn': 'ચેતવણી આપો',
    'Warning': 'ચેતવણી',
    'Warning above': 'ઉપર ચેતવણી',
    'Warning below': 'નીચે ચેતવણી',
    'Warning · peak': 'ચેતવણી · ટોચ',
    'WhatsApp Support': 'વોટ્સએપ સપોર્ટ',
    'Within Limit': 'મર્યાદામાં',
    'Worst': 'સૌથી ખરાબ',
    'Yesterday': 'ગઈકાલે',
    'above': 'ઉપર',
    'above CD': 'સીડી ઉપર',
    'above this week\'s avg': 'આ સપ્તાહની સરેરાશથી ઉપર',
    'above this week\'s avg — good day': 'આ સપ્તાહની સરેરાશથી ઉપર — શુભ દિવસ',
    'active': 'સક્રિય',
    'active issue': 'સક્રિય મુદ્દો',
    'active issues': 'સક્રિય મુદ્દાઓ',
    'added to bill': 'બિલમાં ઉમેર્યું',
    'added to this month\'s bill': 'આ મહિનાના બિલમાં ઉમેરવામાં આવ્યું છે',
    'adjustment': 'ગોઠવણ',
    'all charges finalised.': 'તમામ ચાર્જીસ ફાઇનલ.',
    'and': 'અને',
    'applied for Load Factor ≥ 65%': 'લોડ ફેક્ટર ≥ 65% માટે અરજી કરી',
    'average': 'સરેરાશ',
    'avg': 'સરેરાશ',
    'below': 'નીચે',
    'below average': 'સરેરાશથી નીચે',
    'below min → charged on': 'મિનિટ નીચે → ચાર્જ ચાલુ',
    'below this week\'s avg': 'આ સપ્તાહની સરેરાશથી નીચે',
    'below this week\'s avg — below average': 'આ સપ્તાહની સરેરાશથી નીચે — સરેરાશથી નીચે',
    'consumers under TOD Tariff (CD > 50 kVA); % of energy charge per ToD period': 'TOD ટેરિફ હેઠળના ગ્રાહકો (CD > 50 kVA); ToD સમયગાળા દીઠ ઊર્જા ચાર્જનો %',
    'critical': 'જટિલ',
    'current': 'વર્તમાન',
    'day bill for': 'માટે દિવસનું બિલ',
    'day run rate': 'દિવસનો રન રેટ',
    'days': 'દિવસો',
    'days of actual data.': 'વાસ્તવિક ડેટાના દિવસો.',
    'days of meter data': 'મીટર ડેટાના દિવસો',
    'days remaining': 'દિવસો બાકી',
    'days required for': 'માટે જરૂરી દિવસો',
    'deducted from bill': 'બિલમાંથી કપાત',
    'deducted from this month\'s bill': 'આ મહિનાના બિલમાંથી કાપવામાં આવે છે',
    'delivered': 'વિતરિત',
    'energy charges, Power Factor & Load Factor adjustments, demand charge, duties, and projected net payable.': 'એનર્જી ચાર્જિસ, પાવર ફેક્ટર અને લોડ ફેક્ટર એડજસ્ટમેન્ટ્સ, ડિમાન્ડ ચાર્જ, ડ્યૂટી અને અંદાજિત નેટ ચૂકવવાપાત્ર.',
    'energy per day': 'દિવસ દીઠ ઊર્જા',
    'energy per hour': 'કલાક દીઠ ઊર્જા',
    'excess above CD': 'સીડી ઉપર વધુ',
    'fires when <': 'ટ્રિગર થાય છે જ્યારે <',
    'fires when >': 'ટ્રિગર થાય છે જ્યારે >',
    'good day': 'શુભ દિવસ',
    'if paid after 15 days': 'જો 15 દિવસ પછી ચૂકવણી કરવામાં આવે',
    'if paid by due date': 'જો નિયત તારીખ સુધીમાં ચૂકવવામાં આવે',
    'imbal': 'imbal',
    'invoice estimate': 'ભરતિયું અંદાજ',
    'is above this week\'s avg': 'આ સપ્તાહની સરેરાશથી ઉપર છે',
    'is below this week\'s avg': 'આ સપ્તાહની સરેરાશથી નીચે છે',
    'kVA/month': 'kVA/મહિનો',
    'kVAh': 'kVAh',
    'kWh': 'kWh',
    'limit': 'મર્યાદા',
    'meter': 'મીટર',
    'meters': 'મીટર',
    'min demand applies': 'ન્યૂનતમ માંગ લાગુ પડે છે',
    'month': 'મહિનો',
    'month-to-date': 'મહિનાથી તારીખ',
    'net incl. all charges': 'નેટ સહિત તમામ શુલ્ક',
    'net today': 'નેટ આજે',
    'never': 'ક્યારેય નહીં',
    'no adj.': 'કોઈ adj.',
    'no adjustment': 'કોઈ ગોઠવણ નથી',
    'no adjustment applicable': 'કોઈ ગોઠવણ લાગુ નથી',
    'no adjustment today': 'આજે કોઈ ગોઠવણ નથી',
    'nom': 'નામ',
    'not yet applicable today': 'આજે પણ લાગુ પડતું નથી',
    'of': 'ના',
    'of 24 hours have data': '24 કલાકનો ડેટા હોય છે',
    'of CD': 'ની સીડી',
    'of bill': 'બિલનું',
    'of gross bill': 'કુલ બિલનું',
    'of net bill': 'ચોખ્ખું બિલ',
    'off': 'બંધ',
    'on the excess kVA.': 'વધારાના kVA પર.',
    'over-threshold': 'ઓવર-થ્રેશોલ્ડ',
    'paise/kVAh  (6p flat)': 'પૈસા/kVAh (6p ફ્લેટ)',
    'paise/kWh rebate': 'પૈસા/kWh રિબેટ',
    'paise/kWh surcharge': 'પૈસા/kWh સરચાર્જ',
    'peak kVA': 'પીક kVA',
    'peak kVA today': 'પીક kVA આજે',
    'penalty': 'દંડ',
    'projected penalty': 'અંદાજિત દંડ',
    'projected rebate': 'અંદાજિત રિબેટ',
    'projected surcharge': 'અંદાજિત સરચાર્જ',
    'readings': 'રીડિંગ્સ',
    'readings · 3 phases': 'વાંચન · 3 તબક્કાઓ',
    'rebate': 'રિબેટ',
    'rebate / kWh': 'રિબેટ / kWh',
    'rebate earned': 'રિબેટ મેળવ્યું',
    's': 's',
    's when the tab is visible.': 's જ્યારે ટેબ દેખાય છે.',
    'samples': 'નમૂનાઓ',
    'surcharge': 'સરચાર્જ',
    'surcharge / kWh': 'સરચાર્જ / kWh',
    'surcharge added to bill': 'બિલમાં સરચાર્જ ઉમેરાયો',
    'surcharge applied': 'સરચાર્જ લાગુ',
    'threshold': 'થ્રેશોલ્ડ',
    'to': 'થી',
    'units consumed so far': 'અત્યાર સુધી વપરાયેલા યુનિટ',
    'updated every 5 min': 'દર 5 મિનિટે અપડેટ થાય છે',
    'updating…': 'અપડેટ કરી રહ્યું છે...',
    'warn': 'ચેતવણી',
    '· added to bill today': '· આજે બિલમાં ઉમેર્યું',
    '· saving deducted today': 'આજે બચત કાપવામાં આવી છે',
    '· surcharge added today': '· સરચાર્જ આજે ઉમેરાયો',
    '— · awaiting data': '— · ડેટાની પ્રતીક્ષા છે',
    '≥': '≥',
    '⚠ No Pi telemetry in current data — fields piTempC / piMemPct not populated': '⚠ વર્તમાન ડેટામાં કોઈ Pi ટેલિમેટ્રી નથી — ફીલ્ડ્સ piTempC / piMemPct વસ્તી નથી',
    '⚠️ Thermal throttle active — Pi is running hot, performance reduced': '⚠️ થર્મલ થ્રોટલ સક્રિય — Pi ગરમ ચાલી રહ્યું છે, કાર્યક્ષમતામાં ઘટાડો થયો છે',
    '✓ Rules Saved Successfully': '✓ નિયમો સફળતાપૂર્વક સાચવવામાં આવ્યા',
  },
  hi: {
    'This Week': 'इस सप्ताह',
    'Last Month': 'पिछले महीने',
    'Sensor Dropout': 'सेंसर ड्रॉपआउट',
    'Approaching Overload': 'ओवरलोड के करीब',
    'Frequency Deviation': 'आवृत्ति विचलन',
    'High Voltage THD': 'उच्च वोल्टेज THD',
    'High Current THD': 'उच्च धारा THD',
    'In-app': 'ऐप के अंदर',
    'SMS': 'एसएमएस',
    'WhatsApp': 'व्हाट्सएप',
    'Min. chargeable demand': 'न्यूनतम चार्जेबल डिमांड',
    'Demand charge — Normal': 'मांग शुल्क — सामान्य',
    'Demand charge — Penal': 'मांग शुल्क — दंडात्मक',
    'Electricity duty': 'बिजली शुल्क',
    'Late payment surcharge': 'विलंबित भुगतान अधिभार',
    'Demand charge (up to CD)': 'डिमांड चार्ज (CD तक)',
    'Generating': 'जनरेट किया जा रहा है',
    'Bill PDF…': 'बिल PDF…',
    'What is the Power Analysis Dashboard?': 'पावर एनालिसिस डैशबोर्ड क्या है?',
    'It monitors real-time electrical metrics (voltage, current, power factor, demand, active/reactive energy) collected from Raspberry Pi edge nodes installed at the site.': 'यह साइट पर स्थापित Raspberry Pi एज नोड्स से एकत्रित रीयल-टाइम विद्युत मेट्रिक्स (वोल्टेज, धारा, पावर फैक्टर, मांग, एक्टिव/रिएक्टिव ऊर्जा) की निगरानी करता है।',
    'What do the green/orange/red indicators mean?': 'हरे/नारंगी/लाल संकेतकों का क्या मतलब है?',
    'Green means the Raspberry Pi edge node is online and reporting health telemetry normally. Orange/red indicate potential communication delays or high temperature/resource throttling.': 'हरा रंग दर्शाता है कि Raspberry Pi एज नोड ऑनलाइन है और सामान्य रूप से हेल्थ टेलीमेट्री रिपोर्ट कर रहा है। नारंगी/लाल संभावित संचार देरी या उच्च तापमान/संसाधन थ्रॉटलिंग को दर्शाते हैं।',
    'How are billing demand charges calculated?': 'बिलिंग मांग शुल्क की गणना कैसे की जाती है?',
    'Demand charges are based on the Maximum Demand (MD) recorded in 15-minute integration windows, calculated according to the active tariff structure (e.g., TGSPDCL HT or WBSEDCL B-IDIT).': 'मांग शुल्क 15-मिनट की इंटीग्रेशन विंडो में दर्ज अधिकतम मांग (MD) पर आधारित होते हैं, जिनकी गणना सक्रिय टैरिफ संरचना (जैसे TGSPDCL HT या WBSEDCL B-IDIT) के अनुसार की जाती है।',
    'What should I do if the dashboard shows "No data"?': 'यदि डैशबोर्ड "कोई डेटा नहीं" दिखाता है तो मुझे क्या करना चाहिए?',
    'Verify that the edge node (Raspberry Pi gateway) is powered on and connected to the internet. If the issue persists, contact technical support immediately.': 'सुनिश्चित करें कि एज नोड (Raspberry Pi गेटवे) चालू है और इंटरनेट से जुड़ा है। यदि समस्या बनी रहती है, तो तुरंत तकनीकी सहायता से संपर्क करें।',
    '% of readings': 'पढ़ने का %',
    '/month': '/माह',
    '0.4 kV supply': '0.4 केवी आपूर्ति',
    '12 AM – 12 AM': 'रात 12 बजे – रात 12 बजे',
    '1st 12 AM → now': '1 तारीख रात 12 बजे → अब तक',
    '2x penalty': '2x जुर्माना',
    '33 kV supply': '33 केवी आपूर्ति',
    'About': 'के बारे में',
    'Above': 'ऊपर',
    'Across': 'पार',
    'Active (kW)': 'सक्रिय (किलोवाट)',
    'Active Power & Apparent Power': 'सक्रिय शक्ति एवं स्पष्ट शक्ति',
    'Active power on Phase B': 'चरण बी पर सक्रिय शक्ति',
    'Active power on Phase R': 'चरण आर पर सक्रिय शक्ति',
    'Active power on Phase Y': 'चरण Y पर सक्रिय शक्ति',
    'Active tariff': 'सक्रिय टैरिफ',
    'Add custom variable alert': 'कस्टम वेरिएबल अलर्ट जोड़ें',
    'Additional demand charge': 'अतिरिक्त मांग शुल्क',
    'Alert History': 'अलर्ट इतिहास',
    'Alert Rules': 'अलर्ट नियम',
    'Alerts': 'अलर्ट',
    'All energy/PF/LF values computed by the Cortex Pi gateway per VARIABLES.pdf §2.3 & §3. Demand, ED, rental, and TPR computed in the browser from WBSEDCL tariff constants.': 'सभी ऊर्जा/पीएफ/एलएफ मानों की गणना कॉर्टेक्स पाई गेटवे द्वारा VARIABLES.pdf §2.3 और §3 के अनुसार की जाती है। WBSEDCL टैरिफ स्थिरांक से ब्राउज़र में मांग, ईडी, किराये और टीपीआर की गणना की जाती है।',
    'All systems normal': 'सभी प्रणालियाँ सामान्य हैं',
    'Anomalies': 'विसंगतियाँ',
    'Anomaly': 'विसंगति',
    'Apparent': 'आभासी',
    'Apparent (kVA)': 'स्पष्ट (केवीए)',
    'Approaching Contracted Demand': 'अनुबंधित मांग के करीब पहुंचना',
    'Auto-refreshes every': 'प्रत्येक को स्वतः ताज़ा करता है',
    'Average Power Factor': 'औसत पावर फैक्टर',
    'Average power factor across': 'पार औसत पावर फैक्टर',
    'Avg': 'औसत',
    'Avg Active Power': 'औसत सक्रिय शक्ति',
    'Avg Apparent Power': 'औसत स्पष्ट शक्ति',
    'Base Energy Charge': 'बेस एनर्जी चार्ज',
    'Based on': 'पर आधारित',
    'Below': 'नीचे',
    'Between': 'के बीच',
    'Billing': 'बिलिंग',
    'Billing Cycle Peak': 'बिलिंग चक्र शिखर',
    'Billing Overview': 'बिलिंग विवरण',
    'Both levels disabled': 'दोनों स्तर अक्षम हैं',
    'Building PDF…': 'पीडीएफ का निर्माण…',
    'CD': 'CD',
    'CD 100%': 'CD 100%',
    'CORTEX by Vireon': 'कोर्टेक्स - वायरॉन द्वारा',
    'CRIT': 'गंभीर',
    'Call Now': 'अभी कॉल करें',
    'Call Support': 'कॉल सहायता',
    'Carbon (CO₂)': 'कार्बन (CO₂)',
    'Chargeable demand': 'चार्जेबल डिमांड',
    'Chargeable min:': 'चार्जेबल न्यूनतम:',
    'Chat on WhatsApp': 'व्हाट्सएप पर चैट करें',
    'Check back when more data is synced.': 'अधिक डेटा सिंक होने पर वापस जांचें।',
    'Check your network or sheet sharing settings (Anyone with the link → Viewer).': 'अपने नेटवर्क या शीट शेयरिंग सेटिंग्स की जाँच करें (लिंक वाला कोई भी व्यक्ति → व्यूअर)।',
    'Choose a variable': 'एक वेरिएबल चुनें',
    'Close': 'बंद करें',
    'Close Help and Support Modal': 'सहायता और समर्थन मॉडल बंद करें',
    'Connecting…': 'कनेक्ट किया जा रहा है…',
    'Consumer': 'उपभोक्ता',
    'Contact Tech Support': 'तकनीकी सहायता से संपर्क करें',
    'Contact your administrator if you do not have one.': 'यदि आपके पास कोई नहीं है तो अपने व्यवस्थापक से संपर्क करें।',
    'Contract': 'अनुबंध',
    'Contract Demand (CD)': 'अनुबंध मांग (CD)',
    'Contract Demand Utilisation': 'अनुबंध मांग उपयोग',
    'Contract demand:': 'अनुबंध की मांग:',
    'Contract limit': 'अनुबंध सीमा',
    'Copy Number': 'नंबर कॉपी करें',
    'Cost': 'लागत',
    'Cost breakdown': 'लागत का विवरण',
    'Couldn\'t reach the data sheet': 'डेटा शीट तक नहीं पहुंच सका',
    'Couldn\'t refresh just now.': 'अभी ताज़ा नहीं किया जा सका.',
    'Crit': 'क्रिट',
    'Critical': 'गंभीर',
    'Critical above': 'ऊपर गंभीर',
    'Critical below': 'नीचे गंभीर',
    'Critical · peak': 'गंभीर · शिखर',
    'Current': 'करंट',
    'Current Imbalance': 'करंट असंतुलन',
    'Current K-Factor': 'वर्तमान के-फैक्टर',
    'Current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'वर्तमान के-फैक्टर गंभीर हार्मोनिक लोडिंग को इंगित करता है - ट्रांसफार्मर को व्युत्पन्न किया जाना चाहिए या के-रेटेड इकाई के साथ प्रतिस्थापित किया जाना चाहिए।',
    'Current status': 'वर्तमान स्थिति',
    'Custom': 'कस्टम',
    'Custom Alerts': 'कस्टम अलर्ट',
    'Custom range': 'कस्टम रेंज',
    'Customer charges': 'ग्राहक शुल्क',
    'Daily Cost': 'दैनिक लागत',
    'Dashboard': 'डैशबोर्ड',
    'Deep dive': 'गहन विश्लेषण',
    'Demand Penalty Applied': 'डिमांड पेनाल्टी लागू',
    'Demand charge (billing-cycle peak)': 'मांग शुल्क (बिलिंग-चक्र शिखर)',
    'Demand charge is fixed from the billing cycle peak. PF rebate and LF rebate/surcharge are projected at current rates.': 'डिमांड चार्ज बिलिंग चक्र के शिखर से तय होता है। पीएफ छूट और एलएफ छूट/अधिभार मौजूदा दरों पर अनुमानित हैं।',
    'Demand charges — when Maximum Demand (MD) exceeds Contract Demand (CD)': 'मांग शुल्क - जब अधिकतम मांग (एमडी) अनुबंध मांग (सीडी) से अधिक हो जाती है',
    'Demands under CD pay standard rates on chargeable kVA. Exceeding CD triggers a': 'सीडी के तहत मांगें प्रभार्य केवीए पर मानक दरों का भुगतान करती हैं। सीडी से अधिक होने पर ट्रिगर होता है',
    'Detected on most recent reading': 'नवीनतम रीडिंग पर विसंगति पाई गई',
    'Disabled — no notifications': 'अक्षम - कोई सूचना नहीं',
    'Download Bill': 'बिल डाउनलोड करें',
    'Download Bill PDF': 'बिल पीडीएफ डाउनलोड करें',
    'Download Log': 'लॉग डाउनलोड करें',
    'Download PDF': 'पीडीएफ डाउनलोड करें',
    'Download a printable daily log · Accumulated kWh, Power Factor per hour': 'प्रिंट करने योग्य दैनिक लॉग डाउनलोड करें · संचित kWh, पावर फैक्टर प्रति घंटा',
    'Edge Node · Raspberry Pi Health': 'एज नोड · रास्पबेरी पाई स्वास्थ्य',
    'Electricity Duty (projected)': 'विद्युत शुल्क (अनुमानित)',
    'Elevated current THD — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress and overheating.': 'ऊंचा वर्तमान टीएचडी - गैर-रेखीय भार (वीएफडी, यूपीएस, ड्राइव) को इंगित करता है जो ट्रांसफार्मर तनाव और ओवरहीटिंग का कारण बनता है।',
    'Elevated voltage THD — can damage capacitors, transformers, and sensitive equipment. IEEE 519 limit is 8%.': 'ऊंचा वोल्टेज टीएचडी - कैपेसिटर, ट्रांसफार्मर और संवेदनशील उपकरणों को नुकसान पहुंचा सकता है। आईईईई 519 की सीमा 8% है।',
    'Email Support': 'ईमेल सहायता',
    'Energy': 'ऊर्जा',
    'Energy Charges · Time-of-Day Split': 'ऊर्जा शुल्क · दिन का समय विभाजन',
    'Energy by Time-of-Day': 'दिन के समय के अनुसार ऊर्जा',
    'Energy charges + Demand charges + Electricity Duty + Customer charges · accumulated till date': 'ऊर्जा शुल्क + मांग शुल्क + विद्युत शुल्क + ग्राहक शुल्क · अब तक जमा हुआ',
    'Energy charges + Power Factor adjustment + Load Factor rebates + Demand charges + Electricity Duty + Meter rental · accumulated till date': 'ऊर्जा शुल्क + पावर फैक्टर समायोजन + लोड फैक्टर छूट + मांग शुल्क + बिजली शुल्क + मीटर किराया · आज तक जमा हुआ',
    'Energy charges accumulated by tariff period': 'टैरिफ अवधि के अनुसार संचित ऊर्जा शुल्क',
    'Energy delivered': 'ऊर्जा वितरित की गई',
    'Enter the access password for your site.': 'अपनी साइट के लिए एक्सेस पासवर्ड दर्ज करें।',
    'Enter your access password': 'अपना एक्सेस पासवर्ड दर्ज करें',
    'Failed to copy phone number.': 'फ़ोन नंबर कॉपी करने में विफल।',
    'Fires when PF drops below threshold — attracts utility penalty.': 'जब पीएफ सीमा से नीचे चला जाता है तो ट्रिगर हो जाता है - उपयोगिता जुर्माना लगता है।',
    'Fires when current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'जब वर्तमान के-फैक्टर गंभीर हार्मोनिक लोडिंग का संकेत देता है तो ट्रिगर हो जाता है - ट्रांसफार्मर को व्युत्पन्न किया जाना चाहिए या के-रेटेड इकाई के साथ प्रतिस्थापित किया जाना चाहिए।',
    'Fires when current THD exceeds safe levels — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress.': 'जब वर्तमान टीएचडी सुरक्षित स्तर से अधिक हो जाता है तो ट्रिगर हो जाता है - गैर-रेखीय भार (वीएफडी, यूपीएस, ड्राइव) को इंगित करता है जो ट्रांसफार्मर तनाव का कारण बनता है।',
    'Fires when load % nears or exceeds the contracted demand limit.': 'जब लोड% अनुबंधित मांग सीमा के करीब या उससे अधिक हो जाता है तो ट्रिगर हो जाता है।',
    'Fires when neutral conductor carries excess current — fire risk.': 'जब न्यूट्रल कंडक्टर अधिक करंट प्रवाहित करता है तो ट्रिगर हो जाता है - आग लगने का खतरा।',
    'Fires when phase current imbalance exceeds threshold.': 'जब चरण धारा असंतुलन सीमा से अधिक हो जाता है तो ट्रिगर हो जाता है।',
    'Fires when voltage K-Factor exceeds transformer derating limits — K>4 requires K-rated transformer.': 'जब वोल्टेज K-फैक्टर ट्रांसफार्मर व्युत्पन्न सीमा से अधिक हो जाता है तो ट्रिगर हो जाता है - K>4 के लिए K-रेटेड ट्रांसफार्मर की आवश्यकता होती है।',
    'Fires when voltage THD exceeds safe levels — can damage capacitors, transformers, and sensitive equipment.': 'जब वोल्टेज टीएचडी सुरक्षित स्तर से अधिक हो जाता है तो ट्रिगर हो जाता है - कैपेसिटर, ट्रांसफार्मर और संवेदनशील उपकरणों को नुकसान पहुंचा सकता है।',
    'Frequency': 'आवृत्ति',
    'Frequently asked questions & tech support': 'अक्सर पूछे जाने वाले प्रश्न और तकनीकी सहायता',
    'Full': 'पूर्ण',
    'Get support directly on WhatsApp chat': 'व्हाट्सएप चैट पर सीधे सहायता प्राप्त करें',
    'Help & Support': 'सहायता और समर्थन',
    'Hide code': 'कोड छिपाएँ',
    'High': 'ऊँचा',
    'High Current Harmonic Distortion': 'उच्च धारा हार्मोनिक विरूपण',
    'High Current K-Factor': 'उच्च धारा के-फैक्टर',
    'High Voltage Harmonic Distortion': 'उच्च वोल्टेज हार्मोनिक विरूपण',
    'High Voltage K-Factor': 'उच्च वोल्टेज के-फैक्टर',
    'High neutral current — possible fire risk from unbalanced phases or loose neutral.': 'उच्च तटस्थ धारा - असंतुलित चरणों या ढीले तटस्थ से संभावित आग का खतरा।',
    'Hourly Power Log · PDF': 'प्रति घंटा पावर लॉग · पीडीएफ',
    'Insufficient data': 'अपर्याप्त डेटा',
    'Intraday Bill': 'इंट्राडे बिल',
    'K-Factor': 'के-फैक्टर',
    'K-Factor distribution · sample count per unit band': 'के-फैक्टर वितरण · प्रति यूनिट बैंड नमूना गणना',
    'LF Adjustment (projected)': 'एलएफ समायोजन (अनुमानित)',
    'LF Penalty (projected)': 'एलएफ जुर्माना (अनुमानित)',
    'LF Rebate (projected)': 'एलएफ छूट (अनुमानित)',
    'Last 24 hours': 'पिछले 24 घंटे',
    'Last 24 hours · kW (active) and kVA (apparent)': 'पिछले 24 घंटे · किलोवाट (सक्रिय) और केवीए (स्पष्ट)',
    'Last 30 days': 'पिछले 30 दिन',
    'Last 5 instances · all time': 'अंतिम 5 मामले · सर्वकालिक',
    'Last refresh': 'अंतिम रिफ्रेश',
    'Live': 'लाइव',
    'Live Power Factor': 'लाइव पावर फैक्टर',
    'Live status, risk indicators and threshold breach density.': 'लाइव स्थिति, जोखिम संकेतक और सीमा उल्लंघन घनत्व।',
    'Load Factor': 'लोड फैक्टर',
    'Load Factor (LF) rebate / surcharge — applied per kWh consumed': 'लोड फैक्टर (एलएफ) छूट/अधिभार - प्रति किलोवाट खपत पर लागू',
    'Load Factor Adjustment': 'लोड फैक्टर समायोजन',
    'Load Factor Penalty': 'लोड फैक्टर जुर्माना',
    'Load Factor Rebate': 'लोड फैक्टर छूट',
    'Load Factor Utilisation': 'लोड फैक्टर उपयोग',
    'Load Factor adjustment MTD': 'लोड फैक्टर समायोजन एमटीडी',
    'Load percentage nearing or exceeding contracted demand limit.': 'लोड प्रतिशत अनुबंधित मांग सीमा के करीब या उससे अधिक।',
    'Loading…': 'लोड हो रहा है...',
    'Low Power Factor': 'कम पावर फैक्टर',
    'MD Peak': 'एमडी पीक',
    'Max': 'अधिकतम',
    'Max Demand Analysis': 'अधिकतम मांग विश्लेषण',
    'Max Demand by Time-of-Day Period': 'दिन के समय की अवधि के अनुसार अधिकतम मांग',
    'Max current K-Factor across phases — rates transformer derating for harmonic loads': 'सभी चरणों में अधिकतम वर्तमान के-फैक्टर - हार्मोनिक भार के लिए ट्रांसफॉर्मर व्युत्पन्न दर',
    'Max voltage K-Factor across phases — rates transformer derating for harmonic loads': 'चरणों में अधिकतम वोल्टेज के-फैक्टर - हार्मोनिक भार के लिए ट्रांसफॉर्मर व्युत्पन्न दर',
    'Maximum demand': 'अधिकतम मांग',
    'Meter overview': 'मीटर विवरण',
    'Meter rental': 'मीटर किराया',
    'Metered': 'पैमाइश की गई',
    'Meters discovered': 'खोजे गए मीटर',
    'Metrics · last 5 alerts': 'मेट्रिक्स · अंतिम 5 अलर्ट',
    'Min': 'न्यूनतम',
    'Mon-Sat. 9:00 AM - 6:00 PM IST': 'सोम-शनि सुबह 9:00 बजे - शाम 6:00 बजे IST',
    'Month-to-Date': 'माह-दर-तारीख',
    'Month-to-Date Cost': 'महीने-दर-तारीख लागत',
    'Month-to-date bill for': 'के लिए माह-दर-तारीख बिल',
    'Most recent 5 breach events · reflects your current thresholds': 'सबसे हाल के 5 उल्लंघन मामले · आपके वर्तमान सीमाओं को दर्शाते हैं',
    'Must stay': 'रहना चाहिए',
    'Near limit': 'सीमा के निकट',
    'Net cost today': 'आज शुद्ध लागत',
    'Neutral Current': 'तटस्थ धारा',
    'Neutral zone': 'तटस्थ क्षेत्र',
    'No adj.': 'कोई एडजस्टमेंट नहीं',
    'No adjustment': 'कोई समायोजन नहीं',
    'No alerts found': 'कोई अलर्ट नहीं मिला',
    'No breach events with current thresholds': 'वर्तमान सीमाओं के साथ कोई उल्लंघन मामला नहीं',
    'No breaches on latest reading': 'नवीनतम रीडिंग पर कोई उल्लंघन नहीं',
    'No data': 'कोई डेटा नहीं',
    'No data available yet.': 'अभी तक कोई डेटा उपलब्ध नहीं है.',
    'No data for': 'कोई डेटा नहीं',
    'No data for this day': 'इस दिन का कोई डेटा नहीं',
    'No data for this meter yet': 'इस मीटर के लिए अभी तक कोई डेटा नहीं है',
    'No data for this window': 'इस विंडो के लिए कोई डेटा नहीं',
    'No data in the last 24 hours': 'पिछले 24 घंटों में कोई डेटा नहीं',
    'No rebate': 'कोई छूट नहीं',
    'No samples in': 'कोई नमूना नहीं',
    'No variables match your search.': 'आपकी खोज से कोई वेरिएबल मेल नहीं खाता।',
    'None (WBSEDCL B-IDIT)': 'कोई नहीं (डब्ल्यूबीएसईडीसीएल बी-आईडीआईटी)',
    'Normal': 'सामान्य',
    'Normal demand charge': 'सामान्य मांग शुल्क',
    'Normal · peak': 'सामान्य · शिखर',
    'Notify via': 'के माध्यम से सूचित करें',
    'Off-Peak': 'ऑफ-पीक',
    'Open dashboard': 'डैशबोर्ड खोलें',
    'PDF BI': 'पीडीएफ बीआई',
    'PDF columns BE / BF / BG · max of all 15-min averaged blocks per period': 'पीडीएफ कॉलम बीई/बीएफ/बीजी · प्रति अवधि सभी 15-मिनट के औसत ब्लॉकों में से अधिकतम',
    'PF Adjustment (projected)': 'पीएफ समायोजन (अनुमानित)',
    'PF Penalty (projected)': 'पीएफ जुर्माना (अनुमानित)',
    'PF Penalty / Rebate': 'पीएफ जुर्माना/छूट',
    'PF Rebate (projected)': 'पीएफ छूट (अनुमानित)',
    'PF rebate / penalty MTD': 'पीएफ छूट / जुर्माना एमटीडी',
    'Password': 'पासवर्ड',
    'Peak': 'शिखर',
    'Peak clipped': 'पीक क्लिप्ड',
    'Peak kVA': 'पीक केवीए',
    'Penalty': 'जुर्माना',
    'Penalty <': 'जुर्माना <',
    'Penalty likely': 'जुर्माना लगने की संभावना',
    'Penalty zone': 'दंड क्षेत्र',
    'Per-phase': 'प्रति चरण',
    'Phase': 'चरण',
    'Phase B Current': 'चरण बी वर्तमान',
    'Phase B Power': 'चरण बी पावर',
    'Phase B line current': 'चरण बी लाइन वर्तमान',
    'Phase R Current': 'चरण आर वर्तमान',
    'Phase R Power': 'चरण आर पावर',
    'Phase R line current': 'चरण आर लाइन वर्तमान',
    'Phase Y Current': 'चरण Y वर्तमान',
    'Phase Y Power': 'चरण Y पावर',
    'Phase Y line current': 'चरण Y लाइन करंट',
    'Phase current': 'फेज करंट',
    'Phase current imbalance — indicates uneven load distribution across phases.': 'चरण वर्तमान असंतुलन - चरणों में असमान भार वितरण को इंगित करता है।',
    'Phase voltage (L-N)': 'फेज वोल्टेज (L-N)',
    'Phase voltage imbalance — can damage motors and reduce equipment life.': 'चरण वोल्टेज असंतुलन - मोटरों को नुकसान पहुंचा सकता है और उपकरण जीवन को कम कर सकता है।',
    'Phone number copied to clipboard.': 'फ़ोन नंबर क्लिपबोर्ड पर कॉपी हो गया।',
    'Pi CPU Usage': 'पाई सीपीयू उपयोग',
    'Pi Memory Usage': 'पाई मेमोरी उपयोग',
    'Pi Temperature': 'पाई तापमान',
    'Pi Temperature · Last 24 h': 'पाई तापमान · पिछले 24 घंटे',
    'Power': 'पावर',
    'Power Analysis': 'ऊर्जा विश्लेषण',
    'Power Factor': 'पावर फैक्टर',
    'Power Factor (Month-to-Date)': 'पावर फैक्टर (माह-दर-तारीख)',
    'Power Factor (PF) adjustment — applied as % of energy charge per ToD period': 'पावर फैक्टर (पीएफ) समायोजन - प्रति टीओडी अवधि में ऊर्जा शुल्क के % के रूप में लागू किया जाता है',
    'Power Factor Adjustment': 'पावर फैक्टर समायोजन',
    'Power Factor Penalty': 'पावर फैक्टर जुर्माना',
    'Power Factor Rebate': 'पावर फैक्टर छूट',
    'Power Factor rebate / penalty MTD': 'पावर फैक्टर छूट/जुर्माना एमटीडी',
    'Power factor below threshold — attracting TGSPDCL RKVAH penalty on energy bill.': 'सीमा से नीचे पावर फैक्टर - ऊर्जा बिल पर टीजीएसपीडीसीएल आरकेवीएएच जुर्माना लगेगा।',
    'Production build · v1.0': 'उत्पादन निर्माण · v1.0',
    'Projected Bill': 'प्रक्षेपित विधेयक',
    'Projected Bill · Month-End Estimate': 'अनुमानित बिल · महीने के अंत का अनुमान',
    'Projected energy charge (gross)': 'अनुमानित ऊर्जा प्रभार (सकल)',
    'Projected net payable by due date': 'नियत तिथि तक अनुमानित शुद्ध देय',
    'Projection uses a linear run-rate from': 'प्रोजेक्शन एक रैखिक रन-रेट का उपयोग करता है',
    'RAM Usage (%)': 'रैम उपयोग (%)',
    'Raspberry Pi CPU temperature': 'रास्पबेरी पाई सीपीयू तापमान',
    'Raspberry Pi CPU utilisation': 'रास्पबेरी पाई सीपीयू उपयोग',
    'Raspberry Pi Gateway': 'रास्पबेरी पाई गेटवे',
    'Raspberry Pi memory utilisation': 'रास्पबेरी पाई मेमोरी उपयोग',
    'Rebate': 'छूट',
    'Rebate earned': 'छूट अर्जित की गई',
    'Rebate zone': 'छूट क्षेत्र',
    'Refresh': 'ताज़ा करें',
    'Refresh interval': 'रिफ्रेश अंतराल',
    'Remove this rule': 'इस नियम को हटाओ',
    'Response time usually within 2 hours': 'आमतौर पर 2 घंटे के भीतर जवाब',
    'Rules saved on this device. Production build routes notifications via SMS and WhatsApp.': 'इस डिवाइस पर नियम सहेजे गए। प्रोडक्शन बिल्ड एसएमएस और व्हाट्सएप के माध्यम से नोटिफिकेशन भेजता है।',
    'Running daily energy cost (₹)': 'प्रतिदिन चलने वाली ऊर्जा लागत (₹)',
    'Running maximum of kVA averaged over 15 minutes window': '15 मिनट की विंडो में औसत केवीए की अधिकतम रनिंग',
    'Running session energy (kWh)': 'चल रहे सत्र की ऊर्जा (किलोवाट)',
    'SAFE': 'सुरक्षित',
    'Safe': 'सुरक्षित',
    'Samples loaded': 'लोडेड नमूने',
    'Save Alert Rules': 'अलर्ट नियम सहेजें',
    'Search variables…': 'वेरिएबल्स खोजें…',
    'Select Language': 'भाषा चुनें',
    'Select a date range above': 'ऊपर एक तिथि सीमा चुनें',
    'Select billing period': 'बिलिंग अवधि चुनें',
    'Select language': 'भाषा चुनें',
    'Select meter': 'मीटर चुनें',
    'Send Email': 'ईमेल भेजें',
    'Session Energy': 'सत्र ऊर्जा',
    'Session carbon footprint (kg CO₂)': 'सत्र कार्बन पदचिह्न (किलो CO₂)',
    'Settings': 'सेटिंग्स',
    'Share': 'साझा करें',
    'Show code': 'कोड दिखाएँ',
    'Showing': 'दिखा रहा हूँ',
    'Showing cached data — we\'ll keep retrying automatically.': 'कैश्ड डेटा दिखा रहा है - हम स्वचालित रूप से पुनः प्रयास करते रहेंगे।',
    'Showing month-to-date charges': 'माह-दर-तारीख शुल्क दिखाया जा रहा है',
    'Showing today\'s charges': 'आज के आरोप दिखा रहा हूँ',
    'Sign out': 'साइन आउट',
    'Similar to average': 'औसत के समान',
    'Similar to this week\'s average': 'इस सप्ताह के औसत के समान',
    'Since midnight IST · updates every 5 min': 'मध्यरात्रि IST के बाद से · हर 5 मिनट में अपडेट',
    'Site': 'साइट',
    'Sum of all phase currents': 'सभी चरण धाराओं का योग',
    'Surcharge': 'अधिभार',
    'THD distribution · sample count per 2% band': 'टीएचडी वितरण · नमूना गणना प्रति 2% बैंड',
    'Telangana': 'तेलंगाना',
    'Temperature (°C)': 'तापमान (डिग्री सेल्सियस)',
    'This Month': 'इस महीने',
    'This week (Sun – yesterday)': 'इस सप्ताह (रविवार - कल)',
    'Threshold': 'देहली',
    'Time distribution': 'समय वितरण',
    'Time-of-Day Split': 'दिन का समय विभाजन',
    'Timely Payment Rebate': 'समय पर भुगतान पर छूट',
    'ToD Off-Peak Rebate': 'टीओडी ऑफ-पीक छूट',
    'ToD Peak Penalty': 'टीओडी पीक पेनल्टी',
    'Today': 'आज',
    'Today PF': 'आज पी.एफ',
    'Today is': 'आज है',
    'Today\'s Cost': 'आज की लागत',
    'Today\'s Running Cost': 'आज की परिचालन लागत',
    'Total': 'कुल',
    'Total Active Power': 'कुल सक्रिय शक्ति',
    'Total Apparent Power': 'कुल स्पष्ट शक्ति',
    'Total Current': 'कुल धारा',
    'Total Energy (kWh) consumed last month / (Peak kW observed last month times number of hours last month)': 'पिछले महीने खपत की गई कुल ऊर्जा (किलोवाट) / (पिछले महीने देखी गई अधिकतम किलोवाट गुणा पिछले महीने के घंटों की संख्या)',
    'Total Energy (kWh) consumed this month / (Peak kW observed this month times number of hours this month)': 'इस महीने खपत की गई कुल ऊर्जा (किलोवाट) / (इस महीने देखी गई अधिकतम किलोवाट इस महीने के घंटों की संख्या से गुणा)',
    'Total Energy (kWh) consumed this week / (Peak kW observed this week times number of hours this week)': 'इस सप्ताह खपत की गई कुल ऊर्जा (किलोवाट) / (इस सप्ताह देखी गई अधिकतम किलोवाट इस सप्ताह घंटों की संख्या से गुणा)',
    'Total Energy (kWh) consumed today/ (Peak kW observed today times number of hours today)': 'आज खपत की गई कुल ऊर्जा (किलोवाट)/ (आज देखी गई अधिकतम किलोवाट आज के घंटों की संख्या से गुणा)',
    'Total Energy Charge': 'कुल ऊर्जा प्रभार',
    'Total Harmonic Distortion (%)': 'कुल हार्मोनिक विकृति (%)',
    'Total Watts': 'कुल वाट',
    'Total active power across all phases': 'सभी चरणों में कुल सक्रिय शक्ति',
    'Total apparent power (kVA)': 'कुल स्पष्ट शक्ति (केवीए)',
    'Total demand cost': 'कुल मांग लागत',
    'Total instantaneous power in watts': 'कुल तात्कालिक शक्ति वाट में',
    'Try again': 'पुनः प्रयास करें',
    'Try another meter or wait for the next refresh.': 'दूसरा मीटर आज़माएं या अगले रिफ्रेश की प्रतीक्षा करें।',
    'Use one of the access codes provided for your site.': 'अपने साइट के लिए प्रदान किए गए एक्सेस कोड में से एक का उपयोग करें।',
    'Utilisation %': 'उपयोग %',
    'Voltage': 'वोल्टेज',
    'Voltage Imbalance': 'वोल्टेज असंतुलन',
    'Voltage K-Factor': 'वोल्टेज के-फैक्टर',
    'Voltage K-Factor exceeds transformer derating limit — K>4 requires a K-rated transformer.': 'वोल्टेज K-फैक्टर ट्रांसफार्मर व्युत्पन्न सीमा से अधिक है - K>4 के लिए K-रेटेड ट्रांसफार्मर की आवश्यकता होती है।',
    'WARN': 'चेतावनी',
    'Warn': 'चेतावनी',
    'Warning': 'चेतावनी',
    'Warning above': 'ऊपर चेतावनी',
    'Warning below': 'नीचे चेतावनी',
    'Warning · peak': 'चेतावनी · शिखर',
    'WhatsApp Support': 'व्हाट्सएप सहायता',
    'Within Limit': 'सीमा के अंदर',
    'Worst': 'सबसे ख़राब',
    'Yesterday': 'कल',
    'above': 'ऊपर',
    'above CD': 'सीडी के ऊपर',
    'above this week\'s avg': 'इस सप्ताह के औसत से ऊपर',
    'above this week\'s avg — good day': 'इस सप्ताह के औसत से ऊपर - अच्छा दिन',
    'active': 'सक्रिय',
    'active issue': 'सक्रिय समस्या',
    'active issues': 'सक्रिय समस्याएँ',
    'added to bill': 'बिल में जोड़ा गया',
    'added to this month\'s bill': 'इस महीने के बिल में जोड़ा गया',
    'adjustment': 'समायोजन',
    'all charges finalised.': 'सभी आरोप तय।',
    'and': 'और',
    'applied for Load Factor ≥ 65%': 'लोड फैक्टर ≥ 65% के लिए आवेदन किया गया',
    'average': 'औसत',
    'avg': 'औसत',
    'below': 'नीचे',
    'below average': 'औसत से नीचे',
    'below min → charged on': 'मिनट से नीचे → चार्ज किया गया',
    'below this week\'s avg': 'इस सप्ताह के औसत से नीचे',
    'below this week\'s avg — below average': 'इस सप्ताह के औसत से नीचे - औसत से नीचे',
    'consumers under TOD Tariff (CD > 50 kVA); % of energy charge per ToD period': 'टीओडी टैरिफ के तहत उपभोक्ता (सीडी > 50 केवीए); प्रति टीओडी अवधि में ऊर्जा शुल्क का %',
    'critical': 'आलोचनात्मक',
    'current': 'वर्तमान',
    'day bill for': 'के लिए दिन का बिल',
    'day run rate': 'दिन की रन रेट',
    'days': 'दिन',
    'days of actual data.': 'वास्तविक डेटा के दिन.',
    'days of meter data': 'मीटर डेटा के दिन',
    'days remaining': 'दिन शेष हैं',
    'days required for': 'के लिए आवश्यक दिन',
    'deducted from bill': 'बिल से काटा गया',
    'deducted from this month\'s bill': 'इस माह के बिल से काटा गया',
    'delivered': 'वितरित',
    'energy charges, Power Factor & Load Factor adjustments, demand charge, duties, and projected net payable.': 'ऊर्जा शुल्क, पावर फैक्टर और लोड फैक्टर समायोजन, मांग शुल्क, कर्तव्य और अनुमानित शुद्ध देय।',
    'energy per day': 'प्रति दिन ऊर्जा',
    'energy per hour': 'प्रति घंटा ऊर्जा',
    'excess above CD': 'सीडी के ऊपर अतिरिक्त',
    'fires when <': 'ट्रिगर होता है जब <',
    'fires when >': 'ट्रिगर होता है जब >',
    'good day': 'शुभ दिन',
    'if paid after 15 days': 'यदि 15 दिनों के बाद भुगतान किया जाता है',
    'if paid by due date': 'यदि नियत तिथि तक भुगतान किया जाता है',
    'imbal': 'असंतुलन',
    'invoice estimate': 'चालान अनुमान',
    'is above this week\'s avg': 'इस सप्ताह के औसत से ऊपर है',
    'is below this week\'s avg': 'इस सप्ताह के औसत से नीचे है',
    'kVA/month': 'केवीए/माह',
    'kVAh': 'केवीएएच',
    'kWh': 'kWh',
    'limit': 'सीमा',
    'meter': 'मीटर',
    'meters': 'मीटर',
    'min demand applies': 'न्यूनतम मांग लागू होती है',
    'month': 'महीना',
    'month-to-date': 'माह-दर-तारीख',
    'net incl. all charges': 'नेट सहित. सभी आरोप',
    'net today': 'आज नेट',
    'never': 'कभी नहीं',
    'no adj.': 'कोई एडजस्टमेंट नहीं',
    'no adjustment': 'कोई समायोजन नहीं',
    'no adjustment applicable': 'कोई समायोजन लागू नहीं',
    'no adjustment today': 'आज कोई समायोजन नहीं',
    'nom': 'नामांकित',
    'not yet applicable today': 'आज तक लागू नहीं है',
    'of': 'का',
    'of 24 hours have data': '24 घंटे का डेटा है',
    'of CD': 'सीडी का',
    'of bill': 'बिल का',
    'of gross bill': 'सकल बिल का',
    'of net bill': 'नेट बिल का',
    'off': 'बंद',
    'on the excess kVA.': 'अतिरिक्त केवीए पर.',
    'over-threshold': 'सीमा से अधिक',
    'paise/kVAh  (6p flat)': 'पैसा/केवीएएच (6पी फ्लैट)',
    'paise/kWh rebate': 'पैसे/kWh छूट',
    'paise/kWh surcharge': 'पैसे/किलोवाट अधिभार',
    'peak kVA': 'शिखर केवीए',
    'peak kVA today': 'आज चरम केवीए',
    'penalty': 'जुर्माना',
    'projected penalty': 'अनुमानित जुर्माना',
    'projected rebate': 'अनुमानित छूट',
    'projected surcharge': 'अनुमानित अधिभार',
    'readings': 'रीडिंग',
    'readings · 3 phases': 'रीडिंग · 3 चरण',
    'rebate': 'छूट',
    'rebate / kWh': 'छूट / kWh',
    'rebate earned': 'छूट अर्जित की गई',
    's': 'एस',
    's when the tab is visible.': 'जब टैब दृश्यमान हो.',
    'samples': 'नमूने',
    'surcharge': 'अधिभार',
    'surcharge / kWh': 'अधिभार / kWh',
    'surcharge added to bill': 'बिल में सरचार्ज जोड़ा गया',
    'surcharge applied': 'अधिभार लागू',
    'threshold': 'दहलीज',
    'to': 'को',
    'units consumed so far': 'अब तक खपत की गई इकाइयाँ',
    'updated every 5 min': 'हर 5 मिनट में अपडेट किया गया',
    'updating…': 'अपडेट हो रहा है…',
    'warn': 'चेतावनी',
    '· added to bill today': '· आज बिल में जोड़ा गया',
    '· saving deducted today': '· आज बचत में कटौती की गई',
    '· surcharge added today': '· सरचार्ज आज जोड़ा गया',
    '— · awaiting data': '— · डेटा की प्रतीक्षा है',
    '≥': '≥',
    '⚠ No Pi telemetry in current data — fields piTempC / piMemPct not populated': '⚠ वर्तमान डेटा में कोई Pi टेलीमेट्री नहीं - फ़ील्ड piTempC / piMemPct पॉप्युलेट नहीं हैं',
    '⚠️ Thermal throttle active — Pi is running hot, performance reduced': '⚠️ थर्मल थ्रॉटल सक्रिय - पाई गर्म हो रही है, प्रदर्शन कम हो गया है',
    '✓ Rules Saved Successfully': '✓ नियम सफलतापूर्वक सहेजे गए',
  },
  kn: {
    'This Week': 'ಈ ವಾರ',
    'Last Month': 'ಕಳೆದ ತಿಂಗಳು',
    'Sensor Dropout': 'ಸೆನ್ಸಾರ್ ಡ್ರಾಪ್‌ಔಟ್',
    'Approaching Overload': 'ಓವರ್‌ಲೋಡ್ ಸಮೀಪಿಸುತ್ತಿದೆ',
    'Frequency Deviation': 'ಆವರ್ತನ ವಿಚಲನೆ',
    'High Voltage THD': 'ಹೈ ವೋಲ್ಟೇಜ್ THD',
    'High Current THD': 'ಹೈ ಕರೆಂಟ್ THD',
    'In-app': 'ಅಪ್ಲಿಕೇಶನ್‌ ಒಳಗೆ',
    'SMS': 'ಎಸ್‌ಎಂಎಸ್',
    'WhatsApp': 'ವಾಟ್ಸ್‌ಆಪ್',
    'Min. chargeable demand': 'ಕನಿಷ್ಠ ಚಾರ್ಜ್ ಮಾಡಬಹುದಾದ ಬೇಡಿಕೆ',
    'Demand charge — Normal': 'ಬೇಡಿಕೆ ಶುಲ್ಕ — ಸಾಮಾನ್ಯ',
    'Demand charge — Penal': 'ಬೇಡಿಕೆ ಶುಲ್ಕ — ದಂಡನೀಯ',
    'Electricity duty': 'ವಿದ್ಯುತ್ ಸುಂಕ',
    'Late payment surcharge': 'ವಿಳಂಬ ಪಾವತಿ ಹೆಚ್ಚುವರಿ ಶುಲ್ಕ',
    'Demand charge (up to CD)': 'ಬೇಡಿಕೆ ಶುಲ್ಕ (CD ವರೆಗೆ)',
    'Generating': 'ರಚಿಸಲಾಗುತ್ತಿದೆ',
    'Bill PDF…': 'ಬಿಲ್ PDF…',
    'What is the Power Analysis Dashboard?': 'ಪವರ್ ಅನಾಲಿಸಿಸ್ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ಎಂದರೇನು?',
    'It monitors real-time electrical metrics (voltage, current, power factor, demand, active/reactive energy) collected from Raspberry Pi edge nodes installed at the site.': 'ಇದು ಸೈಟ್‌ನಲ್ಲಿ ಅಳವಡಿಸಲಾದ Raspberry Pi ಎಡ್ಜ್ ನೋಡ್‌ಗಳಿಂದ ಸಂಗ್ರಹಿಸಲಾದ ನೈಜ-ಸಮಯದ ವಿದ್ಯುತ್ ಮೆಟ್ರಿಕ್‌ಗಳನ್ನು (ವೋಲ್ಟೇಜ್, ಕರೆಂಟ್, ಪವರ್ ಫ್ಯಾಕ್ಟರ್, ಬೇಡಿಕೆ, ಸಕ್ರಿಯ/ಪ್ರತಿಕ್ರಿಯಾತ್ಮಕ ಶಕ್ತಿ) ಮೇಲ್ವಿಚಾರಣೆ ಮಾಡುತ್ತದೆ.',
    'What do the green/orange/red indicators mean?': 'ಹಸಿರು/ಕಿತ್ತಳೆ/ಕೆಂಪು ಸೂಚಕಗಳ ಅರ್ಥವೇನು?',
    'Green means the Raspberry Pi edge node is online and reporting health telemetry normally. Orange/red indicate potential communication delays or high temperature/resource throttling.': 'ಹಸಿರು ಎಂದರೆ Raspberry Pi ಎಡ್ಜ್ ನೋಡ್ ಆನ್‌ಲೈನ್‌ನಲ್ಲಿದೆ ಮತ್ತು ಸಾಮಾನ್ಯವಾಗಿ ಆರೋಗ್ಯ ಟೆಲಿಮೆಟ್ರಿಯನ್ನು ವರದಿ ಮಾಡುತ್ತಿದೆ. ಕಿತ್ತಳೆ/ಕೆಂಪು ಸಂಭಾವ್ಯ ಸಂವಹನ ವಿಳಂಬ ಅಥವಾ ಹೆಚ್ಚಿನ ತಾಪಮಾನ/ಸಂಪನ್ಮೂಲ ಥ್ರೊಟ್ಲಿಂಗ್ ಅನ್ನು ಸೂಚಿಸುತ್ತದೆ.',
    'How are billing demand charges calculated?': 'ಬಿಲ್ಲಿಂಗ್ ಬೇಡಿಕೆ ಶುಲ್ಕವನ್ನು ಹೇಗೆ ಲೆಕ್ಕಹಾಕಲಾಗುತ್ತದೆ?',
    'Demand charges are based on the Maximum Demand (MD) recorded in 15-minute integration windows, calculated according to the active tariff structure (e.g., TGSPDCL HT or WBSEDCL B-IDIT).': 'ಬೇಡಿಕೆ ಶುಲ್ಕವು 15 ನಿಮಿಷಗಳ ಇಂಟಿಗ್ರೇಶನ್ ವಿಂಡೋಗಳಲ್ಲಿ ದಾಖಲಾದ ಗರಿಷ್ಠ ಬೇಡಿಕೆ (MD) ಆಧರಿಸಿದ್ದು, ಸಕ್ರಿಯ ಸುಂಕ ರಚನೆಗೆ ಅನುಗುಣವಾಗಿ (ಉದಾ., TGSPDCL HT ಅಥವಾ WBSEDCL B-IDIT) ಲೆಕ್ಕಹಾಕಲಾಗುತ್ತದೆ.',
    'What should I do if the dashboard shows "No data"?': 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ "ಡೇಟಾ ಇಲ್ಲ" ಎಂದು ತೋರಿಸಿದರೆ ನಾನು ಏನು ಮಾಡಬೇಕು?',
    'Verify that the edge node (Raspberry Pi gateway) is powered on and connected to the internet. If the issue persists, contact technical support immediately.': 'ಎಡ್ಜ್ ನೋಡ್ (Raspberry Pi ಗೇಟ್‌ವೇ) ಆನ್ ಆಗಿದೆ ಮತ್ತು ಇಂಟರ್ನೆಟ್‌ಗೆ ಸಂಪರ್ಕಗೊಂಡಿದೆ ಎಂದು ಪರಿಶೀಲಿಸಿ. ಸಮಸ್ಯೆ ಮುಂದುವರಿದರೆ, ತಕ್ಷಣ ತಾಂತ್ರಿಕ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ.',
    '% of readings': '% ವಾಚನಗೋಷ್ಠಿಗಳು',
    '/month': '/ತಿಂಗಳು',
    '0.4 kV supply': '0.4 kV ಪೂರೈಕೆ',
    '12 AM – 12 AM': '12 AM – 12 AM',
    '1st 12 AM → now': '1 ನೇ ತಾರೀಖು 12 AM → ಈಗ',
    '2x penalty': '2x ಪೆನಾಲ್ಟಿ',
    '33 kV supply': '33 ಕೆ.ವಿ',
    'About': 'ಬಗ್ಗೆ',
    'Above': 'ಮೇಲೆ',
    'Across': 'ಅಡ್ಡಲಾಗಿ',
    'Active (kW)': 'ಸಕ್ರಿಯ (kW)',
    'Active Power & Apparent Power': 'ಸಕ್ರಿಯ ಶಕ್ತಿ ಮತ್ತು ಸ್ಪಷ್ಟ ಶಕ್ತಿ',
    'Active power on Phase B': 'ಬಿ ಹಂತದಲ್ಲಿ ಸಕ್ರಿಯ ಶಕ್ತಿ',
    'Active power on Phase R': 'R ಹಂತದಲ್ಲಿ ಸಕ್ರಿಯ ಶಕ್ತಿ',
    'Active power on Phase Y': 'Y ಹಂತದಲ್ಲಿ ಸಕ್ರಿಯ ಶಕ್ತಿ',
    'Active tariff': 'ಸಕ್ರಿಯ ಟ್ಯಾರಿಫ್',
    'Add custom variable alert': 'ಕಸ್ಟಮ್ ವೇರಿಯಬಲ್ ಎಚ್ಚರಿಕೆಯನ್ನು ಸೇರಿಸಿ',
    'Additional demand charge': 'ಹೆಚ್ಚುವರಿ ಬೇಡಿಕೆ ಶುಲ್ಕ',
    'Alert History': 'ಎಚ್ಚರಿಕೆ ಇತಿಹಾಸ',
    'Alert Rules': 'ಎಚ್ಚರಿಕೆ ನಿಯಮಗಳು',
    'Alerts': 'ಎಚ್ಚರಿಕೆಗಳು',
    'All energy/PF/LF values computed by the Cortex Pi gateway per VARIABLES.pdf §2.3 & §3. Demand, ED, rental, and TPR computed in the browser from WBSEDCL tariff constants.': 'ಎಲ್ಲಾ ಶಕ್ತಿ/PF/LF ಮೌಲ್ಯಗಳನ್ನು ಕಾರ್ಟೆಕ್ಸ್ ಪೈ ಗೇಟ್‌ವೇ ಪ್ರತಿ VARIABLES.pdf §2.3 & §3 ಮೂಲಕ ಗಣಿಸಲಾಗಿದೆ. ಬೇಡಿಕೆ, ED, ಬಾಡಿಗೆ ಮತ್ತು TPR ಅನ್ನು WBSEDCL ಸುಂಕದ ಸ್ಥಿರಾಂಕಗಳಿಂದ ಬ್ರೌಸರ್‌ನಲ್ಲಿ ಗಣಿಸಲಾಗಿದೆ.',
    'All systems normal': 'ಎಲ್ಲಾ ವ್ಯವಸ್ಥೆಗಳು ಸಾಮಾನ್ಯ',
    'Anomalies': 'ವೈಪರೀತ್ಯಗಳು',
    'Anomaly': 'ವ್ಯತ್ಯಾಸ',
    'Apparent': 'ಅಪ್ರತ್ಯಕ್ಷ ಶಕ್ತಿ',
    'Apparent (kVA)': 'ಸ್ಪಷ್ಟ (kVA)',
    'Approaching Contracted Demand': 'ಒಪ್ಪಂದದ ಬೇಡಿಕೆಯನ್ನು ಸಮೀಪಿಸುತ್ತಿದೆ',
    'Auto-refreshes every': 'ಪ್ರತಿಯೊಂದೂ ಸ್ವಯಂ-ರಿಫ್ರೆಶ್ ಮಾಡುತ್ತದೆ',
    'Average Power Factor': 'ಸರಾಸರಿ ಪವರ್ ಫ್ಯಾಕ್ಟರ್',
    'Average power factor across': 'ಅಡ್ಡಲಾಗಿ ಸರಾಸರಿ ವಿದ್ಯುತ್ ಅಂಶ',
    'Avg': 'ಸರಾಸರಿ',
    'Avg Active Power': 'ಸರಾಸರಿ ಸಕ್ರಿಯ ಶಕ್ತಿ',
    'Avg Apparent Power': 'ಸರಾಸರಿ ಸ್ಪಷ್ಟ ಶಕ್ತಿ',
    'Base Energy Charge': 'ಬೇಸ್ ಎನರ್ಜಿ ಚಾರ್ಜ್',
    'Based on': 'ಆಧರಿಸಿದೆ',
    'Below': 'ಕೆಳಗೆ',
    'Between': 'ನಡುವೆ',
    'Billing': 'ಬಿಲ್ಲಿಂಗ್',
    'Billing Cycle Peak': 'ಬಿಲ್ಲಿಂಗ್ ಸೈಕಲ್ ಪೀಕ್',
    'Billing Overview': 'ಬಿಲ್ಲಿಂಗ್ ಅವಲೋಕನ',
    'Both levels disabled': 'ಎರಡೂ ಹಂತಗಳನ್ನು ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ',
    'Building PDF…': 'PDF ಅನ್ನು ನಿರ್ಮಿಸಲಾಗುತ್ತಿದೆ...',
    'CD': 'CD',
    'CD 100%': 'CD 100%',
    'CORTEX by Vireon': 'ಕಾರ್ಟೆಕ್ಸ್ - ವೈರಿಯನ್ ಮೂಲಕ',
    'CRIT': 'CRIT',
    'Call Now': 'ಈಗ ಕರೆ ಮಾಡಿ',
    'Call Support': 'ಕರೆ ಬೆಂಬಲ',
    'Carbon (CO₂)': 'ಕಾರ್ಬನ್ (CO₂)',
    'Chargeable demand': 'ಚಾರ್ಜ್ ಮಾಡಬಹುದಾದ ಬೇಡಿಕೆ',
    'Chargeable min:': 'ಚಾರ್ಜ್ ಮಾಡಬಹುದಾದ ಕನಿಷ್ಠ:',
    'Chat on WhatsApp': 'WhatsApp ನಲ್ಲಿ ಚಾಟ್ ಮಾಡಿ',
    'Check back when more data is synced.': 'ಹೆಚ್ಚಿನ ಡೇಟಾವನ್ನು ಸಿಂಕ್ ಮಾಡಿದಾಗ ಮತ್ತೆ ಪರಿಶೀಲಿಸಿ.',
    'Check your network or sheet sharing settings (Anyone with the link → Viewer).': 'ನಿಮ್ಮ ನೆಟ್‌ವರ್ಕ್ ಅಥವಾ ಶೀಟ್ ಹಂಚಿಕೆ ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಪರಿಶೀಲಿಸಿ (ಲಿಂಕ್ ಹೊಂದಿರುವ ಯಾರಾದರೂ → ವೀಕ್ಷಕ).',
    'Choose a variable': 'ವೇರಿಯೇಬಲ್ ಅನ್ನು ಆರಿಸಿ',
    'Close': 'ಮುಚ್ಚಿ',
    'Close Help and Support Modal': 'ಸಹಾಯ ಮತ್ತು ಬೆಂಬಲ ಮೋಡಲ್ ಅನ್ನು ಮುಚ್ಚಿ',
    'Connecting…': 'ಸಂಪರ್ಕಿಸಲಾಗುತ್ತಿದೆ...',
    'Consumer': 'ಗ್ರಾಹಕ',
    'Contact Tech Support': 'ತಾಂತ್ರಿಕ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ',
    'Contact your administrator if you do not have one.': 'ನೀವು ಒಂದನ್ನು ಹೊಂದಿಲ್ಲದಿದ್ದರೆ ನಿಮ್ಮ ನಿರ್ವಾಹಕರನ್ನು ಸಂಪರ್ಕಿಸಿ.',
    'Contract': 'ಒಪ್ಪಂದ',
    'Contract Demand (CD)': 'ಒಪ್ಪಂದದ ಬೇಡಿಕೆ (CD)',
    'Contract Demand Utilisation': 'ಒಪ್ಪಂದದ ಬೇಡಿಕೆಯ ಬಳಕೆ',
    'Contract demand:': 'ಒಪ್ಪಂದದ ಬೇಡಿಕೆ:',
    'Contract limit': 'ಒಪ್ಪಂದದ ಮಿತಿ',
    'Copy Number': 'ಸಂಖ್ಯೆಯನ್ನು ಕಾಪಿ ಮಾಡಿ',
    'Cost': 'ವೆಚ್ಚ',
    'Cost breakdown': 'ವೆಚ್ಚದ ವಿವರ',
    'Couldn\'t reach the data sheet': 'ಡೇಟಾ ಶೀಟ್ ಅನ್ನು ತಲುಪಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ',
    'Couldn\'t refresh just now.': 'ಇದೀಗ ರಿಫ್ರೆಶ್ ಮಾಡಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.',
    'Crit': 'ಕ್ರಿಟ್',
    'Critical': 'ವಿಮರ್ಶಾತ್ಮಕ',
    'Critical above': 'ಮೇಲೆ ನಿರ್ಣಾಯಕ',
    'Critical below': 'ಕೆಳಗೆ ನಿರ್ಣಾಯಕ',
    'Critical · peak': 'ನಿರ್ಣಾಯಕ · ಗರಿಷ್ಠ',
    'Current': 'ಕರೆಂಟ್',
    'Current Imbalance': 'ಕರೆಂಟ್ ಅಸಮತೋಲನ',
    'Current K-Factor': 'ಪ್ರಸ್ತುತ ಕೆ-ಫ್ಯಾಕ್ಟರ್',
    'Current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'ಪ್ರಸ್ತುತ ಕೆ-ಫ್ಯಾಕ್ಟರ್ ತೀವ್ರ ಹಾರ್ಮೋನಿಕ್ ಲೋಡಿಂಗ್ ಅನ್ನು ಸೂಚಿಸುತ್ತದೆ - ಟ್ರಾನ್ಸ್‌ಫಾರ್ಮರ್ ಅನ್ನು ಕೆ-ರೇಟೆಡ್ ಯೂನಿಟ್‌ನೊಂದಿಗೆ ಡಿರೇಟ್ ಮಾಡಬೇಕು ಅಥವಾ ಬದಲಾಯಿಸಬೇಕು.',
    'Current status': 'ಪ್ರಸ್ತುತ ಸ್ಥಿತಿ',
    'Custom': 'ಕಸ್ಟಮ್',
    'Custom Alerts': 'ಕಸ್ಟಮ್ ಎಚ್ಚರಿಕೆಗಳು',
    'Custom range': 'ಕಸ್ಟಮ್ ಶ್ರೇಣಿ',
    'Customer charges': 'ಗ್ರಾಹಕ ಶುಲ್ಕಗಳು',
    'Daily Cost': 'ದೈನಂದಿನ ವೆಚ್ಚ',
    'Dashboard': 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
    'Deep dive': 'ಡೀಪ್ ಡೈವ್',
    'Demand Penalty Applied': 'ಬೇಡಿಕೆಯ ದಂಡವನ್ನು ಅನ್ವಯಿಸಲಾಗಿದೆ',
    'Demand charge (billing-cycle peak)': 'ಬೇಡಿಕೆ ಶುಲ್ಕ (ಬಿಲ್ಲಿಂಗ್-ಸೈಕಲ್ ಪೀಕ್)',
    'Demand charge is fixed from the billing cycle peak. PF rebate and LF rebate/surcharge are projected at current rates.': 'ಬಿಲ್ಲಿಂಗ್ ಸೈಕಲ್ ಪೀಕ್‌ನಿಂದ ಬೇಡಿಕೆ ಶುಲ್ಕವನ್ನು ನಿಗದಿಪಡಿಸಲಾಗಿದೆ. PF ರಿಯಾಯಿತಿ ಮತ್ತು LF ರಿಯಾಯಿತಿ/ಸರ್ಚಾರ್ಜ್ ಅನ್ನು ಪ್ರಸ್ತುತ ದರಗಳಲ್ಲಿ ಯೋಜಿಸಲಾಗಿದೆ.',
    'Demand charges — when Maximum Demand (MD) exceeds Contract Demand (CD)': 'ಬೇಡಿಕೆ ಶುಲ್ಕಗಳು - ಗರಿಷ್ಠ ಬೇಡಿಕೆ (MD) ಒಪ್ಪಂದದ ಬೇಡಿಕೆಯನ್ನು (CD) ಮೀರಿದಾಗ',
    'Demands under CD pay standard rates on chargeable kVA. Exceeding CD triggers a': 'CD ಅಡಿಯಲ್ಲಿ ಬೇಡಿಕೆಗಳು ಚಾರ್ಜ್ ಮಾಡಬಹುದಾದ kVA ಮೇಲೆ ಪ್ರಮಾಣಿತ ದರಗಳನ್ನು ಪಾವತಿಸುತ್ತವೆ. ಸಿಡಿಯನ್ನು ಮೀರಿದರೆ ಎ',
    'Detected on most recent reading': 'ತೀರಾ ಇತ್ತೀಚಿನ ಓದಿನಲ್ಲಿ ಪತ್ತೆಯಾಗಿದೆ',
    'Disabled — no notifications': 'ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ - ಯಾವುದೇ ಅಧಿಸೂಚನೆಗಳಿಲ್ಲ',
    'Download Bill': 'ಬಿಲ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ',
    'Download Bill PDF': 'ಬಿಲ್ PDF ಅನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ',
    'Download Log': 'ಡೌನ್‌ಲೋಡ್ ಲಾಗ್',
    'Download PDF': 'PDF ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ',
    'Download a printable daily log · Accumulated kWh, Power Factor per hour': 'ಮುದ್ರಿಸಬಹುದಾದ ದೈನಂದಿನ ಲಾಗ್ ಅನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ · ಸಂಚಿತ kWh, ಪ್ರತಿ ಗಂಟೆಗೆ ಪವರ್ ಫ್ಯಾಕ್ಟರ್',
    'Edge Node · Raspberry Pi Health': 'ಎಡ್ಜ್ ನೋಡ್ · ರಾಸ್ಪ್ಬೆರಿ ಪೈ ಆರೋಗ್ಯ',
    'Electricity Duty (projected)': 'ವಿದ್ಯುಚ್ಛಕ್ತಿ ಸುಂಕ (ಯೋಜಿತ)',
    'Elevated current THD — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress and overheating.': 'ಎಲಿವೇಟೆಡ್ ಕರೆಂಟ್ THD - ಟ್ರಾನ್ಸ್ಫಾರ್ಮರ್ ಒತ್ತಡ ಮತ್ತು ಅಧಿಕ ತಾಪವನ್ನು ಉಂಟುಮಾಡುವ ರೇಖಾತ್ಮಕವಲ್ಲದ ಲೋಡ್ಗಳನ್ನು (VFDs, UPS, ಡ್ರೈವ್ಗಳು) ಸೂಚಿಸುತ್ತದೆ.',
    'Elevated voltage THD — can damage capacitors, transformers, and sensitive equipment. IEEE 519 limit is 8%.': 'ಎತ್ತರದ ವೋಲ್ಟೇಜ್ THD - ಕೆಪಾಸಿಟರ್‌ಗಳು, ಟ್ರಾನ್ಸ್‌ಫಾರ್ಮರ್‌ಗಳು ಮತ್ತು ಸೂಕ್ಷ್ಮ ಸಾಧನಗಳನ್ನು ಹಾನಿಗೊಳಿಸಬಹುದು. IEEE 519 ಮಿತಿ 8% ಆಗಿದೆ.',
    'Email Support': 'ಇಮೇಲ್ ಬೆಂಬಲ',
    'Energy': 'ಶಕ್ತಿ',
    'Energy Charges · Time-of-Day Split': 'ಶಕ್ತಿಯ ಶುಲ್ಕಗಳು · ದಿನದ ಸಮಯದ ವಿಭಜನೆ',
    'Energy by Time-of-Day': 'ದಿನದ ಸಮಯದ ಮೂಲಕ ಶಕ್ತಿ',
    'Energy charges + Demand charges + Electricity Duty + Customer charges · accumulated till date': 'ಇಂಧನ ಶುಲ್ಕಗಳು + ಬೇಡಿಕೆ ಶುಲ್ಕಗಳು + ವಿದ್ಯುತ್ ಸುಂಕ + ಗ್ರಾಹಕ ಶುಲ್ಕಗಳು · ಇಲ್ಲಿಯವರೆಗೆ ಸಂಗ್ರಹಿಸಲಾಗಿದೆ',
    'Energy charges + Power Factor adjustment + Load Factor rebates + Demand charges + Electricity Duty + Meter rental · accumulated till date': 'ಇಂಧನ ಶುಲ್ಕಗಳು + ಪವರ್ ಫ್ಯಾಕ್ಟರ್ ಹೊಂದಾಣಿಕೆ + ಲೋಡ್ ಫ್ಯಾಕ್ಟರ್ ರಿಯಾಯಿತಿಗಳು + ಬೇಡಿಕೆ ಶುಲ್ಕಗಳು + ವಿದ್ಯುತ್ ಸುಂಕ + ಮೀಟರ್ ಬಾಡಿಗೆ · ಇಲ್ಲಿಯವರೆಗೆ ಸಂಗ್ರಹಿಸಲಾಗಿದೆ',
    'Energy charges accumulated by tariff period': 'ಸುಂಕದ ಅವಧಿಯ ಮೂಲಕ ಸಂಗ್ರಹವಾದ ಶಕ್ತಿ ಶುಲ್ಕಗಳು',
    'Energy delivered': 'ಶಕ್ತಿ ವಿತರಿಸಲಾಗಿದೆ',
    'Enter the access password for your site.': 'ನಿಮ್ಮ ಸೈಟ್‌ಗೆ ಪ್ರವೇಶ ಪಾಸ್‌ವರ್ಡ್ ಅನ್ನು ನಮೂದಿಸಿ.',
    'Enter your access password': 'ನಿಮ್ಮ ಪ್ರವೇಶ ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ',
    'Failed to copy phone number.': 'ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಕಲಿಸಲು ವಿಫಲವಾಗಿದೆ.',
    'Fires when PF drops below threshold — attracts utility penalty.': 'PF ಮಿತಿಗಿಂತ ಕಡಿಮೆಯಾದಾಗ ಟ್ರಿಗರ್ ಆಗುತ್ತದೆ — ಉಪಯುಕ್ತತೆಯ ದಂಡವನ್ನು ಆಕರ್ಷಿಸುತ್ತದೆ.',
    'Fires when current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'ಪ್ರಸ್ತುತ ಕೆ-ಫ್ಯಾಕ್ಟರ್ ತೀವ್ರವಾದ ಹಾರ್ಮೋನಿಕ್ ಲೋಡಿಂಗ್ ಅನ್ನು ಸೂಚಿಸಿದಾಗ ಟ್ರಿಗರ್ ಆಗುತ್ತದೆ — ಟ್ರಾನ್ಸ್ಫಾರ್ಮರ್ ಅನ್ನು ಕೆ-ರೇಟೆಡ್ ಘಟಕದೊಂದಿಗೆ ಡಿರೇಟ್ ಮಾಡಬೇಕು ಅಥವಾ ಬದಲಾಯಿಸಬೇಕು.',
    'Fires when current THD exceeds safe levels — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress.': 'ಪ್ರಸ್ತುತ THD ಸುರಕ್ಷಿತ ಮಟ್ಟವನ್ನು ಮೀರಿದಾಗ ಟ್ರಿಗರ್ ಆಗುತ್ತದೆ — ಟ್ರಾನ್ಸ್ಫಾರ್ಮರ್ ಒತ್ತಡವನ್ನು ಉಂಟುಮಾಡುವ ರೇಖಾತ್ಮಕವಲ್ಲದ ಲೋಡ್ಗಳನ್ನು (VFDs, UPS, ಡ್ರೈವ್ಗಳು) ಸೂಚಿಸುತ್ತದೆ.',
    'Fires when load % nears or exceeds the contracted demand limit.': 'ಲೋಡ್ % ಸಮೀಪಿಸಿದಾಗ ಅಥವಾ ಒಪ್ಪಂದದ ಬೇಡಿಕೆ ಮಿತಿಯನ್ನು ಮೀರಿದಾಗ ಟ್ರಿಗರ್ ಆಗುತ್ತದೆ.',
    'Fires when neutral conductor carries excess current — fire risk.': 'ತಟಸ್ಥ ವಾಹಕವು ಹೆಚ್ಚುವರಿ ಪ್ರವಾಹವನ್ನು ಹೊತ್ತಾಗ ಟ್ರಿಗರ್ ಆಗುತ್ತದೆ — ಬೆಂಕಿಯ ಅಪಾಯ.',
    'Fires when phase current imbalance exceeds threshold.': 'ಹಂತದ ಪ್ರಸ್ತುತ ಅಸಮತೋಲನ ಮಿತಿ ಮೀರಿದಾಗ ಟ್ರಿಗರ್ ಆಗುತ್ತದೆ.',
    'Fires when voltage K-Factor exceeds transformer derating limits — K>4 requires K-rated transformer.': 'ವೋಲ್ಟೇಜ್ ಕೆ-ಫ್ಯಾಕ್ಟರ್ ಟ್ರಾನ್ಸ್‌ಫಾರ್ಮರ್ ಡೀಟಿಂಗ್ ಮಿತಿಗಳನ್ನು ಮೀರಿದಾಗ ಟ್ರಿಗರ್ ಆಗುತ್ತದೆ - ಕೆ>4 ಗೆ ಕೆ-ರೇಟೆಡ್ ಟ್ರಾನ್ಸ್‌ಫಾರ್ಮರ್ ಅಗತ್ಯವಿದೆ.',
    'Fires when voltage THD exceeds safe levels — can damage capacitors, transformers, and sensitive equipment.': 'ವೋಲ್ಟೇಜ್ THD ಸುರಕ್ಷಿತ ಮಟ್ಟವನ್ನು ಮೀರಿದಾಗ ಟ್ರಿಗರ್ ಆಗುತ್ತದೆ — ಕೆಪಾಸಿಟರ್‌ಗಳು, ಟ್ರಾನ್ಸ್‌ಫಾರ್ಮರ್‌ಗಳು ಮತ್ತು ಸೂಕ್ಷ್ಮ ಸಾಧನಗಳನ್ನು ಹಾನಿಗೊಳಿಸಬಹುದು.',
    'Frequency': 'ಆವರ್ತನ',
    'Frequently asked questions & tech support': 'ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು ಮತ್ತು ತಾಂತ್ರಿಕ ಬೆಂಬಲ',
    'Full': 'ಪೂರ್ಣ',
    'Get support directly on WhatsApp chat': 'WhatsApp ಚಾಟ್‌ನಲ್ಲಿ ನೇರವಾಗಿ ಬೆಂಬಲವನ್ನು ಪಡೆಯಿರಿ',
    'Help & Support': 'ಸಹಾಯ ಮತ್ತು ಬೆಂಬಲ',
    'Hide code': 'ಕೋಡ್ ಮರೆಮಾಡಿ',
    'High': 'ಹೆಚ್ಚು',
    'High Current Harmonic Distortion': 'ಹೈ ಕರೆಂಟ್ ಹಾರ್ಮೋನಿಕ್ ಅಸ್ಪಷ್ಟತೆ',
    'High Current K-Factor': 'ಹೈ ಕರೆಂಟ್ ಕೆ-ಫ್ಯಾಕ್ಟರ್',
    'High Voltage Harmonic Distortion': 'ಹೈ ವೋಲ್ಟೇಜ್ ಹಾರ್ಮೋನಿಕ್ ಅಸ್ಪಷ್ಟತೆ',
    'High Voltage K-Factor': 'ಹೈ ವೋಲ್ಟೇಜ್ ಕೆ-ಫ್ಯಾಕ್ಟರ್',
    'High neutral current — possible fire risk from unbalanced phases or loose neutral.': 'ಹೆಚ್ಚಿನ ತಟಸ್ಥ ಪ್ರವಾಹ - ಅಸಮತೋಲಿತ ಹಂತಗಳು ಅಥವಾ ಸಡಿಲವಾದ ತಟಸ್ಥದಿಂದ ಸಂಭವನೀಯ ಬೆಂಕಿಯ ಅಪಾಯ.',
    'Hourly Power Log · PDF': 'ಗಂಟೆಯ ಪವರ್ ಲಾಗ್ · PDF',
    'Insufficient data': 'ಸಾಕಷ್ಟು ಡೇಟಾ ಇಲ್ಲ',
    'Intraday Bill': 'ಇಂಟ್ರಾಡೇ ಬಿಲ್',
    'K-Factor': 'ಕೆ-ಫ್ಯಾಕ್ಟರ್',
    'K-Factor distribution · sample count per unit band': 'ಕೆ-ಫ್ಯಾಕ್ಟರ್ ವಿತರಣೆ · ಯುನಿಟ್ ಬ್ಯಾಂಡ್‌ಗೆ ಮಾದರಿ ಎಣಿಕೆ',
    'LF Adjustment (projected)': 'LF ಹೊಂದಾಣಿಕೆ (ಯೋಜಿತ)',
    'LF Penalty (projected)': 'LF ಪೆನಾಲ್ಟಿ (ಯೋಜಿತ)',
    'LF Rebate (projected)': 'LF ರಿಯಾಯಿತಿ (ಯೋಜಿತ)',
    'Last 24 hours': 'ಕಳೆದ 24 ಗಂಟೆಗಳು',
    'Last 24 hours · kW (active) and kVA (apparent)': 'ಕಳೆದ 24 ಗಂಟೆಗಳು · kW (ಸಕ್ರಿಯ) ಮತ್ತು kVA (ಸ್ಪಷ್ಟ)',
    'Last 30 days': 'ಕಳೆದ 30 ದಿನಗಳು',
    'Last 5 instances · all time': 'ಕೊನೆಯ 5 ನಿದರ್ಶನಗಳು · ಸಾರ್ವಕಾಲಿಕ',
    'Last refresh': 'ಕೊನೆಯ ರಿಫ್ರೆಶ್',
    'Live': 'ಲೈವ್',
    'Live Power Factor': 'ಲೈವ್ ಪವರ್ ಫ್ಯಾಕ್ಟರ್',
    'Live status, risk indicators and threshold breach density.': 'ಲೈವ್ ಸ್ಥಿತಿ, ಅಪಾಯ ಸೂಚಕಗಳು ಮತ್ತು ಮಿತಿ ಉಲ್ಲಂಘನೆ ಸಾಂದ್ರತೆ.',
    'Load Factor': 'ಲೋಡ್ ಫ್ಯಾಕ್ಟರ್',
    'Load Factor (LF) rebate / surcharge — applied per kWh consumed': 'ಲೋಡ್ ಫ್ಯಾಕ್ಟರ್ (LF) ರಿಯಾಯಿತಿ / ಹೆಚ್ಚುವರಿ ಶುಲ್ಕ - ಪ್ರತಿ kWh ಅನ್ನು ಸೇವಿಸಲಾಗುತ್ತದೆ',
    'Load Factor Adjustment': 'ಲೋಡ್ ಫ್ಯಾಕ್ಟರ್ ಹೊಂದಾಣಿಕೆ',
    'Load Factor Penalty': 'ಲೋಡ್ ಫ್ಯಾಕ್ಟರ್ ಪೆನಾಲ್ಟಿ',
    'Load Factor Rebate': 'ಲೋಡ್ ಫ್ಯಾಕ್ಟರ್ ರಿಯಾಯಿತಿ',
    'Load Factor Utilisation': 'ಲೋಡ್ ಫ್ಯಾಕ್ಟರ್ ಬಳಕೆ',
    'Load Factor adjustment MTD': 'ಲೋಡ್ ಫ್ಯಾಕ್ಟರ್ ಹೊಂದಾಣಿಕೆ MTD',
    'Load percentage nearing or exceeding contracted demand limit.': 'ಲೋಡ್ ಶೇಕಡಾವಾರು ಒಪ್ಪಂದದ ಬೇಡಿಕೆ ಮಿತಿಯನ್ನು ಸಮೀಪಿಸುತ್ತಿದೆ ಅಥವಾ ಮೀರಿದೆ.',
    'Loading…': 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
    'Low Power Factor': 'ಕಡಿಮೆ ಶಕ್ತಿಯ ಅಂಶ',
    'MD Peak': 'ಎಂಡಿ ಪೀಕ್',
    'Max': 'ಗರಿಷ್ಠ',
    'Max Demand Analysis': 'ಗರಿಷ್ಠ ಬೇಡಿಕೆ ವಿಶ್ಲೇಷಣೆ',
    'Max Demand by Time-of-Day Period': 'ದಿನದ ಅವಧಿಯಿಂದ ಗರಿಷ್ಠ ಬೇಡಿಕೆ',
    'Max current K-Factor across phases — rates transformer derating for harmonic loads': 'ಹಂತಗಳಾದ್ಯಂತ ಮ್ಯಾಕ್ಸ್ ಕರೆಂಟ್ ಕೆ-ಫ್ಯಾಕ್ಟರ್ - ಹಾರ್ಮೋನಿಕ್ ಲೋಡ್‌ಗಳಿಗೆ ದರದ ಟ್ರಾನ್ಸ್‌ಫಾರ್ಮರ್ ಅನ್ನು ಕಡಿಮೆ ಮಾಡುತ್ತದೆ',
    'Max voltage K-Factor across phases — rates transformer derating for harmonic loads': 'ಹಂತಗಳಲ್ಲಿ ಗರಿಷ್ಠ ವೋಲ್ಟೇಜ್ ಕೆ-ಫ್ಯಾಕ್ಟರ್ - ಹಾರ್ಮೋನಿಕ್ ಲೋಡ್‌ಗಳಿಗೆ ದರದ ಟ್ರಾನ್ಸ್‌ಫಾರ್ಮರ್ ಅನ್ನು ಕಡಿಮೆ ಮಾಡುತ್ತದೆ',
    'Maximum demand': 'ಗರಿಷ್ಠ ಬೇಡಿಕೆ',
    'Meter overview': 'ಮೀಟರ್ ಅವಲೋಕನ',
    'Meter rental': 'ಮೀಟರ್ ಬಾಡಿಗೆ',
    'Metered': 'ಮಾಪನ ಮಾಡಲಾಗಿದೆ',
    'Meters discovered': 'ಪತ್ತೆಯಾದ ಮೀಟರ್‌ಗಳು',
    'Metrics · last 5 alerts': 'ಮೆಟ್ರಿಕ್ಸ್ · ಕೊನೆಯ 5 ಎಚ್ಚರಿಕೆಗಳು',
    'Min': 'ಕನಿಷ್ಠ',
    'Mon-Sat. 9:00 AM - 6:00 PM IST': 'ಸೋಮ-ಶನಿ. 9:00 AM - 6:00 PM IST',
    'Month-to-Date': 'ತಿಂಗಳಿಂದ ದಿನಾಂಕ',
    'Month-to-Date Cost': 'ತಿಂಗಳಿನಿಂದ ದಿನಾಂಕದ ವೆಚ್ಚ',
    'Month-to-date bill for': 'ತಿಂಗಳಿನಿಂದ ದಿನಾಂಕದ ಬಿಲ್',
    'Most recent 5 breach events · reflects your current thresholds': 'ತೀರಾ ಇತ್ತೀಚಿನ 5 ಉಲ್ಲಂಘನೆ ಘಟನೆಗಳು · ನಿಮ್ಮ ಪ್ರಸ್ತುತ ಮಿತಿಗಳನ್ನು ಪ್ರತಿಬಿಂಬಿಸುತ್ತದೆ',
    'Must stay': 'ಉಳಿಯಬೇಕು',
    'Near limit': 'ಮಿತಿಯ ಸಮೀಪದಲ್ಲಿದೆ',
    'Net cost today': 'ಇಂದು ನಿವ್ವಳ ವೆಚ್ಚ',
    'Neutral Current': 'ತಟಸ್ಥ ಪ್ರವಾಹ',
    'Neutral zone': 'ತಟಸ್ಥ ವಲಯ',
    'No adj.': 'ಯಾವುದೇ adj.',
    'No adjustment': 'ಹೊಂದಾಣಿಕೆ ಇಲ್ಲ',
    'No alerts found': 'ಯಾವುದೇ ಎಚ್ಚರಿಕೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ',
    'No breach events with current thresholds': 'ಪ್ರಸ್ತುತ ಮಿತಿಗಳೊಂದಿಗೆ ಯಾವುದೇ ಉಲ್ಲಂಘನೆ ಘಟನೆಗಳಿಲ್ಲ',
    'No breaches on latest reading': 'ಇತ್ತೀಚಿನ ಓದುವಿಕೆಯಲ್ಲಿ ಯಾವುದೇ ಉಲ್ಲಂಘನೆಗಳಿಲ್ಲ',
    'No data': 'ಡೇಟಾ ಇಲ್ಲ',
    'No data available yet.': 'ಇನ್ನೂ ಯಾವುದೇ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ.',
    'No data for': 'ಯಾವುದೇ ಡೇಟಾ ಇಲ್ಲ',
    'No data for this day': 'ಈ ದಿನಕ್ಕೆ ಯಾವುದೇ ಡೇಟಾ ಇಲ್ಲ',
    'No data for this meter yet': 'ಈ ಮೀಟರ್‌ಗೆ ಇನ್ನೂ ಯಾವುದೇ ಡೇಟಾ ಇಲ್ಲ',
    'No data for this window': 'ಈ ವಿಂಡೋಗೆ ಯಾವುದೇ ಡೇಟಾ ಇಲ್ಲ',
    'No data in the last 24 hours': 'ಕಳೆದ 24 ಗಂಟೆಗಳಲ್ಲಿ ಯಾವುದೇ ಡೇಟಾ ಇಲ್ಲ',
    'No rebate': 'ರಿಯಾಯಿತಿ ಇಲ್ಲ',
    'No samples in': 'ಯಾವುದೇ ಮಾದರಿಗಳಿಲ್ಲ',
    'No variables match your search.': 'ನಿಮ್ಮ ಹುಡುಕಾಟಕ್ಕೆ ಯಾವುದೇ ಅಸ್ಥಿರಗಳು ಹೊಂದಿಕೆಯಾಗುವುದಿಲ್ಲ.',
    'None (WBSEDCL B-IDIT)': 'ಯಾವುದೂ ಇಲ್ಲ (WBSEDCL B-IDIT)',
    'Normal': 'ಸಾಮಾನ್ಯ',
    'Normal demand charge': 'ಸಾಮಾನ್ಯ ಬೇಡಿಕೆ ಶುಲ್ಕ',
    'Normal · peak': 'ಸಾಮಾನ್ಯ · ಗರಿಷ್ಠ',
    'Notify via': 'ಮೂಲಕ ಸೂಚಿಸಿ',
    'Off-Peak': 'ಆಫ್-ಪೀಕ್',
    'Open dashboard': 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ತೆರೆಯಿರಿ',
    'PDF BI': 'PDF BI',
    'PDF columns BE / BF / BG · max of all 15-min averaged blocks per period': 'PDF ಕಾಲಮ್‌ಗಳು BE / BF / BG · ಪ್ರತಿ ಅವಧಿಗೆ ಎಲ್ಲಾ 15 ನಿಮಿಷಗಳ ಸರಾಸರಿ ಬ್ಲಾಕ್‌ಗಳು',
    'PF Adjustment (projected)': 'PF ಹೊಂದಾಣಿಕೆ (ಯೋಜಿತ)',
    'PF Penalty (projected)': 'PF ಪೆನಾಲ್ಟಿ (ಯೋಜಿತ)',
    'PF Penalty / Rebate': 'PF ಪೆನಾಲ್ಟಿ / ರಿಯಾಯಿತಿ',
    'PF Rebate (projected)': 'ಪಿಎಫ್ ರಿಯಾಯಿತಿ (ಯೋಜಿತ)',
    'PF rebate / penalty MTD': 'PF ರಿಯಾಯಿತಿ / ಪೆನಾಲ್ಟಿ MTD',
    'Password': 'ಪಾಸ್ವರ್ಡ್',
    'Peak': 'ಶಿಖರ',
    'Peak clipped': 'ಪೀಕ್ ಕ್ಲಿಪ್ ಮಾಡಲಾಗಿದೆ',
    'Peak kVA': 'ಪೀಕ್ kVA',
    'Penalty': 'ದಂಡ',
    'Penalty <': 'ದಂಡ <',
    'Penalty likely': 'ದಂಡ ಸಾಧ್ಯತೆ',
    'Penalty zone': 'ದಂಡದ ವಲಯ',
    'Per-phase': 'ಪ್ರತಿ ಹಂತ',
    'Phase': 'ಹಂತ',
    'Phase B Current': 'ಹಂತ ಬಿ ಪ್ರಸ್ತುತ',
    'Phase B Power': 'ಹಂತ ಬಿ ಪವರ್',
    'Phase B line current': 'ಹಂತ ಬಿ ಲೈನ್ ಪ್ರಸ್ತುತ',
    'Phase R Current': 'ಹಂತ R ಪ್ರಸ್ತುತ',
    'Phase R Power': 'ಹಂತ R ಪವರ್',
    'Phase R line current': 'ಹಂತ R ಲೈನ್ ಪ್ರಸ್ತುತ',
    'Phase Y Current': 'ಹಂತ Y ಪ್ರಸ್ತುತ',
    'Phase Y Power': 'ಹಂತ Y ಪವರ್',
    'Phase Y line current': 'ಹಂತ Y ಲೈನ್ ಪ್ರಸ್ತುತ',
    'Phase current': 'ಹಂತದ ಪ್ರಸ್ತುತ',
    'Phase current imbalance — indicates uneven load distribution across phases.': 'ಹಂತದ ಪ್ರಸ್ತುತ ಅಸಮತೋಲನ - ಹಂತಗಳಲ್ಲಿ ಅಸಮ ಲೋಡ್ ವಿತರಣೆಯನ್ನು ಸೂಚಿಸುತ್ತದೆ.',
    'Phase voltage (L-N)': 'ಹಂತದ ವೋಲ್ಟೇಜ್ (L-N)',
    'Phase voltage imbalance — can damage motors and reduce equipment life.': 'ಹಂತದ ವೋಲ್ಟೇಜ್ ಅಸಮತೋಲನ - ಮೋಟಾರ್‌ಗಳನ್ನು ಹಾನಿಗೊಳಿಸಬಹುದು ಮತ್ತು ಸಲಕರಣೆಗಳ ಜೀವಿತಾವಧಿಯನ್ನು ಕಡಿಮೆ ಮಾಡಬಹುದು.',
    'Phone number copied to clipboard.': 'ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ಕ್ಲಿಪ್‌ಬೋರ್ಡ್‌ಗೆ ನಕಲಿಸಲಾಗಿದೆ.',
    'Pi CPU Usage': 'ಪೈ ಸಿಪಿಯು ಬಳಕೆ',
    'Pi Memory Usage': 'ಪೈ ಮೆಮೊರಿ ಬಳಕೆ',
    'Pi Temperature': 'ಪೈ ತಾಪಮಾನ',
    'Pi Temperature · Last 24 h': 'ಪೈ ತಾಪಮಾನ · ಕಳೆದ 24 ಗಂ',
    'Power': 'ವಿದ್ಯುತ್',
    'Power Analysis': 'ವಿದ್ಯುತ್ ವಿಶ್ಲೇಷಣೆ',
    'Power Factor': 'ಪವರ್ ಫ್ಯಾಕ್ಟರ್',
    'Power Factor (Month-to-Date)': 'ಪವರ್ ಫ್ಯಾಕ್ಟರ್ (ತಿಂಗಳಿಂದ ದಿನಾಂಕ)',
    'Power Factor (PF) adjustment — applied as % of energy charge per ToD period': 'ಪವರ್ ಫ್ಯಾಕ್ಟರ್ (PF) ಹೊಂದಾಣಿಕೆ - ಪ್ರತಿ ToD ಅವಧಿಗೆ ಶಕ್ತಿಯ ಶುಲ್ಕದ % ನಂತೆ ಅನ್ವಯಿಸಲಾಗಿದೆ',
    'Power Factor Adjustment': 'ಪವರ್ ಫ್ಯಾಕ್ಟರ್ ಹೊಂದಾಣಿಕೆ',
    'Power Factor Penalty': 'ಪವರ್ ಫ್ಯಾಕ್ಟರ್ ಪೆನಾಲ್ಟಿ',
    'Power Factor Rebate': 'ಪವರ್ ಫ್ಯಾಕ್ಟರ್ ರಿಯಾಯಿತಿ',
    'Power Factor rebate / penalty MTD': 'ಪವರ್ ಫ್ಯಾಕ್ಟರ್ ರಿಬೇಟ್ / ಪೆನಾಲ್ಟಿ MTD',
    'Power factor below threshold — attracting TGSPDCL RKVAH penalty on energy bill.': 'ಮಿತಿಗಿಂತ ಕೆಳಗಿರುವ ಪವರ್ ಫ್ಯಾಕ್ಟರ್ - ಶಕ್ತಿ ಬಿಲ್‌ನಲ್ಲಿ TGSPDCL RKVAH ಪೆನಾಲ್ಟಿಯನ್ನು ಆಕರ್ಷಿಸುತ್ತದೆ.',
    'Production build · v1.0': 'ಉತ್ಪಾದನೆ ನಿರ್ಮಾಣ · v1.0',
    'Projected Bill': 'ಯೋಜಿತ ಬಿಲ್',
    'Projected Bill · Month-End Estimate': 'ಯೋಜಿತ ಬಿಲ್ · ತಿಂಗಳ ಅಂತ್ಯದ ಅಂದಾಜು',
    'Projected energy charge (gross)': 'ಯೋಜಿತ ಶಕ್ತಿ ಚಾರ್ಜ್ (ಒಟ್ಟು)',
    'Projected net payable by due date': 'ನಿಗದಿತ ದಿನಾಂಕದೊಳಗೆ ಪಾವತಿಸಬೇಕಾದ ನಿವ್ವಳ',
    'Projection uses a linear run-rate from': 'ಪ್ರೊಜೆಕ್ಷನ್ ರೇಖೀಯ ರನ್-ರೇಟ್ ಅನ್ನು ಬಳಸುತ್ತದೆ',
    'RAM Usage (%)': 'RAM ಬಳಕೆ (%)',
    'Raspberry Pi CPU temperature': 'ರಾಸ್ಪ್ಬೆರಿ ಪೈ ಸಿಪಿಯು ತಾಪಮಾನ',
    'Raspberry Pi CPU utilisation': 'ರಾಸ್ಪ್ಬೆರಿ ಪೈ ಸಿಪಿಯು ಬಳಕೆ',
    'Raspberry Pi Gateway': 'ರಾಸ್ಪ್ಬೆರಿ ಪೈ ಗೇಟ್ವೇ',
    'Raspberry Pi memory utilisation': 'ರಾಸ್ಪ್ಬೆರಿ ಪೈ ಮೆಮೊರಿ ಬಳಕೆ',
    'Rebate': 'ರಿಯಾಯಿತಿ',
    'Rebate earned': 'ರಿಯಾಯಿತಿ ಗಳಿಸಿದೆ',
    'Rebate zone': 'ರಿಯಾಯಿತಿ ವಲಯ',
    'Refresh': 'ರಿಫ್ರೆಶ್ ಮಾಡಿ',
    'Refresh interval': 'ರಿಫ್ರೆಶ್ ಮಧ್ಯಂತರ',
    'Remove this rule': 'ಈ ನಿಯಮವನ್ನು ತೆಗೆದುಹಾಕಿ',
    'Response time usually within 2 hours': 'ಪ್ರತಿಕ್ರಿಯೆ ಸಮಯ ಸಾಮಾನ್ಯವಾಗಿ 2 ಗಂಟೆಗಳ ಒಳಗೆ',
    'Rules saved on this device. Production build routes notifications via SMS and WhatsApp.': 'ಈ ಸಾಧನದಲ್ಲಿ ನಿಯಮಗಳನ್ನು ಉಳಿಸಲಾಗಿದೆ. ಎಸ್‌ಎಂಎಸ್ ಮತ್ತು ವಾಟ್ಸಾಪ್ ಮೂಲಕ ಉತ್ಪಾದನಾ ಮಾರ್ಗಗಳ ಅಧಿಸೂಚನೆಗಳನ್ನು ನಿರ್ಮಿಸಿ.',
    'Running daily energy cost (₹)': 'ಚಾಲನೆಯಲ್ಲಿರುವ ದೈನಂದಿನ ಶಕ್ತಿಯ ವೆಚ್ಚ (₹)',
    'Running maximum of kVA averaged over 15 minutes window': 'ಸರಾಸರಿ 15 ನಿಮಿಷಗಳ ವಿಂಡೋದಲ್ಲಿ ಗರಿಷ್ಠ kVA ರನ್ನಿಂಗ್',
    'Running session energy (kWh)': 'ಚಾಲನೆಯಲ್ಲಿರುವ ಸೆಷನ್ ಶಕ್ತಿ (kWh)',
    'SAFE': 'ಸುರಕ್ಷಿತ',
    'Safe': 'ಸುರಕ್ಷಿತ',
    'Samples loaded': 'ಲೋಡ್ ಮಾಡಲಾದ ಮಾದರಿಗಳು',
    'Save Alert Rules': 'ಎಚ್ಚರಿಕೆ ನಿಯಮಗಳನ್ನು ಉಳಿಸಿ',
    'Search variables…': 'ವೇರಿಯೇಬಲ್‌ಗಳನ್ನು ಹುಡುಕಿ...',
    'Select Language': 'ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    'Select a date range above': 'ಮೇಲಿನ ದಿನಾಂಕದ ಶ್ರೇಣಿಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    'Select billing period': 'ಬಿಲ್ಲಿಂಗ್ ಅವಧಿಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    'Select language': 'ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    'Select meter': 'ಮೀಟರ್ ಆಯ್ಕೆಮಾಡಿ',
    'Send Email': 'ಇಮೇಲ್ ಕಳುಹಿಸಿ',
    'Session Energy': 'ಸೆಷನ್ ಎನರ್ಜಿ',
    'Session carbon footprint (kg CO₂)': 'ಸೆಷನ್ ಇಂಗಾಲದ ಹೆಜ್ಜೆಗುರುತು (ಕೆಜಿ CO₂)',
    'Settings': 'ಸೆಟ್ಟಿಂಗ್ಸ್',
    'Share': 'ಹಂಚಿಕೊಳ್ಳಿ',
    'Show code': 'ಕೋಡ್ ತೋರಿಸಿ',
    'Showing': 'ತೋರಿಸಲಾಗುತ್ತಿದೆ',
    'Showing cached data — we\'ll keep retrying automatically.': 'ಸಂಗ್ರಹಿಸಲಾದ ಡೇಟಾವನ್ನು ತೋರಿಸಲಾಗುತ್ತಿದೆ - ನಾವು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಮರುಪ್ರಯತ್ನಿಸುತ್ತಲೇ ಇರುತ್ತೇವೆ.',
    'Showing month-to-date charges': 'ತಿಂಗಳಿಂದ ದಿನಾಂಕದ ಶುಲ್ಕಗಳನ್ನು ತೋರಿಸಲಾಗುತ್ತಿದೆ',
    'Showing today\'s charges': 'ಇಂದಿನ ಶುಲ್ಕಗಳನ್ನು ತೋರಿಸಲಾಗುತ್ತಿದೆ',
    'Sign out': 'ಸೈನ್ ಔಟ್',
    'Similar to average': 'ಸರಾಸರಿಗೆ ಹೋಲುತ್ತದೆ',
    'Similar to this week\'s average': 'ಈ ವಾರದ ಸರಾಸರಿಯನ್ನು ಹೋಲುತ್ತದೆ',
    'Since midnight IST · updates every 5 min': 'ಮಧ್ಯರಾತ್ರಿಯಿಂದ IST · ಪ್ರತಿ 5 ನಿಮಿಷಗಳಿಗೊಮ್ಮೆ ನವೀಕರಿಸಲಾಗುತ್ತದೆ',
    'Site': 'ಸೈಟ್',
    'Sum of all phase currents': 'ಎಲ್ಲಾ ಹಂತದ ಪ್ರವಾಹಗಳ ಮೊತ್ತ',
    'Surcharge': 'ಸರ್ಚಾರ್ಜ್',
    'THD distribution · sample count per 2% band': 'THD ವಿತರಣೆ · 2% ಬ್ಯಾಂಡ್‌ಗೆ ಮಾದರಿ ಎಣಿಕೆ',
    'Telangana': 'ತೆಲಂಗಾಣ',
    'Temperature (°C)': 'ತಾಪಮಾನ (°C)',
    'This Month': 'ಈ ತಿಂಗಳು',
    'This week (Sun – yesterday)': 'ಈ ವಾರ (ಸೂರ್ಯ - ನಿನ್ನೆ)',
    'Threshold': 'ಮಿತಿ',
    'Time distribution': 'ಸಮಯದ ವಿತರಣೆ',
    'Time-of-Day Split': 'ದಿನದ ಸಮಯ ವಿಭಜನೆ',
    'Timely Payment Rebate': 'ಸಮಯೋಚಿತ ಪಾವತಿ ರಿಯಾಯಿತಿ',
    'ToD Off-Peak Rebate': 'ToD ಆಫ್-ಪೀಕ್ ರಿಯಾಯಿತಿ',
    'ToD Peak Penalty': 'ToD ಪೀಕ್ ಪೆನಾಲ್ಟಿ',
    'Today': 'ಇಂದು',
    'Today PF': 'ಇಂದು ಪಿಎಫ್',
    'Today is': 'ಇಂದು ಆಗಿದೆ',
    'Today\'s Cost': 'ಇಂದಿನ ವೆಚ್ಚ',
    'Today\'s Running Cost': 'ಇಂದಿನ ರನ್ನಿಂಗ್ ವೆಚ್ಚ',
    'Total': 'ಒಟ್ಟು',
    'Total Active Power': 'ಒಟ್ಟು ಸಕ್ರಿಯ ಶಕ್ತಿ',
    'Total Apparent Power': 'ಒಟ್ಟು ಸ್ಪಷ್ಟ ಶಕ್ತಿ',
    'Total Current': 'ಒಟ್ಟು ಕರೆಂಟ್',
    'Total Energy (kWh) consumed last month / (Peak kW observed last month times number of hours last month)': 'ಕಳೆದ ತಿಂಗಳು ಸೇವಿಸಿದ ಒಟ್ಟು ಶಕ್ತಿ (kWh) / (ಕಳೆದ ತಿಂಗಳು ಗರಿಷ್ಠ kW ಅನ್ನು ಗಮನಿಸಲಾಗಿದೆ ಮತ್ತು ಕಳೆದ ತಿಂಗಳು ಗಂಟೆಗಳ ಸಂಖ್ಯೆ)',
    'Total Energy (kWh) consumed this month / (Peak kW observed this month times number of hours this month)': 'ಈ ತಿಂಗಳು ಸೇವಿಸಿದ ಒಟ್ಟು ಶಕ್ತಿ (kWh)',
    'Total Energy (kWh) consumed this week / (Peak kW observed this week times number of hours this week)': 'ಈ ವಾರ ಸೇವಿಸಿದ ಒಟ್ಟು ಶಕ್ತಿ (kWh) / (ಈ ವಾರದ ಗರಿಷ್ಠ kW ಅನ್ನು ಗಮನಿಸಲಾಗಿದೆ ಮತ್ತು ಈ ವಾರ ಗಂಟೆಗಳ ಸಂಖ್ಯೆ)',
    'Total Energy (kWh) consumed today/ (Peak kW observed today times number of hours today)': 'ಇಂದು ಸೇವಿಸಿದ ಒಟ್ಟು ಶಕ್ತಿ (kWh)',
    'Total Energy Charge': 'ಒಟ್ಟು ಶಕ್ತಿ ಶುಲ್ಕ',
    'Total Harmonic Distortion (%)': 'ಒಟ್ಟು ಹಾರ್ಮೋನಿಕ್ ಅಸ್ಪಷ್ಟತೆ (%)',
    'Total Watts': 'ಒಟ್ಟು ವ್ಯಾಟ್ಸ್',
    'Total active power across all phases': 'ಎಲ್ಲಾ ಹಂತಗಳಲ್ಲಿ ಒಟ್ಟು ಸಕ್ರಿಯ ಶಕ್ತಿ',
    'Total apparent power (kVA)': 'ಒಟ್ಟು ಸ್ಪಷ್ಟ ಶಕ್ತಿ (kVA)',
    'Total demand cost': 'ಒಟ್ಟು ಬೇಡಿಕೆ ವೆಚ್ಚ',
    'Total instantaneous power in watts': 'ವ್ಯಾಟ್‌ಗಳಲ್ಲಿ ಒಟ್ಟು ತತ್‌ಕ್ಷಣದ ಶಕ್ತಿ',
    'Try again': 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
    'Try another meter or wait for the next refresh.': 'ಇನ್ನೊಂದು ಮೀಟರ್ ಅನ್ನು ಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ಮುಂದಿನ ರಿಫ್ರೆಶ್‌ಗಾಗಿ ನಿರೀಕ್ಷಿಸಿ.',
    'Use one of the access codes provided for your site.': 'ನಿಮ್ಮ ಸೈಟ್‌ಗಾಗಿ ಒದಗಿಸಲಾದ ಪ್ರವೇಶ ಕೋಡ್‌ಗಳಲ್ಲಿ ಒಂದನ್ನು ಬಳಸಿ.',
    'Utilisation %': 'ಬಳಕೆ %',
    'Voltage': 'ವೋಲ್ಟೇಜ್',
    'Voltage Imbalance': 'ವೋಲ್ಟೇಜ್ ಅಸಮತೋಲನ',
    'Voltage K-Factor': 'ವೋಲ್ಟೇಜ್ ಕೆ-ಫ್ಯಾಕ್ಟರ್',
    'Voltage K-Factor exceeds transformer derating limit — K>4 requires a K-rated transformer.': 'ವೋಲ್ಟೇಜ್ K-ಫ್ಯಾಕ್ಟರ್ ಟ್ರಾನ್ಸ್‌ಫಾರ್ಮರ್ ಡೀಟಿಂಗ್ ಮಿತಿಯನ್ನು ಮೀರಿದೆ - K>4 ಗೆ K-ರೇಟೆಡ್ ಟ್ರಾನ್ಸ್‌ಫಾರ್ಮರ್ ಅಗತ್ಯವಿದೆ.',
    'WARN': 'ಎಚ್ಚರಿಕೆ',
    'Warn': 'ಎಚ್ಚರಿಕೆ',
    'Warning': 'ಎಚ್ಚರಿಕೆ',
    'Warning above': 'ಮೇಲಿನ ಎಚ್ಚರಿಕೆ',
    'Warning below': 'ಕೆಳಗೆ ಎಚ್ಚರಿಕೆ',
    'Warning · peak': 'ಎಚ್ಚರಿಕೆ · ಗರಿಷ್ಠ',
    'WhatsApp Support': 'WhatsApp ಬೆಂಬಲ',
    'Within Limit': 'ಮಿತಿಯೊಳಗೆ',
    'Worst': 'ಕೆಟ್ಟದ್ದು',
    'Yesterday': 'ನಿನ್ನೆ',
    'above': 'ಮೇಲೆ',
    'above CD': 'CD ಮೇಲೆ',
    'above this week\'s avg': 'ಈ ವಾರದ ಸರಾಸರಿಗಿಂತ ಹೆಚ್ಚು',
    'above this week\'s avg — good day': 'ಈ ವಾರದ ಸರಾಸರಿಗಿಂತ ಹೆಚ್ಚು — ಒಳ್ಳೆಯ ದಿನ',
    'active': 'ಸಕ್ರಿಯ',
    'active issue': 'ಸಕ್ರಿಯ ಸಮಸ್ಯೆ',
    'active issues': 'ಸಕ್ರಿಯ ಸಮಸ್ಯೆಗಳು',
    'added to bill': 'ಬಿಲ್‌ಗೆ ಸೇರಿಸಲಾಗಿದೆ',
    'added to this month\'s bill': 'ಈ ತಿಂಗಳ ಬಿಲ್‌ಗೆ ಸೇರಿಸಲಾಗಿದೆ',
    'adjustment': 'ಹೊಂದಾಣಿಕೆ',
    'all charges finalised.': 'ಎಲ್ಲಾ ಆರೋಪಗಳನ್ನು ಅಂತಿಮಗೊಳಿಸಲಾಗಿದೆ.',
    'and': 'ಮತ್ತು',
    'applied for Load Factor ≥ 65%': 'ಲೋಡ್ ಫ್ಯಾಕ್ಟರ್ ≥ 65% ಗೆ ಅನ್ವಯಿಸಲಾಗಿದೆ',
    'average': 'ಸರಾಸರಿ',
    'avg': 'ಸರಾಸರಿ',
    'below': 'ಕೆಳಗೆ',
    'below average': 'ಸರಾಸರಿಗಿಂತ ಕಡಿಮೆ',
    'below min → charged on': 'ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ → ಚಾರ್ಜ್ ಮಾಡಲಾಗಿದೆ',
    'below this week\'s avg': 'ಈ ವಾರದ ಸರಾಸರಿಗಿಂತ ಕಡಿಮೆ',
    'below this week\'s avg — below average': 'ಈ ವಾರದ ಸರಾಸರಿಗಿಂತ ಕಡಿಮೆ - ಸರಾಸರಿಗಿಂತ ಕಡಿಮೆ',
    'consumers under TOD Tariff (CD > 50 kVA); % of energy charge per ToD period': 'TOD ಸುಂಕದ ಅಡಿಯಲ್ಲಿ ಗ್ರಾಹಕರು (CD > 50 kVA); ಪ್ರತಿ ToD ಅವಧಿಗೆ ಶಕ್ತಿಯ ಶುಲ್ಕದ %',
    'critical': 'ನಿರ್ಣಾಯಕ',
    'current': 'ಪ್ರಸ್ತುತ',
    'day bill for': 'ದಿನದ ಬಿಲ್',
    'day run rate': 'ದಿನದ ರನ್ ರೇಟ್',
    'days': 'ದಿನಗಳು',
    'days of actual data.': 'ನಿಜವಾದ ಡೇಟಾದ ದಿನಗಳು.',
    'days of meter data': 'ಮೀಟರ್ ಡೇಟಾದ ದಿನಗಳು',
    'days remaining': 'ದಿನಗಳು ಉಳಿದಿವೆ',
    'days required for': 'ಅಗತ್ಯವಿರುವ ದಿನಗಳು',
    'deducted from bill': 'ಬಿಲ್‌ನಿಂದ ಕಡಿತಗೊಳಿಸಲಾಗಿದೆ',
    'deducted from this month\'s bill': 'ಈ ತಿಂಗಳ ಬಿಲ್‌ನಿಂದ ಕಡಿತಗೊಳಿಸಲಾಗಿದೆ',
    'delivered': 'ವಿತರಿಸಲಾಯಿತು',
    'energy charges, Power Factor & Load Factor adjustments, demand charge, duties, and projected net payable.': 'ಶಕ್ತಿ ಶುಲ್ಕಗಳು, ಪವರ್ ಫ್ಯಾಕ್ಟರ್ ಮತ್ತು ಲೋಡ್ ಫ್ಯಾಕ್ಟರ್ ಹೊಂದಾಣಿಕೆಗಳು, ಬೇಡಿಕೆ ಶುಲ್ಕ, ಸುಂಕಗಳು ಮತ್ತು ಯೋಜಿತ ನಿವ್ವಳ ಪಾವತಿ.',
    'energy per day': 'ದಿನಕ್ಕೆ ಶಕ್ತಿ',
    'energy per hour': 'ಗಂಟೆಗೆ ಶಕ್ತಿ',
    'excess above CD': 'CD ಮೇಲಿನ ಹೆಚ್ಚುವರಿ',
    'fires when <': 'ಟ್ರಿಗರ್ ಆಗುತ್ತದೆ <',
    'fires when >': 'ಟ್ರಿಗರ್ ಆಗುತ್ತದೆ >',
    'good day': 'ಒಳ್ಳೆಯ ದಿನ',
    'if paid after 15 days': '15 ದಿನಗಳ ನಂತರ ಪಾವತಿಸಿದರೆ',
    'if paid by due date': 'ನಿಗದಿತ ದಿನಾಂಕದೊಳಗೆ ಪಾವತಿಸಿದರೆ',
    'imbal': 'ಇಂಬಲ್',
    'invoice estimate': 'ಸರಕುಪಟ್ಟಿ ಅಂದಾಜು',
    'is above this week\'s avg': 'ಈ ವಾರದ ಸರಾಸರಿಗಿಂತ ಹೆಚ್ಚಾಗಿದೆ',
    'is below this week\'s avg': 'ಈ ವಾರದ ಸರಾಸರಿಗಿಂತ ಕೆಳಗಿದೆ',
    'kVA/month': 'kVA/ತಿಂಗಳು',
    'kVAh': 'kVAh',
    'kWh': 'kWh',
    'limit': 'ಮಿತಿ',
    'meter': 'ಮೀಟರ್',
    'meters': 'ಮೀಟರ್',
    'min demand applies': 'ಕನಿಷ್ಠ ಬೇಡಿಕೆ ಅನ್ವಯಿಸುತ್ತದೆ',
    'month': 'ತಿಂಗಳು',
    'month-to-date': 'ತಿಂಗಳಿಂದ ಇಲ್ಲಿಯವರೆಗೆ',
    'net incl. all charges': 'ನಿವ್ವಳ ಸೇರಿದಂತೆ. ಎಲ್ಲಾ ಶುಲ್ಕಗಳು',
    'net today': 'ಇಂದು ನಿವ್ವಳ',
    'never': 'ಎಂದಿಗೂ',
    'no adj.': 'ಯಾವುದೇ adj',
    'no adjustment': 'ಹೊಂದಾಣಿಕೆ ಇಲ್ಲ',
    'no adjustment applicable': 'ಯಾವುದೇ ಹೊಂದಾಣಿಕೆ ಅನ್ವಯಿಸುವುದಿಲ್ಲ',
    'no adjustment today': 'ಇಂದು ಯಾವುದೇ ಹೊಂದಾಣಿಕೆ ಇಲ್ಲ',
    'nom': 'ಸಂ',
    'not yet applicable today': 'ಇಂದಿಗೂ ಅನ್ವಯಿಸುವುದಿಲ್ಲ',
    'of': 'ನ',
    'of 24 hours have data': '24 ಗಂಟೆಗಳ ಡೇಟಾವನ್ನು ಹೊಂದಿದೆ',
    'of CD': 'CD ನ',
    'of bill': 'ಬಿಲ್ ನ',
    'of gross bill': 'ಒಟ್ಟು ಬಿಲ್ ನ',
    'of net bill': 'ನಿವ್ವಳ ಬಿಲ್',
    'off': 'ಆಫ್',
    'on the excess kVA.': 'ಹೆಚ್ಚುವರಿ kVA ಮೇಲೆ.',
    'over-threshold': 'ಮಿತಿಮೀರಿದ ಮಿತಿ',
    'paise/kVAh  (6p flat)': 'ಪೈಸೆ/ಕೆವಿಎಎಚ್ (6p ಫ್ಲಾಟ್)',
    'paise/kWh rebate': 'ಪೈಸೆ/kWh ರಿಯಾಯಿತಿ',
    'paise/kWh surcharge': 'ಪೈಸೆ/kWh ಹೆಚ್ಚುವರಿ ಶುಲ್ಕ',
    'peak kVA': 'ಗರಿಷ್ಠ kVA',
    'peak kVA today': 'ಇಂದು ಗರಿಷ್ಠ kVA',
    'penalty': 'ದಂಡ',
    'projected penalty': 'ಯೋಜಿತ ದಂಡ',
    'projected rebate': 'ಯೋಜಿತ ರಿಯಾಯಿತಿ',
    'projected surcharge': 'ಯೋಜಿತ ಹೆಚ್ಚುವರಿ ಶುಲ್ಕ',
    'readings': 'ರೀಡಿಂಗ್‌ಗಳು',
    'readings · 3 phases': 'ವಾಚನಗೋಷ್ಠಿಗಳು · 3 ಹಂತಗಳು',
    'rebate': 'ರಿಯಾಯಿತಿ',
    'rebate / kWh': 'ರಿಯಾಯಿತಿ / kWh',
    'rebate earned': 'ರಿಯಾಯಿತಿ ಗಳಿಸಿದೆ',
    's': 'ರು',
    's when the tab is visible.': 'ಟ್ಯಾಬ್ ಗೋಚರಿಸುವಾಗ ರು.',
    'samples': 'ಮಾದರಿಗಳು',
    'surcharge': 'ಹೆಚ್ಚುವರಿ ಶುಲ್ಕ',
    'surcharge / kWh': 'ಹೆಚ್ಚುವರಿ ಶುಲ್ಕ / kWh',
    'surcharge added to bill': 'ಬಿಲ್‌ಗೆ ಹೆಚ್ಚುವರಿ ಶುಲ್ಕವನ್ನು ಸೇರಿಸಲಾಗಿದೆ',
    'surcharge applied': 'ಹೆಚ್ಚುವರಿ ಶುಲ್ಕವನ್ನು ಅನ್ವಯಿಸಲಾಗಿದೆ',
    'threshold': 'ಮಿತಿ',
    'to': 'ಗೆ',
    'units consumed so far': 'ಇದುವರೆಗೆ ಬಳಸಿದ ಯುನಿಟ್‌ಗಳು',
    'updated every 5 min': 'ಪ್ರತಿ 5 ನಿಮಿಷಕ್ಕೆ ನವೀಕರಿಸಲಾಗಿದೆ',
    'updating…': 'ನವೀಕರಿಸಲಾಗುತ್ತಿದೆ...',
    'warn': 'ಎಚ್ಚರಿಸುತ್ತಾರೆ',
    '· added to bill today': '· ಇಂದು ಬಿಲ್‌ಗೆ ಸೇರಿಸಲಾಗಿದೆ',
    '· saving deducted today': '· ಇಂದು ಉಳಿತಾಯವನ್ನು ಕಡಿತಗೊಳಿಸಲಾಗಿದೆ',
    '· surcharge added today': '· ಇಂದು ಹೆಚ್ಚುವರಿ ಶುಲ್ಕವನ್ನು ಸೇರಿಸಲಾಗಿದೆ',
    '— · awaiting data': '— · ಡೇಟಾ ನಿರೀಕ್ಷಿಸಲಾಗುತ್ತಿದೆ',
    '≥': '≥',
    '⚠ No Pi telemetry in current data — fields piTempC / piMemPct not populated': '⚠ ಪ್ರಸ್ತುತ ಡೇಟಾದಲ್ಲಿ ಪೈ ಟೆಲಿಮೆಟ್ರಿ ಇಲ್ಲ - ಕ್ಷೇತ್ರಗಳು piTempC / piMemPct ಜನಸಂಖ್ಯೆಯಿಲ್ಲ',
    '⚠️ Thermal throttle active — Pi is running hot, performance reduced': '⚠️ ಥರ್ಮಲ್ ಥ್ರೊಟಲ್ ಸಕ್ರಿಯವಾಗಿದೆ - ಪೈ ಬಿಸಿಯಾಗಿ ಚಾಲನೆಯಲ್ಲಿದೆ, ಕಾರ್ಯಕ್ಷಮತೆ ಕಡಿಮೆಯಾಗಿದೆ',
    '✓ Rules Saved Successfully': '✓ ನಿಯಮಗಳನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಉಳಿಸಲಾಗಿದೆ',
  },
  ml: {
    'This Week': 'ഈ ആഴ്ച',
    'Last Month': 'കഴിഞ്ഞ മാസം',
    'Sensor Dropout': 'സെൻസർ ഡ്രോപ്പ്ഔട്ട്',
    'Approaching Overload': 'ഓവർലോഡ് അടുക്കുന്നു',
    'Frequency Deviation': 'ആവൃത്തി വ്യതിയാനം',
    'High Voltage THD': 'ഹൈ വോൾട്ടേജ് THD',
    'High Current THD': 'ഹൈ കറന്റ് THD',
    'In-app': 'ആപ്പിനുള്ളിൽ',
    'SMS': 'എസ്എംഎസ്',
    'WhatsApp': 'വാട്സ്ആപ്പ്',
    'Min. chargeable demand': 'കുറഞ്ഞ ചാർജ് ചെയ്യാവുന്ന ഡിമാൻഡ്',
    'Demand charge — Normal': 'ഡിമാൻഡ് ചാർജ് — സാധാരണ',
    'Demand charge — Penal': 'ഡിമാൻഡ് ചാർജ് — ശിക്ഷാപരമായ',
    'Electricity duty': 'വൈദ്യുതി തീരുവ',
    'Late payment surcharge': 'വൈകിയ പേയ്‌മെന്റ് സർചാർജ്',
    'Demand charge (up to CD)': 'ഡിമാൻഡ് ചാർജ് (CD വരെ)',
    'Generating': 'സൃഷ്ടിക്കുന്നു',
    'Bill PDF…': 'ബിൽ PDF…',
    'What is the Power Analysis Dashboard?': 'പവർ അനാലിസിസ് ഡാഷ്‌ബോർഡ് എന്താണ്?',
    'It monitors real-time electrical metrics (voltage, current, power factor, demand, active/reactive energy) collected from Raspberry Pi edge nodes installed at the site.': 'സൈറ്റിൽ ഇൻസ്റ്റാൾ ചെയ്ത Raspberry Pi എഡ്ജ് നോഡുകളിൽ നിന്ന് ശേഖരിക്കുന്ന തത്സമയ വൈദ്യുത അളവുകൾ (വോൾട്ടേജ്, കറന്റ്, പവർ ഫാക്ടർ, ഡിമാൻഡ്, ആക്ടീവ്/റിയാക്ടീവ് ഊർജ്ജം) ഇത് നിരീക്ഷിക്കുന്നു.',
    'What do the green/orange/red indicators mean?': 'പച്ച/ഓറഞ്ച്/ചുവപ്പ് സൂചകങ്ങൾ എന്താണ് അർത്ഥമാക്കുന്നത്?',
    'Green means the Raspberry Pi edge node is online and reporting health telemetry normally. Orange/red indicate potential communication delays or high temperature/resource throttling.': 'പച്ച എന്നാൽ Raspberry Pi എഡ്ജ് നോഡ് ഓൺലൈനിലാണെന്നും സാധാരണ നിലയിൽ ഹെൽത്ത് ടെലിമെട്രി റിപ്പോർട്ട് ചെയ്യുന്നുവെന്നും അർത്ഥമാക്കുന്നു. ഓറഞ്ച്/ചുവപ്പ് സാധ്യതയുള്ള ആശയവിനിമയ കാലതാമസം അല്ലെങ്കിൽ ഉയർന്ന താപനില/റിസോഴ്സ് ത്രോട്ടിലിംഗ് സൂചിപ്പിക്കുന്നു.',
    'How are billing demand charges calculated?': 'ബില്ലിംഗ് ഡിമാൻഡ് ചാർജുകൾ എങ്ങനെയാണ് കണക്കാക്കുന്നത്?',
    'Demand charges are based on the Maximum Demand (MD) recorded in 15-minute integration windows, calculated according to the active tariff structure (e.g., TGSPDCL HT or WBSEDCL B-IDIT).': '15 മിനിറ്റ് ഇന്റഗ്രേഷൻ വിൻഡോകളിൽ രേഖപ്പെടുത്തിയ പരമാവധി ഡിമാൻഡ് (MD) അടിസ്ഥാനമാക്കി, സജീവ താരിഫ് ഘടന (ഉദാ., TGSPDCL HT അല്ലെങ്കിൽ WBSEDCL B-IDIT) അനുസരിച്ച് ഡിമാൻഡ് ചാർജുകൾ കണക്കാക്കുന്നു.',
    'What should I do if the dashboard shows "No data"?': 'ഡാഷ്‌ബോർഡ് "ഡാറ്റ ഇല്ല" എന്ന് കാണിച്ചാൽ ഞാൻ എന്ത് ചെയ്യണം?',
    'Verify that the edge node (Raspberry Pi gateway) is powered on and connected to the internet. If the issue persists, contact technical support immediately.': 'എഡ്ജ് നോഡ് (Raspberry Pi ഗേറ്റ്‌വേ) ഓണായിരിക്കുകയും ഇന്റർനെറ്റുമായി ബന്ധിപ്പിച്ചിരിക്കുകയും ചെയ്യുന്നുവെന്ന് ഉറപ്പാക്കുക. പ്രശ്നം തുടരുകയാണെങ്കിൽ, ഉടൻ സാങ്കേതിക സഹായവുമായി ബന്ധപ്പെടുക.',
    '% of readings': 'വായനകളുടെ %',
    '/month': '/മാസം',
    '0.4 kV supply': '0.4 കെ.വി',
    '12 AM – 12 AM': '12 AM – 12 AM',
    '1st 12 AM → now': 'ഒന്നാം തീയതി 12 AM → ഇപ്പോൾ',
    '2x penalty': '2x പെനാൽറ്റി',
    '33 kV supply': '33 കെ.വി',
    'About': 'വിവരങ്ങൾ',
    'Above': 'മുകളിൽ',
    'Across': 'ഉടനീളം',
    'Active (kW)': 'സജീവം (kW)',
    'Active Power & Apparent Power': 'സജീവ ശക്തിയും പ്രത്യക്ഷ ശക്തിയും',
    'Active power on Phase B': 'ബി ഘട്ടത്തിൽ സജീവ ശക്തി',
    'Active power on Phase R': 'R ഘട്ടത്തിൽ സജീവ ശക്തി',
    'Active power on Phase Y': 'Y ഘട്ടത്തിൽ സജീവ ശക്തി',
    'Active tariff': 'സജീവ താരിഫ്',
    'Add custom variable alert': 'ഇഷ്‌ടാനുസൃത വേരിയബിൾ അലേർട്ട് ചേർക്കുക',
    'Additional demand charge': 'അധിക ഡിമാൻഡ് ചാർജ്',
    'Alert History': 'അലേർട്ട് ചരിത്രം',
    'Alert Rules': 'മുന്നറിയിപ്പ് നിയമങ്ങൾ',
    'Alerts': 'അലേർട്ടുകൾ',
    'All energy/PF/LF values computed by the Cortex Pi gateway per VARIABLES.pdf §2.3 & §3. Demand, ED, rental, and TPR computed in the browser from WBSEDCL tariff constants.': 'VARIABLES.pdf §2.3 & §3 എന്നിവയ്‌ക്ക് കോർടെക്‌സ് പൈ ഗേറ്റ്‌വേ കണക്കാക്കിയ എല്ലാ ഊർജ്ജ/PF/LF മൂല്യങ്ങളും. WBSEDCL താരിഫ് സ്ഥിരാങ്കങ്ങളിൽ നിന്ന് ബ്രൗസറിൽ കണക്കാക്കിയ ഡിമാൻഡ്, ED, റെൻ്റൽ, TPR എന്നിവ.',
    'All systems normal': 'എല്ലാ സംവിധാനങ്ങളും സാധാരണമാണ്',
    'Anomalies': 'അപാകതകൾ',
    'Anomaly': 'അപാകത',
    'Apparent': 'അപ്പാരന്റ് പവർ',
    'Apparent (kVA)': 'പ്രത്യക്ഷമായ (kVA)',
    'Approaching Contracted Demand': 'കരാർ ഡിമാൻഡ് അടുക്കുന്നു',
    'Auto-refreshes every': 'ഓരോന്നും സ്വയമേവ പുതുക്കുന്നു',
    'Average Power Factor': 'ശരാശരി പവർ ഫാക്ടർ',
    'Average power factor across': 'കുറുകെയുള്ള ശരാശരി പവർ ഫാക്ടർ',
    'Avg': 'ശരാശരി',
    'Avg Active Power': 'ശരാശരി സജീവ ശക്തി',
    'Avg Apparent Power': 'ശരാശരി പ്രത്യക്ഷ ശക്തി',
    'Base Energy Charge': 'അടിസ്ഥാന ഊർജ്ജ ചാർജ്',
    'Based on': 'അടിസ്ഥാനമാക്കി',
    'Below': 'താഴെ',
    'Between': 'ഇടയിൽ',
    'Billing': 'ബില്ലിംഗ്',
    'Billing Cycle Peak': 'ബില്ലിംഗ് സൈക്കിൾ പീക്ക്',
    'Billing Overview': 'ബില്ലിംഗ് അവലോകനം',
    'Both levels disabled': 'രണ്ട് തലങ്ങളും പ്രവർത്തനരഹിതമാക്കി',
    'Building PDF…': 'PDF നിർമ്മിക്കുന്നു...',
    'CD': 'CD',
    'CD 100%': 'CD 100%',
    'CORTEX by Vireon': 'കോർട്ടെക്സ് - വൈറിയൻ നിർമ്മിതം',
    'CRIT': 'CRIT',
    'Call Now': 'ഇപ്പോൾ വിളിക്കൂ',
    'Call Support': 'പിന്തുണയെ വിളിക്കുക',
    'Carbon (CO₂)': 'കാർബൺ (CO₂)',
    'Chargeable demand': 'ചാർജ് ചെയ്യാവുന്ന ഡിമാൻഡ്',
    'Chargeable min:': 'ചാർജ് ചെയ്യാവുന്ന മിനിമം:',
    'Chat on WhatsApp': 'വാട്ട്‌സ്ആപ്പിൽ ചാറ്റ് ചെയ്യുക',
    'Check back when more data is synced.': 'കൂടുതൽ ഡാറ്റ സമന്വയിപ്പിക്കുമ്പോൾ വീണ്ടും പരിശോധിക്കുക.',
    'Check your network or sheet sharing settings (Anyone with the link → Viewer).': 'നിങ്ങളുടെ നെറ്റ്‌വർക്ക് അല്ലെങ്കിൽ ഷീറ്റ് പങ്കിടൽ ക്രമീകരണങ്ങൾ പരിശോധിക്കുക (ലിങ്കുള്ള ആർക്കും → വ്യൂവർ).',
    'Choose a variable': 'ഒരു വേരിയബിൾ തിരഞ്ഞെടുക്കുക',
    'Close': 'അടയ്ക്കുക',
    'Close Help and Support Modal': 'സഹായവും പിന്തുണയും മോഡൽ അടയ്ക്കുക',
    'Connecting…': 'ബന്ധിപ്പിക്കുന്നു...',
    'Consumer': 'ഉപഭോക്താവ്',
    'Contact Tech Support': 'സാങ്കേതിക പിന്തുണയുമായി ബന്ധപ്പെടുക',
    'Contact your administrator if you do not have one.': 'നിങ്ങൾക്ക് ഒന്നുമില്ലെങ്കിൽ നിങ്ങളുടെ അഡ്‌മിനിസ്‌ട്രേറ്ററെ ബന്ധപ്പെടുക.',
    'Contract': 'കരാർ',
    'Contract Demand (CD)': 'കരാർ ഡിമാൻഡ് (CD)',
    'Contract Demand Utilisation': 'കരാർ ഡിമാൻഡ് വിനിയോഗം',
    'Contract demand:': 'കരാർ ആവശ്യം:',
    'Contract limit': 'കരാർ പരിധി',
    'Copy Number': 'നമ്പർ പകർത്തുക',
    'Cost': 'ചെലവ്',
    'Cost breakdown': 'ചെലവ് വിവരങ്ങൾ',
    'Couldn\'t reach the data sheet': 'ഡാറ്റ ഷീറ്റിൽ എത്താൻ കഴിഞ്ഞില്ല',
    'Couldn\'t refresh just now.': 'ഇപ്പോൾ പുതുക്കാൻ കഴിഞ്ഞില്ല.',
    'Crit': 'ക്രിറ്റ്',
    'Critical': 'ക്രിട്ടിക്കൽ',
    'Critical above': 'മുകളിൽ ഗുരുതരം',
    'Critical below': 'താഴെ ഗുരുതരം',
    'Critical · peak': 'ഗുരുതരം · കൊടുമുടി',
    'Current': 'കറന്റ്',
    'Current Imbalance': 'കറന്റ് അസന്തുലിതാവസ്ഥ',
    'Current K-Factor': 'നിലവിലെ കെ-ഫാക്ടർ',
    'Current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'നിലവിലെ കെ-ഫാക്ടർ കടുത്ത ഹാർമോണിക് ലോഡിംഗിനെ സൂചിപ്പിക്കുന്നു - ട്രാൻസ്ഫോർമർ ഡിറേറ്റ് ചെയ്യണം അല്ലെങ്കിൽ കെ-റേറ്റഡ് യൂണിറ്റ് ഉപയോഗിച്ച് മാറ്റിസ്ഥാപിക്കണം.',
    'Current status': 'നിലവിലെ സ്ഥിതി',
    'Custom': 'കസ്റ്റം',
    'Custom Alerts': 'ഇഷ്‌ടാനുസൃത അലേർട്ടുകൾ',
    'Custom range': 'ഇഷ്‌ടാനുസൃത ശ്രേണി',
    'Customer charges': 'ഉപഭോക്തൃ നിരക്കുകൾ',
    'Daily Cost': 'പ്രതിദിന ചെലവ്',
    'Dashboard': 'ഡാഷ്ബോർഡ്',
    'Deep dive': 'ഡീപ് ഡൈവ്',
    'Demand Penalty Applied': 'ഡിമാൻഡ് പെനാൽറ്റി പ്രയോഗിച്ചു',
    'Demand charge (billing-cycle peak)': 'ഡിമാൻഡ് ചാർജ് (ബില്ലിംഗ്-സൈക്കിൾ പീക്ക്)',
    'Demand charge is fixed from the billing cycle peak. PF rebate and LF rebate/surcharge are projected at current rates.': 'ബില്ലിംഗ് സൈക്കിൾ പീക്ക് മുതൽ ഡിമാൻഡ് ചാർജ് നിശ്ചയിച്ചിരിക്കുന്നു. പിഎഫ് റിബേറ്റും എൽഎഫ് റിബേറ്റും/സർചാർജും നിലവിലെ നിരക്കിൽ പ്രതീക്ഷിക്കുന്നു.',
    'Demand charges — when Maximum Demand (MD) exceeds Contract Demand (CD)': 'ഡിമാൻഡ് ചാർജുകൾ - പരമാവധി ഡിമാൻഡ് (MD) കരാർ ഡിമാൻഡ് (സിഡി) കവിയുമ്പോൾ',
    'Demands under CD pay standard rates on chargeable kVA. Exceeding CD triggers a': 'ചാർജ് ചെയ്യാവുന്ന കെവിഎയിൽ സിഡി പേ സ്റ്റാൻഡേർഡ് നിരക്കുകൾക്ക് കീഴിലുള്ള ആവശ്യങ്ങൾ. CD ട്രിഗറുകൾ കവിയുന്നത് a',
    'Detected on most recent reading': 'ഏറ്റവും പുതിയ വായനയിൽ കണ്ടെത്തി',
    'Disabled — no notifications': 'പ്രവർത്തനരഹിതമാക്കി - അറിയിപ്പുകളൊന്നുമില്ല',
    'Download Bill': 'ബിൽ ഡൗൺലോഡ് ചെയ്യുക',
    'Download Bill PDF': 'ബിൽ PDF ഡൗൺലോഡ് ചെയ്യുക',
    'Download Log': 'ഡൗൺലോഡ് ലോഗ്',
    'Download PDF': 'PDF ഡൗൺലോഡ് ചെയ്യുക',
    'Download a printable daily log · Accumulated kWh, Power Factor per hour': 'പ്രിൻ്റ് ചെയ്യാവുന്ന പ്രതിദിന ലോഗ് ഡൗൺലോഡ് ചെയ്യുക · സഞ്ചിത kWh, മണിക്കൂറിൽ പവർ ഫാക്ടർ',
    'Edge Node · Raspberry Pi Health': 'എഡ്ജ് നോഡ് · റാസ്ബെറി പൈ ഹെൽത്ത്',
    'Electricity Duty (projected)': 'ഇലക്‌ട്രിസിറ്റി ഡ്യൂട്ടി (പ്രൊജക്റ്റ് ചെയ്‌തത്)',
    'Elevated current THD — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress and overheating.': 'എലവേറ്റഡ് കറൻ്റ് THD - ട്രാൻസ്ഫോർമർ സമ്മർദ്ദത്തിനും അമിത ചൂടാക്കലിനും കാരണമാകുന്ന നോൺ-ലീനിയർ ലോഡുകളെ (VFDs, UPS, ഡ്രൈവുകൾ) സൂചിപ്പിക്കുന്നു.',
    'Elevated voltage THD — can damage capacitors, transformers, and sensitive equipment. IEEE 519 limit is 8%.': 'ഉയർന്ന വോൾട്ടേജ് THD - കപ്പാസിറ്ററുകൾ, ട്രാൻസ്ഫോർമറുകൾ, സെൻസിറ്റീവ് ഉപകരണങ്ങൾ എന്നിവയ്ക്ക് കേടുവരുത്തും. IEEE 519 പരിധി 8% ആണ്.',
    'Email Support': 'ഇമെയിൽ പിന്തുണ',
    'Energy': 'ഊർജ്ജം',
    'Energy Charges · Time-of-Day Split': 'ഊർജ്ജ നിരക്കുകൾ · ദിവസത്തിൻ്റെ സമയ വിഭജനം',
    'Energy by Time-of-Day': 'ദിവസം-ഓഫ്-ഡേ പ്രകാരം ഊർജ്ജം',
    'Energy charges + Demand charges + Electricity Duty + Customer charges · accumulated till date': 'എനർജി ചാർജുകൾ + ഡിമാൻഡ് ചാർജുകൾ + ഇലക്‌ട്രിസിറ്റി ഡ്യൂട്ടി + ഉപഭോക്തൃ ചാർജുകൾ · നാളിതുവരെ ശേഖരിച്ചു',
    'Energy charges + Power Factor adjustment + Load Factor rebates + Demand charges + Electricity Duty + Meter rental · accumulated till date': 'എനർജി ചാർജുകൾ + പവർ ഫാക്ടർ അഡ്ജസ്റ്റ്‌മെൻ്റ് + ലോഡ് ഫാക്ടർ റിബേറ്റുകൾ + ഡിമാൻഡ് ചാർജുകൾ + ഇലക്‌ട്രിസിറ്റി ഡ്യൂട്ടി + മീറ്റർ വാടക · നാളിതുവരെ ശേഖരിച്ചു',
    'Energy charges accumulated by tariff period': 'താരിഫ് കാലയളവിൽ കുമിഞ്ഞുകൂടിയ ഊർജ്ജ ചാർജുകൾ',
    'Energy delivered': 'ഊർജ്ജം വിതരണം ചെയ്തു',
    'Enter the access password for your site.': 'നിങ്ങളുടെ സൈറ്റിൻ്റെ പ്രവേശന പാസ്‌വേഡ് നൽകുക.',
    'Enter your access password': 'നിങ്ങളുടെ പ്രവേശന പാസ്‌വേഡ് നൽകുക',
    'Failed to copy phone number.': 'ഫോൺ നമ്പർ പകർത്തുന്നതിൽ പരാജയപ്പെട്ടു.',
    'Fires when PF drops below threshold — attracts utility penalty.': 'പിഎഫ് പരിധിക്ക് താഴെയാകുമ്പോൾ ട്രിഗർ ആകുന്നു - യൂട്ടിലിറ്റി പെനാൽറ്റി ആകർഷിക്കുന്നു.',
    'Fires when current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'നിലവിലെ കെ-ഫാക്ടർ കഠിനമായ ഹാർമോണിക് ലോഡിംഗ് സൂചിപ്പിക്കുമ്പോൾ ട്രിഗർ ആകുന്നു - ട്രാൻസ്ഫോർമർ ഡീറേറ്റ് ചെയ്യപ്പെടുകയോ കെ-റേറ്റഡ് യൂണിറ്റ് ഉപയോഗിച്ച് മാറ്റി സ്ഥാപിക്കുകയോ വേണം.',
    'Fires when current THD exceeds safe levels — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress.': 'നിലവിലെ THD സുരക്ഷിതമായ ലെവലുകൾ കവിയുമ്പോൾ ട്രിഗർ ആകുന്നു — ട്രാൻസ്ഫോർമർ സമ്മർദ്ദത്തിന് കാരണമാകുന്ന നോൺ-ലീനിയർ ലോഡുകളെ (VFDs, UPS, ഡ്രൈവുകൾ) സൂചിപ്പിക്കുന്നു.',
    'Fires when load % nears or exceeds the contracted demand limit.': 'ലോഡ്% അടുത്ത് വരികയോ അല്ലെങ്കിൽ കരാർ ചെയ്ത ഡിമാൻഡ് പരിധി കവിയുകയോ ചെയ്യുമ്പോൾ ട്രിഗർ ആകുന്നു.',
    'Fires when neutral conductor carries excess current — fire risk.': 'ന്യൂട്രൽ കണ്ടക്ടർ അധിക കറൻ്റ് വഹിക്കുമ്പോൾ ട്രിഗർ ആകുന്നു - തീപിടുത്തം.',
    'Fires when phase current imbalance exceeds threshold.': 'ഘട്ടം കറൻ്റ് അസന്തുലിതാവസ്ഥ ത്രെഷോൾഡ് കവിയുമ്പോൾ ട്രിഗർ ആകുന്നു.',
    'Fires when voltage K-Factor exceeds transformer derating limits — K>4 requires K-rated transformer.': 'വോൾട്ടേജ് കെ-ഫാക്ടർ ട്രാൻസ്ഫോർമർ ഡിറേറ്റിംഗ് പരിധികൾ കവിയുമ്പോൾ ട്രിഗർ ആകുന്നു - K>4-ന് കെ-റേറ്റഡ് ട്രാൻസ്ഫോർമർ ആവശ്യമാണ്.',
    'Fires when voltage THD exceeds safe levels — can damage capacitors, transformers, and sensitive equipment.': 'വോൾട്ടേജ് THD സുരക്ഷിതമായ ലെവലുകൾ കവിയുമ്പോൾ ട്രിഗർ ആകുന്നു — കപ്പാസിറ്ററുകൾ, ട്രാൻസ്ഫോർമറുകൾ, സെൻസിറ്റീവ് ഉപകരണങ്ങൾ എന്നിവയ്ക്ക് കേടുപാടുകൾ വരുത്താം.',
    'Frequency': 'ആവൃത്തി',
    'Frequently asked questions & tech support': 'പതിവായി ചോദിക്കുന്ന ചോദ്യങ്ങളും സാങ്കേതിക പിന്തുണയും',
    'Full': 'നിറഞ്ഞു',
    'Get support directly on WhatsApp chat': 'WhatsApp ചാറ്റിൽ നേരിട്ട് പിന്തുണ നേടുക',
    'Help & Support': 'സഹായവും പിന്തുണയും',
    'Hide code': 'കോഡ് മറയ്ക്കുക',
    'High': 'ഉയർന്നത്',
    'High Current Harmonic Distortion': 'ഉയർന്ന കറൻ്റ് ഹാർമോണിക് ഡിസ്റ്റോർഷൻ',
    'High Current K-Factor': 'ഉയർന്ന കറൻ്റ് കെ-ഫാക്ടർ',
    'High Voltage Harmonic Distortion': 'ഉയർന്ന വോൾട്ടേജ് ഹാർമോണിക് ഡിസ്റ്റോർഷൻ',
    'High Voltage K-Factor': 'ഉയർന്ന വോൾട്ടേജ് കെ-ഫാക്ടർ',
    'High neutral current — possible fire risk from unbalanced phases or loose neutral.': 'ഉയർന്ന ന്യൂട്രൽ കറൻ്റ് - അസന്തുലിതമായ ഘട്ടങ്ങളിൽ നിന്നോ അയഞ്ഞ ന്യൂട്രലിൽ നിന്നോ സാധ്യമായ തീപിടുത്തം.',
    'Hourly Power Log · PDF': 'മണിക്കൂറിൽ പവർ ലോഗ് · PDF',
    'Insufficient data': 'അപര്യാപ്തമായ ഡാറ്റ',
    'Intraday Bill': 'ഇൻട്രാഡേ ബിൽ',
    'K-Factor': 'കെ-ഘടകം',
    'K-Factor distribution · sample count per unit band': 'കെ-ഫാക്ടർ ഡിസ്ട്രിബ്യൂഷൻ · യൂണിറ്റ് ബാൻഡിന് സാമ്പിൾ എണ്ണം',
    'LF Adjustment (projected)': 'LF അഡ്ജസ്റ്റ്മെൻ്റ് (പ്രൊജക്റ്റഡ്)',
    'LF Penalty (projected)': 'LF പെനാൽറ്റി (പ്രൊജക്റ്റ്)',
    'LF Rebate (projected)': 'എൽഎഫ് റിബേറ്റ് (പ്രൊജക്റ്റ്)',
    'Last 24 hours': 'കഴിഞ്ഞ 24 മണിക്കൂർ',
    'Last 24 hours · kW (active) and kVA (apparent)': 'കഴിഞ്ഞ 24 മണിക്കൂർ · kW (ആക്റ്റീവ്), kVA (വ്യക്തം)',
    'Last 30 days': 'കഴിഞ്ഞ 30 ദിവസം',
    'Last 5 instances · all time': 'അവസാന 5 സന്ദർഭങ്ങൾ · എല്ലാ സമയത്തും',
    'Last refresh': 'അവസാന പുതുക്കൽ',
    'Live': 'തത്സമയം',
    'Live Power Factor': 'ലൈവ് പവർ ഫാക്ടർ',
    'Live status, risk indicators and threshold breach density.': 'തത്സമയ നില, അപകടസാധ്യത സൂചകങ്ങൾ, ത്രെഷോൾഡ് ലംഘന സാന്ദ്രത.',
    'Load Factor': 'ലോഡ് ഫാക്ടർ',
    'Load Factor (LF) rebate / surcharge — applied per kWh consumed': 'ലോഡ് ഫാക്ടർ (എൽഎഫ്) റിബേറ്റ് / സർചാർജ് - ഓരോ kWh ഉപഭോഗത്തിനും ബാധകമാണ്',
    'Load Factor Adjustment': 'ലോഡ് ഫാക്ടർ അഡ്ജസ്റ്റ്മെൻ്റ്',
    'Load Factor Penalty': 'ലോഡ് ഫാക്ടർ പെനാൽറ്റി',
    'Load Factor Rebate': 'ലോഡ് ഫാക്ടർ റിബേറ്റ്',
    'Load Factor Utilisation': 'ലോഡ് ഫാക്ടർ വിനിയോഗം',
    'Load Factor adjustment MTD': 'ലോഡ് ഫാക്ടർ ക്രമീകരണം MTD',
    'Load percentage nearing or exceeding contracted demand limit.': 'കരാർ ഡിമാൻഡ് പരിധിക്ക് അടുത്തോ അതിലധികമോ ലോഡ് ശതമാനം.',
    'Loading…': 'ലോഡ് ചെയ്യുന്നു...',
    'Low Power Factor': 'കുറഞ്ഞ പവർ ഫാക്ടർ',
    'MD Peak': 'MD കൊടുമുടി',
    'Max': 'പരമാവധി',
    'Max Demand Analysis': 'പരമാവധി ഡിമാൻഡ് വിശകലനം',
    'Max Demand by Time-of-Day Period': 'ദിവസ കാലയളവ് അനുസരിച്ച് പരമാവധി ഡിമാൻഡ്',
    'Max current K-Factor across phases — rates transformer derating for harmonic loads': 'ഘട്ടങ്ങളിലുടനീളമുള്ള പരമാവധി കറൻ്റ് കെ-ഫാക്ടർ - ഹാർമോണിക് ലോഡുകളുടെ ട്രാൻസ്ഫോർമറിൻ്റെ നിരക്ക് കുറയ്ക്കുന്നു',
    'Max voltage K-Factor across phases — rates transformer derating for harmonic loads': 'ഘട്ടങ്ങളിലുടനീളമുള്ള പരമാവധി വോൾട്ടേജ് കെ-ഫാക്ടർ - ഹാർമോണിക് ലോഡുകളുടെ നിരക്കുകൾ ട്രാൻസ്ഫോർമർ കുറയ്ക്കുന്നു',
    'Maximum demand': 'പരമാവധി ആവശ്യം',
    'Meter overview': 'മീറ്റർ അവലോകനം',
    'Meter rental': 'മീറ്റർ വാടക',
    'Metered': 'അളക്കുന്നത്',
    'Meters discovered': 'കണ്ടെത്തിയ മീറ്ററുകൾ',
    'Metrics · last 5 alerts': 'മെട്രിക്കുകൾ · അവസാന 5 അലേർട്ടുകൾ',
    'Min': 'മിനി',
    'Mon-Sat. 9:00 AM - 6:00 PM IST': 'തിങ്കൾ-ശനി. 9:00 AM - 6:00 PM IST',
    'Month-to-Date': 'മാസം മുതൽ തീയതി വരെ',
    'Month-to-Date Cost': 'പ്രതിമാസ ചെലവ്',
    'Month-to-date bill for': 'പ്രതിമാസ ബിൽ',
    'Most recent 5 breach events · reflects your current thresholds': 'ഏറ്റവും പുതിയ 5 ലംഘന ഇവൻ്റുകൾ · നിങ്ങളുടെ നിലവിലെ പരിധി പ്രതിഫലിപ്പിക്കുന്നു',
    'Must stay': 'താമസിക്കണം',
    'Near limit': 'പരിധിക്ക് സമീപം',
    'Net cost today': 'ഇന്നത്തെ മൊത്തം ചെലവ്',
    'Neutral Current': 'ന്യൂട്രൽ കറൻ്റ്',
    'Neutral zone': 'ന്യൂട്രൽ സോൺ',
    'No adj.': 'പരസ്യമില്ല.',
    'No adjustment': 'അഡ്ജസ്റ്റ്മെൻ്റ് ഇല്ല',
    'No alerts found': 'അലേർട്ടുകളൊന്നും കണ്ടെത്തിയില്ല',
    'No breach events with current thresholds': 'നിലവിലെ പരിധിയിൽ ലംഘന സംഭവങ്ങളൊന്നുമില്ല',
    'No breaches on latest reading': 'ഏറ്റവും പുതിയ വായനയിൽ ലംഘനങ്ങളൊന്നുമില്ല',
    'No data': 'ഡാറ്റ ഇല്ല',
    'No data available yet.': 'ഇതുവരെ വിവരങ്ങളൊന്നും ലഭ്യമല്ല.',
    'No data for': 'എന്നതിന് ഡാറ്റയില്ല',
    'No data for this day': 'ഈ ദിവസത്തെ ഡാറ്റകളൊന്നുമില്ല',
    'No data for this meter yet': 'ഈ മീറ്ററിന് ഇതുവരെ ഡാറ്റയൊന്നുമില്ല',
    'No data for this window': 'ഈ വിൻഡോയ്ക്ക് ഡാറ്റയില്ല',
    'No data in the last 24 hours': 'കഴിഞ്ഞ 24 മണിക്കൂറിൽ ഡാറ്റയൊന്നുമില്ല',
    'No rebate': 'റിബേറ്റില്ല',
    'No samples in': 'സാമ്പിളുകളൊന്നുമില്ല',
    'No variables match your search.': 'നിങ്ങളുടെ തിരയലുമായി പൊരുത്തപ്പെടുന്ന വേരിയബിളുകളൊന്നും ഇല്ല.',
    'None (WBSEDCL B-IDIT)': 'ഒന്നുമില്ല (WBSEDCL B-IDIT)',
    'Normal': 'സാധാരണ',
    'Normal demand charge': 'സാധാരണ ഡിമാൻഡ് ചാർജ്',
    'Normal · peak': 'സാധാരണ · കൊടുമുടി',
    'Notify via': 'വഴി അറിയിക്കുക',
    'Off-Peak': 'ഓഫ്-പീക്ക്',
    'Open dashboard': 'ഡാഷ്‌ബോർഡ് തുറക്കുക',
    'PDF BI': 'PDF BI',
    'PDF columns BE / BF / BG · max of all 15-min averaged blocks per period': 'PDF കോളങ്ങൾ BE / BF / BG · ഒരു കാലയളവിലെ എല്ലാ 15-മിനിറ്റ് ശരാശരി ബ്ലോക്കുകളുടെയും പരമാവധി',
    'PF Adjustment (projected)': 'PF അഡ്ജസ്റ്റ്മെൻ്റ് (പ്രൊജക്റ്റഡ്)',
    'PF Penalty (projected)': 'PF പിഴ (പ്രൊജക്റ്റ്)',
    'PF Penalty / Rebate': 'പിഎഫ് പിഴ / റിബേറ്റ്',
    'PF Rebate (projected)': 'പിഎഫ് റിബേറ്റ് (പ്രൊജക്റ്റ്)',
    'PF rebate / penalty MTD': 'PF റിബേറ്റ് / പിഴ MTD',
    'Password': 'രഹസ്യവാക്ക്',
    'Peak': 'കൊടുമുടി',
    'Peak clipped': 'പീക്ക് ക്ലിപ്പ് ചെയ്തു',
    'Peak kVA': 'പീക്ക് kVA',
    'Penalty': 'പെനാൽറ്റി',
    'Penalty <': 'പിഴ <',
    'Penalty likely': 'പെനാൽറ്റി സാധ്യത',
    'Penalty zone': 'പെനാൽറ്റി സോൺ',
    'Per-phase': 'ഓരോ ഘട്ടത്തിലും',
    'Phase': 'ഘട്ടം',
    'Phase B Current': 'ഘട്ടം ബി നിലവിലെ',
    'Phase B Power': 'ഘട്ടം ബി പവർ',
    'Phase B line current': 'ഘട്ടം ബി ലൈൻ കറൻ്റ്',
    'Phase R Current': 'ഘട്ടം R നിലവിലെ',
    'Phase R Power': 'ഘട്ടം R പവർ',
    'Phase R line current': 'ഘട്ടം R ലൈൻ കറൻ്റ്',
    'Phase Y Current': 'ഘട്ടം Y നിലവിലെ',
    'Phase Y Power': 'ഘട്ടം വൈ പവർ',
    'Phase Y line current': 'ഘട്ടം Y ലൈൻ കറൻ്റ്',
    'Phase current': 'ഘട്ടം കറൻ്റ്',
    'Phase current imbalance — indicates uneven load distribution across phases.': 'ഘട്ടം നിലവിലെ അസന്തുലിതാവസ്ഥ - ഘട്ടങ്ങളിലുടനീളം അസമമായ ലോഡ് വിതരണത്തെ സൂചിപ്പിക്കുന്നു.',
    'Phase voltage (L-N)': 'ഘട്ടം വോൾട്ടേജ് (L-N)',
    'Phase voltage imbalance — can damage motors and reduce equipment life.': 'ഘട്ടം വോൾട്ടേജ് അസന്തുലിതാവസ്ഥ - മോട്ടോറുകൾക്ക് കേടുപാടുകൾ വരുത്തുകയും ഉപകരണങ്ങളുടെ ആയുസ്സ് കുറയ്ക്കുകയും ചെയ്യും.',
    'Phone number copied to clipboard.': 'ഫോൺ നമ്പർ ക്ലിപ്പ്ബോർഡിലേക്ക് പകർത്തി.',
    'Pi CPU Usage': 'പൈ സിപിയു ഉപയോഗം',
    'Pi Memory Usage': 'പൈ മെമ്മറി ഉപയോഗം',
    'Pi Temperature': 'പൈ താപനില',
    'Pi Temperature · Last 24 h': 'പൈ താപനില · കഴിഞ്ഞ 24 മണിക്കൂർ',
    'Power': 'വൈദ്യുതി',
    'Power Analysis': 'പവർ വിശകലനം',
    'Power Factor': 'പവർ ഫാക്ടർ',
    'Power Factor (Month-to-Date)': 'പവർ ഫാക്ടർ (മാസം മുതൽ തീയതി വരെ)',
    'Power Factor (PF) adjustment — applied as % of energy charge per ToD period': 'പവർ ഫാക്ടർ (പിഎഫ്) ക്രമീകരണം - ഓരോ ടോഡി കാലയളവിലും എനർജി ചാർജിൻ്റെ% ആയി പ്രയോഗിക്കുന്നു',
    'Power Factor Adjustment': 'പവർ ഫാക്ടർ അഡ്ജസ്റ്റ്മെൻ്റ്',
    'Power Factor Penalty': 'പവർ ഫാക്ടർ പിഴ',
    'Power Factor Rebate': 'പവർ ഫാക്ടർ റിബേറ്റ്',
    'Power Factor rebate / penalty MTD': 'പവർ ഫാക്ടർ റിബേറ്റ് / പെനാൽറ്റി MTD',
    'Power factor below threshold — attracting TGSPDCL RKVAH penalty on energy bill.': 'പരിധിക്ക് താഴെയുള്ള പവർ ഫാക്ടർ - ഊർജ്ജ ബില്ലിൽ TGSPDCL RKVAH പിഴ ഈടാക്കുന്നു.',
    'Production build · v1.0': 'പ്രൊഡക്ഷൻ ബിൽഡ് · v1.0',
    'Projected Bill': 'പ്രൊജക്റ്റഡ് ബിൽ',
    'Projected Bill · Month-End Estimate': 'പ്രൊജക്റ്റഡ് ബിൽ · മാസാവസാന എസ്റ്റിമേറ്റ്',
    'Projected energy charge (gross)': 'പ്രൊജക്റ്റഡ് എനർജി ചാർജ് (മൊത്തം)',
    'Projected net payable by due date': 'നിശ്ചിത തീയതിക്കകം നൽകേണ്ട പ്രൊജക്റ്റ് നെറ്റ്',
    'Projection uses a linear run-rate from': 'പ്രൊജക്ഷൻ ഒരു ലീനിയർ റൺ-റേറ്റ് ഉപയോഗിക്കുന്നു',
    'RAM Usage (%)': 'റാം ഉപയോഗം (%)',
    'Raspberry Pi CPU temperature': 'റാസ്ബെറി പൈ സിപിയു താപനില',
    'Raspberry Pi CPU utilisation': 'റാസ്‌ബെറി പൈ സിപിയു ഉപയോഗം',
    'Raspberry Pi Gateway': 'റാസ്‌ബെറി പൈ ഗേറ്റ്‌വേ',
    'Raspberry Pi memory utilisation': 'റാസ്‌ബെറി പൈ മെമ്മറി ഉപയോഗം',
    'Rebate': 'റിബേറ്റ്',
    'Rebate earned': 'റിബേറ്റ് നേടി',
    'Rebate zone': 'റിബേറ്റ് സോൺ',
    'Refresh': 'പുതുക്കുക',
    'Refresh interval': 'പുതുക്കൽ ഇടവേള',
    'Remove this rule': 'ഈ നിയമം നീക്കം ചെയ്യുക',
    'Response time usually within 2 hours': 'പ്രതികരണ സമയം സാധാരണയായി 2 മണിക്കൂറിനുള്ളിൽ',
    'Rules saved on this device. Production build routes notifications via SMS and WhatsApp.': 'ഈ ഉപകരണത്തിൽ നിയമങ്ങൾ സംരക്ഷിച്ചു. എസ്എംഎസ് വഴിയും വാട്ട്‌സ്ആപ്പ് വഴിയും പ്രൊഡക്ഷൻ ബിൽഡ് റൂട്ടുകളുടെ അറിയിപ്പുകൾ.',
    'Running daily energy cost (₹)': 'പ്രതിദിന ഊർജ്ജ ചെലവ് (₹)',
    'Running maximum of kVA averaged over 15 minutes window': 'ശരാശരി 15 മിനിറ്റ് വിൻഡോയിൽ പരമാവധി kVA പ്രവർത്തിക്കുന്നു',
    'Running session energy (kWh)': 'റണ്ണിംഗ് സെഷൻ ഊർജ്ജം (kWh)',
    'SAFE': 'സുരക്ഷിതം',
    'Safe': 'സുരക്ഷിതം',
    'Samples loaded': 'ഡാറ്റ സാമ്പിളുകൾ',
    'Save Alert Rules': 'അലേർട്ട് നിയമങ്ങൾ സംരക്ഷിക്കുക',
    'Search variables…': 'വേരിയബിളുകൾ തിരയുക...',
    'Select Language': 'ഭാഷ തിരഞ്ഞെടുക്കുക',
    'Select a date range above': 'മുകളിലുള്ള ഒരു തീയതി ശ്രേണി തിരഞ്ഞെടുക്കുക',
    'Select billing period': 'ബില്ലിംഗ് കാലയളവ് തിരഞ്ഞെടുക്കുക',
    'Select language': 'ഭാഷ തിരഞ്ഞെടുക്കുക',
    'Select meter': 'മീറ്റർ തിരഞ്ഞെടുക്കുക',
    'Send Email': 'ഇമെയിൽ അയയ്ക്കുക',
    'Session Energy': 'സെഷൻ ഊർജ്ജം',
    'Session carbon footprint (kg CO₂)': 'സെഷൻ കാർബൺ കാൽപ്പാട് (കിലോ CO₂)',
    'Settings': 'സെറ്റിംഗ്സ്',
    'Share': 'പങ്കിടുക',
    'Show code': 'കോഡ് കാണിക്കുക',
    'Showing': 'കാണിക്കുന്നു',
    'Showing cached data — we\'ll keep retrying automatically.': 'കാഷെ ചെയ്ത ഡാറ്റ കാണിക്കുന്നു - ഞങ്ങൾ സ്വയമേവ വീണ്ടും ശ്രമിച്ചുകൊണ്ടിരിക്കും.',
    'Showing month-to-date charges': 'പ്രതിമാസ നിരക്കുകൾ കാണിക്കുന്നു',
    'Showing today\'s charges': 'ഇന്നത്തെ നിരക്കുകൾ കാണിക്കുന്നു',
    'Sign out': 'സൈൻ ഔട്ട്',
    'Similar to average': 'ശരാശരിക്ക് സമാനമാണ്',
    'Similar to this week\'s average': 'ഈ ആഴ്‌ചയിലെ ശരാശരിക്ക് സമാനമാണ്',
    'Since midnight IST · updates every 5 min': 'അർദ്ധരാത്രി മുതൽ IST · ഓരോ 5 മിനിറ്റിലും അപ്‌ഡേറ്റുകൾ',
    'Site': 'സൈറ്റ്',
    'Sum of all phase currents': 'എല്ലാ ഘട്ട പ്രവാഹങ്ങളുടെയും ആകെത്തുക',
    'Surcharge': 'സർചാർജ്',
    'THD distribution · sample count per 2% band': 'THD വിതരണം · 2% ബാൻഡിന് സാമ്പിൾ എണ്ണം',
    'Telangana': 'തെലങ്കാന',
    'Temperature (°C)': 'താപനില (°C)',
    'This Month': 'ഈ മാസം',
    'This week (Sun – yesterday)': 'ഈ ആഴ്ച (സൂര്യൻ - ഇന്നലെ)',
    'Threshold': 'ത്രെഷോൾഡ്',
    'Time distribution': 'സമയ വിതരണം',
    'Time-of-Day Split': 'ദിവസത്തിൻ്റെ സമയ വിഭജനം',
    'Timely Payment Rebate': 'സമയബന്ധിതമായ പേയ്‌മെൻ്റ് റിബേറ്റ്',
    'ToD Off-Peak Rebate': 'ToD ഓഫ്-പീക്ക് റിബേറ്റ്',
    'ToD Peak Penalty': 'ToD പീക്ക് പെനാൽറ്റി',
    'Today': 'ഇന്ന്',
    'Today PF': 'ഇന്ന് പി.എഫ്',
    'Today is': 'ഇന്നാണ്',
    'Today\'s Cost': 'ഇന്നത്തെ ചെലവ്',
    'Today\'s Running Cost': 'ഇന്നത്തെ റണ്ണിംഗ് കോസ്റ്റ്',
    'Total': 'ആകെ',
    'Total Active Power': 'മൊത്തം സജീവ ശക്തി',
    'Total Apparent Power': 'മൊത്തം പ്രത്യക്ഷ ശക്തി',
    'Total Current': 'മൊത്തം കറൻ്റ്',
    'Total Energy (kWh) consumed last month / (Peak kW observed last month times number of hours last month)': 'കഴിഞ്ഞ മാസം ഉപയോഗിച്ച മൊത്തം ഊർജ്ജം (kWh) / (കഴിഞ്ഞ മാസം നിരീക്ഷിച്ച പീക്ക് kW കഴിഞ്ഞ മാസത്തെ മണിക്കൂറുകളുടെ എണ്ണം)',
    'Total Energy (kWh) consumed this month / (Peak kW observed this month times number of hours this month)': 'ഈ മാസം ഉപയോഗിച്ച മൊത്തം ഊർജ്ജം (kWh) / (ഈ മാസത്തെ പീക്ക് kW, ഈ മാസത്തെ മണിക്കൂറുകളുടെ എണ്ണം)',
    'Total Energy (kWh) consumed this week / (Peak kW observed this week times number of hours this week)': 'ഈ ആഴ്‌ച ഉപയോഗിച്ച മൊത്തം ഊർജ്ജം (kWh)',
    'Total Energy (kWh) consumed today/ (Peak kW observed today times number of hours today)': 'ഇന്ന് ഉപയോഗിക്കുന്ന മൊത്തം ഊർജ്ജം (kWh)',
    'Total Energy Charge': 'മൊത്തം ഊർജ്ജ ചാർജ്',
    'Total Harmonic Distortion (%)': 'ആകെ ഹാർമോണിക് ഡിസ്റ്റോർഷൻ (%)',
    'Total Watts': 'മൊത്തം വാട്ട്സ്',
    'Total active power across all phases': 'എല്ലാ ഘട്ടങ്ങളിലും മൊത്തം സജീവ ശക്തി',
    'Total apparent power (kVA)': 'മൊത്തം പ്രത്യക്ഷ ശക്തി (kVA)',
    'Total demand cost': 'മൊത്തം ഡിമാൻഡ് ചെലവ്',
    'Total instantaneous power in watts': 'വാട്ടുകളിൽ ആകെ തൽക്ഷണ ശക്തി',
    'Try again': 'വീണ്ടും ശ്രമിക്കുക',
    'Try another meter or wait for the next refresh.': 'മറ്റൊരു മീറ്റർ പരീക്ഷിക്കുക അല്ലെങ്കിൽ അടുത്ത പുതുക്കലിനായി കാത്തിരിക്കുക.',
    'Use one of the access codes provided for your site.': 'നിങ്ങളുടെ സൈറ്റിനായി നൽകിയിരിക്കുന്ന ആക്സസ് കോഡുകളിലൊന്ന് ഉപയോഗിക്കുക.',
    'Utilisation %': 'ഉപയോഗം %',
    'Voltage': 'വോൾട്ടേജ്',
    'Voltage Imbalance': 'വോൾട്ടേജ് അസന്തുലിതാവസ്ഥ',
    'Voltage K-Factor': 'വോൾട്ടേജ് കെ-ഫാക്ടർ',
    'Voltage K-Factor exceeds transformer derating limit — K>4 requires a K-rated transformer.': 'വോൾട്ടേജ് കെ-ഫാക്ടർ ട്രാൻസ്ഫോർമർ ഡിറേറ്റിംഗ് പരിധി കവിയുന്നു - K>4-ന് കെ-റേറ്റഡ് ട്രാൻസ്ഫോർമർ ആവശ്യമാണ്.',
    'WARN': 'മുന്നറിയിപ്പ്',
    'Warn': 'മുന്നറിയിപ്പ് നൽകുക',
    'Warning': 'മുന്നറിയിപ്പ്',
    'Warning above': 'മുകളിൽ മുന്നറിയിപ്പ്',
    'Warning below': 'മുന്നറിയിപ്പ് താഴെ',
    'Warning · peak': 'മുന്നറിയിപ്പ് · കൊടുമുടി',
    'WhatsApp Support': 'WhatsApp പിന്തുണ',
    'Within Limit': 'പരിധിക്കുള്ളിൽ',
    'Worst': 'ഏറ്റവും മോശം',
    'Yesterday': 'ഇന്നലെ',
    'above': 'മുകളിൽ',
    'above CD': 'മുകളിൽ സി.ഡി',
    'above this week\'s avg': 'ഈ ആഴ്‌ചയിലെ ശരാശരിക്ക് മുകളിൽ',
    'above this week\'s avg — good day': 'ഈ ആഴ്‌ചയിലെ ശരാശരിക്ക് മുകളിൽ - നല്ല ദിവസം',
    'active': 'സജീവമാണ്',
    'active issue': 'സജീവ പ്രശ്നം',
    'active issues': 'സജീവമായ പ്രശ്നങ്ങൾ',
    'added to bill': 'ബില്ലിൽ ചേർത്തു',
    'added to this month\'s bill': 'ഈ മാസത്തെ ബില്ലിൽ ചേർത്തു',
    'adjustment': 'ക്രമീകരിക്കൽ',
    'all charges finalised.': 'എല്ലാ ചാർജുകളും അന്തിമമായി.',
    'and': 'ഒപ്പം',
    'applied for Load Factor ≥ 65%': 'ലോഡ് ഫാക്ടറിന് ≥ 65% അപേക്ഷിച്ചു',
    'average': 'ശരാശരി',
    'avg': 'ശരാശരി',
    'below': 'താഴെ',
    'below average': 'ശരാശരിയിൽ താഴെ',
    'below min → charged on': 'മിനിറ്റിന് താഴെ → ചാർജ് ചെയ്തു',
    'below this week\'s avg': 'ഈ ആഴ്‌ചയിലെ ശരാശരിക്ക് താഴെ',
    'below this week\'s avg — below average': 'ഈ ആഴ്‌ചയിലെ ശരാശരിക്ക് താഴെ - ശരാശരിയിലും താഴെ',
    'consumers under TOD Tariff (CD > 50 kVA); % of energy charge per ToD period': 'TOD താരിഫിന് കീഴിലുള്ള ഉപഭോക്താക്കൾ (CD > 50 kVA); ഓരോ ToD കാലയളവിലും ഊർജ്ജ ചാർജിൻ്റെ %',
    'critical': 'വിമർശനാത്മകം',
    'current': 'നിലവിലെ',
    'day bill for': 'ദിവസ ബിൽ',
    'day run rate': 'ദിവസത്തെ റൺ റേറ്റ്',
    'days': 'ദിവസങ്ങൾ',
    'days of actual data.': 'യഥാർത്ഥ ഡാറ്റയുടെ ദിവസങ്ങൾ.',
    'days of meter data': 'മീറ്റർ ഡാറ്റയുടെ ദിവസങ്ങൾ',
    'days remaining': 'ദിവസങ്ങൾ ബാക്കി',
    'days required for': 'ആവശ്യമായ ദിവസങ്ങൾ',
    'deducted from bill': 'ബില്ലിൽ നിന്ന് കുറച്ചു',
    'deducted from this month\'s bill': 'ഈ മാസത്തെ ബില്ലിൽ നിന്ന് കുറച്ചു',
    'delivered': 'എത്തിച്ചു',
    'energy charges, Power Factor & Load Factor adjustments, demand charge, duties, and projected net payable.': 'എനർജി ചാർജുകൾ, പവർ ഫാക്ടർ & ലോഡ് ഫാക്ടർ അഡ്ജസ്റ്റ്‌മെൻ്റുകൾ, ഡിമാൻഡ് ചാർജ്, ഡ്യൂട്ടികൾ, പ്രൊജക്റ്റഡ് നെറ്റ് അടയ്‌ക്കേണ്ടവ.',
    'energy per day': 'പ്രതിദിനം ഊർജ്ജം',
    'energy per hour': 'മണിക്കൂറിൽ ഊർജ്ജം',
    'excess above CD': 'സിഡിക്ക് മുകളിലുള്ള അധികമാണ്',
    'fires when <': 'ട്രിഗർ ആകുന്നു <',
    'fires when >': 'ട്രിഗർ ആകുന്നു >',
    'good day': 'നല്ല ദിവസം',
    'if paid after 15 days': '15 ദിവസത്തിന് ശേഷം പണമടച്ചാൽ',
    'if paid by due date': 'നിശ്ചിത തീയതിയിൽ പണമടച്ചാൽ',
    'imbal': 'ഇമ്പാൽ',
    'invoice estimate': 'ഇൻവോയ്സ് എസ്റ്റിമേറ്റ്',
    'is above this week\'s avg': 'ഈ ആഴ്‌ചയിലെ ശരാശരിക്ക് മുകളിലാണ്',
    'is below this week\'s avg': 'ഈ ആഴ്‌ചയിലെ ശരാശരിക്ക് താഴെയാണ്',
    'kVA/month': 'kVA/മാസം',
    'kVAh': 'kVAh',
    'kWh': 'kWh',
    'limit': 'പരിധി',
    'meter': 'മീറ്റർ',
    'meters': 'മീറ്റർ',
    'min demand applies': 'മിനിമം ആവശ്യം ബാധകമാണ്',
    'month': 'മാസം',
    'month-to-date': 'മാസം മുതൽ തീയതി വരെ',
    'net incl. all charges': 'നെറ്റ് ഉൾപ്പെടെ. എല്ലാ ചാർജുകളും',
    'net today': 'ഇന്ന് നെറ്റ്',
    'never': 'ഒരിക്കലും',
    'no adj.': 'adj ഇല്ല.',
    'no adjustment': 'ക്രമീകരണം ഇല്ല',
    'no adjustment applicable': 'ക്രമീകരണം ബാധകമല്ല',
    'no adjustment today': 'ഇന്ന് ക്രമീകരണമില്ല',
    'nom': 'നമ്പർ',
    'not yet applicable today': 'ഇന്നും ബാധകമല്ല',
    'of': 'യുടെ',
    'of 24 hours have data': '24 മണിക്കൂർ ഡാറ്റയുണ്ട്',
    'of CD': 'സിഡിയുടെ',
    'of bill': 'ബില്ലിൻ്റെ',
    'of gross bill': 'മൊത്ത ബില്ലിൻ്റെ',
    'of net bill': 'നെറ്റ് ബില്ലിൻ്റെ',
    'off': 'ഓഫ്',
    'on the excess kVA.': 'അധിക kVA-യിൽ.',
    'over-threshold': 'ഓവർ-ത്രെഷോൾഡ്',
    'paise/kVAh  (6p flat)': 'പൈസ/kVAh (6p ഫ്ലാറ്റ്)',
    'paise/kWh rebate': 'പൈസ/kWh റിബേറ്റ്',
    'paise/kWh surcharge': 'പൈസ/kWh സർചാർജ്',
    'peak kVA': 'കൊടുമുടി kVA',
    'peak kVA today': 'ഇന്ന് ഏറ്റവും ഉയർന്ന kVA',
    'penalty': 'പിഴ',
    'projected penalty': 'പ്രൊജക്റ്റ് പെനാൽറ്റി',
    'projected rebate': 'പ്രൊജക്റ്റ് റിബേറ്റ്',
    'projected surcharge': 'പ്രൊജക്റ്റ് സർചാർജ്',
    'readings': 'റീഡിംഗുകൾ',
    'readings · 3 phases': 'വായനകൾ · 3 ഘട്ടങ്ങൾ',
    'rebate': 'റിബേറ്റ്',
    'rebate / kWh': 'റിബേറ്റ് / kWh',
    'rebate earned': 'റിബേറ്റ് നേടി',
    's': 'എസ്',
    's when the tab is visible.': 'ടാബ് ദൃശ്യമാകുമ്പോൾ s.',
    'samples': 'സാമ്പിളുകൾ',
    'surcharge': 'സർചാർജ്',
    'surcharge / kWh': 'സർചാർജ് / kWh',
    'surcharge added to bill': 'ബില്ലിൽ സർചാർജ് ചേർത്തു',
    'surcharge applied': 'സർചാർജ് പ്രയോഗിച്ചു',
    'threshold': 'ഉമ്മരപ്പടി',
    'to': 'വരെ',
    'units consumed so far': 'ഇതുവരെ ഉപയോഗിച്ച യൂണിറ്റുകൾ',
    'updated every 5 min': 'ഓരോ 5 മിനിറ്റിലും അപ്ഡേറ്റ് ചെയ്യുന്നു',
    'updating…': 'അപ്ഡേറ്റ് ചെയ്യുന്നു...',
    'warn': 'മുന്നറിയിപ്പ്',
    '· added to bill today': '· ഇന്നത്തെ ബില്ലിൽ ചേർത്തു',
    '· saving deducted today': '· സേവിംഗ് ഇന്ന് കുറച്ചിരിക്കുന്നു',
    '· surcharge added today': '· ഇന്ന് സർചാർജ് ചേർത്തു',
    '— · awaiting data': '— · ഡാറ്റയ്ക്കായി കാത്തിരിക്കുന്നു',
    '≥': '≥',
    '⚠ No Pi telemetry in current data — fields piTempC / piMemPct not populated': '⚠ നിലവിലെ ഡാറ്റയിൽ പൈ ടെലിമെട്രി ഇല്ല — ഫീൽഡുകൾ piTempC / piMemPct പോപ്പുലേറ്റ് ചെയ്തിട്ടില്ല',
    '⚠️ Thermal throttle active — Pi is running hot, performance reduced': '⚠️ തെർമൽ ത്രോട്ടിൽ സജീവമാണ് - പൈ ചൂടായി പ്രവർത്തിക്കുന്നു, പ്രകടനം കുറയുന്നു',
    '✓ Rules Saved Successfully': '✓ നിയമങ്ങൾ വിജയകരമായി സംരക്ഷിച്ചു',
  },
  mr: {
    'This Week': 'या आठवड्यात',
    'Last Month': 'गेल्या महिन्यात',
    'Sensor Dropout': 'सेन्सर ड्रॉपआउट',
    'Approaching Overload': 'ओव्हरलोड जवळ येत आहे',
    'Frequency Deviation': 'वारंवारता विचलन',
    'High Voltage THD': 'उच्च व्होल्टेज THD',
    'High Current THD': 'उच्च करंट THD',
    'In-app': 'अ‍ॅपमध्ये',
    'SMS': 'एसएमएस',
    'WhatsApp': 'व्हॉट्सअ‍ॅप',
    'Min. chargeable demand': 'किमान चार्जेबल मागणी',
    'Demand charge — Normal': 'डिमांड चार्ज — सामान्य',
    'Demand charge — Penal': 'डिमांड चार्ज — दंडात्मक',
    'Electricity duty': 'वीज शुल्क',
    'Late payment surcharge': 'विलंब पेमेंट अधिभार',
    'Demand charge (up to CD)': 'डिमांड चार्ज (CD पर्यंत)',
    'Generating': 'तयार होत आहे',
    'Bill PDF…': 'बिल PDF…',
    'What is the Power Analysis Dashboard?': 'पॉवर अ‍ॅनालिसिस डॅशबोर्ड म्हणजे काय?',
    'It monitors real-time electrical metrics (voltage, current, power factor, demand, active/reactive energy) collected from Raspberry Pi edge nodes installed at the site.': 'हे साइटवर स्थापित केलेल्या Raspberry Pi एज नोड्समधून गोळा केलेल्या रिअल-टाइम विद्युत मेट्रिक्सचे (व्होल्टेज, करंट, पॉवर फॅक्टर, डिमांड, अ‍ॅक्टिव्ह/रिअ‍ॅक्टिव्ह ऊर्जा) निरीक्षण करते.',
    'What do the green/orange/red indicators mean?': 'हिरव्या/नारिंगी/लाल निर्देशकांचा अर्थ काय आहे?',
    'Green means the Raspberry Pi edge node is online and reporting health telemetry normally. Orange/red indicate potential communication delays or high temperature/resource throttling.': 'हिरवा म्हणजे Raspberry Pi एज नोड ऑनलाइन आहे आणि सामान्यपणे हेल्थ टेलिमेट्री रिपोर्ट करत आहे. नारिंगी/लाल संभाव्य संप्रेषण विलंब किंवा उच्च तापमान/संसाधन थ्रॉटलिंग दर्शवतात.',
    'How are billing demand charges calculated?': 'बिलिंग डिमांड चार्जची गणना कशी केली जाते?',
    'Demand charges are based on the Maximum Demand (MD) recorded in 15-minute integration windows, calculated according to the active tariff structure (e.g., TGSPDCL HT or WBSEDCL B-IDIT).': 'डिमांड चार्ज 15-मिनिटांच्या इंटिग्रेशन विंडोमध्ये नोंदवलेल्या कमाल मागणीवर (MD) आधारित असतात, सक्रिय दर रचनेनुसार (उदा., TGSPDCL HT किंवा WBSEDCL B-IDIT) गणना केली जाते.',
    'What should I do if the dashboard shows "No data"?': 'डॅशबोर्डवर "डेटा नाही" दाखवल्यास मी काय करावे?',
    'Verify that the edge node (Raspberry Pi gateway) is powered on and connected to the internet. If the issue persists, contact technical support immediately.': 'एज नोड (Raspberry Pi गेटवे) चालू आहे आणि इंटरनेटशी जोडलेला आहे याची खात्री करा. समस्या कायम राहिल्यास, ताबडतोब तांत्रिक सहाय्याशी संपर्क साधा.',
    '% of readings': 'वाचनाचा %',
    '/month': '/ महिना',
    '0.4 kV supply': '०.४ केव्ही पुरवठा',
    '12 AM – 12 AM': 'रात्री १२ - रात्री १२',
    '1st 12 AM → now': '१ तारीख रात्री १२ → आतापर्यंत',
    '2x penalty': '2x दंड',
    '33 kV supply': '33 केव्ही पुरवठा',
    'About': 'बद्दल',
    'Above': 'वर',
    'Across': 'ओलांडून',
    'Active (kW)': 'सक्रिय (kW)',
    'Active Power & Apparent Power': 'सक्रिय शक्ती आणि उघड शक्ती',
    'Active power on Phase B': 'फेज बी वर सक्रिय शक्ती',
    'Active power on Phase R': 'फेज आर वर सक्रिय शक्ती',
    'Active power on Phase Y': 'फेज Y वर सक्रिय शक्ती',
    'Active tariff': 'सक्रिय टॅरिफ',
    'Add custom variable alert': 'कस्टम व्हेरिएबल अलर्ट जोडा',
    'Additional demand charge': 'अतिरिक्त मागणी शुल्क',
    'Alert History': 'अलर्ट इतिहास',
    'Alert Rules': 'सूचना नियम',
    'Alerts': 'अलर्ट',
    'All energy/PF/LF values computed by the Cortex Pi gateway per VARIABLES.pdf §2.3 & §3. Demand, ED, rental, and TPR computed in the browser from WBSEDCL tariff constants.': 'Cortex Pi गेटवे प्रति VARIABLES.pdf §2.3 आणि §3 द्वारे गणना केलेली सर्व ऊर्जा/PF/LF मूल्ये. मागणी, ED, भाडे, आणि TPR ची गणना WBSEDCL टॅरिफ स्थिरांकांवरून ब्राउझरमध्ये केली जाते.',
    'All systems normal': 'सर्व प्रणाली सामान्य',
    'Anomalies': 'विसंगती',
    'Anomaly': 'विसंगती',
    'Apparent': 'आभासी ऊर्जा',
    'Apparent (kVA)': 'स्पष्ट (kVA)',
    'Approaching Contracted Demand': 'कंत्राटी मागणी गाठत',
    'Auto-refreshes every': 'प्रत्येक स्वयं-रिफ्रेश करते',
    'Average Power Factor': 'सरासरी पॉवर फॅक्टर',
    'Average power factor across': 'सरासरी पॉवर फॅक्टर ओलांडून',
    'Avg': 'सरासरी',
    'Avg Active Power': 'सरासरी सक्रिय शक्ती',
    'Avg Apparent Power': 'सरासरी उघड शक्ती',
    'Base Energy Charge': 'बेस एनर्जी चार्ज',
    'Based on': 'वर आधारित',
    'Below': 'खाली',
    'Between': 'दरम्यान',
    'Billing': 'बिलिंग',
    'Billing Cycle Peak': 'बिलिंग सायकल पीक',
    'Billing Overview': 'बिलिंगचा आढावा',
    'Both levels disabled': 'दोन्ही स्तर अक्षम',
    'Building PDF…': 'पीडीएफ तयार करत आहे...',
    'CD': 'CD',
    'CD 100%': 'CD 100%',
    'CORTEX by Vireon': 'कॉर्टेक्स - व्हायरॉन द्वारे',
    'CRIT': 'CRIT',
    'Call Now': 'आता कॉल करा',
    'Call Support': 'कॉल सपोर्ट',
    'Carbon (CO₂)': 'कार्बन (CO₂)',
    'Chargeable demand': 'चार्जेबल मागणी',
    'Chargeable min:': 'चार्ज करण्यायोग्य किमान:',
    'Chat on WhatsApp': 'व्हॉट्सॲपवर चॅट करा',
    'Check back when more data is synced.': 'अधिक डेटा समक्रमित झाल्यावर परत तपासा.',
    'Check your network or sheet sharing settings (Anyone with the link → Viewer).': 'तुमचे नेटवर्क किंवा शीट शेअरिंग सेटिंग्ज तपासा (लिंक असलेले कोणीही → दर्शक).',
    'Choose a variable': 'व्हेरिएबल निवडा',
    'Close': 'बंद करा',
    'Close Help and Support Modal': 'मदत आणि समर्थन मॉडेल बंद करा',
    'Connecting…': 'कनेक्ट करत आहे...',
    'Consumer': 'ग्राहक',
    'Contact Tech Support': 'टेक सपोर्टशी संपर्क साधा',
    'Contact your administrator if you do not have one.': 'तुमच्याकडे नसल्यास तुमच्या प्रशासकाशी संपर्क साधा.',
    'Contract': 'करार',
    'Contract Demand (CD)': 'करार मागणी (CD)',
    'Contract Demand Utilisation': 'करार मागणी वापर',
    'Contract demand:': 'कराराची मागणी:',
    'Contract limit': 'करार मर्यादा',
    'Copy Number': 'क्रमांक कॉपी करा',
    'Cost': 'खर्च',
    'Cost breakdown': 'खर्चाचा तपशील',
    'Couldn\'t reach the data sheet': 'डेटा शीटपर्यंत पोहोचू शकलो नाही',
    'Couldn\'t refresh just now.': 'आत्ताच रिफ्रेश करू शकलो नाही.',
    'Crit': 'क्रिट',
    'Critical': 'गंभीर',
    'Critical above': 'वर गंभीर',
    'Critical below': 'खाली गंभीर',
    'Critical · peak': 'गंभीर · शिखर',
    'Current': 'करंट',
    'Current Imbalance': 'करंट असमतोल',
    'Current K-Factor': 'वर्तमान के-फॅक्टर',
    'Current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'सध्याचा के-फॅक्टर गंभीर हार्मोनिक लोडिंग दर्शवतो — ट्रान्सफॉर्मर कमी केला गेला पाहिजे किंवा के-रेट युनिटने बदलला पाहिजे.',
    'Current status': 'सद्यस्थिती',
    'Custom': 'सानुकूल',
    'Custom Alerts': 'सानुकूल सूचना',
    'Custom range': 'सानुकूल श्रेणी',
    'Customer charges': 'ग्राहक शुल्क',
    'Daily Cost': 'दैनिक खर्च',
    'Dashboard': 'डॅशबोर्ड',
    'Deep dive': 'सखोल विश्लेषण',
    'Demand Penalty Applied': 'मागणी दंड लागू',
    'Demand charge (billing-cycle peak)': 'डिमांड चार्ज (बिलिंग-सायकल पीक)',
    'Demand charge is fixed from the billing cycle peak. PF rebate and LF rebate/surcharge are projected at current rates.': 'बिलिंग सायकल पीक पासून मागणी शुल्क निश्चित केले आहे. पीएफ सवलत आणि एलएफ सवलत/अधिभार सध्याच्या दरांवर प्रक्षेपित आहेत.',
    'Demand charges — when Maximum Demand (MD) exceeds Contract Demand (CD)': 'मागणी शुल्क - जेव्हा कमाल मागणी (MD) कॉन्ट्रॅक्ट डिमांड (CD) पेक्षा जास्त असते',
    'Demands under CD pay standard rates on chargeable kVA. Exceeding CD triggers a': 'CD अंतर्गत मागणी आकारण्यायोग्य kVA वर मानक दर देतात. ओलांडणे सीडी ट्रिगर करते a',
    'Detected on most recent reading': 'सर्वात अलीकडील वाचनावर आढळले',
    'Disabled — no notifications': 'अक्षम — कोणत्याही सूचना नाहीत',
    'Download Bill': 'बिल डाउनलोड करा',
    'Download Bill PDF': 'बिल PDF डाउनलोड करा',
    'Download Log': 'लॉग डाउनलोड करा',
    'Download PDF': 'पीडीएफ डाउनलोड करा',
    'Download a printable daily log · Accumulated kWh, Power Factor per hour': 'छापण्यायोग्य दैनिक लॉग डाउनलोड करा · जमा kWh, पॉवर फॅक्टर प्रति तास',
    'Edge Node · Raspberry Pi Health': 'एज नोड · रास्पबेरी पाई आरोग्य',
    'Electricity Duty (projected)': 'विद्युत शुल्क (प्रकल्पित)',
    'Elevated current THD — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress and overheating.': 'एलिव्हेटेड करंट THD — नॉन-लाइनियर लोड्स (VFDs, UPS, ड्राइव्हस्) सूचित करते ज्यामुळे ट्रान्सफॉर्मरचा ताण आणि जास्त गरम होते.',
    'Elevated voltage THD — can damage capacitors, transformers, and sensitive equipment. IEEE 519 limit is 8%.': 'एलिव्हेटेड व्होल्टेज THD — कॅपेसिटर, ट्रान्सफॉर्मर आणि संवेदनशील उपकरणे खराब करू शकतात. IEEE 519 मर्यादा 8% आहे.',
    'Email Support': 'ईमेल समर्थन',
    'Energy': 'ऊर्जा',
    'Energy Charges · Time-of-Day Split': 'ऊर्जा शुल्क · वेळ-दिवसाचे विभाजन',
    'Energy by Time-of-Day': 'दिवसाच्या वेळेनुसार ऊर्जा',
    'Energy charges + Demand charges + Electricity Duty + Customer charges · accumulated till date': 'ऊर्जा शुल्क + मागणी शुल्क + विद्युत शुल्क + ग्राहक शुल्क · आजपर्यंत जमा',
    'Energy charges + Power Factor adjustment + Load Factor rebates + Demand charges + Electricity Duty + Meter rental · accumulated till date': 'ऊर्जा शुल्क + पॉवर फॅक्टर समायोजन + लोड फॅक्टर सवलत + मागणी शुल्क + विद्युत शुल्क + मीटर भाडे · आजपर्यंत जमा',
    'Energy charges accumulated by tariff period': 'टॅरिफ कालावधीनुसार जमा झालेले ऊर्जा शुल्क',
    'Energy delivered': 'ऊर्जा दिली',
    'Enter the access password for your site.': 'तुमच्या साइटसाठी प्रवेश संकेतशब्द प्रविष्ट करा.',
    'Enter your access password': 'तुमचा प्रवेश संकेतशब्द प्रविष्ट करा',
    'Failed to copy phone number.': 'फोन नंबर कॉपी करण्यात अयशस्वी.',
    'Fires when PF drops below threshold — attracts utility penalty.': 'पीएफ थ्रेशोल्डच्या खाली गेल्यावर ट्रिगर होते — युटिलिटी पेनल्टी आकर्षित करते.',
    'Fires when current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'जेव्हा वर्तमान के-फॅक्टर गंभीर हार्मोनिक लोडिंग दर्शवते तेव्हा ट्रिगर होते — ट्रान्सफॉर्मर कमी करणे आवश्यक आहे किंवा के-रेट युनिटने बदलले पाहिजे.',
    'Fires when current THD exceeds safe levels — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress.': 'जेव्हा वर्तमान THD सुरक्षित पातळी ओलांडते तेव्हा ट्रिगर होते — नॉन-लिनियर लोड्स (VFDs, UPS, ड्राइव्ह) दर्शवते ज्यामुळे ट्रान्सफॉर्मर तणाव होतो.',
    'Fires when load % nears or exceeds the contracted demand limit.': 'जेव्हा लोड % कॉन्ट्रॅक्ट केलेल्या मागणी मर्यादेच्या जवळ किंवा ओलांडते तेव्हा ट्रिगर होते.',
    'Fires when neutral conductor carries excess current — fire risk.': 'जेव्हा तटस्थ कंडक्टरमध्ये जास्त विद्युत प्रवाह असतो तेव्हा ट्रिगर होते - आगीचा धोका.',
    'Fires when phase current imbalance exceeds threshold.': 'जेव्हा फेज चालू असमतोल थ्रेशोल्ड ओलांडते तेव्हा ट्रिगर होते.',
    'Fires when voltage K-Factor exceeds transformer derating limits — K>4 requires K-rated transformer.': 'व्होल्टेज के-फॅक्टरने ट्रान्सफॉर्मरची मर्यादा ओलांडली की ट्रिगर होते — K>4 ला K-रेट केलेले ट्रान्सफॉर्मर आवश्यक आहे.',
    'Fires when voltage THD exceeds safe levels — can damage capacitors, transformers, and sensitive equipment.': 'जेव्हा व्होल्टेज THD सुरक्षित पातळी ओलांडते तेव्हा ट्रिगर होते — कॅपेसिटर, ट्रान्सफॉर्मर आणि संवेदनशील उपकरणांना नुकसान होऊ शकते.',
    'Frequency': 'वारंवारता',
    'Frequently asked questions & tech support': 'वारंवार विचारले जाणारे प्रश्न आणि तंत्रज्ञान समर्थन',
    'Full': 'पूर्ण',
    'Get support directly on WhatsApp chat': 'व्हॉट्सॲप चॅटवर थेट समर्थन मिळवा',
    'Help & Support': 'मदत आणि समर्थन',
    'Hide code': 'कोड लपवा',
    'High': 'उच्च',
    'High Current Harmonic Distortion': 'उच्च वर्तमान हार्मोनिक विरूपण',
    'High Current K-Factor': 'उच्च वर्तमान के-फॅक्टर',
    'High Voltage Harmonic Distortion': 'उच्च व्होल्टेज हार्मोनिक विरूपण',
    'High Voltage K-Factor': 'उच्च व्होल्टेज के-फॅक्टर',
    'High neutral current — possible fire risk from unbalanced phases or loose neutral.': 'उच्च तटस्थ प्रवाह - असंतुलित टप्प्यांतून किंवा लूज न्यूट्रलमुळे संभाव्य आगीचा धोका.',
    'Hourly Power Log · PDF': 'ताशी पॉवर लॉग · PDF',
    'Insufficient data': 'अपुरा डेटा',
    'Intraday Bill': 'इंट्राडे बिल',
    'K-Factor': 'के-फॅक्टर',
    'K-Factor distribution · sample count per unit band': 'के-फॅक्टर वितरण · प्रति युनिट बँड नमुना संख्या',
    'LF Adjustment (projected)': 'एलएफ समायोजन (प्रक्षेपित)',
    'LF Penalty (projected)': 'LF दंड (प्रक्षेपित)',
    'LF Rebate (projected)': 'एलएफ रिबेट (प्रक्षेपित)',
    'Last 24 hours': 'शेवटचे २४ तास',
    'Last 24 hours · kW (active) and kVA (apparent)': 'शेवटचे २४ तास · kW (सक्रिय) आणि kVA (स्पष्ट)',
    'Last 30 days': 'शेवटचे ३० दिवस',
    'Last 5 instances · all time': 'शेवटची ५ उदाहरणे · सर्व वेळ',
    'Last refresh': 'शेवटचे रिफ्रेश',
    'Live': 'लाइव्ह',
    'Live Power Factor': 'लाइव्ह पॉवर फॅक्टर',
    'Live status, risk indicators and threshold breach density.': 'थेट स्थिती, जोखीम निर्देशक आणि थ्रेशोल्ड उल्लंघन घनता.',
    'Load Factor': 'लोड फॅक्टर',
    'Load Factor (LF) rebate / surcharge — applied per kWh consumed': 'लोड फॅक्टर (LF) रिबेट / अधिभार — वापरलेल्या प्रति kWh लागू',
    'Load Factor Adjustment': 'लोड फॅक्टर समायोजन',
    'Load Factor Penalty': 'लोड फॅक्टर दंड',
    'Load Factor Rebate': 'लोड फॅक्टर रिबेट',
    'Load Factor Utilisation': 'लोड फॅक्टर वापर',
    'Load Factor adjustment MTD': 'लोड फॅक्टर समायोजन MTD',
    'Load percentage nearing or exceeding contracted demand limit.': 'लोडची टक्केवारी कॉन्ट्रॅक्ट केलेल्या मागणी मर्यादेच्या जवळ किंवा ओलांडत आहे.',
    'Loading…': 'लोड करत आहे...',
    'Low Power Factor': 'कमी पॉवर फॅक्टर',
    'MD Peak': 'एमडी पीक',
    'Max': 'कमाल',
    'Max Demand Analysis': 'कमाल मागणी विश्लेषण',
    'Max Demand by Time-of-Day Period': 'दिवसाच्या वेळेनुसार कमाल मागणी',
    'Max current K-Factor across phases — rates transformer derating for harmonic loads': 'टप्प्याटप्प्याने कमाल वर्तमान के-फॅक्टर — हार्मोनिक लोड्ससाठी ट्रान्सफॉर्मरचे दर कमी करतात',
    'Max voltage K-Factor across phases — rates transformer derating for harmonic loads': 'टप्प्याटप्प्याने कमाल व्होल्टेज के-फॅक्टर — हार्मोनिक लोड्ससाठी ट्रान्सफॉर्मरचे दर कमी करतात',
    'Maximum demand': 'जास्तीत जास्त मागणी',
    'Meter overview': 'मीटरचा आढावा',
    'Meter rental': 'मीटर भाडे',
    'Metered': 'मीटर केलेले',
    'Meters discovered': 'शोधलेले मीटर',
    'Metrics · last 5 alerts': 'मेट्रिक्स · अंतिम 5 सूचना',
    'Min': 'मि',
    'Mon-Sat. 9:00 AM - 6:00 PM IST': 'सोम-शनि. सकाळी 9:00 ते संध्याकाळी 6:00 IST',
    'Month-to-Date': 'महिना-ते-तारीख',
    'Month-to-Date Cost': 'महिना-ते-तारीख खर्च',
    'Month-to-date bill for': 'साठी महिन्यापासून तारीख बिल',
    'Most recent 5 breach events · reflects your current thresholds': 'सर्वात अलीकडील 5 उल्लंघन घटना · तुमचे वर्तमान थ्रेशोल्ड प्रतिबिंबित करते',
    'Must stay': 'राहिले पाहिजे',
    'Near limit': 'मर्यादेच्या जवळ',
    'Net cost today': 'आज निव्वळ खर्च',
    'Neutral Current': 'तटस्थ प्रवाह',
    'Neutral zone': 'तटस्थ झोन',
    'No adj.': 'adj नाही.',
    'No adjustment': 'समायोजन नाही',
    'No alerts found': 'कोणतेही अलर्ट आढळले नाहीत',
    'No breach events with current thresholds': 'वर्तमान थ्रेशोल्डसह कोणतेही उल्लंघन घटना नाहीत',
    'No breaches on latest reading': 'नवीनतम वाचनात कोणतेही उल्लंघन नाही',
    'No data': 'डेटा नाही',
    'No data available yet.': 'अद्याप कोणताही डेटा उपलब्ध नाही.',
    'No data for': 'साठी डेटा नाही',
    'No data for this day': 'या दिवसासाठी कोणताही डेटा नाही',
    'No data for this meter yet': 'या मीटरसाठी अद्याप कोणताही डेटा नाही',
    'No data for this window': 'या विंडोसाठी कोणताही डेटा नाही',
    'No data in the last 24 hours': 'गेल्या २४ तासात कोणताही डेटा नाही',
    'No rebate': 'सवलत नाही',
    'No samples in': 'मध्ये कोणतेही नमुने नाहीत',
    'No variables match your search.': 'कोणतेही व्हेरिएबल्स तुमच्या शोधाशी जुळत नाहीत.',
    'None (WBSEDCL B-IDIT)': 'काहीही नाही (WBSEDCL B-IDIT)',
    'Normal': 'सामान्य',
    'Normal demand charge': 'सामान्य मागणी शुल्क',
    'Normal · peak': 'सामान्य · शिखर',
    'Notify via': 'द्वारे सूचित करा',
    'Off-Peak': 'ऑफ-पीक',
    'Open dashboard': 'डॅशबोर्ड उघडा',
    'PDF BI': 'PDF BI',
    'PDF columns BE / BF / BG · max of all 15-min averaged blocks per period': 'पीडीएफ स्तंभ BE / BF / BG · प्रत्येक कालावधीतील सर्व 15-मिनिटांच्या सरासरी ब्लॉक्सपैकी कमाल',
    'PF Adjustment (projected)': 'पीएफ समायोजन (प्रक्षेपित)',
    'PF Penalty (projected)': 'पीएफ दंड (प्रक्षेपित)',
    'PF Penalty / Rebate': 'पीएफ दंड/सवलत',
    'PF Rebate (projected)': 'पीएफ रिबेट (प्रक्षेपित)',
    'PF rebate / penalty MTD': 'पीएफ रिबेट / दंड MTD',
    'Password': 'पासवर्ड',
    'Peak': 'शिखर',
    'Peak clipped': 'पीक क्लिप केले',
    'Peak kVA': 'पीक kVA',
    'Penalty': 'दंड',
    'Penalty <': 'दंड <',
    'Penalty likely': 'दंड होण्याची शक्यता',
    'Penalty zone': 'पेनल्टी झोन',
    'Per-phase': 'प्रति-टप्पा',
    'Phase': 'टप्पा',
    'Phase B Current': 'टप्पा बी वर्तमान',
    'Phase B Power': 'टप्पा बी पॉवर',
    'Phase B line current': 'फेज बी लाइन वर्तमान',
    'Phase R Current': 'टप्पा आर वर्तमान',
    'Phase R Power': 'टप्पा आर पॉवर',
    'Phase R line current': 'फेज आर लाइन वर्तमान',
    'Phase Y Current': 'टप्पा Y वर्तमान',
    'Phase Y Power': 'टप्पा Y पॉवर',
    'Phase Y line current': 'फेज Y ओळ चालू',
    'Phase current': 'टप्पा वर्तमान',
    'Phase current imbalance — indicates uneven load distribution across phases.': 'फेज चालू असमतोल — टप्प्याटप्प्याने असमान लोड वितरण सूचित करते.',
    'Phase voltage (L-N)': 'फेज व्होल्टेज (L-N)',
    'Phase voltage imbalance — can damage motors and reduce equipment life.': 'फेज व्होल्टेज असंतुलन - मोटर्सचे नुकसान करू शकते आणि उपकरणांचे आयुष्य कमी करू शकते.',
    'Phone number copied to clipboard.': 'फोन नंबर क्लिपबोर्डवर कॉपी केला.',
    'Pi CPU Usage': 'Pi CPU वापर',
    'Pi Memory Usage': 'Pi मेमरी वापर',
    'Pi Temperature': 'पाई तापमान',
    'Pi Temperature · Last 24 h': 'Pi तापमान · शेवटचे २४ तास',
    'Power': 'ऊर्जा',
    'Power Analysis': 'ऊर्जा विश्लेषण',
    'Power Factor': 'पॉवर फॅक्टर',
    'Power Factor (Month-to-Date)': 'पॉवर फॅक्टर (महिना-ते-तारीख)',
    'Power Factor (PF) adjustment — applied as % of energy charge per ToD period': 'पॉवर फॅक्टर (PF) समायोजन — प्रति ToD कालावधीसाठी ऊर्जा शुल्काच्या % म्हणून लागू',
    'Power Factor Adjustment': 'पॉवर फॅक्टर समायोजन',
    'Power Factor Penalty': 'पॉवर फॅक्टर दंड',
    'Power Factor Rebate': 'पॉवर फॅक्टर रिबेट',
    'Power Factor rebate / penalty MTD': 'पॉवर फॅक्टर रिबेट / पेनल्टी MTD',
    'Power factor below threshold — attracting TGSPDCL RKVAH penalty on energy bill.': 'थ्रेशोल्डच्या खाली पॉवर फॅक्टर — ऊर्जा बिलावर TGSPDCL RKVAH दंड आकर्षित करणे.',
    'Production build · v1.0': 'उत्पादन बिल्ड · v1.0',
    'Projected Bill': 'प्रक्षेपित विधेयक',
    'Projected Bill · Month-End Estimate': 'प्रक्षेपित बिल · महिन्याच्या शेवटी अंदाज',
    'Projected energy charge (gross)': 'प्रक्षेपित ऊर्जा शुल्क (एकूण)',
    'Projected net payable by due date': 'देय तारखेपर्यंत अंदाजित निव्वळ देय',
    'Projection uses a linear run-rate from': 'प्रोजेक्शन पासून एक रेखीय रन-रेट वापरते',
    'RAM Usage (%)': 'RAM वापर (%)',
    'Raspberry Pi CPU temperature': 'रास्पबेरी Pi CPU तापमान',
    'Raspberry Pi CPU utilisation': 'रास्पबेरी पाई सीपीयू वापर',
    'Raspberry Pi Gateway': 'रास्पबेरी पाई गेटवे',
    'Raspberry Pi memory utilisation': 'रास्पबेरी पाई मेमरी वापर',
    'Rebate': 'सवलत',
    'Rebate earned': 'रिबेट मिळवले',
    'Rebate zone': 'रिबेट झोन',
    'Refresh': 'रिफ्रेश करा',
    'Refresh interval': 'रिफ्रेश अंतराल',
    'Remove this rule': 'हा नियम काढून टाका',
    'Response time usually within 2 hours': 'प्रतिसाद वेळ सहसा 2 तासांच्या आत',
    'Rules saved on this device. Production build routes notifications via SMS and WhatsApp.': 'या डिव्हाइसवर नियम जतन केले आहेत. एसएमएस आणि व्हॉट्सॲप द्वारे उत्पादन मार्ग सूचना.',
    'Running daily energy cost (₹)': 'रनिंग दैनंदिन ऊर्जा खर्च (₹)',
    'Running maximum of kVA averaged over 15 minutes window': 'कमाल kVA धावणे सरासरी 15 मिनिटांपेक्षा जास्त विंडो',
    'Running session energy (kWh)': 'चालू सत्र ऊर्जा (kWh)',
    'SAFE': 'सुरक्षित',
    'Safe': 'सुरक्षित',
    'Samples loaded': 'लोड केलेले नमुने',
    'Save Alert Rules': 'अलर्ट नियम जतन करा',
    'Search variables…': 'व्हेरिएबल्स शोधा…',
    'Select Language': 'भाषा निवडा',
    'Select a date range above': 'वरील तारीख श्रेणी निवडा',
    'Select billing period': 'बिलिंग कालावधी निवडा',
    'Select language': 'भाषा निवडा',
    'Select meter': 'मीटर निवडा',
    'Send Email': 'ईमेल पाठवा',
    'Session Energy': 'सत्र ऊर्जा',
    'Session carbon footprint (kg CO₂)': 'सत्र कार्बन फूटप्रिंट (किलो CO₂)',
    'Settings': 'सेटिंग्ज',
    'Share': 'शेअर करा',
    'Show code': 'कोड दाखवा',
    'Showing': 'दाखवत आहे',
    'Showing cached data — we\'ll keep retrying automatically.': 'कॅशे केलेला डेटा दाखवत आहे — आम्ही आपोआप पुन्हा प्रयत्न करत राहू.',
    'Showing month-to-date charges': 'महिन्यापासून तारीख शुल्क दर्शवित आहे',
    'Showing today\'s charges': 'आजचे शुल्क दाखवत आहे',
    'Sign out': 'साइन आउट',
    'Similar to average': 'सरासरी प्रमाणेच',
    'Similar to this week\'s average': 'या आठवड्याच्या सरासरीप्रमाणेच',
    'Since midnight IST · updates every 5 min': 'मध्यरात्रीपासून IST · दर 5 मिनिटांनी अपडेट होते',
    'Site': 'साइट',
    'Sum of all phase currents': 'सर्व फेज प्रवाहांची बेरीज',
    'Surcharge': 'अधिभार',
    'THD distribution · sample count per 2% band': 'THD वितरण · प्रति 2% बँड नमुना संख्या',
    'Telangana': 'तेलंगणा',
    'Temperature (°C)': 'तापमान (°C)',
    'This Month': 'या महिन्यात',
    'This week (Sun – yesterday)': 'या आठवड्यात (रवि - काल)',
    'Threshold': 'उंबरठा',
    'Time distribution': 'वेळेचे वितरण',
    'Time-of-Day Split': 'टाइम-ऑफ-डे स्प्लिट',
    'Timely Payment Rebate': 'वेळेवर पेमेंट रिबेट',
    'ToD Off-Peak Rebate': 'ToD ऑफ-पीक सूट',
    'ToD Peak Penalty': 'ToD पीक पेनल्टी',
    'Today': 'आज',
    'Today PF': 'आज पी.एफ',
    'Today is': 'आज आहे',
    'Today\'s Cost': 'आजची किंमत',
    'Today\'s Running Cost': 'आजची रनिंग कॉस्ट',
    'Total': 'एकूण',
    'Total Active Power': 'एकूण सक्रिय शक्ती',
    'Total Apparent Power': 'एकूण उघड शक्ती',
    'Total Current': 'एकूण वर्तमान',
    'Total Energy (kWh) consumed last month / (Peak kW observed last month times number of hours last month)': 'गेल्या महिन्यात वापरण्यात आलेली एकूण ऊर्जा (kWh) / (मागील महिन्यात पाहिल्या गेलेल्या पीक kW च्या वेळा गेल्या महिन्यात तासांच्या संख्येच्या संख्येने)',
    'Total Energy (kWh) consumed this month / (Peak kW observed this month times number of hours this month)': 'या महिन्यात वापरण्यात आलेली एकूण ऊर्जा (kWh) / (या महिन्यात पाहिलेले पीक kWh या महिन्यात तासांच्या पट संख्या)',
    'Total Energy (kWh) consumed this week / (Peak kW observed this week times number of hours this week)': 'या आठवड्यात एकूण ऊर्जा (kWh) वापरली / (या आठवड्यात पाहिल्या गेलेल्या पीक kW वेळा या आठवड्यात तासांची संख्या)',
    'Total Energy (kWh) consumed today/ (Peak kW observed today times number of hours today)': 'आज वापरलेली एकूण ऊर्जा (kWh)/ (आज पाहिलेले पीक kWh)',
    'Total Energy Charge': 'एकूण ऊर्जा शुल्क',
    'Total Harmonic Distortion (%)': 'एकूण हार्मोनिक विकृती (%)',
    'Total Watts': 'एकूण वॅट्स',
    'Total active power across all phases': 'सर्व टप्प्यांमध्ये एकूण सक्रिय शक्ती',
    'Total apparent power (kVA)': 'एकूण उघड शक्ती (kVA)',
    'Total demand cost': 'एकूण मागणी खर्च',
    'Total instantaneous power in watts': 'वॅट्समध्ये एकूण तात्काळ शक्ती',
    'Try again': 'पुन्हा प्रयत्न करा',
    'Try another meter or wait for the next refresh.': 'दुसरे मीटर वापरून पहा किंवा पुढील रिफ्रेशची प्रतीक्षा करा.',
    'Use one of the access codes provided for your site.': 'तुमच्या साइटसाठी प्रदान केलेल्या प्रवेश कोडपैकी एक वापरा.',
    'Utilisation %': 'वापर %',
    'Voltage': 'व्होल्टेज',
    'Voltage Imbalance': 'व्होल्टेज असंतुलन',
    'Voltage K-Factor': 'व्होल्टेज के-फॅक्टर',
    'Voltage K-Factor exceeds transformer derating limit — K>4 requires a K-rated transformer.': 'व्होल्टेज के-फॅक्टर ट्रान्सफॉर्मर डेरेटिंग मर्यादा ओलांडतो — K>4 ला K-रेट केलेले ट्रान्सफॉर्मर आवश्यक आहे.',
    'WARN': 'चेतावणी द्या',
    'Warn': 'चेतावणी द्या',
    'Warning': 'चेतावणी',
    'Warning above': 'वरील चेतावणी',
    'Warning below': 'खाली चेतावणी',
    'Warning · peak': 'चेतावणी · शिखर',
    'WhatsApp Support': 'WhatsApp समर्थन',
    'Within Limit': 'मर्यादेत',
    'Worst': 'सर्वात वाईट',
    'Yesterday': 'काल',
    'above': 'वर',
    'above CD': 'सीडी वर',
    'above this week\'s avg': 'या आठवड्याच्या सरासरीच्या वर',
    'above this week\'s avg — good day': 'या आठवड्याच्या सरासरीपेक्षा जास्त — चांगला दिवस',
    'active': 'सक्रिय',
    'active issue': 'सक्रिय समस्या',
    'active issues': 'सक्रिय समस्या',
    'added to bill': 'बिलात जोडले',
    'added to this month\'s bill': 'या महिन्याच्या बिलात जोडले',
    'adjustment': 'समायोजन',
    'all charges finalised.': 'सर्व शुल्क अंतिम.',
    'and': 'आणि',
    'applied for Load Factor ≥ 65%': 'लोड फॅक्टर ≥ 65% साठी अर्ज केला',
    'average': 'सरासरी',
    'avg': 'सरासरी',
    'below': 'खाली',
    'below average': 'सरासरीपेक्षा कमी',
    'below min → charged on': 'कमी मिनिट → चार्ज चालू',
    'below this week\'s avg': 'या आठवड्याच्या सरासरीच्या खाली',
    'below this week\'s avg — below average': 'या आठवड्याच्या सरासरीपेक्षा कमी — सरासरीपेक्षा कमी',
    'consumers under TOD Tariff (CD > 50 kVA); % of energy charge per ToD period': 'TOD टॅरिफ अंतर्गत ग्राहक (CD > 50 kVA); प्रति ToD कालावधी ऊर्जा शुल्काचा %',
    'critical': 'गंभीर',
    'current': 'वर्तमान',
    'day bill for': 'साठी दिवसाचे बिल',
    'day run rate': 'दैनिक रन रेट',
    'days': 'दिवस',
    'days of actual data.': 'वास्तविक डेटाचे दिवस.',
    'days of meter data': 'मीटर डेटाचे दिवस',
    'days remaining': 'दिवस शिल्लक',
    'days required for': 'साठी आवश्यक दिवस',
    'deducted from bill': 'बिलातून वजा केले',
    'deducted from this month\'s bill': 'या महिन्याच्या बिलातून वजा केले',
    'delivered': 'वितरित',
    'energy charges, Power Factor & Load Factor adjustments, demand charge, duties, and projected net payable.': 'ऊर्जा शुल्क, पॉवर फॅक्टर आणि लोड फॅक्टर ऍडजस्टमेंट, डिमांड चार्ज, ड्युटी आणि अंदाजित निव्वळ देय.',
    'energy per day': 'दररोज ऊर्जा',
    'energy per hour': 'प्रति तास ऊर्जा',
    'excess above CD': 'CD वर जास्त',
    'fires when <': 'ट्रिगर होते जेव्हा <',
    'fires when >': 'ट्रिगर होते जेव्हा >',
    'good day': 'शुभ दिवस',
    'if paid after 15 days': 'जर 15 दिवसांनी पैसे दिले',
    'if paid by due date': 'देय तारखेपर्यंत पैसे भरल्यास',
    'imbal': 'imbal',
    'invoice estimate': 'चलन अंदाज',
    'is above this week\'s avg': 'या आठवड्याच्या सरासरीपेक्षा जास्त आहे',
    'is below this week\'s avg': 'या आठवड्याच्या सरासरीपेक्षा कमी आहे',
    'kVA/month': 'kVA/महिना',
    'kVAh': 'kVAh',
    'kWh': 'kWh',
    'limit': 'मर्यादा',
    'meter': 'मीटर',
    'meters': 'मीटर',
    'min demand applies': 'किमान मागणी लागू होते',
    'month': 'महिना',
    'month-to-date': 'महिना-ते-तारीख',
    'net incl. all charges': 'निव्वळ समावेश सर्व शुल्क',
    'net today': 'आज निव्वळ',
    'never': 'कधीही',
    'no adj.': 'adj नाही',
    'no adjustment': 'समायोजन नाही',
    'no adjustment applicable': 'कोणतेही समायोजन लागू नाही',
    'no adjustment today': 'आज समायोजन नाही',
    'nom': 'nom',
    'not yet applicable today': 'आजही लागू नाही',
    'of': 'च्या',
    'of 24 hours have data': '24 तासांचा डेटा असतो',
    'of CD': 'CD चे',
    'of bill': 'बिलाचे',
    'of gross bill': 'एकूण बिलाचे',
    'of net bill': 'निव्वळ बिल',
    'off': 'बंद',
    'on the excess kVA.': 'जादा kVA वर.',
    'over-threshold': 'ओव्हर-थ्रेशोल्ड',
    'paise/kVAh  (6p flat)': 'paise/kVAh (6p फ्लॅट)',
    'paise/kWh rebate': 'पैसे/kWh रिबेट',
    'paise/kWh surcharge': 'पैसे/kWh अधिभार',
    'peak kVA': 'शिखर kVA',
    'peak kVA today': 'पीक kVA आज',
    'penalty': 'दंड',
    'projected penalty': 'अंदाजित दंड',
    'projected rebate': 'अंदाजित सूट',
    'projected surcharge': 'अंदाजित अधिभार',
    'readings': 'रीडिंग',
    'readings · 3 phases': 'वाचन · 3 टप्पे',
    'rebate': 'सूट',
    'rebate / kWh': 'रिबेट / kWh',
    'rebate earned': 'सवलत मिळवली',
    's': 's',
    's when the tab is visible.': 's जेव्हा टॅब दृश्यमान असतो.',
    'samples': 'नमुने',
    'surcharge': 'अधिभार',
    'surcharge / kWh': 'अधिभार / kWh',
    'surcharge added to bill': 'बिलात अधिभार जोडला',
    'surcharge applied': 'अधिभार लागू',
    'threshold': 'उंबरठा',
    'to': 'करण्यासाठी',
    'units consumed so far': 'आतापर्यंत वापरलेले युनिट्स',
    'updated every 5 min': 'दर 5 मिनिटांनी अद्यतनित',
    'updating…': 'अपडेट करत आहे...',
    'warn': 'चेतावणी',
    '· added to bill today': '· आज बिलात जोडले',
    '· saving deducted today': '· बचत आज वजा केली',
    '· surcharge added today': '· अधिभार आज जोडला गेला',
    '— · awaiting data': '— · डेटाची प्रतीक्षा आहे',
    '≥': '≥',
    '⚠ No Pi telemetry in current data — fields piTempC / piMemPct not populated': '⚠ वर्तमान डेटामध्ये Pi टेलीमेट्री नाही — फील्ड piTempC / piMemPct पॉप्युलेट नाही',
    '⚠️ Thermal throttle active — Pi is running hot, performance reduced': '⚠️ थर्मल थ्रोटल सक्रिय — Pi गरम चालू आहे, कार्यप्रदर्शन कमी झाले आहे',
    '✓ Rules Saved Successfully': '✓ नियम यशस्वीरित्या जतन केले',
  },
  od: {
    'This Week': 'ଏହି ସପ୍ତାହ',
    'Last Month': 'ଗତ ମାସ',
    'Sensor Dropout': 'ସେନ୍ସର୍ ଡ୍ରପଆଉଟ୍',
    'Approaching Overload': 'ଓଭରଲୋଡ୍ ନିକଟବର୍ତ୍ତୀ',
    'Frequency Deviation': 'ଫ୍ରିକ୍ୱେନ୍ସି ବିଚ୍ୟୁତି',
    'High Voltage THD': 'ଉଚ୍ଚ ଭୋଲଟେଜ୍ THD',
    'High Current THD': 'ଉଚ୍ଚ କରେଣ୍ଟ୍ THD',
    'In-app': 'ଆପ୍ ମଧ୍ୟରେ',
    'SMS': 'ଏସଏମଏସ୍',
    'WhatsApp': 'ହ୍ୱାଟସଆପ୍',
    'Min. chargeable demand': 'ସର୍ବନିମ୍ନ ଚାର୍ଜ ଯୋଗ୍ୟ ଚାହିଦା',
    'Demand charge — Normal': 'ଡିମାଣ୍ଡ ଚାର୍ଜ — ସାଧାରଣ',
    'Demand charge — Penal': 'ଡିମାଣ୍ଡ ଚାର୍ଜ — ଦଣ୍ଡନୀୟ',
    'Electricity duty': 'ବିଦ୍ୟୁତ୍ ଶୁଳ୍କ',
    'Late payment surcharge': 'ବିଳମ୍ବିତ ଦେୟ ସର୍ଚାର୍ଜ',
    'Demand charge (up to CD)': 'ଡିମାଣ୍ଡ ଚାର୍ଜ (CD ପର୍ଯ୍ୟନ୍ତ)',
    'Generating': 'ସୃଷ୍ଟି ହେଉଛି',
    'Bill PDF…': 'ବିଲ PDF…',
    'What is the Power Analysis Dashboard?': 'ପାୱାର ଆନାଲିସିସ ଡ୍ୟାସବୋର୍ଡ କ\'ଣ?',
    'It monitors real-time electrical metrics (voltage, current, power factor, demand, active/reactive energy) collected from Raspberry Pi edge nodes installed at the site.': 'ଏହା ସାଇଟରେ ସ୍ଥାପିତ Raspberry Pi ଏଜ୍ ନୋଡ୍‌ଗୁଡ଼ିକରୁ ସଂଗୃହିତ ରିଅଲ-ଟାଇମ୍ ବୈଦ୍ୟୁତିକ ମେଟ୍ରିକ୍ସ (ଭୋଲଟେଜ୍, କରେଣ୍ଟ୍, ପାୱାର ଫ୍ୟାକ୍ଟର, ଡିମାଣ୍ଡ, ଆକ୍ଟିଭ୍/ରିଆକ୍ଟିଭ୍ ଶକ୍ତି) ମନିଟର କରେ।',
    'What do the green/orange/red indicators mean?': 'ସବୁଜ/କମଳା/ଲାଲ ସୂଚକଗୁଡ଼ିକର ଅର୍ଥ କ\'ଣ?',
    'Green means the Raspberry Pi edge node is online and reporting health telemetry normally. Orange/red indicate potential communication delays or high temperature/resource throttling.': 'ସବୁଜ ଅର୍ଥ Raspberry Pi ଏଜ୍ ନୋଡ୍ ଅନଲାଇନ୍ ଅଛି ଏବଂ ସାଧାରଣ ଭାବରେ ହେଲ୍ଥ ଟେଲିମେଟ୍ରି ରିପୋର୍ଟ କରୁଛି। କମଳା/ଲାଲ ସମ୍ଭାବ୍ୟ ଯୋଗାଯୋଗ ବିଳମ୍ବ କିମ୍ବା ଉଚ୍ଚ ତାପମାତ୍ରା/ସମ୍ବଳ ଥ୍ରଟଲିଂ ସୂଚାଏ।',
    'How are billing demand charges calculated?': 'ବିଲିଂ ଡିମାଣ୍ଡ ଚାର୍ଜ କିପରି ଗଣନା ହୁଏ?',
    'Demand charges are based on the Maximum Demand (MD) recorded in 15-minute integration windows, calculated according to the active tariff structure (e.g., TGSPDCL HT or WBSEDCL B-IDIT).': 'ଡିମାଣ୍ଡ ଚାର୍ଜ 15-ମିନିଟ୍ ଇଣ୍ଟିଗ୍ରେସନ୍ ୱିଣ୍ଡୋରେ ରେକର୍ଡ ହୋଇଥିବା ସର୍ବାଧିକ ଡିମାଣ୍ଡ (MD) ଉପରେ ଆଧାରିତ, ସକ୍ରିୟ ଟାରିଫ୍ ଗଠନ (ଯଥା, TGSPDCL HT କିମ୍ବା WBSEDCL B-IDIT) ଅନୁଯାୟୀ ଗଣନା ହୁଏ।',
    'What should I do if the dashboard shows "No data"?': 'ଡ୍ୟାସବୋର୍ଡରେ "କୌଣସି ତଥ୍ୟ ନାହିଁ" ଦେଖାଗଲେ ମୁଁ କଣ କରିବି?',
    'Verify that the edge node (Raspberry Pi gateway) is powered on and connected to the internet. If the issue persists, contact technical support immediately.': 'ଏଜ୍ ନୋଡ୍ (Raspberry Pi ଗେଟୱେ) ଚାଲୁ ଅଛି ଏବଂ ଇଣ୍ଟରନେଟ୍ ସହିତ ସଂଯୁକ୍ତ ଅଛି ବୋଲି ଯାଞ୍ଚ କରନ୍ତୁ। ସମସ୍ୟା ଲାଗି ରହିଲେ, ତୁରନ୍ତ ଟେକ୍ନିକାଲ ସପୋର୍ଟ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ।',
    '% of readings': '% ପଠନ',
    '/month': '/ ମାସ',
    '0.4 kV supply': '0.4 କେଭି ଯୋଗାଣ',
    '12 AM – 12 AM': 'ରାତି 12 - ରାତି 12',
    '1st 12 AM → now': '1 ତାରିଖ ରାତି 12 → ବର୍ତ୍ତମାନ',
    '2x penalty': '2x ପେନାଲ୍ଟି',
    '33 kV supply': '33 କେଭି ଯୋଗାଣ',
    'About': 'ବିଷୟରେ',
    'Above': 'ଉପରେ',
    'Across': 'ସମଗ୍ର',
    'Active (kW)': 'ସକ୍ରିୟ (kW)',
    'Active Power & Apparent Power': 'ସକ୍ରିୟ ଶକ୍ତି ଏବଂ ଦୃଶ୍ୟମାନ ଶକ୍ତି',
    'Active power on Phase B': 'ପ୍ରଥମ ପର୍ଯ୍ୟାୟରେ ସକ୍ରିୟ ଶକ୍ତି',
    'Active power on Phase R': 'ଚରଣ R ଉପରେ ସକ୍ରିୟ ଶକ୍ତି',
    'Active power on Phase Y': 'ଚରଣ Y ରେ ସକ୍ରିୟ ଶକ୍ତି',
    'Active tariff': 'ସକ୍ରିୟ ଟାରିଫ୍',
    'Add custom variable alert': 'କଷ୍ଟମ୍ ଭେରିଏବଲ୍ ଆଲର୍ଟ ଯୋଡନ୍ତୁ',
    'Additional demand charge': 'ଅତିରିକ୍ତ ଚାହିଦା ଦେୟ',
    'Alert History': 'ସତର୍କତା ଇତିହାସ',
    'Alert Rules': 'ସତର୍କ ନିୟମ',
    'Alerts': 'ସତର୍କତା',
    'All energy/PF/LF values computed by the Cortex Pi gateway per VARIABLES.pdf §2.3 & §3. Demand, ED, rental, and TPR computed in the browser from WBSEDCL tariff constants.': 'ସମସ୍ତ ଶକ୍ତି / PF / LF ମୂଲ୍ୟଗୁଡ଼ିକ VARIABLES.pdf ପ୍ରତି କର୍ଟେକ୍ସ ପି ଗେଟୱେ ଦ୍ୱାରା ଗଣିତ §2.3 & §3। WBSEDCL ଶୁଳ୍କ କନଷ୍ଟାଣ୍ଟରୁ ବ୍ରାଉଜରରେ ଡିମାଣ୍ଡ, ଇଡି, ଭଡା, ଏବଂ TPR ଗଣିତ',
    'All systems normal': 'ସମସ୍ତ ସିଷ୍ଟମ୍ ସାଧାରଣ ଅଟେ',
    'Anomalies': 'ଅସନ୍ତୁଷ୍ଟତା',
    'Anomaly': 'ଅସଙ୍ଗତି',
    'Apparent': 'ଆଭାସୀ',
    'Apparent (kVA)': 'ଦୃଶ୍ୟମାନ (kVA)',
    'Approaching Contracted Demand': 'ଚୁକ୍ତିଭିତ୍ତିକ ଚାହିଦା ନିକଟକୁ ଆସିବା',
    'Auto-refreshes every': 'ପ୍ରତ୍ୟେକକୁ ଅଟୋ-ସତେଜ କରେ',
    'Average Power Factor': 'ହାରାହାରି ପାୱାର୍ ଫ୍ୟାକ୍ଟର୍',
    'Average power factor across': 'ହାରାହାରି ଶକ୍ତି କାରକ',
    'Avg': 'ହାରାହାରି',
    'Avg Active Power': 'ହାରାହାରି ସକ୍ରିୟ ଶକ୍ତି',
    'Avg Apparent Power': 'ହାରାହାରି ଶକ୍ତି',
    'Base Energy Charge': 'ଆଧାର ଶକ୍ତି ଚାର୍ଜ',
    'Based on': 'ଉପରେ ଆଧାରିତ',
    'Below': 'ନିମ୍ନରେ',
    'Between': 'ମଧ୍ୟରେ',
    'Billing': 'ବିଲିଙ୍ଗ',
    'Billing Cycle Peak': 'ବିଲିଂ ଚକ୍ର ଶିଖର',
    'Billing Overview': 'ବିଲିଙ୍ଗ୍ ସମୀକ୍ଷା',
    'Both levels disabled': 'ଉଭୟ ସ୍ତର ଅକ୍ଷମ ହୋଇଛି',
    'Building PDF…': 'PDF ନିର୍ମାଣ…',
    'CD': 'CD',
    'CD 100%': 'CD 100%',
    'CORTEX by Vireon': 'କୋର୍ଟେକ୍ସ - ୱାଇରନ୍ ଦ୍ୱାରା',
    'CRIT': 'CRIT',
    'Call Now': 'ବର୍ତ୍ତମାନ କଲ୍ କରନ୍ତୁ',
    'Call Support': 'କଲ୍ ସମର୍ଥନ',
    'Carbon (CO₂)': 'କାର୍ବନ (CO₂)',
    'Chargeable demand': 'ଚାର୍ଜ ଯୋଗ୍ୟ ଚାହିଦା',
    'Chargeable min:': 'ଚାର୍ଜ ଯୋଗ୍ୟ ସର୍ବନିମ୍ନ:',
    'Chat on WhatsApp': 'ୱାଟ୍ସଆପ୍‌ରେ ଚାଟ୍ କରନ୍ତୁ',
    'Check back when more data is synced.': 'ଯେତେବେଳେ ଅଧିକ ତଥ୍ୟ ସିଙ୍କ୍ ହୁଏ, ପୁନଃ ଯାଞ୍ଚ କରନ୍ତୁ',
    'Check your network or sheet sharing settings (Anyone with the link → Viewer).': 'ଆପଣଙ୍କର ନେଟୱାର୍କ କିମ୍ବା ଶୀଟ୍ ଅଂଶୀଦାର ସେଟିଂସମୂହ ଯାଞ୍ଚ କରନ୍ତୁ (ଲିଙ୍କ୍ → ଦର୍ଶକ ସହିତ ଯେକ Anyone ଣସି ବ୍ୟକ୍ତି)',
    'Choose a variable': 'ଏକ ଭେରିଏବଲ୍ ବାଛନ୍ତୁ',
    'Close': 'ବନ୍ଦ',
    'Close Help and Support Modal': 'ସହାୟତା ଏବଂ ସମର୍ଥନ ମୋଡାଲ୍ ବନ୍ଦ କରନ୍ତୁ',
    'Connecting…': 'ସଂଯୋଗ…',
    'Consumer': 'ଉପଭୋକ୍ତା',
    'Contact Tech Support': 'ଟେକ୍ ସମର୍ଥନ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ',
    'Contact your administrator if you do not have one.': 'ଯଦି ଆପଣଙ୍କ ପାଖରେ ନାହିଁ ତେବେ ଆପଣଙ୍କର ପ୍ରଶାସକଙ୍କ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ',
    'Contract': 'ଚୁକ୍ତିନାମା',
    'Contract Demand (CD)': 'ଚୁକ୍ତିନାମା ଚାହିଦା (CD)',
    'Contract Demand Utilisation': 'ଚୁକ୍ତିନାମା ଚାହିଦା ବ୍ୟବହାର',
    'Contract demand:': 'ଚୁକ୍ତିନାମା ଚାହିଦା:',
    'Contract limit': 'ଚୁକ୍ତିନାମା ସୀମା',
    'Copy Number': 'ସଂଖ୍ୟା କପି କରନ୍ତୁ',
    'Cost': 'ମୂଲ୍ୟ',
    'Cost breakdown': 'ଖର୍ଚ୍ଚ ବିବରଣୀ',
    'Couldn\'t reach the data sheet': 'ଡାଟା ସିଟ୍ ପାଖରେ ପହଞ୍ଚି ପାରିଲା ନାହିଁ',
    'Couldn\'t refresh just now.': 'ବର୍ତ୍ତମାନ ସତେଜ ହୋଇପାରିଲା ନାହିଁ',
    'Crit': 'ସମାଲୋଚକ',
    'Critical': 'ଗୁରୁତର',
    'Critical above': 'ଉପରେ ଗୁରୁତର',
    'Critical below': 'ନିମ୍ନରେ ଗୁରୁତର',
    'Critical · peak': 'ଗୁରୁତର · ଶିଖର',
    'Current': 'କରେଣ୍ଟ',
    'Current Imbalance': 'କରେଣ୍ଟ ଅସନ୍ତୁଳନ',
    'Current K-Factor': 'ସାମ୍ପ୍ରତିକ କେ-ଫ୍ୟାକ୍ଟର୍',
    'Current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'ସାମ୍ପ୍ରତିକ କେ-ଫ୍ୟାକ୍ଟର୍ ଗୁରୁତର ହରମୋନିକ୍ ଲୋଡିଙ୍ଗ୍ ସୂଚାଇଥାଏ - ଟ୍ରାନ୍ସଫର୍ମର ନିଶ୍ଚିତ ଭାବରେ ଡି-ରେଡ୍ ୟୁନିଟ୍ ସହିତ ବଦଳାଯିବା ଆବଶ୍ୟକ',
    'Current status': 'ସାମ୍ପ୍ରତିକ ସ୍ଥିତି',
    'Custom': 'କଷ୍ଟମ୍',
    'Custom Alerts': 'କଷ୍ଟମ୍ ଆଲର୍ଟ',
    'Custom range': 'କଷ୍ଟମ୍ ପରିସର',
    'Customer charges': 'ଗ୍ରାହକ ଦେୟ',
    'Daily Cost': 'ଦୈନିକ ମୂଲ୍ୟ',
    'Dashboard': 'ଡ୍ୟାସବୋର୍ଡ',
    'Deep dive': 'ଗଭୀର ବିଶ୍ଳେଷଣ',
    'Demand Penalty Applied': 'ଡିମାଣ୍ଡ ପେନାଲ୍ଟି ଲାଗୁ ହୋଇଛି',
    'Demand charge (billing-cycle peak)': 'ଡିମାଣ୍ଡ ଚାର୍ଜ (ବିଲିଂ-ଚକ୍ର ଶିଖ)',
    'Demand charge is fixed from the billing cycle peak. PF rebate and LF rebate/surcharge are projected at current rates.': 'ବିଲିଂ ଚକ୍ର ଶିଖରରୁ ଡିମାଣ୍ଡ ଚାର୍ଜ ସ୍ଥିର କରାଯାଇଛି। ବର୍ତ୍ତମାନର ହାରରେ PF ରିହାତି ଏବଂ LF ରିହାତି / ସରଚାର୍ଜ ଆକଳନ କରାଯାଇଛି',
    'Demand charges — when Maximum Demand (MD) exceeds Contract Demand (CD)': 'ଡିମାଣ୍ଡ ଚାର୍ଜ - ଯେତେବେଳେ ସର୍ବାଧିକ ଡିମାଣ୍ଡ (MD) କଣ୍ଟ୍ରାକ୍ଟ ଡିମାଣ୍ଡ (CD) ଅତିକ୍ରମ କରେ',
    'Demands under CD pay standard rates on chargeable kVA. Exceeding CD triggers a': 'CD ଅଧୀନରେ ଚାହିଦା kVA ଉପରେ ମାନକ ହାର ପ୍ରଦାନ କରେ। ସିଡି ଅତିକ୍ରମ କରିବା a',
    'Detected on most recent reading': 'ସାମ୍ପ୍ରତିକ ରିଡିଂ ଉପରେ ଚିହ୍ନଟ',
    'Disabled — no notifications': 'ଅକ୍ଷମ - କୌଣସି ବିଜ୍ଞପ୍ତି ନାହିଁ',
    'Download Bill': 'ବିଲ୍ ଡାଉନଲୋଡ୍ କରନ୍ତୁ',
    'Download Bill PDF': 'ବିଲ୍ PDF ଡାଉନଲୋଡ୍ କରନ୍ତୁ',
    'Download Log': 'ଲଗ୍ ଡାଉନଲୋଡ୍ କରନ୍ତୁ',
    'Download PDF': 'PDF ଡାଉନଲୋଡ୍ କରନ୍ତୁ',
    'Download a printable daily log · Accumulated kWh, Power Factor per hour': 'ଏକ ମୁଦ୍ରଣଯୋଗ୍ୟ ଦୈନିକ ଲଗ ଡାଉନଲୋଡ୍ କରନ୍ତୁ · ସଂଗୃହିତ kWh, ଘଣ୍ଟା ପ୍ରତି ପାୱାର ଫ୍ୟାକ୍ଟର୍',
    'Edge Node · Raspberry Pi Health': 'ଏଜ୍ ନୋଡ୍ · ରସବେରୀ ପି ସ୍ୱାସ୍ଥ୍ୟ',
    'Electricity Duty (projected)': 'ବିଦ୍ୟୁତ୍ କର୍ତ୍ତବ୍ୟ (ପ୍ରୋଜେକ୍ଟ)',
    'Elevated current THD — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress and overheating.': 'ଉଚ୍ଚତର ସାମ୍ପ୍ରତିକ THD - ଅଣ-ରୈଖିକ ଲୋଡ୍ (VFDs, UPS, ଡ୍ରାଇଭ୍) କୁ ସୂଚାଇଥାଏ ଯାହା ଟ୍ରାନ୍ସଫର୍ମର ଚାପ ଏବଂ ଅତ୍ୟଧିକ ଗରମ ସୃଷ୍ଟି କରିଥାଏ',
    'Elevated voltage THD — can damage capacitors, transformers, and sensitive equipment. IEEE 519 limit is 8%.': 'ଉତ୍ତୋଳିତ ଭୋଲଟେଜ୍ THD - କ୍ୟାପଟେଟର, ଟ୍ରାନ୍ସଫର୍ମର ଏବଂ ସମ୍ବେଦନଶୀଳ ଉପକରଣକୁ କ୍ଷତି ପହଞ୍ଚାଇପାରେ। IEEE 519 ସୀମା ହେଉଛି 8%',
    'Email Support': 'ଇମେଲ୍ ସମର୍ଥନ',
    'Energy': 'ଶକ୍ତି',
    'Energy Charges · Time-of-Day Split': 'ଶକ୍ତି ଚାର୍ଜ · ସମୟ-ଦିନର ବିଭାଜନ',
    'Energy by Time-of-Day': 'ସମୟ-ଦିନ ଦ୍ୱାରା ଶକ୍ତି',
    'Energy charges + Demand charges + Electricity Duty + Customer charges · accumulated till date': 'ଶକ୍ତି ଚାର୍ଜ + ଡିମାଣ୍ଡ ଚାର୍ଜ + ବିଦ୍ୟୁତ୍ ଡ୍ୟୁଟି + ଗ୍ରାହକ ଚାର୍ଜ · ଆଜି ପର୍ଯ୍ୟନ୍ତ ଜମା ହୋଇଛି',
    'Energy charges + Power Factor adjustment + Load Factor rebates + Demand charges + Electricity Duty + Meter rental · accumulated till date': 'ଶକ୍ତି ଚାର୍ଜ + ପାୱାର ଫ୍ୟାକ୍ଟର୍ ଆଡଜଷ୍ଟମେଣ୍ଟ୍ + ଲୋଡ୍ ଫ୍ୟାକ୍ଟର୍ ରିହାତି + ଡିମାଣ୍ଡ ଚାର୍ଜ + ବିଦ୍ୟୁତ୍ ଡ୍ୟୁଟି + ମିଟର ଭଡା · ଆଜି ପର୍ଯ୍ୟନ୍ତ ଜମା ହୋଇଛି',
    'Energy charges accumulated by tariff period': 'ଶୁଳ୍କ ଅବଧି ଦ୍ୱାରା ଜମା ହୋଇଥିବା ଶକ୍ତି ଚାର୍ଜ',
    'Energy delivered': 'ଶକ୍ତି ବିତରଣ',
    'Enter the access password for your site.': 'ଆପଣଙ୍କ ସାଇଟ୍ ପାଇଁ ପ୍ରବେଶ ପାସୱାର୍ଡ ପ୍ରବେଶ କରନ୍ତୁ',
    'Enter your access password': 'ଆପଣଙ୍କର ପ୍ରବେଶ ପାସୱାର୍ଡ ପ୍ରବେଶ କରନ୍ତୁ',
    'Failed to copy phone number.': 'ଫୋନ୍ ନମ୍ବର କପି କରିବାରେ ବିଫଳ',
    'Fires when PF drops below threshold — attracts utility penalty.': 'ଯେତେବେଳେ PF ଥ୍ରେସହୋଲ୍ଡ ତଳକୁ ଖସିଯାଏ - ଉପଯୋଗୀତା ଦଣ୍ଡକୁ ଆକର୍ଷିତ କରେ',
    'Fires when current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'ସାମ୍ପ୍ରତିକ କେ-ଫ୍ୟାକ୍ଟର୍ ଭୟଙ୍କର ହରମୋନିକ୍ ଲୋଡିଙ୍ଗ୍ ସୂଚାଇଥାଏ - ଟ୍ରାନ୍ସଫର୍ମର ନିଶ୍ଚିତ ଭାବରେ ଡି-ରେଡ୍ ୟୁନିଟ୍ ସହିତ ବଦଳାଯିବା ଆବଶ୍ୟକ',
    'Fires when current THD exceeds safe levels — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress.': 'ସାମ୍ପ୍ରତିକ THD ସୁରକ୍ଷିତ ସ୍ତର ଅତିକ୍ରମ କଲାବେଳେ ଟ୍ରିଗର ହୁଏ - ଟ୍ରାନ୍ସଫର୍ମର ଚାପ ସୃଷ୍ଟି କରୁଥିବା ଅଣ-ଲାଇନ୍ ଲୋଡ୍ (VFD, UPS, ଡ୍ରାଇଭ୍) କୁ ସୂଚିତ କରେ',
    'Fires when load % nears or exceeds the contracted demand limit.': 'ଚୁକ୍ତି ହୋଇଥିବା ଚାହିଦା ସୀମା ପାଖାପାଖି କିମ୍ବା ଅତିକ୍ରମ କଲାବେଳେ ଟ୍ରିଗର ହୁଏ',
    'Fires when neutral conductor carries excess current — fire risk.': 'ଯେତେବେଳେ ନିରପେକ୍ଷ କଣ୍ଡକ୍ଟର ଅତ୍ୟଧିକ କରେଣ୍ଟ ବହନ କରେ - ଅଗ୍ନି ବିପଦ',
    'Fires when phase current imbalance exceeds threshold.': 'ପର୍ଯ୍ୟାୟ ସାମ୍ପ୍ରତିକ ଅସନ୍ତୁଳନ ସୀମା ଅତିକ୍ରମ କଲାବେଳେ ଟ୍ରିଗର ହୁଏ',
    'Fires when voltage K-Factor exceeds transformer derating limits — K>4 requires K-rated transformer.': 'ଯେତେବେଳେ ଭୋଲଟେଜ୍ କେ-ଫ୍ୟାକ୍ଟର୍ ଟ୍ରାନ୍ସଫର୍ମର ଡେରିଟିଂ ସୀମା ଅତିକ୍ରମ କରେ - K> 4 K- ରେଟେଡ୍ ଟ୍ରାନ୍ସଫର୍ମର ଆବଶ୍ୟକ କରେ',
    'Fires when voltage THD exceeds safe levels — can damage capacitors, transformers, and sensitive equipment.': 'ଭୋଲଟେଜ୍ THD ସୁରକ୍ଷିତ ସ୍ତର ଅତିକ୍ରମ କଲାବେଳେ ଟ୍ରିଗର ହୁଏ - କ୍ୟାପେସିଟର, ଟ୍ରାନ୍ସଫର୍ମର ଏବଂ ସମ୍ବେଦନଶୀଳ ଉପକରଣକୁ କ୍ଷତି ପହଞ୍ଚାଇପାରେ',
    'Frequency': 'ଆବୃତ୍ତି',
    'Frequently asked questions & tech support': 'ବାରମ୍ବାର ପଚରାଯାଉଥିବା ପ୍ରଶ୍ନ ଏବଂ ବୈଷୟିକ ସହାୟତା',
    'Full': 'ପୂର୍ଣ୍ଣ',
    'Get support directly on WhatsApp chat': 'ୱାଟ୍ସଆପ୍ ଚାଟ୍ ରେ ସିଧାସଳଖ ସମର୍ଥନ ପ୍ରାପ୍ତ କରନ୍ତୁ',
    'Help & Support': 'ସହାୟତା ଓ ସମର୍ଥନ',
    'Hide code': 'କୋଡ୍ ଲୁଚାନ୍ତୁ',
    'High': 'ଉଚ୍ଚ',
    'High Current Harmonic Distortion': 'ଉଚ୍ଚ ସାମ୍ପ୍ରତିକ ହରମୋନିକ୍ ବିକୃତି',
    'High Current K-Factor': 'ଉଚ୍ଚ କରେଣ୍ଟ୍ କେ-ଫ୍ୟାକ୍ଟର୍',
    'High Voltage Harmonic Distortion': 'ଉଚ୍ଚ ଭୋଲଟେଜ୍ ହରମୋନିକ୍ ବିକୃତି',
    'High Voltage K-Factor': 'ହାଇ ଭୋଲଟେଜ୍ କେ-ଫ୍ୟାକ୍ଟର୍',
    'High neutral current — possible fire risk from unbalanced phases or loose neutral.': 'ଉଚ୍ଚ ନିରପେକ୍ଷ କରେଣ୍ଟ - ଅସନ୍ତୁଳିତ ପର୍ଯ୍ୟାୟ କିମ୍ବା ଖାଲି ନିରପେକ୍ଷରୁ ଅଗ୍ନି ବିପଦ',
    'Hourly Power Log · PDF': 'ଘଣ୍ଟା ଶକ୍ତି ଲଗ୍ · PDF',
    'Insufficient data': 'ପର୍ଯ୍ୟାପ୍ତ ତଥ୍ୟ',
    'Intraday Bill': 'ଇଣ୍ଟ୍ରେଡେ ବିଲ୍',
    'K-Factor': 'କେ-ଫ୍ୟାକ୍ଟର୍',
    'K-Factor distribution · sample count per unit band': 'କେ-ଫ୍ୟାକ୍ଟର୍ ବଣ୍ଟନ · ୟୁନିଟ୍ ବ୍ୟାଣ୍ଡ ପ୍ରତି ନମୁନା ଗଣନା',
    'LF Adjustment (projected)': 'LF ଆଡଜଷ୍ଟମେଣ୍ଟ (ପ୍ରୋଜେକ୍ଟ)',
    'LF Penalty (projected)': 'LF ଦଣ୍ଡ (ପ୍ରୋଜେକ୍ଟ)',
    'LF Rebate (projected)': 'LF ରେବେଟ୍ (ପ୍ରୋଜେକ୍ଟ)',
    'Last 24 hours': 'ଗତ 24 ଘଣ୍ଟା',
    'Last 24 hours · kW (active) and kVA (apparent)': 'ଗତ 24 ଘଣ୍ଟା · kW (ସକ୍ରିୟ) ଏବଂ kVA (ସ୍ପଷ୍ଟ)',
    'Last 30 days': 'ଗତ 30 ଦିନ',
    'Last 5 instances · all time': 'ଶେଷ 5 ଉଦାହରଣ · ସବୁ ସମୟ',
    'Last refresh': 'ଶେଷ ରିଫ୍ରେଶ୍',
    'Live': 'ଲାଇଭ୍',
    'Live Power Factor': 'ଲାଇଭ୍ ପାୱାର୍ ଫ୍ୟାକ୍ଟର୍',
    'Live status, risk indicators and threshold breach density.': 'ଜୀବନ୍ତ ସ୍ଥିତି, ବିପଦ ସୂଚକ ଏବଂ ସୀମା ଭଙ୍ଗ ଘନତା',
    'Load Factor': 'ଲୋଡ୍ ଫ୍ୟାକ୍ଟର୍',
    'Load Factor (LF) rebate / surcharge — applied per kWh consumed': 'ଲୋଡ୍ ଫ୍ୟାକ୍ଟର୍ (LF) ରିହାତି / ସରଚାର୍ଜ - ଖାଉଥିବା ପ୍ରତି କିଲୋୱାଚ୍ ପ୍ରତି ପ୍ରୟୋଗ କରାଯାଏ',
    'Load Factor Adjustment': 'ଲୋଡ୍ ଫ୍ୟାକ୍ଟର୍ ଆଡଜଷ୍ଟମେଣ୍ଟ୍',
    'Load Factor Penalty': 'ଫ୍ୟାକ୍ଟର୍ ପେନାଲ୍ଟି ଲୋଡ୍ କରନ୍ତୁ',
    'Load Factor Rebate': 'ଲୋଡ୍ ଫ୍ୟାକ୍ଟର୍ ରେବେଟ୍',
    'Load Factor Utilisation': 'ଲୋଡ୍ ଫ୍ୟାକ୍ଟର୍ ବ୍ୟବହାର',
    'Load Factor adjustment MTD': 'ଲୋଡ୍ ଫ୍ୟାକ୍ଟର୍ ଆଡଜଷ୍ଟମେଣ୍ଟ୍ MTD',
    'Load percentage nearing or exceeding contracted demand limit.': 'ଚୁକ୍ତିଭିତ୍ତିକ ଚାହିଦା ସୀମା ପାଖାପାଖି କିମ୍ବା ଅତିକ୍ରମ କରନ୍ତୁ',
    'Loading…': 'ଲୋଡିଂ…',
    'Low Power Factor': 'ନିମ୍ନ ଶକ୍ତି କାରକ',
    'MD Peak': 'MD ଶିଖର',
    'Max': 'ସର୍ବାଧିକ',
    'Max Demand Analysis': 'ସର୍ବାଧିକ ଚାହିଦା ବିଶ୍ଳେଷଣ',
    'Max Demand by Time-of-Day Period': 'ସମୟ-ସମୟ ଅବଧି ଦ୍ୱାରା ସର୍ବାଧିକ ଚାହିଦା',
    'Max current K-Factor across phases — rates transformer derating for harmonic loads': 'ପର୍ଯ୍ୟାୟରେ ସର୍ବାଧିକ ସାମ୍ପ୍ରତିକ କେ-ଫ୍ୟାକ୍ଟର୍ - ହାରମୋନିକ୍ ଲୋଡ୍ ପାଇଁ ରେଫର୍ ଟ୍ରାନ୍ସଫର୍ମର',
    'Max voltage K-Factor across phases — rates transformer derating for harmonic loads': 'ପର୍ଯ୍ୟାୟରେ ସର୍ବାଧିକ ଭୋଲଟେଜ୍ କେ-ଫ୍ୟାକ୍ଟର୍ - ହାରମୋନିକ୍ ଲୋଡ୍ ପାଇଁ ରେଫର୍ ଟ୍ରାନ୍ସଫର୍ମର',
    'Maximum demand': 'ସର୍ବାଧିକ ଚାହିଦା',
    'Meter overview': 'ମିଟର ସମୀକ୍ଷା',
    'Meter rental': 'ମିଟର ଭଡା',
    'Metered': 'ମିଟର',
    'Meters discovered': 'ଆବିଷ୍କୃତ ମିଟର',
    'Metrics · last 5 alerts': 'ମେଟ୍ରିକ୍ସ · ଶେଷ 5 ଟି ଆଲର୍ଟ',
    'Min': 'ମିନିଟ୍',
    'Mon-Sat. 9:00 AM - 6:00 PM IST': 'ସୋମ-ଶନି 9:00 AM - 6:00 PM IST',
    'Month-to-Date': 'ମାସ-ରୁ-ତାରିଖ',
    'Month-to-Date Cost': 'ମାସ-ରୁ-ତାରିଖ ମୂଲ୍ୟ',
    'Month-to-date bill for': 'ପାଇଁ ମାସ-ଟୁ-ଡେଟ୍ ବିଲ୍',
    'Most recent 5 breach events · reflects your current thresholds': 'ସାମ୍ପ୍ରତିକ 5 ଟି ଉଲ୍ଲଂଘନ ଘଟଣା · ଆପଣଙ୍କର ସାମ୍ପ୍ରତିକ ସୀମାକୁ ପ୍ରତିଫଳିତ କରେ',
    'Must stay': 'ରହିବା ଜରୁରୀ',
    'Near limit': 'ସୀମା ପାଖାପାଖି',
    'Net cost today': 'ଆଜି ନିଟ୍ ମୂଲ୍ୟ',
    'Neutral Current': 'ନିରପେକ୍ଷ କରେଣ୍ଟ୍',
    'Neutral zone': 'ନିରପେକ୍ଷ ଜୋନ୍',
    'No adj.': 'କୌଣସି ଆଡଜଷ୍ଟ ନାହିଁ',
    'No adjustment': 'କୌଣସି ଆଡଜଷ୍ଟମେଣ୍ଟ ନାହିଁ',
    'No alerts found': 'କୌଣସି ସତର୍କତା ମିଳିଲା ନାହିଁ',
    'No breach events with current thresholds': 'ସାମ୍ପ୍ରତିକ ସୀମା ସହିତ କୌଣସି ଉଲ୍ଲଂଘନ ଘଟଣା',
    'No breaches on latest reading': 'ସର୍ବଶେଷ ରିଡିଂ ଉପରେ କୌଣସି ଖଣ୍ଡନ ନାହିଁ',
    'No data': 'କୌଣସି ତଥ୍ୟ ନାହିଁ',
    'No data available yet.': 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ତଥ୍ୟ ଉପଲବ୍ଧ ନାହିଁ',
    'No data for': 'ପାଇଁ କୌଣସି ତଥ୍ୟ ନାହିଁ',
    'No data for this day': 'ଏହି ଦିନ ପାଇଁ କୌଣସି ତଥ୍ୟ ନାହିଁ',
    'No data for this meter yet': 'ଏହି ମିଟର ପାଇଁ ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ତଥ୍ୟ ନାହିଁ',
    'No data for this window': 'ଏହି ୱିଣ୍ଡୋ ପାଇଁ କୌଣସି ତଥ୍ୟ ନାହିଁ',
    'No data in the last 24 hours': 'ଗତ 24 ଘଣ୍ଟା ମଧ୍ୟରେ କୌଣସି ତଥ୍ୟ ନାହିଁ',
    'No rebate': 'କଣସି ରିହାତି ନାହିଁ',
    'No samples in': 'କୌଣସି ନମୁନା ନାହିଁ',
    'No variables match your search.': 'କୌଣସି ଭେରିଏବଲ୍ ଆପଣଙ୍କ ସନ୍ଧାନ ସହିତ ମେଳ ଖାଉ ନାହିଁ',
    'None (WBSEDCL B-IDIT)': 'କିଛି ନୁହେଁ (WBSEDCL B-IDIT)',
    'Normal': 'ସାଧାରଣ',
    'Normal demand charge': 'ସାଧାରଣ ଚାହିଦା ଚାର୍ଜ',
    'Normal · peak': 'ସାଧାରଣ · ଶିଖର',
    'Notify via': 'ମାଧ୍ୟମରେ ଜଣାନ୍ତୁ',
    'Off-Peak': 'ଅଫ୍-ପିକ୍',
    'Open dashboard': 'ଡ୍ୟାସବୋର୍ଡ ଖୋଲନ୍ତୁ',
    'PDF BI': 'PDF BI',
    'PDF columns BE / BF / BG · max of all 15-min averaged blocks per period': 'ପିଡିଏଫ୍ ସ୍ତମ୍ଭଗୁଡିକ BE / BF / BG · ପିରିୟଡ୍ ପ୍ରତି 15-ମିନିଟ୍ ହାରାହାରି ବ୍ଲକଗୁଡିକର ସର୍ବାଧିକ',
    'PF Adjustment (projected)': 'PF ଆଡଜଷ୍ଟମେଣ୍ଟ (ପ୍ରୋଜେକ୍ଟ)',
    'PF Penalty (projected)': 'PF ଦଣ୍ଡ (ପ୍ରୋଜେକ୍ଟ)',
    'PF Penalty / Rebate': 'PF ଦଣ୍ଡ / ପୁନର୍ବାର',
    'PF Rebate (projected)': 'PF ରେବେଟ୍ (ପ୍ରୋଜେକ୍ଟ)',
    'PF rebate / penalty MTD': 'PF ରିହାତି / ପେନାଲ୍ଟି MTD',
    'Password': 'ପାସୱାର୍ଡ',
    'Peak': 'ଶିଖର',
    'Peak clipped': 'ପିକ୍ କ୍ଲିପ୍ ହୋଇଛି',
    'Peak kVA': 'ଶିଖର kVA',
    'Penalty': 'ଦଣ୍ଡ',
    'Penalty <': 'ଦଣ୍ଡ <',
    'Penalty likely': 'ଦଣ୍ଡ ସମ୍ଭବତ।',
    'Penalty zone': 'ପେନାଲ୍ଟି ଜୋନ୍',
    'Per-phase': 'ପ୍ରତି ପର୍ଯ୍ୟାୟରେ',
    'Phase': 'ପର୍ଯ୍ୟାୟ',
    'Phase B Current': 'ପର୍ଯ୍ୟାୟ B କରେଣ୍ଟ୍',
    'Phase B Power': 'ପର୍ଯ୍ୟାୟ ବି ଶକ୍ତି',
    'Phase B line current': 'ପର୍ଯ୍ୟାୟ B ରେଖା କରେଣ୍ଟ୍',
    'Phase R Current': 'ଚରଣ R ସାମ୍ପ୍ରତିକ',
    'Phase R Power': 'ଚରଣ R ଶକ୍ତି',
    'Phase R line current': 'ପର୍ଯ୍ୟାୟ R ରେଖା କରେଣ୍ଟ୍',
    'Phase Y Current': 'ପ୍ରଥମ ପର୍ଯ୍ୟାୟ',
    'Phase Y Power': 'ଚରଣ Y ଶକ୍ତି',
    'Phase Y line current': 'ପର୍ଯ୍ୟାୟ Y ରେଖା କରେଣ୍ଟ୍',
    'Phase current': 'ପର୍ଯ୍ୟାୟ କରେଣ୍ଟ୍',
    'Phase current imbalance — indicates uneven load distribution across phases.': 'ପର୍ଯ୍ୟାୟ ସାମ୍ପ୍ରତିକ ଅସନ୍ତୁଳନ - ପର୍ଯ୍ୟାୟରେ ଅସମାନ ଭାର ବଣ୍ଟନକୁ ସୂଚିତ କରେ',
    'Phase voltage (L-N)': 'ପର୍ଯ୍ୟାୟ ଭୋଲଟେଜ୍ (L-N)',
    'Phase voltage imbalance — can damage motors and reduce equipment life.': 'ପର୍ଯ୍ୟାୟ ଭୋଲଟେଜ୍ ଅସନ୍ତୁଳନ - ମୋଟରକୁ କ୍ଷତି ପହଞ୍ଚାଇପାରେ ଏବଂ ଯନ୍ତ୍ରପାତିର ଜୀବନ ହ୍ରାସ କରିପାରେ',
    'Phone number copied to clipboard.': 'କ୍ଲିପବୋର୍ଡରେ ଫୋନ୍ ନମ୍ବର କପି ହୋଇଛି',
    'Pi CPU Usage': 'Pi CPU ବ୍ୟବହାର',
    'Pi Memory Usage': 'ପି ମେମୋରୀ ବ୍ୟବହାର',
    'Pi Temperature': 'ପି ତାପମାତ୍ରା',
    'Pi Temperature · Last 24 h': 'ପି ତାପମାତ୍ରା · ଶେଷ 24 ଘଣ୍ଟା',
    'Power': 'ଶକ୍ତି',
    'Power Analysis': 'ଶକ୍ତି ବିଶ୍ଳେଷଣ',
    'Power Factor': 'ଶକ୍ତି କାରକ',
    'Power Factor (Month-to-Date)': 'ଶକ୍ତି କାରକ (ମାସ-ରୁ-ତାରିଖ)',
    'Power Factor (PF) adjustment — applied as % of energy charge per ToD period': 'ପାୱାର ଫ୍ୟାକ୍ଟର୍ (PF) ଆଡଜଷ୍ଟମେଣ୍ଟ୍ - ToD ଅବଧି ପାଇଁ ଶକ୍ତି ଚାର୍ଜର% ଭାବରେ ପ୍ରୟୋଗ କରାଯାଏ',
    'Power Factor Adjustment': 'ଶକ୍ତି ଫ୍ୟାକ୍ଟର୍ ଆଡଜଷ୍ଟମେଣ୍ଟ୍',
    'Power Factor Penalty': 'ଶକ୍ତି କାରକ ଦଣ୍ଡ',
    'Power Factor Rebate': 'ପାୱାର୍ ଫ୍ୟାକ୍ଟର୍ ରେବେଟ୍',
    'Power Factor rebate / penalty MTD': 'ପାୱାର ଫ୍ୟାକ୍ଟର୍ ରିହାତି / ପେନାଲ୍ଟି MTD',
    'Power factor below threshold — attracting TGSPDCL RKVAH penalty on energy bill.': 'ଥ୍ରେସହୋଲ୍ଡ ତଳେ ପାୱାର ଫ୍ୟାକ୍ଟର୍ - ଶକ୍ତି ବିଲ୍ ଉପରେ TGSPDCL RKVAH ଦଣ୍ଡକୁ ଆକର୍ଷିତ କରିବା',
    'Production build · v1.0': 'ଉତ୍ପାଦନ ନିର୍ମାଣ · v1.0',
    'Projected Bill': 'ପ୍ରୋଜେକ୍ଟ ବିଲ୍',
    'Projected Bill · Month-End Estimate': 'ପ୍ରୋଜେକ୍ଟ ବିଲ୍ · ମାସ-ଶେଷ ଆକଳନ',
    'Projected energy charge (gross)': 'ଆନୁମାନିକ ଶକ୍ତି ଚାର୍ଜ (ମୋଟ)',
    'Projected net payable by due date': 'ଧାର୍ଯ୍ୟ ତାରିଖ ସୁଦ୍ଧା ଦେୟଯୁକ୍ତ ପ୍ରୋଜେକ୍ଟ୍ ନେଟ୍',
    'Projection uses a linear run-rate from': 'ପ୍ରୋଜେକସନ ଠାରୁ ଏକ ରୈଖିକ ରନ୍-ରେଟ୍ ବ୍ୟବହାର କରେ',
    'RAM Usage (%)': 'RAM ବ୍ୟବହାର (%)',
    'Raspberry Pi CPU temperature': 'ରସବେରୀ ପି CPU ତାପମାତ୍ରା',
    'Raspberry Pi CPU utilisation': 'ରସବେରୀ ପି CPU ବ୍ୟବହାର',
    'Raspberry Pi Gateway': 'ରସବେରୀ ପି ଗେଟୱେ',
    'Raspberry Pi memory utilisation': 'ରସବେରୀ ପି ମେମୋରୀ ବ୍ୟବହାର',
    'Rebate': 'ପୁନର୍ବାର କରନ୍ତୁ',
    'Rebate earned': 'ପୁନର୍ବାର ରୋଜଗାର',
    'Rebate zone': 'ରେବେଟ୍ ଜୋନ୍',
    'Refresh': 'ସତେଜ କରନ୍ତୁ',
    'Refresh interval': 'ରିଫ୍ରେଶ୍ ଅନ୍ତରାଳ',
    'Remove this rule': 'ଏହି ନିୟମ ହଟାନ୍ତୁ',
    'Response time usually within 2 hours': 'ପ୍ରତିକ୍ରିୟା ସମୟ ସାଧାରଣତ 2 2 ଘଣ୍ଟା ମଧ୍ୟରେ',
    'Rules saved on this device. Production build routes notifications via SMS and WhatsApp.': 'ଏହି ଉପକରଣରେ ନିୟମ ସେଭ୍ ହୋଇଛି। SMS ଏବଂ ୱାଟ୍ସଆପ୍ ମାଧ୍ୟମରେ ଉତ୍ପାଦନ ନିର୍ମାଣ ମାର୍ଗ ବିଜ୍ଞପ୍ତି',
    'Running daily energy cost (₹)': 'ଦୈନିକ ଶକ୍ତି ଖର୍ଚ୍ଚ (₹)',
    'Running maximum of kVA averaged over 15 minutes window': 'ସର୍ବାଧିକ 15 ମିନିଟ୍ ୱିଣ୍ଡୋରେ ସର୍ବାଧିକ kVA ଚାଲିବା',
    'Running session energy (kWh)': 'ଚାଲୁଥିବା ଅଧିବେଶନ ଶକ୍ତି (kWh)',
    'SAFE': 'ସୁରକ୍ଷିତ',
    'Safe': 'ନିରାପଦ',
    'Samples loaded': 'ଲୋଡ୍ ହୋଇଥିବା ନମୁନା',
    'Save Alert Rules': 'ଆଲର୍ଟ ନିୟମଗୁଡିକ ସେଭ୍ କରନ୍ତୁ',
    'Search variables…': 'ଭେରିଏବଲ୍ ସନ୍ଧାନ…',
    'Select Language': 'ଭାଷା ଚୟନ କରନ୍ତୁ',
    'Select a date range above': 'ଉପରେ ଏକ ତାରିଖ ସୀମା ଚୟନ କରନ୍ତୁ',
    'Select billing period': 'ବିଲିଂ ଅବଧି ଚୟନ କରନ୍ତୁ',
    'Select language': 'ଭାଷା ଚୟନ କରନ୍ତୁ',
    'Select meter': 'ମିଟର ଚୟନ କରନ୍ତୁ',
    'Send Email': 'ଇମେଲ୍ ପଠାନ୍ତୁ',
    'Session Energy': 'ଅଧିବେଶନ ଶକ୍ତି',
    'Session carbon footprint (kg CO₂)': 'ଅଧିବେଶନ କାର୍ବନ ଫୁଟ୍ ପ୍ରିଣ୍ଟ (କିଗ୍ରା CO₂)',
    'Settings': 'ସେଟିଂସ',
    'Share': 'ଅଂଶୀଦାର କରନ୍ତୁ',
    'Show code': 'କୋଡ୍ ଦେଖାନ୍ତୁ',
    'Showing': 'ଦେଖାଉଛି',
    'Showing cached data — we\'ll keep retrying automatically.': 'କ୍ୟାଚ୍ ହୋଇଥିବା ଡାଟା ଦେଖାଉଛି - ଆମେ ସ୍ୱୟଂଚାଳିତ ଭାବରେ ପୁନଃ ଚେଷ୍ଟା କରିବୁ',
    'Showing month-to-date charges': 'ମାସ-ଟୁ-ଡେଟ୍ ଚାର୍ଜ ଦେଖାଉଛି',
    'Showing today\'s charges': 'ଆଜିର ଚାର୍ଜ ଦେଖାଉଛି',
    'Sign out': 'ସାଇନ୍ ଆଉଟ୍',
    'Similar to average': 'ହାରାହାରି ସହିତ ସମାନ',
    'Similar to this week\'s average': 'ଏହି ସପ୍ତାହର ହାରାହାରି ପରି',
    'Since midnight IST · updates every 5 min': 'ମଧ୍ୟରାତ୍ରିରୁ IST · ପ୍ରତି 5 ମିନିଟରେ ଅପଡେଟ୍ କରେ',
    'Site': 'ସାଇଟ୍',
    'Sum of all phase currents': 'ସମସ୍ତ ପର୍ଯ୍ୟାୟ ସ୍ରୋତଗୁଡ଼ିକର ସମଷ୍ଟି',
    'Surcharge': 'ସରଚାର୍ଜ',
    'THD distribution · sample count per 2% band': 'THD ବଣ୍ଟନ · 2% ବ୍ୟାଣ୍ଡ ପ୍ରତି ନମୁନା ଗଣନା',
    'Telangana': 'ତେଲେଙ୍ଗାନା',
    'Temperature (°C)': 'ତାପମାତ୍ରା (° C)',
    'This Month': 'ଏହି ମାସ',
    'This week (Sun – yesterday)': 'ଏହି ସପ୍ତାହ (ସୂର୍ଯ୍ୟ - ଗତକାଲି)',
    'Threshold': 'ଥ୍ରେସହୋଲ୍ଡ',
    'Time distribution': 'ସମୟ ବଣ୍ଟନ',
    'Time-of-Day Split': 'ସମୟ-ଦିନର ବିଭାଜନ',
    'Timely Payment Rebate': 'ଠିକ୍ ସମୟରେ ଦେୟ ରିବେଟ୍',
    'ToD Off-Peak Rebate': 'ToD ଅଫ୍ ପାଇକ୍ ରେବେଟ୍',
    'ToD Peak Penalty': 'ToD ଶିଖର ଦଣ୍ଡ',
    'Today': 'ଆଜି',
    'Today PF': 'ଆଜି PF',
    'Today is': 'ଆଜି ହେଉଛି',
    'Today\'s Cost': 'ଆଜିର ମୂଲ୍ୟ',
    'Today\'s Running Cost': 'ଆଜିର ଚାଲିବା ମୂଲ୍ୟ',
    'Total': 'ସମୁଦାୟ',
    'Total Active Power': 'ସମୁଦାୟ ସକ୍ରିୟ ଶକ୍ତି',
    'Total Apparent Power': 'ସମୁଦାୟ ଦୃଶ୍ୟମାନ ଶକ୍ତି',
    'Total Current': 'ସମୁଦାୟ କରେଣ୍ଟ୍',
    'Total Energy (kWh) consumed last month / (Peak kW observed last month times number of hours last month)': 'ଗତ ମାସରେ ସମୁଦାୟ ଶକ୍ତି (kWh) ଖର୍ଚ୍ଚ ହୋଇଛି /',
    'Total Energy (kWh) consumed this month / (Peak kW observed this month times number of hours this month)': 'ସମୁଦାୟ ଶକ୍ତି (kWh) ଏହି ମାସରେ ଖର୍ଚ୍ଚ ହୋଇଛି /',
    'Total Energy (kWh) consumed this week / (Peak kW observed this week times number of hours this week)': 'ସମୁଦାୟ ଶକ୍ତି (kWh) ଏହି ସପ୍ତାହରେ ଖର୍ଚ୍ଚ ହୋଇଛି /',
    'Total Energy (kWh) consumed today/ (Peak kW observed today times number of hours today)': 'ଆଜି ସମୁଦାୟ ଶକ୍ତି (kWh) ଖର୍ଚ୍ଚ ହୋଇଛି /',
    'Total Energy Charge': 'ମୋଟ ଶକ୍ତି ଚାର୍ଜ',
    'Total Harmonic Distortion (%)': 'ସମୁଦାୟ ହାରମୋନିକ୍ ବିକୃତି (%)',
    'Total Watts': 'ମୋଟ ୱାଟସ୍',
    'Total active power across all phases': 'ସମସ୍ତ ପର୍ଯ୍ୟାୟରେ ସମୁଦାୟ ସକ୍ରିୟ ଶକ୍ତି',
    'Total apparent power (kVA)': 'ସମୁଦାୟ ସ୍ପଷ୍ଟ ଶକ୍ତି (kVA)',
    'Total demand cost': 'ମୋଟ ଚାହିଦା ମୂଲ୍ୟ',
    'Total instantaneous power in watts': 'ୱାଟରେ ସମୁଦାୟ ତତକ୍ଷଣାତ୍ ଶକ୍ତି',
    'Try again': 'ପୁନର୍ବାର ଚେଷ୍ଟା କରନ୍ତୁ',
    'Try another meter or wait for the next refresh.': 'ଅନ୍ୟ ଏକ ମିଟର ଚେଷ୍ଟା କରନ୍ତୁ କିମ୍ବା ପରବର୍ତ୍ତୀ ସତେଜ ପାଇଁ ଅପେକ୍ଷା କରନ୍ତୁ',
    'Use one of the access codes provided for your site.': 'ଆପଣଙ୍କ ସାଇଟ୍ ପାଇଁ ପ୍ରଦାନ କରାଯାଇଥିବା ଏକ ଆକ୍ସେସ୍ କୋଡ୍ ବ୍ୟବହାର କରନ୍ତୁ',
    'Utilisation %': 'ଉପଯୋଗ%',
    'Voltage': 'ଭୋଲଟେଜ୍',
    'Voltage Imbalance': 'ଭୋଲଟେଜ୍ ଅସନ୍ତୁଳନ',
    'Voltage K-Factor': 'ଭୋଲଟେଜ୍ କେ-ଫ୍ୟାକ୍ଟର୍',
    'Voltage K-Factor exceeds transformer derating limit — K>4 requires a K-rated transformer.': 'ଭୋଲଟେଜ୍ କେ-ଫ୍ୟାକ୍ଟର୍ ଟ୍ରାନ୍ସଫର୍ମର ଡେରିଟିଂ ସୀମା ଅତିକ୍ରମ କରେ - K> 4 ଏକ K- ରେଟେଡ୍ ଟ୍ରାନ୍ସଫର୍ମର ଆବଶ୍ୟକ କରେ',
    'WARN': 'ସତର୍କବାଣୀ',
    'Warn': 'ସତର୍କ କର',
    'Warning': 'ଚେତାବନୀ',
    'Warning above': 'ଉପରେ ଚେତାବନୀ',
    'Warning below': 'ନିମ୍ନରେ ଚେତାବନୀ',
    'Warning · peak': 'ଚେତାବନୀ',
    'WhatsApp Support': 'ୱାଟ୍ସଆପ୍ ସମର୍ଥନ',
    'Within Limit': 'ସୀମା ମଧ୍ୟରେ',
    'Worst': 'ସବୁଠାରୁ ଖରାପ',
    'Yesterday': 'ଗତକାଲି',
    'above': 'ଉପରେ',
    'above CD': 'CD ଉପରେ',
    'above this week\'s avg': 'ଏହି ସପ୍ତାହର ହାରାହାରି ଉପରେ',
    'above this week\'s avg — good day': 'ଏହି ସପ୍ତାହର ହାରାହାରି ଉପରେ - ଶୁଭ ଦିନ',
    'active': 'ସକ୍ରିୟ',
    'active issue': 'ସକ୍ରିୟ ସମସ୍ୟା',
    'active issues': 'ସକ୍ରିୟ ପ୍ରସଙ୍ଗଗୁଡିକ',
    'added to bill': 'ବିଲରେ ଯୋଡା ଯାଇଛି',
    'added to this month\'s bill': 'ଏହି ମାସର ବିଲରେ ଯୋଡି ହୋଇଛି',
    'adjustment': 'ଆଡଜଷ୍ଟମେଣ୍ଟ୍',
    'all charges finalised.': 'ସମସ୍ତ ଚାର୍ଜ ଚୂଡାନ୍ତ ହୋଇଛି',
    'and': 'ଏବଂ',
    'applied for Load Factor ≥ 65%': 'ଲୋଡ୍ ଫ୍ୟାକ୍ଟର୍ ≥ 65% ପାଇଁ ଆବେଦନ କରାଯାଇଛି',
    'average': 'ହାରାହାରି',
    'avg': 'ହାରାହାରି',
    'below': 'ନିମ୍ନରେ',
    'below average': 'ହାରାହାରି ତଳେ',
    'below min → charged on': 'ମିନିଟ୍ ତଳେ → ଚାର୍ଜ ହୋଇଛି',
    'below this week\'s avg': 'ଏହି ସପ୍ତାହର ହାରାହାରି ତଳେ',
    'below this week\'s avg — below average': 'ଏହି ସପ୍ତାହର ହାରାହାରି ତଳେ - ହାରାହାରି ତଳେ',
    'consumers under TOD Tariff (CD > 50 kVA); % of energy charge per ToD period': 'TOD Tariff (CD> 50 kVA) ଅଧୀନରେ ଗ୍ରାହକ; ToD ଅବଧି ପାଇଁ ଶକ୍ତି ଚାର୍ଜର%',
    'critical': 'ଗୁରୁତର',
    'current': 'ସାମ୍ପ୍ରତିକ',
    'day bill for': 'ଦିନ ବିଲ୍ ପାଇଁ',
    'day run rate': 'ଦୈନିକ ରନ୍ ରେଟ୍',
    'days': 'ଦିନ',
    'days of actual data.': 'ପ୍ରକୃତ ତଥ୍ୟର ଦିନ',
    'days of meter data': 'ମିଟର ତଥ୍ୟର ଦିନ',
    'days remaining': 'ଦିନ ବାକି ଅଛି',
    'days required for': 'ଦିନ ପାଇଁ ଆବଶ୍ୟକ',
    'deducted from bill': 'ବିଲରୁ କଟାଯାଇଛି',
    'deducted from this month\'s bill': 'ଏହି ମାସର ବିଲରୁ କଟାଯାଇଛି',
    'delivered': 'ବିତରଣ',
    'energy charges, Power Factor & Load Factor adjustments, demand charge, duties, and projected net payable.': 'ଶକ୍ତି ଚାର୍ଜ, ପାୱାର ଫ୍ୟାକ୍ଟର୍ ଏବଂ ଲୋଡ୍ ଫ୍ୟାକ୍ଟର୍ ଆଡଜଷ୍ଟେସନ୍, ଡିମାଣ୍ଡ ଚାର୍ଜ, ଡ୍ୟୁଟି, ଏବଂ ପ୍ରୋଜେକ୍ଟ ନେଟ୍ ପେମେଣ୍ଟ୍',
    'energy per day': 'ପ୍ରତିଦିନ ଶକ୍ତି',
    'energy per hour': 'ଘଣ୍ଟା ପ୍ରତି ଶକ୍ତି',
    'excess above CD': 'CD ଉପରେ ଅଧିକ',
    'fires when <': 'ଟ୍ରିଗର ହୁଏ ଯେତେବେଳେ <',
    'fires when >': 'ଟ୍ରିଗର ହୁଏ ଯେତେବେଳେ >',
    'good day': 'ଶୁଭ ଦିନ',
    'if paid after 15 days': 'ଯଦି 15 ଦିନ ପରେ ଦେୟ ଦିଆଯାଏ',
    'if paid by due date': 'ଯଦି ଧାର୍ଯ୍ୟ ତାରିଖ ସୁଦ୍ଧା ପ୍ରଦାନ କରାଯାଏ',
    'imbal': 'imbal',
    'invoice estimate': 'ଇନଭଏସ୍ ଆକଳନ',
    'is above this week\'s avg': 'ଏହି ସପ୍ତାହର ହାରାହାରି ଉପରେ',
    'is below this week\'s avg': 'ଏହି ସପ୍ତାହର ହାରାହାରି ତଳେ',
    'kVA/month': 'kVA / ମାସ',
    'kVAh': 'kVAh',
    'kWh': 'kWh',
    'limit': 'ସୀମା',
    'meter': 'ମିଟର',
    'meters': 'ମିଟର',
    'min demand applies': 'ମିନିଟ୍ ଚାହିଦା ପ୍ରଯୁଜ୍ୟ',
    'month': 'ମାସ',
    'month-to-date': 'ମାସ-ରୁ-ତାରିଖ',
    'net incl. all charges': 'net incl ସମସ୍ତ ଦେୟ',
    'net today': 'ଆଜି ନେଟ୍',
    'never': 'କେବେ ନୁହେଁ',
    'no adj.': 'ନା adj',
    'no adjustment': 'କୌଣସି ଆଡଜଷ୍ଟମେଣ୍ଟ୍ ନାହିଁ',
    'no adjustment applicable': 'କୌଣସି ଆଡଜଷ୍ଟମେଣ୍ଟ ପ୍ରଯୁଜ୍ୟ ନୁହେଁ',
    'no adjustment today': 'ଆଜି କୌଣସି ଆଡଜଷ୍ଟମେଣ୍ଟ ନାହିଁ',
    'nom': 'ନାମ',
    'not yet applicable today': 'ଆଜି ମଧ୍ୟ ପ୍ରଯୁଜ୍ୟ ନୁହେଁ',
    'of': 'ର',
    'of 24 hours have data': '24 ଘଣ୍ଟାର ତଥ୍ୟ ଅଛି',
    'of CD': 'CD ର',
    'of bill': 'ବିଲ୍',
    'of gross bill': 'ମୋଟ ବିଲ୍',
    'of net bill': 'ନେଟ୍ ବିଲ୍ ର',
    'off': 'ବନ୍ଦ',
    'on the excess kVA.': 'ଅତିରିକ୍ତ kVA ଉପରେ',
    'over-threshold': 'ଓଭର-ଥ୍ରେସହୋଲ୍ଡ',
    'paise/kVAh  (6p flat)': 'paise / kVAh (6p ଫ୍ଲାଟ)',
    'paise/kWh rebate': 'paise / kWh ରିହାତି',
    'paise/kWh surcharge': 'paise / kWh ସରଚାର୍ଜ',
    'peak kVA': 'ଶିଖର kVA',
    'peak kVA today': 'ଆଜି ଶିଖର kVA',
    'penalty': 'ଦଣ୍ଡ',
    'projected penalty': 'ଧାର୍ଯ୍ୟ ଦଣ୍ଡ',
    'projected rebate': 'ଆନୁମାନିକ ରିହାତି',
    'projected surcharge': 'ପ୍ରୋଜେକ୍ଟ ସରଚାର୍ଜ',
    'readings': 'ରିଡିଂ',
    'readings · 3 phases': 'ପଠନ · 3 ପର୍ଯ୍ୟାୟ',
    'rebate': 'ରିହାତି',
    'rebate / kWh': 'ରିହାତି / kWh',
    'rebate earned': 'ରିହାତି',
    's': 's',
    's when the tab is visible.': 's ଯେତେବେଳେ ଟ୍ୟାବ୍ ଦୃଶ୍ୟମାନ ହୁଏ',
    'samples': 'ନମୁନା',
    'surcharge': 'ସରଚାର୍ଜ',
    'surcharge / kWh': 'ସରଚାର୍ଜ / kWh',
    'surcharge added to bill': 'ସରଚାର୍ଜ ବିଲରେ ଯୋଡି ହୋଇଛି',
    'surcharge applied': 'ସରଚାର୍ଜ ପ୍ରୟୋଗ',
    'threshold': 'ସୀମା',
    'to': 'କୁ',
    'units consumed so far': 'ଏପର୍ଯ୍ୟନ୍ତ ବ୍ୟବହୃତ ୟୁନିଟ୍',
    'updated every 5 min': 'ପ୍ରତି 5 ମିନିଟରେ ଅପଡେଟ୍',
    'updating…': 'ଅଦ୍ୟତନ…',
    'warn': 'ସତର୍କ କର',
    '· added to bill today': '· ଆଜି ବିଲରେ ଯୋଡି ହୋଇଛି',
    '· saving deducted today': 'ଆଜି ସଞ୍ଚୟ କଟାଯାଇଛି',
    '· surcharge added today': '· ସରଚାର୍ଜ ଆଜି ଯୋଗ କରାଯାଇଛି',
    '— · awaiting data': '— · ଡାଟା ଅପେକ୍ଷାରେ',
    '≥': '≥',
    '⚠ No Pi telemetry in current data — fields piTempC / piMemPct not populated': 'Current ସାମ୍ପ୍ରତିକ ତଥ୍ୟରେ କ Pi ଣସି ପି ଟେଲିମେଟ୍ରି ନାହିଁ - ଫିଲ୍ଡଗୁଡିକ piTempC / piMemPct ଜନବହୁଳ ନୁହେଁ',
    '⚠️ Thermal throttle active — Pi is running hot, performance reduced': '⚠️ ଥର୍ମାଲ୍ ଥ୍ରୋଟଲ୍ ସକ୍ରିୟ - ପି ଗରମ ଚାଲୁଛି, କାର୍ଯ୍ୟଦକ୍ଷତା ହ୍ରାସ ପାଇଛି',
    '✓ Rules Saved Successfully': 'ସଫଳତାର ସହିତ ସଞ୍ଚୟ ହୋଇଥିବା ନିୟମ',
  },
  pa: {
    'This Week': 'ਇਸ ਹਫ਼ਤੇ',
    'Last Month': 'ਪਿਛਲੇ ਮਹੀਨੇ',
    'Sensor Dropout': 'ਸੈਂਸਰ ਡਰਾਪਆਉਟ',
    'Approaching Overload': 'ਓਵਰਲੋਡ ਨੇੜੇ ਆ ਰਿਹਾ ਹੈ',
    'Frequency Deviation': 'ਫ੍ਰੀਕੁਐਂਸੀ ਭਟਕਾਅ',
    'High Voltage THD': 'ਹਾਈ ਵੋਲਟੇਜ THD',
    'High Current THD': 'ਹਾਈ ਕਰੰਟ THD',
    'In-app': 'ਐਪ ਦੇ ਅੰਦਰ',
    'SMS': 'ਐਸਐਮਐਸ',
    'WhatsApp': 'ਵਟਸਐਪ',
    'Min. chargeable demand': 'ਘੱਟੋ-ਘੱਟ ਚਾਰਜਯੋਗ ਮੰਗ',
    'Demand charge — Normal': 'ਡਿਮਾਂਡ ਚਾਰਜ — ਆਮ',
    'Demand charge — Penal': 'ਡਿਮਾਂਡ ਚਾਰਜ — ਦੰਡਕਾਰੀ',
    'Electricity duty': 'ਬਿਜਲੀ ਡਿਊਟੀ',
    'Late payment surcharge': 'ਦੇਰੀ ਭੁਗਤਾਨ ਸਰਚਾਰਜ',
    'Demand charge (up to CD)': 'ਡਿਮਾਂਡ ਚਾਰਜ (CD ਤੱਕ)',
    'Generating': 'ਤਿਆਰ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ',
    'Bill PDF…': 'ਬਿੱਲ PDF…',
    'What is the Power Analysis Dashboard?': 'ਪਾਵਰ ਵਿਸ਼ਲੇਸ਼ਣ ਡੈਸ਼ਬੋਰਡ ਕੀ ਹੈ?',
    'It monitors real-time electrical metrics (voltage, current, power factor, demand, active/reactive energy) collected from Raspberry Pi edge nodes installed at the site.': 'ਇਹ ਸਾਈਟ \'ਤੇ ਸਥਾਪਿਤ Raspberry Pi ਐਜ ਨੋਡਾਂ ਤੋਂ ਇਕੱਠੇ ਕੀਤੇ ਰੀਅਲ-ਟਾਈਮ ਬਿਜਲੀ ਮੈਟ੍ਰਿਕਸ (ਵੋਲਟੇਜ, ਕਰੰਟ, ਪਾਵਰ ਫੈਕਟਰ, ਮੰਗ, ਐਕਟਿਵ/ਰਿਐਕਟਿਵ ਊਰਜਾ) ਦੀ ਨਿਗਰਾਨੀ ਕਰਦਾ ਹੈ।',
    'What do the green/orange/red indicators mean?': 'ਹਰੇ/ਸੰਤਰੀ/ਲਾਲ ਸੂਚਕਾਂ ਦਾ ਕੀ ਮਤਲਬ ਹੈ?',
    'Green means the Raspberry Pi edge node is online and reporting health telemetry normally. Orange/red indicate potential communication delays or high temperature/resource throttling.': 'ਹਰਾ ਮਤਲਬ Raspberry Pi ਐਜ ਨੋਡ ਆਨਲਾਈਨ ਹੈ ਅਤੇ ਆਮ ਤੌਰ \'ਤੇ ਹੈਲਥ ਟੈਲੀਮੈਟਰੀ ਰਿਪੋਰਟ ਕਰ ਰਿਹਾ ਹੈ। ਸੰਤਰੀ/ਲਾਲ ਸੰਭਾਵੀ ਸੰਚਾਰ ਦੇਰੀ ਜਾਂ ਉੱਚ ਤਾਪਮਾਨ/ਸਰੋਤ ਥ੍ਰੌਟਲਿੰਗ ਨੂੰ ਦਰਸਾਉਂਦੇ ਹਨ।',
    'How are billing demand charges calculated?': 'ਬਿਲਿੰਗ ਡਿਮਾਂਡ ਚਾਰਜ ਦੀ ਗਣਨਾ ਕਿਵੇਂ ਕੀਤੀ ਜਾਂਦੀ ਹੈ?',
    'Demand charges are based on the Maximum Demand (MD) recorded in 15-minute integration windows, calculated according to the active tariff structure (e.g., TGSPDCL HT or WBSEDCL B-IDIT).': 'ਡਿਮਾਂਡ ਚਾਰਜ 15-ਮਿੰਟ ਦੇ ਇੰਟੀਗ੍ਰੇਸ਼ਨ ਵਿੰਡੋਜ਼ ਵਿੱਚ ਦਰਜ ਵੱਧ ਤੋਂ ਵੱਧ ਮੰਗ (MD) \'ਤੇ ਅਧਾਰਤ ਹਨ, ਸਰਗਰਮ ਟੈਰਿਫ ਢਾਂਚੇ (ਜਿਵੇਂ ਕਿ TGSPDCL HT ਜਾਂ WBSEDCL B-IDIT) ਅਨੁਸਾਰ ਗਿਣੇ ਜਾਂਦੇ ਹਨ।',
    'What should I do if the dashboard shows "No data"?': 'ਜੇ ਡੈਸ਼ਬੋਰਡ "ਕੋਈ ਡਾਟਾ ਨਹੀਂ" ਦਿਖਾਉਂਦਾ ਹੈ ਤਾਂ ਮੈਨੂੰ ਕੀ ਕਰਨਾ ਚਾਹੀਦਾ ਹੈ?',
    'Verify that the edge node (Raspberry Pi gateway) is powered on and connected to the internet. If the issue persists, contact technical support immediately.': 'ਪੁਸ਼ਟੀ ਕਰੋ ਕਿ ਐਜ ਨੋਡ (Raspberry Pi ਗੇਟਵੇ) ਚਾਲੂ ਹੈ ਅਤੇ ਇੰਟਰਨੈੱਟ ਨਾਲ ਜੁੜਿਆ ਹੋਇਆ ਹੈ। ਜੇ ਸਮੱਸਿਆ ਬਣੀ ਰਹਿੰਦੀ ਹੈ, ਤਾਂ ਤੁਰੰਤ ਤਕਨੀਕੀ ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।',
    '% of readings': 'ਰੀਡਿੰਗਾਂ ਦਾ %',
    '/month': '/ਮਹੀਨਾ',
    '0.4 kV supply': '0.4 ਕੇਵੀ ਸਪਲਾਈ',
    '12 AM – 12 AM': 'ਰਾਤ 12 - ਰਾਤ 12',
    '1st 12 AM → now': '1 ਤਰੀਕ ਰਾਤ 12 → ਹੁਣ',
    '2x penalty': '2x ਜੁਰਮਾਨਾ',
    '33 kV supply': '33 ਕੇਵੀ ਸਪਲਾਈ',
    'About': 'ਬਾਰੇ',
    'Above': 'ਉੱਪਰ',
    'Across': 'ਪਾਰ',
    'Active (kW)': 'ਕਿਰਿਆਸ਼ੀਲ (kW)',
    'Active Power & Apparent Power': 'ਕਿਰਿਆਸ਼ੀਲ ਸ਼ਕਤੀ ਅਤੇ ਸਪੱਸ਼ਟ ਸ਼ਕਤੀ',
    'Active power on Phase B': 'ਫੇਜ਼ ਬੀ \'ਤੇ ਕਿਰਿਆਸ਼ੀਲ ਸ਼ਕਤੀ',
    'Active power on Phase R': 'ਫੇਜ਼ ਆਰ \'ਤੇ ਕਿਰਿਆਸ਼ੀਲ ਸ਼ਕਤੀ',
    'Active power on Phase Y': 'ਪੜਾਅ Y \'ਤੇ ਕਿਰਿਆਸ਼ੀਲ ਸ਼ਕਤੀ',
    'Active tariff': 'ਸਰਗਰਮ ਟੈਰਿਫ',
    'Add custom variable alert': 'ਕਸਟਮ ਵੇਰੀਏਬਲ ਚੇਤਾਵਨੀ ਸ਼ਾਮਲ ਕਰੋ',
    'Additional demand charge': 'ਵਾਧੂ ਮੰਗ ਚਾਰਜ',
    'Alert History': 'ਅਲਰਟ ਇਤਿਹਾਸ',
    'Alert Rules': 'ਚੇਤਾਵਨੀ ਨਿਯਮ',
    'Alerts': 'ਅਲਰਟ',
    'All energy/PF/LF values computed by the Cortex Pi gateway per VARIABLES.pdf §2.3 & §3. Demand, ED, rental, and TPR computed in the browser from WBSEDCL tariff constants.': 'Cortex Pi ਗੇਟਵੇ ਪ੍ਰਤੀ VARIABLES.pdf §2.3 ਅਤੇ §3 ਦੁਆਰਾ ਗਣਨਾ ਕੀਤੇ ਗਏ ਸਾਰੇ ਊਰਜਾ/PF/LF ਮੁੱਲ। ਮੰਗ, ED, ਰੈਂਟਲ, ਅਤੇ TPR ਦੀ ਗਣਨਾ WBSEDCL ਟੈਰਿਫ ਸਥਿਰਾਂਕਾਂ ਤੋਂ ਬ੍ਰਾਊਜ਼ਰ ਵਿੱਚ ਕੀਤੀ ਜਾਂਦੀ ਹੈ।',
    'All systems normal': 'ਸਾਰੇ ਸਿਸਟਮ ਆਮ',
    'Anomalies': 'ਵਿਸੰਗਤੀਆਂ',
    'Anomaly': 'ਖਰਾਬੀ',
    'Apparent': 'ਆਭਾਸੀ',
    'Apparent (kVA)': 'ਸਪੱਸ਼ਟ (kVA)',
    'Approaching Contracted Demand': 'ਕੰਟਰੈਕਟਡ ਮੰਗ ਨੂੰ ਪੂਰਾ ਕਰਨਾ',
    'Auto-refreshes every': 'ਹਰ ਇੱਕ ਨੂੰ ਸਵੈ-ਤਾਜ਼ਾ ਕਰਦਾ ਹੈ',
    'Average Power Factor': 'ਔਸਤ ਪਾਵਰ ਫੈਕਟਰ',
    'Average power factor across': 'ਔਸਤ ਪਾਵਰ ਫੈਕਟਰ ਪਾਰ',
    'Avg': 'ਔਸਤ',
    'Avg Active Power': 'ਔਸਤ ਕਿਰਿਆਸ਼ੀਲ ਸ਼ਕਤੀ',
    'Avg Apparent Power': 'ਔਸਤ ਪ੍ਰਤੱਖ ਸ਼ਕਤੀ',
    'Base Energy Charge': 'ਬੇਸ ਐਨਰਜੀ ਚਾਰਜ',
    'Based on': '\'ਤੇ ਆਧਾਰਿਤ ਹੈ',
    'Below': 'ਹੇਠਾਂ',
    'Between': 'ਵਿਚਕਾਰ',
    'Billing': 'ਬਿਲਿੰਗ',
    'Billing Cycle Peak': 'ਬਿਲਿੰਗ ਸਾਈਕਲ ਪੀਕ',
    'Billing Overview': 'ਬਿਲਿੰਗ ਦਾ ਵੇਰਵਾ',
    'Both levels disabled': 'ਦੋਵੇਂ ਪੱਧਰਾਂ ਨੂੰ ਅਯੋਗ ਬਣਾਇਆ ਗਿਆ',
    'Building PDF…': 'PDF ਬਣਾ ਰਿਹਾ ਹੈ...',
    'CD': 'CD',
    'CD 100%': 'CD 100%',
    'CORTEX by Vireon': 'ਕੋਰਟੈਕਸ - ਵਾਇਰਨ ਦੁਆਰਾ',
    'CRIT': 'ਸੀ.ਆਰ.ਆਈ.ਟੀ',
    'Call Now': 'ਹੁਣੇ ਕਾਲ ਕਰੋ',
    'Call Support': 'ਸਹਾਇਤਾ ਨੂੰ ਕਾਲ ਕਰੋ',
    'Carbon (CO₂)': 'ਕਾਰਬਨ (CO₂)',
    'Chargeable demand': 'ਚਾਰਜਯੋਗ ਮੰਗ',
    'Chargeable min:': 'ਚਾਰਜਯੋਗ ਘੱਟੋ-ਘੱਟ:',
    'Chat on WhatsApp': 'ਵਟਸਐਪ \'ਤੇ ਚੈਟ ਕਰੋ',
    'Check back when more data is synced.': 'ਹੋਰ ਡਾਟਾ ਸਿੰਕ ਹੋਣ \'ਤੇ ਵਾਪਸ ਜਾਂਚ ਕਰੋ।',
    'Check your network or sheet sharing settings (Anyone with the link → Viewer).': 'ਆਪਣੇ ਨੈੱਟਵਰਕ ਜਾਂ ਸ਼ੀਟ ਸ਼ੇਅਰਿੰਗ ਸੈਟਿੰਗਾਂ ਦੀ ਜਾਂਚ ਕਰੋ (ਲਿੰਕ ਵਾਲਾ ਕੋਈ ਵੀ → ਦਰਸ਼ਕ)।',
    'Choose a variable': 'ਇੱਕ ਵੇਰੀਏਬਲ ਚੁਣੋ',
    'Close': 'ਬੰਦ ਕਰੋ',
    'Close Help and Support Modal': 'ਮਦਦ ਅਤੇ ਸਹਾਇਤਾ ਮਾਡਲ ਨੂੰ ਬੰਦ ਕਰੋ',
    'Connecting…': 'ਕਨੈਕਟ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...',
    'Consumer': 'ਖਪਤਕਾਰ',
    'Contact Tech Support': 'ਤਕਨੀਕੀ ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ',
    'Contact your administrator if you do not have one.': 'ਜੇਕਰ ਤੁਹਾਡੇ ਕੋਲ ਨਹੀਂ ਹੈ ਤਾਂ ਆਪਣੇ ਪ੍ਰਸ਼ਾਸਕ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।',
    'Contract': 'ਇਕਰਾਰਨਾਮਾ',
    'Contract Demand (CD)': 'ਇਕਰਾਰਨਾਮਾ ਮੰਗ (CD)',
    'Contract Demand Utilisation': 'ਕੰਟਰੈਕਟ ਡਿਮਾਂਡ ਉਪਯੋਗਤਾ',
    'Contract demand:': 'ਇਕਰਾਰਨਾਮੇ ਦੀ ਮੰਗ:',
    'Contract limit': 'ਇਕਰਾਰਨਾਮੇ ਦੀ ਸੀਮਾ',
    'Copy Number': 'ਨੰਬਰ ਕਾਪੀ ਕਰੋ',
    'Cost': 'ਲਾਗਤ',
    'Cost breakdown': 'ਲਾਗਤ ਦਾ ਵੇਰਵਾ',
    'Couldn\'t reach the data sheet': 'ਡਾਟਾ ਸ਼ੀਟ ਤੱਕ ਨਹੀਂ ਪਹੁੰਚ ਸਕਿਆ',
    'Couldn\'t refresh just now.': 'ਹੁਣੇ ਰਿਫ੍ਰੈਸ਼ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਿਆ।',
    'Crit': 'ਕ੍ਰਿਟ',
    'Critical': 'ਨਾਜ਼ੁਕ',
    'Critical above': 'ਉਪਰੋਕਤ ਨਾਜ਼ੁਕ',
    'Critical below': 'ਹੇਠਾਂ ਗੰਭੀਰ',
    'Critical · peak': 'ਨਾਜ਼ੁਕ · ਸਿਖਰ',
    'Current': 'ਕਰੰਟ',
    'Current Imbalance': 'ਕਰੰਟ ਅਸੰਤੁਲਨ',
    'Current K-Factor': 'ਮੌਜੂਦਾ ਕੇ-ਫੈਕਟਰ',
    'Current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'ਮੌਜੂਦਾ ਕੇ-ਫੈਕਟਰ ਗੰਭੀਰ ਹਾਰਮੋਨਿਕ ਲੋਡਿੰਗ ਨੂੰ ਦਰਸਾਉਂਦਾ ਹੈ — ਟ੍ਰਾਂਸਫਾਰਮਰ ਨੂੰ ਡੀਰੇਟ ਕੀਤਾ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ ਜਾਂ ਕੇ-ਰੇਟਿਡ ਯੂਨਿਟ ਨਾਲ ਬਦਲਿਆ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ।',
    'Current status': 'ਮੌਜੂਦਾ ਸਥਿਤੀ',
    'Custom': 'ਕਸਟਮ',
    'Custom Alerts': 'ਕਸਟਮ ਚੇਤਾਵਨੀਆਂ',
    'Custom range': 'ਕਸਟਮ ਰੇਂਜ',
    'Customer charges': 'ਗਾਹਕ ਖਰਚੇ',
    'Daily Cost': 'ਰੋਜ਼ਾਨਾ ਦੀ ਲਾਗਤ',
    'Dashboard': 'ਡੈਸ਼ਬੋਰਡ',
    'Deep dive': 'ਡੂੰਘਾਈ ਨਾਲ ਵਿਸ਼ਲੇਸ਼ਣ',
    'Demand Penalty Applied': 'ਡਿਮਾਂਡ ਪੈਨਲਟੀ ਲਾਗੂ ਕੀਤੀ ਗਈ',
    'Demand charge (billing-cycle peak)': 'ਡਿਮਾਂਡ ਚਾਰਜ (ਬਿਲਿੰਗ-ਸਾਈਕਲ ਪੀਕ)',
    'Demand charge is fixed from the billing cycle peak. PF rebate and LF rebate/surcharge are projected at current rates.': 'ਡਿਮਾਂਡ ਚਾਰਜ ਬਿਲਿੰਗ ਚੱਕਰ ਦੇ ਸਿਖਰ ਤੋਂ ਨਿਸ਼ਚਿਤ ਕੀਤਾ ਗਿਆ ਹੈ। PF ਛੋਟ ਅਤੇ LF ਛੋਟ/ਸਰਚਾਰਜ ਮੌਜੂਦਾ ਦਰਾਂ \'ਤੇ ਅਨੁਮਾਨਿਤ ਹਨ।',
    'Demand charges — when Maximum Demand (MD) exceeds Contract Demand (CD)': 'ਮੰਗ ਖਰਚੇ - ਜਦੋਂ ਅਧਿਕਤਮ ਮੰਗ (MD) ਕੰਟਰੈਕਟ ਡਿਮਾਂਡ (CD) ਤੋਂ ਵੱਧ ਜਾਂਦੀ ਹੈ',
    'Demands under CD pay standard rates on chargeable kVA. Exceeding CD triggers a': 'ਸੀਡੀ ਅਧੀਨ ਮੰਗਾਂ ਚਾਰਜਯੋਗ kVA \'ਤੇ ਮਿਆਰੀ ਦਰਾਂ ਦਾ ਭੁਗਤਾਨ ਕਰਦੀਆਂ ਹਨ। ਸੀਡੀ ਤੋਂ ਵੱਧ ਹੋਣਾ ਏ',
    'Detected on most recent reading': 'ਸਭ ਤੋਂ ਤਾਜ਼ਾ ਰੀਡਿੰਗ \'ਤੇ ਖੋਜਿਆ ਗਿਆ',
    'Disabled — no notifications': 'ਅਯੋਗ - ਕੋਈ ਸੂਚਨਾਵਾਂ ਨਹੀਂ',
    'Download Bill': 'ਬਿੱਲ ਡਾਊਨਲੋਡ ਕਰੋ',
    'Download Bill PDF': 'ਬਿੱਲ PDF ਡਾਊਨਲੋਡ ਕਰੋ',
    'Download Log': 'ਲੌਗ ਡਾਊਨਲੋਡ ਕਰੋ',
    'Download PDF': 'PDF ਡਾਊਨਲੋਡ ਕਰੋ',
    'Download a printable daily log · Accumulated kWh, Power Factor per hour': 'ਇੱਕ ਛਾਪਣਯੋਗ ਰੋਜ਼ਾਨਾ ਲੌਗ ਡਾਊਨਲੋਡ ਕਰੋ · ਇਕੱਤਰ ਕੀਤਾ kWh, ਪਾਵਰ ਫੈਕਟਰ ਪ੍ਰਤੀ ਘੰਟਾ',
    'Edge Node · Raspberry Pi Health': 'ਕਿਨਾਰੇ ਨੋਡ · ਰਸਬੇਰੀ ਪਾਈ ਸਿਹਤ',
    'Electricity Duty (projected)': 'ਬਿਜਲੀ ਡਿਊਟੀ (ਅਨੁਮਾਨਿਤ)',
    'Elevated current THD — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress and overheating.': 'ਐਲੀਵੇਟਿਡ ਮੌਜੂਦਾ THD — ਗੈਰ-ਲੀਨੀਅਰ ਲੋਡ (VFDs, UPS, ਡਰਾਈਵਾਂ) ਨੂੰ ਦਰਸਾਉਂਦਾ ਹੈ ਜਿਸ ਨਾਲ ਟ੍ਰਾਂਸਫਾਰਮਰ ਤਣਾਅ ਅਤੇ ਓਵਰਹੀਟਿੰਗ ਹੁੰਦਾ ਹੈ।',
    'Elevated voltage THD — can damage capacitors, transformers, and sensitive equipment. IEEE 519 limit is 8%.': 'ਐਲੀਵੇਟਿਡ ਵੋਲਟੇਜ THD — ਕੈਪਸੀਟਰਾਂ, ਟ੍ਰਾਂਸਫਾਰਮਰਾਂ ਅਤੇ ਸੰਵੇਦਨਸ਼ੀਲ ਉਪਕਰਣਾਂ ਨੂੰ ਨੁਕਸਾਨ ਪਹੁੰਚਾ ਸਕਦੀ ਹੈ। IEEE 519 ਸੀਮਾ 8% ਹੈ।',
    'Email Support': 'ਈਮੇਲ ਸਹਾਇਤਾ',
    'Energy': 'ਊਰਜਾ',
    'Energy Charges · Time-of-Day Split': 'ਊਰਜਾ ਖਰਚੇ · ਦਿਨ ਦਾ ਸਮਾਂ ਵੰਡਣਾ',
    'Energy by Time-of-Day': 'ਦਿਨ ਦੇ ਸਮੇਂ ਅਨੁਸਾਰ ਊਰਜਾ',
    'Energy charges + Demand charges + Electricity Duty + Customer charges · accumulated till date': 'ਊਰਜਾ ਖਰਚੇ + ਮੰਗ ਖਰਚੇ + ਬਿਜਲੀ ਡਿਊਟੀ + ਗਾਹਕ ਖਰਚੇ · ਅੱਜ ਤੱਕ ਜਮ੍ਹਾ',
    'Energy charges + Power Factor adjustment + Load Factor rebates + Demand charges + Electricity Duty + Meter rental · accumulated till date': 'ਐਨਰਜੀ ਚਾਰਜਿਜ਼ + ਪਾਵਰ ਫੈਕਟਰ ਐਡਜਸਟਮੈਂਟ + ਲੋਡ ਫੈਕਟਰ ਰਿਬੇਟਸ + ਡਿਮਾਂਡ ਚਾਰਜਿਜ਼ + ਇਲੈਕਟ੍ਰੀਸਿਟੀ ਡਿਊਟੀ + ਮੀਟਰ ਰੈਂਟਲ · ਅੱਜ ਤੱਕ ਜਮ੍ਹਾ',
    'Energy charges accumulated by tariff period': 'ਟੈਰਿਫ ਦੀ ਮਿਆਦ ਦੁਆਰਾ ਇਕੱਤਰ ਕੀਤੇ ਊਰਜਾ ਖਰਚੇ',
    'Energy delivered': 'ਊਰਜਾ ਪ੍ਰਦਾਨ ਕੀਤੀ ਗਈ',
    'Enter the access password for your site.': 'ਆਪਣੀ ਸਾਈਟ ਲਈ ਐਕਸੈਸ ਪਾਸਵਰਡ ਦਰਜ ਕਰੋ।',
    'Enter your access password': 'ਆਪਣਾ ਪਹੁੰਚ ਪਾਸਵਰਡ ਦਰਜ ਕਰੋ',
    'Failed to copy phone number.': 'ਫ਼ੋਨ ਨੰਬਰ ਕਾਪੀ ਕਰਨਾ ਅਸਫਲ ਰਿਹਾ।',
    'Fires when PF drops below threshold — attracts utility penalty.': 'PF ਥ੍ਰੈਸ਼ਹੋਲਡ ਤੋਂ ਹੇਠਾਂ ਜਾਣ \'ਤੇ ਟ੍ਰਿਗਰ ਹੁੰਦਾ ਹੈ — ਉਪਯੋਗਤਾ ਜੁਰਮਾਨਾ ਆਕਰਸ਼ਿਤ ਕਰਦਾ ਹੈ।',
    'Fires when current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'ਟ੍ਰਿਗਰ ਉਦੋਂ ਹੁੰਦਾ ਹੈ ਜਦੋਂ ਮੌਜੂਦਾ ਕੇ-ਫੈਕਟਰ ਗੰਭੀਰ ਹਾਰਮੋਨਿਕ ਲੋਡਿੰਗ ਨੂੰ ਦਰਸਾਉਂਦਾ ਹੈ — ਟ੍ਰਾਂਸਫਾਰਮਰ ਨੂੰ ਡੀਰੇਟ ਕੀਤਾ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ ਜਾਂ ਕੇ-ਰੇਟਿਡ ਯੂਨਿਟ ਨਾਲ ਬਦਲਿਆ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ।',
    'Fires when current THD exceeds safe levels — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress.': 'ਟ੍ਰਿਗਰ ਉਦੋਂ ਹੁੰਦਾ ਹੈ ਜਦੋਂ ਮੌਜੂਦਾ THD ਸੁਰੱਖਿਅਤ ਪੱਧਰਾਂ ਤੋਂ ਵੱਧ ਜਾਂਦਾ ਹੈ — ਗੈਰ-ਲੀਨੀਅਰ ਲੋਡ (VFDs, UPS, ਡਰਾਈਵਾਂ) ਨੂੰ ਦਰਸਾਉਂਦਾ ਹੈ ਜੋ ਟ੍ਰਾਂਸਫਾਰਮਰ ਤਣਾਅ ਦਾ ਕਾਰਨ ਬਣਦਾ ਹੈ।',
    'Fires when load % nears or exceeds the contracted demand limit.': 'ਜਦੋਂ ਲੋਡ % ਕੰਟਰੈਕਟਡ ਮੰਗ ਸੀਮਾ ਦੇ ਨੇੜੇ ਜਾਂ ਵੱਧ ਜਾਂਦਾ ਹੈ ਤਾਂ ਟ੍ਰਿਗਰ ਹੁੰਦਾ ਹੈ।',
    'Fires when neutral conductor carries excess current — fire risk.': 'ਟ੍ਰਿਗਰ ਉਦੋਂ ਹੁੰਦਾ ਹੈ ਜਦੋਂ ਨਿਰਪੱਖ ਕੰਡਕਟਰ ਵਾਧੂ ਕਰੰਟ ਲੈ ਕੇ ਜਾਂਦਾ ਹੈ - ਅੱਗ ਦਾ ਜੋਖਮ।',
    'Fires when phase current imbalance exceeds threshold.': 'ਜਦੋਂ ਪੜਾਅ ਮੌਜੂਦਾ ਅਸੰਤੁਲਨ ਥ੍ਰੈਸ਼ਹੋਲਡ ਤੋਂ ਵੱਧ ਜਾਂਦਾ ਹੈ ਤਾਂ ਟ੍ਰਿਗਰ ਹੁੰਦਾ ਹੈ।',
    'Fires when voltage K-Factor exceeds transformer derating limits — K>4 requires K-rated transformer.': 'ਟ੍ਰਿਗਰ ਉਦੋਂ ਹੁੰਦਾ ਹੈ ਜਦੋਂ ਵੋਲਟੇਜ K-ਫੈਕਟਰ ਟ੍ਰਾਂਸਫਾਰਮਰ ਡੀਰੇਟਿੰਗ ਸੀਮਾ ਤੋਂ ਵੱਧ ਜਾਂਦੀ ਹੈ — K>4 ਨੂੰ K-ਰੇਟਿਡ ਟ੍ਰਾਂਸਫਾਰਮਰ ਦੀ ਲੋੜ ਹੁੰਦੀ ਹੈ।',
    'Fires when voltage THD exceeds safe levels — can damage capacitors, transformers, and sensitive equipment.': 'ਜਦੋਂ ਵੋਲਟੇਜ THD ਸੁਰੱਖਿਅਤ ਪੱਧਰਾਂ ਤੋਂ ਵੱਧ ਜਾਂਦੀ ਹੈ ਤਾਂ ਟ੍ਰਿਗਰ ਹੁੰਦਾ ਹੈ — ਕੈਪਸੀਟਰਾਂ, ਟ੍ਰਾਂਸਫਾਰਮਰਾਂ ਅਤੇ ਸੰਵੇਦਨਸ਼ੀਲ ਉਪਕਰਣਾਂ ਨੂੰ ਨੁਕਸਾਨ ਪਹੁੰਚਾ ਸਕਦੀ ਹੈ।',
    'Frequency': 'ਬਾਰੰਬਾਰਤਾ',
    'Frequently asked questions & tech support': 'ਅਕਸਰ ਪੁੱਛੇ ਜਾਂਦੇ ਸਵਾਲ ਅਤੇ ਤਕਨੀਕੀ ਸਹਾਇਤਾ',
    'Full': 'ਪੂਰਾ',
    'Get support directly on WhatsApp chat': 'ਵਟਸਐਪ ਚੈਟ \'ਤੇ ਸਿੱਧਾ ਸਮਰਥਨ ਪ੍ਰਾਪਤ ਕਰੋ',
    'Help & Support': 'ਮਦਦ ਅਤੇ ਸਹਾਇਤਾ',
    'Hide code': 'ਕੋਡ ਲੁਕਾਓ',
    'High': 'ਉੱਚ',
    'High Current Harmonic Distortion': 'ਉੱਚ ਮੌਜੂਦਾ ਹਾਰਮੋਨਿਕ ਵਿਗਾੜ',
    'High Current K-Factor': 'ਉੱਚ ਮੌਜੂਦਾ ਕੇ-ਫੈਕਟਰ',
    'High Voltage Harmonic Distortion': 'ਉੱਚ ਵੋਲਟੇਜ ਹਾਰਮੋਨਿਕ ਵਿਗਾੜ',
    'High Voltage K-Factor': 'ਹਾਈ ਵੋਲਟੇਜ ਕੇ-ਫੈਕਟਰ',
    'High neutral current — possible fire risk from unbalanced phases or loose neutral.': 'ਉੱਚ ਨਿਰਪੱਖ ਕਰੰਟ - ਅਸੰਤੁਲਿਤ ਪੜਾਵਾਂ ਜਾਂ ਢਿੱਲੀ ਨਿਰਪੱਖ ਤੋਂ ਅੱਗ ਦਾ ਸੰਭਾਵਿਤ ਜੋਖਮ।',
    'Hourly Power Log · PDF': 'ਘੰਟਾਵਾਰ ਪਾਵਰ ਲੌਗ · PDF',
    'Insufficient data': 'ਨਾਕਾਫ਼ੀ ਡਾਟਾ',
    'Intraday Bill': 'ਇੰਟਰਾਡੇ ਬਿੱਲ',
    'K-Factor': 'ਕੇ-ਫੈਕਟਰ',
    'K-Factor distribution · sample count per unit band': 'ਕੇ-ਫੈਕਟਰ ਵੰਡ · ਪ੍ਰਤੀ ਯੂਨਿਟ ਬੈਂਡ ਨਮੂਨਾ ਗਿਣਤੀ',
    'LF Adjustment (projected)': 'LF ਐਡਜਸਟਮੈਂਟ (ਅਨੁਮਾਨਿਤ)',
    'LF Penalty (projected)': 'LF ਪੈਨਲਟੀ (ਅਨੁਮਾਨਿਤ)',
    'LF Rebate (projected)': 'LF ਛੋਟ (ਅਨੁਮਾਨਿਤ)',
    'Last 24 hours': 'ਪਿਛਲੇ 24 ਘੰਟੇ',
    'Last 24 hours · kW (active) and kVA (apparent)': 'ਪਿਛਲੇ 24 ਘੰਟੇ · kW (ਕਿਰਿਆਸ਼ੀਲ) ਅਤੇ kVA (ਸਪੱਸ਼ਟ)',
    'Last 30 days': 'ਪਿਛਲੇ 30 ਦਿਨ',
    'Last 5 instances · all time': 'ਆਖਰੀ 5 ਮੌਕਿਆਂ · ਹਰ ਸਮੇਂ',
    'Last refresh': 'ਆਖਰੀ ਰਿਫ੍ਰੈਸ਼',
    'Live': 'ਲਾਈਵ',
    'Live Power Factor': 'ਲਾਈਵ ਪਾਵਰ ਫੈਕਟਰ',
    'Live status, risk indicators and threshold breach density.': 'ਲਾਈਵ ਸਥਿਤੀ, ਜੋਖਮ ਸੰਕੇਤਕ ਅਤੇ ਥ੍ਰੈਸ਼ਹੋਲਡ ਉਲੰਘਣਾ ਘਣਤਾ।',
    'Load Factor': 'ਲੋਡ ਫੈਕਟਰ',
    'Load Factor (LF) rebate / surcharge — applied per kWh consumed': 'ਲੋਡ ਫੈਕਟਰ (LF) ਛੋਟ / ਸਰਚਾਰਜ — ਪ੍ਰਤੀ kWh ਖਪਤ ਕੀਤੀ ਗਈ',
    'Load Factor Adjustment': 'ਲੋਡ ਫੈਕਟਰ ਐਡਜਸਟਮੈਂਟ',
    'Load Factor Penalty': 'ਲੋਡ ਫੈਕਟਰ ਪੈਨਲਟੀ',
    'Load Factor Rebate': 'ਲੋਡ ਫੈਕਟਰ ਛੋਟ',
    'Load Factor Utilisation': 'ਲੋਡ ਫੈਕਟਰ ਉਪਯੋਗਤਾ',
    'Load Factor adjustment MTD': 'ਲੋਡ ਫੈਕਟਰ ਐਡਜਸਟਮੈਂਟ MTD',
    'Load percentage nearing or exceeding contracted demand limit.': 'ਕੰਟਰੈਕਟਡ ਮੰਗ ਸੀਮਾ ਦੇ ਨੇੜੇ ਜਾਂ ਵੱਧ ਲੋਡ ਪ੍ਰਤੀਸ਼ਤ।',
    'Loading…': 'ਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...',
    'Low Power Factor': 'ਘੱਟ ਪਾਵਰ ਫੈਕਟਰ',
    'MD Peak': 'ਐਮਡੀ ਪੀਕ',
    'Max': 'ਅਧਿਕਤਮ',
    'Max Demand Analysis': 'ਅਧਿਕਤਮ ਮੰਗ ਵਿਸ਼ਲੇਸ਼ਣ',
    'Max Demand by Time-of-Day Period': 'ਦਿਨ ਦੀ ਮਿਆਦ ਦੁਆਰਾ ਅਧਿਕਤਮ ਮੰਗ',
    'Max current K-Factor across phases — rates transformer derating for harmonic loads': 'ਪੜਾਵਾਂ ਵਿੱਚ ਅਧਿਕਤਮ ਮੌਜੂਦਾ ਕੇ-ਫੈਕਟਰ — ਹਾਰਮੋਨਿਕ ਲੋਡਾਂ ਲਈ ਟਰਾਂਸਫਾਰਮਰ ਨੂੰ ਦਰਸਾਉਂਦਾ ਹੈ',
    'Max voltage K-Factor across phases — rates transformer derating for harmonic loads': 'ਪੜਾਵਾਂ ਵਿੱਚ ਅਧਿਕਤਮ ਵੋਲਟੇਜ ਕੇ-ਫੈਕਟਰ — ਹਾਰਮੋਨਿਕ ਲੋਡ ਲਈ ਟਰਾਂਸਫਾਰਮਰ ਨੂੰ ਦਰਸਾਉਂਦਾ ਹੈ',
    'Maximum demand': 'ਵੱਧ ਤੋਂ ਵੱਧ ਮੰਗ',
    'Meter overview': 'ਮੀਟਰ ਦਾ ਵੇਰਵਾ',
    'Meter rental': 'ਮੀਟਰ ਕਿਰਾਇਆ',
    'Metered': 'ਮੀਟਰਡ',
    'Meters discovered': 'ਖੋਜੇ ਗਏ ਮੀਟਰ',
    'Metrics · last 5 alerts': 'ਮੈਟ੍ਰਿਕਸ · ਆਖਰੀ 5 ਚੇਤਾਵਨੀਆਂ',
    'Min': 'ਘੱਟੋ-ਘੱਟ',
    'Mon-Sat. 9:00 AM - 6:00 PM IST': 'ਸੋਮ-ਸ਼ਨਿ। 9:00 AM - 6:00 PM IST',
    'Month-to-Date': 'ਮਹੀਨਾ-ਤੋਂ-ਤਰੀਕ',
    'Month-to-Date Cost': 'ਮਹੀਨੇ ਤੋਂ ਤਾਰੀਖ ਦੀ ਲਾਗਤ',
    'Month-to-date bill for': 'ਲਈ ਮਹੀਨੇ ਤੋਂ ਮਿਤੀ ਦਾ ਬਿੱਲ',
    'Most recent 5 breach events · reflects your current thresholds': 'ਸਭ ਤੋਂ ਤਾਜ਼ਾ 5 ਉਲੰਘਣਾ ਦੀਆਂ ਘਟਨਾਵਾਂ · ਤੁਹਾਡੇ ਮੌਜੂਦਾ ਥ੍ਰੈਸ਼ਹੋਲਡ ਨੂੰ ਦਰਸਾਉਂਦੀਆਂ ਹਨ',
    'Must stay': 'ਰਹਿਣਾ ਚਾਹੀਦਾ ਹੈ',
    'Near limit': 'ਸੀਮਾ ਦੇ ਨੇੜੇ',
    'Net cost today': 'ਅੱਜ ਦੀ ਸ਼ੁੱਧ ਲਾਗਤ',
    'Neutral Current': 'ਨਿਰਪੱਖ ਵਰਤਮਾਨ',
    'Neutral zone': 'ਨਿਰਪੱਖ ਜ਼ੋਨ',
    'No adj.': 'ਕੋਈ ਐਡਜ.',
    'No adjustment': 'ਕੋਈ ਵਿਵਸਥਾ ਨਹੀਂ',
    'No alerts found': 'ਕੋਈ ਅਲਰਟ ਨਹੀਂ ਮਿਲਿਆ',
    'No breach events with current thresholds': 'ਮੌਜੂਦਾ ਥ੍ਰੈਸ਼ਹੋਲਡ ਦੇ ਨਾਲ ਕੋਈ ਉਲੰਘਣਾ ਘਟਨਾ ਨਹੀਂ ਹੈ',
    'No breaches on latest reading': 'ਨਵੀਨਤਮ ਰੀਡਿੰਗ \'ਤੇ ਕੋਈ ਉਲੰਘਣਾ ਨਹੀਂ',
    'No data': 'ਕੋਈ ਡਾਟਾ ਨਹੀਂ',
    'No data available yet.': 'ਅਜੇ ਕੋਈ ਡਾਟਾ ਉਪਲਬਧ ਨਹੀਂ ਹੈ।',
    'No data for': 'ਲਈ ਕੋਈ ਡਾਟਾ ਨਹੀਂ ਹੈ',
    'No data for this day': 'ਇਸ ਦਿਨ ਲਈ ਕੋਈ ਡਾਟਾ ਨਹੀਂ ਹੈ',
    'No data for this meter yet': 'ਇਸ ਮੀਟਰ ਲਈ ਅਜੇ ਕੋਈ ਡਾਟਾ ਨਹੀਂ ਹੈ',
    'No data for this window': 'ਇਸ ਵਿੰਡੋ ਲਈ ਕੋਈ ਡਾਟਾ ਨਹੀਂ ਹੈ',
    'No data in the last 24 hours': 'ਪਿਛਲੇ 24 ਘੰਟਿਆਂ ਵਿੱਚ ਕੋਈ ਡਾਟਾ ਨਹੀਂ ਹੈ',
    'No rebate': 'ਕੋਈ ਛੋਟ ਨਹੀਂ',
    'No samples in': 'ਵਿੱਚ ਕੋਈ ਨਮੂਨੇ ਨਹੀਂ ਹਨ',
    'No variables match your search.': 'ਕੋਈ ਵੀ ਵੇਰੀਏਬਲ ਤੁਹਾਡੀ ਖੋਜ ਨਾਲ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ।',
    'None (WBSEDCL B-IDIT)': 'ਕੋਈ ਨਹੀਂ (WBSEDCL B-IDIT)',
    'Normal': 'ਸਧਾਰਣ',
    'Normal demand charge': 'ਆਮ ਮੰਗ ਚਾਰਜ',
    'Normal · peak': 'ਸਧਾਰਣ · ਸਿਖਰ',
    'Notify via': 'ਰਾਹੀਂ ਸੂਚਿਤ ਕਰੋ',
    'Off-Peak': 'ਔਫ-ਪੀਕ',
    'Open dashboard': 'ਡੈਸ਼ਬੋਰਡ ਖੋਲ੍ਹੋ',
    'PDF BI': 'PDF BI',
    'PDF columns BE / BF / BG · max of all 15-min averaged blocks per period': 'PDF ਕਾਲਮ BE / BF / BG · ਪ੍ਰਤੀ ਮਿਆਦ ਦੇ ਸਾਰੇ 15-ਮਿੰਟ ਔਸਤ ਬਲਾਕਾਂ ਦਾ ਅਧਿਕਤਮ',
    'PF Adjustment (projected)': 'ਪੀਐਫ ਐਡਜਸਟਮੈਂਟ (ਅਨੁਮਾਨਿਤ)',
    'PF Penalty (projected)': 'PF ਜੁਰਮਾਨਾ (ਅਨੁਮਾਨਿਤ)',
    'PF Penalty / Rebate': 'PF ਜੁਰਮਾਨਾ / ਛੋਟ',
    'PF Rebate (projected)': 'PF ਛੋਟ (ਅਨੁਮਾਨਿਤ)',
    'PF rebate / penalty MTD': 'PF ਛੋਟ / ਜੁਰਮਾਨਾ MTD',
    'Password': 'ਪਾਸਵਰਡ',
    'Peak': 'ਪੀਕ',
    'Peak clipped': 'ਪੀਕ ਕੱਟੀ ਗਈ',
    'Peak kVA': 'ਪੀਕ kVA',
    'Penalty': 'ਜੁਰਮਾਨਾ',
    'Penalty <': 'ਜੁਰਮਾਨਾ <',
    'Penalty likely': 'ਸਜ਼ਾ ਦੀ ਸੰਭਾਵਨਾ ਹੈ',
    'Penalty zone': 'ਪੈਨਲਟੀ ਜ਼ੋਨ',
    'Per-phase': 'ਪ੍ਰਤੀ-ਪੜਾਅ',
    'Phase': 'ਪੜਾਅ',
    'Phase B Current': 'ਫੇਜ਼ ਬੀ ਮੌਜੂਦਾ',
    'Phase B Power': 'ਫੇਜ਼ ਬੀ ਪਾਵਰ',
    'Phase B line current': 'ਪੜਾਅ B ਲਾਈਨ ਮੌਜੂਦਾ',
    'Phase R Current': 'ਪੜਾਅ R ਵਰਤਮਾਨ',
    'Phase R Power': 'ਪੜਾਅ ਆਰ ਪਾਵਰ',
    'Phase R line current': 'ਪੜਾਅ R ਲਾਈਨ ਮੌਜੂਦਾ',
    'Phase Y Current': 'ਪੜਾਅ Y ਵਰਤਮਾਨ',
    'Phase Y Power': 'ਪੜਾਅ Y ਪਾਵਰ',
    'Phase Y line current': 'ਪੜਾਅ Y ਲਾਈਨ ਮੌਜੂਦਾ',
    'Phase current': 'ਮੌਜੂਦਾ ਪੜਾਅ',
    'Phase current imbalance — indicates uneven load distribution across phases.': 'ਪੜਾਅ ਮੌਜੂਦਾ ਅਸੰਤੁਲਨ — ਪੜਾਵਾਂ ਵਿੱਚ ਅਸਮਾਨ ਲੋਡ ਵੰਡ ਨੂੰ ਦਰਸਾਉਂਦਾ ਹੈ।',
    'Phase voltage (L-N)': 'ਪੜਾਅ ਵੋਲਟੇਜ (L-N)',
    'Phase voltage imbalance — can damage motors and reduce equipment life.': 'ਫੇਜ਼ ਵੋਲਟੇਜ ਅਸੰਤੁਲਨ — ਮੋਟਰਾਂ ਨੂੰ ਨੁਕਸਾਨ ਪਹੁੰਚਾ ਸਕਦਾ ਹੈ ਅਤੇ ਸਾਜ਼ੋ-ਸਾਮਾਨ ਦੀ ਉਮਰ ਘਟਾ ਸਕਦਾ ਹੈ।',
    'Phone number copied to clipboard.': 'ਫ਼ੋਨ ਨੰਬਰ ਕਲਿੱਪਬੋਰਡ \'ਤੇ ਕਾਪੀ ਕੀਤਾ ਗਿਆ।',
    'Pi CPU Usage': 'Pi CPU ਵਰਤੋਂ',
    'Pi Memory Usage': 'Pi ਮੈਮੋਰੀ ਵਰਤੋਂ',
    'Pi Temperature': 'ਪਾਈ ਦਾ ਤਾਪਮਾਨ',
    'Pi Temperature · Last 24 h': 'Pi ਤਾਪਮਾਨ · ਪਿਛਲੇ 24 ਘੰਟੇ',
    'Power': 'ਬਿਜਲੀ',
    'Power Analysis': 'ਬਿਜਲੀ ਵਿਸ਼ਲੇਸ਼ਣ',
    'Power Factor': 'ਪਾਵਰ ਫੈਕਟਰ',
    'Power Factor (Month-to-Date)': 'ਪਾਵਰ ਫੈਕਟਰ (ਮਹੀਨਾ-ਤੋਂ-ਤਾਰੀਕ)',
    'Power Factor (PF) adjustment — applied as % of energy charge per ToD period': 'ਪਾਵਰ ਫੈਕਟਰ (PF) ਸਮਾਯੋਜਨ — ਪ੍ਰਤੀ ToD ਮਿਆਦ ਦੇ ਊਰਜਾ ਚਾਰਜ ਦੇ % ਵਜੋਂ ਲਾਗੂ ਕੀਤਾ ਗਿਆ ਹੈ',
    'Power Factor Adjustment': 'ਪਾਵਰ ਫੈਕਟਰ ਐਡਜਸਟਮੈਂਟ',
    'Power Factor Penalty': 'ਪਾਵਰ ਫੈਕਟਰ ਪੈਨਲਟੀ',
    'Power Factor Rebate': 'ਪਾਵਰ ਫੈਕਟਰ ਛੋਟ',
    'Power Factor rebate / penalty MTD': 'ਪਾਵਰ ਫੈਕਟਰ ਛੋਟ / ਜੁਰਮਾਨਾ MTD',
    'Power factor below threshold — attracting TGSPDCL RKVAH penalty on energy bill.': 'ਥ੍ਰੈਸ਼ਹੋਲਡ ਤੋਂ ਹੇਠਾਂ ਪਾਵਰ ਫੈਕਟਰ — ਊਰਜਾ ਬਿੱਲ \'ਤੇ TGSPDCL RKVAH ਪੈਨਲਟੀ ਨੂੰ ਆਕਰਸ਼ਿਤ ਕਰਨਾ।',
    'Production build · v1.0': 'ਉਤਪਾਦਨ ਬਿਲਡ · v1.0',
    'Projected Bill': 'ਅਨੁਮਾਨਿਤ ਬਿੱਲ',
    'Projected Bill · Month-End Estimate': 'ਅਨੁਮਾਨਿਤ ਬਿੱਲ · ਮਹੀਨੇ ਦੇ ਅੰਤ ਦਾ ਅਨੁਮਾਨ',
    'Projected energy charge (gross)': 'ਅਨੁਮਾਨਿਤ ਊਰਜਾ ਚਾਰਜ (ਕੁੱਲ)',
    'Projected net payable by due date': 'ਨਿਯਤ ਮਿਤੀ ਦੁਆਰਾ ਅਨੁਮਾਨਿਤ ਸ਼ੁੱਧ ਭੁਗਤਾਨਯੋਗ',
    'Projection uses a linear run-rate from': 'ਪ੍ਰੋਜੈਕਸ਼ਨ ਤੋਂ ਇੱਕ ਲੀਨੀਅਰ ਰਨ-ਰੇਟ ਵਰਤਦਾ ਹੈ',
    'RAM Usage (%)': 'RAM ਦੀ ਵਰਤੋਂ (%)',
    'Raspberry Pi CPU temperature': 'ਰਸਬੇਰੀ Pi CPU ਤਾਪਮਾਨ',
    'Raspberry Pi CPU utilisation': 'Raspberry Pi CPU ਉਪਯੋਗਤਾ',
    'Raspberry Pi Gateway': 'ਰਸਬੇਰੀ ਪਾਈ ਗੇਟਵੇ',
    'Raspberry Pi memory utilisation': 'ਰਸਬੇਰੀ ਪਾਈ ਮੈਮੋਰੀ ਉਪਯੋਗਤਾ',
    'Rebate': 'ਛੋਟ',
    'Rebate earned': 'ਛੋਟ ਹਾਸਲ ਕੀਤੀ',
    'Rebate zone': 'ਛੋਟ ਜ਼ੋਨ',
    'Refresh': 'ਤਾਜ਼ਾ ਕਰੋ',
    'Refresh interval': 'ਰਿਫ੍ਰੈਸ਼ ਅੰਤਰਾਲ',
    'Remove this rule': 'ਇਸ ਨਿਯਮ ਨੂੰ ਹਟਾਓ',
    'Response time usually within 2 hours': 'ਜਵਾਬ ਸਮਾਂ ਆਮ ਤੌਰ \'ਤੇ 2 ਘੰਟਿਆਂ ਦੇ ਅੰਦਰ',
    'Rules saved on this device. Production build routes notifications via SMS and WhatsApp.': 'ਨਿਯਮ ਇਸ ਡੀਵਾਈਸ \'ਤੇ ਰੱਖਿਅਤ ਕੀਤੇ ਗਏ ਹਨ। ਐਸਐਮਐਸ ਅਤੇ ਵਟਸਐਪ ਰਾਹੀਂ ਪ੍ਰੋਡਕਸ਼ਨ ਬਿਲਡ ਰੂਟ ਸੂਚਨਾਵਾਂ।',
    'Running daily energy cost (₹)': 'ਚੱਲ ਰਹੀ ਰੋਜ਼ਾਨਾ ਊਰਜਾ ਲਾਗਤ (₹)',
    'Running maximum of kVA averaged over 15 minutes window': 'ਵੱਧ ਤੋਂ ਵੱਧ kVA ਨੂੰ ਚਲਾਉਣਾ ਔਸਤ 15 ਮਿੰਟਾਂ ਦੀ ਵਿੰਡੋ ਤੋਂ ਵੱਧ ਹੈ',
    'Running session energy (kWh)': 'ਚੱਲ ਰਹੇ ਸੈਸ਼ਨ ਊਰਜਾ (kWh)',
    'SAFE': 'ਸੁਰੱਖਿਅਤ',
    'Safe': 'ਸੁਰੱਖਿਅਤ',
    'Samples loaded': 'ਲੋਡ ਕੀਤੇ ਨਮੂਨੇ',
    'Save Alert Rules': 'ਚੇਤਾਵਨੀ ਨਿਯਮ ਸੁਰੱਖਿਅਤ ਕਰੋ',
    'Search variables…': 'ਵੇਰੀਏਬਲ ਖੋਜੋ...',
    'Select Language': 'ਭਾਸ਼ਾ ਚੁਣੋ',
    'Select a date range above': 'ਉਪਰੋਕਤ ਇੱਕ ਮਿਤੀ ਸੀਮਾ ਚੁਣੋ',
    'Select billing period': 'ਬਿਲਿੰਗ ਮਿਆਦ ਚੁਣੋ',
    'Select language': 'ਭਾਸ਼ਾ ਚੁਣੋ',
    'Select meter': 'ਮੀਟਰ ਚੁਣੋ',
    'Send Email': 'ਈਮੇਲ ਭੇਜੋ',
    'Session Energy': 'ਸੈਸ਼ਨ ਊਰਜਾ',
    'Session carbon footprint (kg CO₂)': 'ਸੈਸ਼ਨ ਕਾਰਬਨ ਫੁੱਟਪ੍ਰਿੰਟ (ਕਿਲੋ CO₂)',
    'Settings': 'ਸੈਟਿੰਗਜ਼',
    'Share': 'ਸ਼ੇਅਰ ਕਰੋ',
    'Show code': 'ਕੋਡ ਦਿਖਾਓ',
    'Showing': 'ਦਿਖਾ ਰਿਹਾ ਹੈ',
    'Showing cached data — we\'ll keep retrying automatically.': 'ਕੈਸ਼ ਕੀਤਾ ਡੇਟਾ ਦਿਖਾ ਰਿਹਾ ਹੈ — ਅਸੀਂ ਆਪਣੇ ਆਪ ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰਦੇ ਰਹਾਂਗੇ।',
    'Showing month-to-date charges': 'ਮਹੀਨਾ-ਤੋਂ-ਡੇਟ ਖਰਚੇ ਦਿਖਾ ਰਿਹਾ ਹੈ',
    'Showing today\'s charges': 'ਅੱਜ ਦੇ ਚਾਰਜ ਦਿਖਾ ਰਿਹਾ ਹੈ',
    'Sign out': 'ਸਾਈਨ ਆਊਟ',
    'Similar to average': 'ਔਸਤ ਦੇ ਸਮਾਨ',
    'Similar to this week\'s average': 'ਇਸ ਹਫ਼ਤੇ ਦੀ ਔਸਤ ਦੇ ਸਮਾਨ',
    'Since midnight IST · updates every 5 min': 'ਅੱਧੀ ਰਾਤ ਤੋਂ IST · ਹਰ 5 ਮਿੰਟ ਬਾਅਦ ਅੱਪਡੇਟ ਹੁੰਦਾ ਹੈ',
    'Site': 'ਸਾਈਟ',
    'Sum of all phase currents': 'ਸਾਰੇ ਪੜਾਅ ਕਰੰਟ ਦਾ ਜੋੜ',
    'Surcharge': 'ਸਰਚਾਰਜ',
    'THD distribution · sample count per 2% band': 'THD ਵੰਡ · ਪ੍ਰਤੀ 2% ਬੈਂਡ ਦੇ ਨਮੂਨੇ ਦੀ ਗਿਣਤੀ',
    'Telangana': 'ਤੇਲੰਗਾਨਾ',
    'Temperature (°C)': 'ਤਾਪਮਾਨ (°C)',
    'This Month': 'ਇਸ ਮਹੀਨੇ',
    'This week (Sun – yesterday)': 'ਇਸ ਹਫ਼ਤੇ (ਸੂਰਜ - ਕੱਲ੍ਹ)',
    'Threshold': 'ਥ੍ਰੈਸ਼ਹੋਲਡ',
    'Time distribution': 'ਸਮੇਂ ਦੀ ਵੰਡ',
    'Time-of-Day Split': 'ਦਿਨ ਦਾ ਸਮਾਂ ਵੰਡ',
    'Timely Payment Rebate': 'ਸਮੇਂ ਸਿਰ ਭੁਗਤਾਨ ਛੋਟ',
    'ToD Off-Peak Rebate': 'ToD ਆਫ-ਪੀਕ ਛੋਟ',
    'ToD Peak Penalty': 'ToD ਪੀਕ ਪੈਨਲਟੀ',
    'Today': 'ਅੱਜ',
    'Today PF': 'ਅੱਜ ਪੀ.ਐਫ',
    'Today is': 'ਅੱਜ ਹੈ',
    'Today\'s Cost': 'ਅੱਜ ਦੀ ਲਾਗਤ',
    'Today\'s Running Cost': 'ਅੱਜ ਦੀ ਚੱਲ ਰਹੀ ਲਾਗਤ',
    'Total': 'ਕੁੱਲ',
    'Total Active Power': 'ਕੁੱਲ ਕਿਰਿਆਸ਼ੀਲ ਸ਼ਕਤੀ',
    'Total Apparent Power': 'ਕੁੱਲ ਸਪੱਸ਼ਟ ਸ਼ਕਤੀ',
    'Total Current': 'ਕੁੱਲ ਵਰਤਮਾਨ',
    'Total Energy (kWh) consumed last month / (Peak kW observed last month times number of hours last month)': 'ਪਿਛਲੇ ਮਹੀਨੇ ਖਪਤ ਹੋਈ ਕੁੱਲ ਊਰਜਾ (kWh) / (ਪਿਛਲੇ ਮਹੀਨੇ ਦੇਖੀ ਗਈ ਸਿਖਰ kWh ਗੁਣਾ ਪਿਛਲੇ ਮਹੀਨੇ ਘੰਟਿਆਂ ਦੀ ਗਿਣਤੀ)',
    'Total Energy (kWh) consumed this month / (Peak kW observed this month times number of hours this month)': 'ਇਸ ਮਹੀਨੇ ਖਪਤ ਕੀਤੀ ਕੁੱਲ ਊਰਜਾ (kWh) / (ਇਸ ਮਹੀਨੇ ਦੇਖੀ ਗਈ ਸਿਖਰ kWh ਗੁਣਾ ਇਸ ਮਹੀਨੇ ਘੰਟਿਆਂ ਦੀ ਗਿਣਤੀ)',
    'Total Energy (kWh) consumed this week / (Peak kW observed this week times number of hours this week)': 'ਇਸ ਹਫ਼ਤੇ ਖਪਤ ਕੀਤੀ ਕੁੱਲ ਊਰਜਾ (kWh)',
    'Total Energy (kWh) consumed today/ (Peak kW observed today times number of hours today)': 'ਅੱਜ ਖਪਤ ਕੀਤੀ ਗਈ ਕੁੱਲ ਊਰਜਾ (kWh)',
    'Total Energy Charge': 'ਕੁੱਲ ਊਰਜਾ ਚਾਰਜ',
    'Total Harmonic Distortion (%)': 'ਕੁੱਲ ਹਾਰਮੋਨਿਕ ਵਿਗਾੜ (%)',
    'Total Watts': 'ਕੁੱਲ ਵਾਟਸ',
    'Total active power across all phases': 'ਸਾਰੇ ਪੜਾਵਾਂ ਵਿੱਚ ਕੁੱਲ ਕਿਰਿਆਸ਼ੀਲ ਸ਼ਕਤੀ',
    'Total apparent power (kVA)': 'ਕੁੱਲ ਸਪੱਸ਼ਟ ਸ਼ਕਤੀ (kVA)',
    'Total demand cost': 'ਕੁੱਲ ਮੰਗ ਲਾਗਤ',
    'Total instantaneous power in watts': 'ਵਾਟਸ ਵਿੱਚ ਕੁੱਲ ਤਤਕਾਲ ਪਾਵਰ',
    'Try again': 'ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ',
    'Try another meter or wait for the next refresh.': 'ਕੋਈ ਹੋਰ ਮੀਟਰ ਅਜ਼ਮਾਓ ਜਾਂ ਅਗਲੇ ਰਿਫ੍ਰੈਸ਼ ਦੀ ਉਡੀਕ ਕਰੋ।',
    'Use one of the access codes provided for your site.': 'ਆਪਣੀ ਸਾਈਟ ਲਈ ਪ੍ਰਦਾਨ ਕੀਤੇ ਐਕਸੈਸ ਕੋਡਾਂ ਵਿੱਚੋਂ ਇੱਕ ਦੀ ਵਰਤੋਂ ਕਰੋ।',
    'Utilisation %': 'ਉਪਯੋਗਤਾ %',
    'Voltage': 'ਵੋਲਟੇਜ',
    'Voltage Imbalance': 'ਵੋਲਟੇਜ ਅਸੰਤੁਲਨ',
    'Voltage K-Factor': 'ਵੋਲਟੇਜ ਕੇ-ਫੈਕਟਰ',
    'Voltage K-Factor exceeds transformer derating limit — K>4 requires a K-rated transformer.': 'ਵੋਲਟੇਜ ਕੇ-ਫੈਕਟਰ ਟਰਾਂਸਫਾਰਮਰ ਡੀਰੇਟਿੰਗ ਸੀਮਾ ਤੋਂ ਵੱਧ ਗਿਆ ਹੈ — K>4 ਲਈ ਇੱਕ K-ਰੇਟਿਡ ਟ੍ਰਾਂਸਫਾਰਮਰ ਦੀ ਲੋੜ ਹੈ।',
    'WARN': 'ਚੇਤਾਵਨੀ',
    'Warn': 'ਚੇਤਾਵਨੀ',
    'Warning': 'ਚੇਤਾਵਨੀ',
    'Warning above': 'ਉਪਰੋਕਤ ਚੇਤਾਵਨੀ',
    'Warning below': 'ਹੇਠਾਂ ਚੇਤਾਵਨੀ',
    'Warning · peak': 'ਚੇਤਾਵਨੀ · ਸਿਖਰ',
    'WhatsApp Support': 'ਵਟਸਐਪ ਸਪੋਰਟ',
    'Within Limit': 'ਸੀਮਾ ਦੇ ਅੰਦਰ',
    'Worst': 'ਸਭ ਤੋਂ ਭੈੜਾ',
    'Yesterday': 'ਕੱਲ੍ਹ',
    'above': 'ਉੱਪਰ',
    'above CD': 'ਉੱਪਰ CD',
    'above this week\'s avg': 'ਇਸ ਹਫ਼ਤੇ ਦੀ ਔਸਤ ਤੋਂ ਉੱਪਰ',
    'above this week\'s avg — good day': 'ਇਸ ਹਫ਼ਤੇ ਦੀ ਔਸਤ ਤੋਂ ਉੱਪਰ — ਚੰਗਾ ਦਿਨ',
    'active': 'ਸਰਗਰਮ',
    'active issue': 'ਸਰਗਰਮ ਮੁੱਦਾ',
    'active issues': 'ਸਰਗਰਮ ਮੁੱਦੇ',
    'added to bill': 'ਬਿੱਲ ਵਿੱਚ ਸ਼ਾਮਲ ਕੀਤਾ ਗਿਆ',
    'added to this month\'s bill': 'ਇਸ ਮਹੀਨੇ ਦੇ ਬਿੱਲ ਵਿੱਚ ਸ਼ਾਮਲ ਕੀਤਾ ਗਿਆ',
    'adjustment': 'ਵਿਵਸਥਾ',
    'all charges finalised.': 'ਸਾਰੇ ਦੋਸ਼ਾਂ ਨੂੰ ਅੰਤਿਮ ਰੂਪ ਦਿੱਤਾ ਗਿਆ।',
    'and': 'ਅਤੇ',
    'applied for Load Factor ≥ 65%': 'ਲੋਡ ਫੈਕਟਰ ≥ 65% ਲਈ ਅਰਜ਼ੀ ਦਿੱਤੀ ਗਈ',
    'average': 'ਔਸਤ',
    'avg': 'ਔਸਤ',
    'below': 'ਹੇਠਾਂ',
    'below average': 'ਔਸਤ ਤੋਂ ਘੱਟ',
    'below min → charged on': 'ਘੱਟ ਤੋਂ ਘੱਟ → ਚਾਰਜ ਚਾਲੂ',
    'below this week\'s avg': 'ਇਸ ਹਫ਼ਤੇ ਦੀ ਔਸਤ ਤੋਂ ਘੱਟ',
    'below this week\'s avg — below average': 'ਇਸ ਹਫ਼ਤੇ ਦੀ ਔਸਤ ਤੋਂ ਹੇਠਾਂ — ਔਸਤ ਤੋਂ ਘੱਟ',
    'consumers under TOD Tariff (CD > 50 kVA); % of energy charge per ToD period': 'TOD ਟੈਰਿਫ (CD > 50 kVA) ਦੇ ਅਧੀਨ ਖਪਤਕਾਰ; ਊਰਜਾ ਚਾਰਜ ਦਾ % ਪ੍ਰਤੀ ToD ਮਿਆਦ',
    'critical': 'ਨਾਜ਼ੁਕ',
    'current': 'ਮੌਜੂਦਾ',
    'day bill for': 'ਲਈ ਦਿਨ ਦਾ ਬਿੱਲ',
    'day run rate': 'ਦਿਨ ਦੀ ਰਨ ਰੇਟ',
    'days': 'ਦਿਨ',
    'days of actual data.': 'ਅਸਲ ਡੇਟਾ ਦੇ ਦਿਨ.',
    'days of meter data': 'ਮੀਟਰ ਡੇਟਾ ਦੇ ਦਿਨ',
    'days remaining': 'ਦਿਨ ਬਾਕੀ',
    'days required for': 'ਦਿਨ ਲਈ ਲੋੜੀਂਦਾ ਹੈ',
    'deducted from bill': 'ਬਿੱਲ ਤੋਂ ਕਟੌਤੀ ਕੀਤੀ ਗਈ',
    'deducted from this month\'s bill': 'ਇਸ ਮਹੀਨੇ ਦੇ ਬਿੱਲ ਵਿੱਚੋਂ ਕਟੌਤੀ ਕੀਤੀ ਗਈ',
    'delivered': 'ਡਿਲੀਵਰ ਕੀਤਾ',
    'energy charges, Power Factor & Load Factor adjustments, demand charge, duties, and projected net payable.': 'ਊਰਜਾ ਖਰਚੇ, ਪਾਵਰ ਫੈਕਟਰ ਅਤੇ ਲੋਡ ਫੈਕਟਰ ਐਡਜਸਟਮੈਂਟ, ਡਿਮਾਂਡ ਚਾਰਜ, ਡਿਊਟੀਆਂ, ਅਤੇ ਅਨੁਮਾਨਿਤ ਸ਼ੁੱਧ ਭੁਗਤਾਨਯੋਗ।',
    'energy per day': 'ਪ੍ਰਤੀ ਦਿਨ ਊਰਜਾ',
    'energy per hour': 'ਊਰਜਾ ਪ੍ਰਤੀ ਘੰਟਾ',
    'excess above CD': 'CD ਤੋਂ ਵੱਧ',
    'fires when <': 'ਟ੍ਰਿਗਰ ਉਦੋਂ ਹੁੰਦਾ ਹੈ ਜਦੋਂ <',
    'fires when >': 'ਟ੍ਰਿਗਰ ਉਦੋਂ ਹੁੰਦਾ ਹੈ ਜਦੋਂ >',
    'good day': 'ਚੰਗਾ ਦਿਨ',
    'if paid after 15 days': 'ਜੇਕਰ 15 ਦਿਨਾਂ ਬਾਅਦ ਭੁਗਤਾਨ ਕੀਤਾ ਜਾਂਦਾ ਹੈ',
    'if paid by due date': 'ਜੇਕਰ ਨਿਯਤ ਮਿਤੀ ਦੁਆਰਾ ਭੁਗਤਾਨ ਕੀਤਾ ਜਾਂਦਾ ਹੈ',
    'imbal': 'imbal',
    'invoice estimate': 'ਇਨਵੌਇਸ ਅਨੁਮਾਨ',
    'is above this week\'s avg': 'ਇਸ ਹਫ਼ਤੇ ਦੇ ਔਸਤ ਤੋਂ ਉੱਪਰ ਹੈ',
    'is below this week\'s avg': 'ਇਸ ਹਫ਼ਤੇ ਦੀ ਔਸਤ ਤੋਂ ਘੱਟ ਹੈ',
    'kVA/month': 'kVA/ਮਹੀਨਾ',
    'kVAh': 'kVAh',
    'kWh': 'kWh',
    'limit': 'ਸੀਮਾ',
    'meter': 'ਮੀਟਰ',
    'meters': 'ਮੀਟਰ',
    'min demand applies': 'ਘੱਟੋ-ਘੱਟ ਮੰਗ ਲਾਗੂ ਹੁੰਦੀ ਹੈ',
    'month': 'ਮਹੀਨਾ',
    'month-to-date': 'ਮਹੀਨਾ-ਤੋਂ-ਤਰੀਕ',
    'net incl. all charges': 'ਸ਼ੁੱਧ ਸਮੇਤ ਸਾਰੇ ਖਰਚੇ',
    'net today': 'ਅੱਜ ਨੈੱਟ',
    'never': 'ਕਦੇ ਨਹੀਂ',
    'no adj.': 'ਕੋਈ adj.',
    'no adjustment': 'ਕੋਈ ਵਿਵਸਥਾ ਨਹੀਂ',
    'no adjustment applicable': 'ਕੋਈ ਵਿਵਸਥਾ ਲਾਗੂ ਨਹੀਂ ਹੈ',
    'no adjustment today': 'ਅੱਜ ਕੋਈ ਵਿਵਸਥਾ ਨਹੀਂ',
    'nom': 'nom',
    'not yet applicable today': 'ਅੱਜ ਤੱਕ ਲਾਗੂ ਨਹੀਂ ਹੈ',
    'of': 'ਦੇ',
    'of 24 hours have data': '24 ਘੰਟੇ ਦਾ ਡਾਟਾ ਹੈ',
    'of CD': 'CD ਦਾ',
    'of bill': 'ਬਿੱਲ ਦਾ',
    'of gross bill': 'ਕੁੱਲ ਬਿੱਲ ਦਾ',
    'of net bill': 'ਸ਼ੁੱਧ ਬਿੱਲ ਦਾ',
    'off': 'ਬੰਦ',
    'on the excess kVA.': 'ਵਾਧੂ kVA \'ਤੇ.',
    'over-threshold': 'ਓਵਰ-ਥ੍ਰੈਸ਼ਹੋਲਡ',
    'paise/kVAh  (6p flat)': 'ਪੈਸੇ/kVAh (6p ਫਲੈਟ)',
    'paise/kWh rebate': 'ਪੈਸੇ/kWh ਛੋਟ',
    'paise/kWh surcharge': 'ਪੈਸੇ/kWh ਸਰਚਾਰਜ',
    'peak kVA': 'ਪੀਕ kVA',
    'peak kVA today': 'ਸਿਖਰ kVA ਅੱਜ',
    'penalty': 'ਜੁਰਮਾਨਾ',
    'projected penalty': 'ਅਨੁਮਾਨਿਤ ਜੁਰਮਾਨਾ',
    'projected rebate': 'ਅਨੁਮਾਨਿਤ ਛੋਟ',
    'projected surcharge': 'ਅਨੁਮਾਨਿਤ ਸਰਚਾਰਜ',
    'readings': 'ਰੀਡਿੰਗ',
    'readings · 3 phases': 'ਰੀਡਿੰਗ · 3 ਪੜਾਅ',
    'rebate': 'ਛੋਟ',
    'rebate / kWh': 'ਛੋਟ / kWh',
    'rebate earned': 'ਛੋਟ ਹਾਸਲ ਕੀਤੀ',
    's': 'ਐੱਸ',
    's when the tab is visible.': 's ਜਦੋਂ ਟੈਬ ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ।',
    'samples': 'ਨਮੂਨੇ',
    'surcharge': 'ਸਰਚਾਰਜ',
    'surcharge / kWh': 'ਸਰਚਾਰਜ / kWh',
    'surcharge added to bill': 'ਬਿੱਲ ਵਿੱਚ ਸਰਚਾਰਜ ਜੋੜਿਆ ਗਿਆ',
    'surcharge applied': 'ਸਰਚਾਰਜ ਲਾਗੂ ਕੀਤਾ ਗਿਆ',
    'threshold': 'ਥ੍ਰੈਸ਼ਹੋਲਡ',
    'to': 'ਨੂੰ',
    'units consumed so far': 'ਹੁਣ ਤੱਕ ਵਰਤੀਆਂ ਗਈਆਂ ਇਕਾਈਆਂ',
    'updated every 5 min': 'ਹਰ 5 ਮਿੰਟ ਵਿੱਚ ਅੱਪਡੇਟ ਕੀਤਾ ਜਾਂਦਾ ਹੈ',
    'updating…': 'ਅੱਪਡੇਟ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...',
    'warn': 'ਚੇਤਾਵਨੀ',
    '· added to bill today': '· ਅੱਜ ਬਿੱਲ ਵਿੱਚ ਸ਼ਾਮਲ ਕੀਤਾ ਗਿਆ',
    '· saving deducted today': '· ਬੱਚਤ ਅੱਜ ਕੱਟੀ ਗਈ',
    '· surcharge added today': '· ਸਰਚਾਰਜ ਅੱਜ ਜੋੜਿਆ ਗਿਆ',
    '— · awaiting data': '— · ਡੇਟਾ ਦੀ ਉਡੀਕ ਹੈ',
    '≥': '≥',
    '⚠ No Pi telemetry in current data — fields piTempC / piMemPct not populated': '⚠ ਮੌਜੂਦਾ ਡੇਟਾ ਵਿੱਚ ਕੋਈ Pi ਟੈਲੀਮੈਟਰੀ ਨਹੀਂ — ਖੇਤਰ piTempC / piMemPct ਆਬਾਦੀ ਨਹੀਂ ਹਨ',
    '⚠️ Thermal throttle active — Pi is running hot, performance reduced': '⚠️ ਥਰਮਲ ਥਰੋਟਲ ਕਿਰਿਆਸ਼ੀਲ — Pi ਗਰਮ ਚੱਲ ਰਿਹਾ ਹੈ, ਕਾਰਗੁਜ਼ਾਰੀ ਘਟੀ ਹੈ',
    '✓ Rules Saved Successfully': '✓ ਨਿਯਮ ਸਫਲਤਾਪੂਰਵਕ ਸੁਰੱਖਿਅਤ ਕੀਤੇ ਗਏ',
  },
  ta: {
    'This Week': 'இந்த வாரம்',
    'Last Month': 'கடந்த மாதம்',
    'Sensor Dropout': 'சென்சார் துண்டிப்பு',
    'Approaching Overload': 'ஓவர்லோட் நெருங்குகிறது',
    'Frequency Deviation': 'அதிர்வெண் விலகல்',
    'High Voltage THD': 'உயர் மின்னழுத்த THD',
    'High Current THD': 'உயர் மின்னோட்ட THD',
    'In-app': 'ஆப்பிற்குள்',
    'SMS': 'எஸ்எம்எஸ்',
    'WhatsApp': 'வாட்ஸ்அப்',
    'Min. chargeable demand': 'குறைந்தபட்ச கட்டணத் தேவை',
    'Demand charge — Normal': 'தேவை கட்டணம் — சாதாரண',
    'Demand charge — Penal': 'தேவை கட்டணம் — தண்டனை',
    'Electricity duty': 'மின்சார வரி',
    'Late payment surcharge': 'தாமத கட்டண கூடுதல் கட்டணம்',
    'Demand charge (up to CD)': 'தேவை கட்டணம் (CD வரை)',
    'Generating': 'உருவாக்கப்படுகிறது',
    'Bill PDF…': 'பில் PDF…',
    'What is the Power Analysis Dashboard?': 'பவர் அனாலிசிஸ் டாஷ்போர்டு என்றால் என்ன?',
    'It monitors real-time electrical metrics (voltage, current, power factor, demand, active/reactive energy) collected from Raspberry Pi edge nodes installed at the site.': 'இது தளத்தில் நிறுவப்பட்ட Raspberry Pi எட்ஜ் நோடுகளிலிருந்து சேகரிக்கப்பட்ட நிகழ்நேர மின் அளவீடுகளை (மின்னழுத்தம், மின்னோட்டம், பவர் ஃபேக்டர், தேவை, செயலில்/எதிர்வினை ஆற்றல்) கண்காணிக்கிறது.',
    'What do the green/orange/red indicators mean?': 'பச்சை/ஆரஞ்சு/சிவப்பு குறிகாட்டிகள் என்ன அர்த்தம்?',
    'Green means the Raspberry Pi edge node is online and reporting health telemetry normally. Orange/red indicate potential communication delays or high temperature/resource throttling.': 'பச்சை என்பது Raspberry Pi எட்ஜ் நோடு ஆன்லைனில் இருந்து சாதாரணமாக ஹெல்த் டெலிமெட்ரியை அறிக்கை செய்கிறது என்பதைக் குறிக்கிறது. ஆரஞ்சு/சிவப்பு சாத்தியமான தொடர்பு தாமதங்கள் அல்லது அதிக வெப்பநிலை/வளத் தடையைக் குறிக்கிறது.',
    'How are billing demand charges calculated?': 'பில்லிங் தேவை கட்டணங்கள் எவ்வாறு கணக்கிடப்படுகின்றன?',
    'Demand charges are based on the Maximum Demand (MD) recorded in 15-minute integration windows, calculated according to the active tariff structure (e.g., TGSPDCL HT or WBSEDCL B-IDIT).': 'தேவை கட்டணங்கள் 15-நிமிட ஒருங்கிணைப்பு சாளரங்களில் பதிவு செய்யப்பட்ட அதிகபட்ச தேவையை (MD) அடிப்படையாகக் கொண்டவை, செயலில் உள்ள கட்டண கட்டமைப்பின்படி (எ.கா., TGSPDCL HT அல்லது WBSEDCL B-IDIT) கணக்கிடப்படுகின்றன.',
    'What should I do if the dashboard shows "No data"?': 'டாஷ்போர்டு "தரவு இல்லை" எனக் காட்டினால் நான் என்ன செய்ய வேண்டும்?',
    'Verify that the edge node (Raspberry Pi gateway) is powered on and connected to the internet. If the issue persists, contact technical support immediately.': 'எட்ஜ் நோடு (Raspberry Pi நுழைவாயில்) இயங்குகிறதா, இணையத்துடன் இணைக்கப்பட்டுள்ளதா எனச் சரிபார்க்கவும். சிக்கல் தொடர்ந்தால், உடனடியாக தொழில்நுட்ப ஆதரவைத் தொடர்பு கொள்ளவும்.',
    '% of readings': 'வாசிப்புகளின் %',
    '/month': '/மாதம்',
    '0.4 kV supply': '0.4 kV வழங்கல்',
    '12 AM – 12 AM': '12 AM – 12 AM',
    '1st 12 AM → now': '1ஆம் தேதி 12 AM → இப்போது',
    '2x penalty': '2x அபராதம்',
    '33 kV supply': '33 கே.வி',
    'About': 'பற்றி',
    'Above': 'மேலே',
    'Across': 'முழுவதும்',
    'Active (kW)': 'செயலில் (kW)',
    'Active Power & Apparent Power': 'செயலில் உள்ள ஆற்றல் & வெளிப்படையான சக்தி',
    'Active power on Phase B': 'B கட்டத்தில் செயலில் உள்ள சக்தி',
    'Active power on Phase R': 'ஆர் கட்டத்தில் செயலில் உள்ள சக்தி',
    'Active power on Phase Y': 'Y கட்டத்தில் செயலில் உள்ள சக்தி',
    'Active tariff': 'செயலில் உள்ள கட்டணம்',
    'Add custom variable alert': 'தனிப்பயன் மாறி எச்சரிக்கையைச் சேர்க்கவும்',
    'Additional demand charge': 'கூடுதல் தேவை கட்டணம்',
    'Alert History': 'வரலாறு',
    'Alert Rules': 'எச்சரிக்கை விதிகள்',
    'Alerts': 'அறிவிப்புகள்',
    'All energy/PF/LF values computed by the Cortex Pi gateway per VARIABLES.pdf §2.3 & §3. Demand, ED, rental, and TPR computed in the browser from WBSEDCL tariff constants.': 'VARIABLES.pdf §2.3 & §3க்கு கார்டெக்ஸ் பை கேட்வே மூலம் கணக்கிடப்படும் அனைத்து ஆற்றல்/PF/LF மதிப்புகள். தேவை, ED, வாடகை மற்றும் TPR ஆகியவை உலாவியில் WBSEDCL கட்டண மாறிலிகளிலிருந்து கணக்கிடப்படுகிறது.',
    'All systems normal': 'அனைத்து அமைப்புகளும் இயல்பானவை',
    'Anomalies': 'முரண்பாடுகள்',
    'Anomaly': 'முரண்பாடு',
    'Apparent': 'மின் அளவு',
    'Apparent (kVA)': 'வெளிப்படையான (kVA)',
    'Approaching Contracted Demand': 'ஒப்பந்த கோரிக்கையை நெருங்குகிறது',
    'Auto-refreshes every': 'ஒவ்வொன்றையும் தானாகப் புதுப்பிக்கிறது',
    'Average Power Factor': 'சராசரி பவர் பேக்டர்',
    'Average power factor across': 'முழுவதும் சராசரி ஆற்றல் காரணி',
    'Avg': 'சராசரி',
    'Avg Active Power': 'சராசரி செயலில் ஆற்றல்',
    'Avg Apparent Power': 'சராசரி வெளிப்படையான சக்தி',
    'Base Energy Charge': 'அடிப்படை ஆற்றல் கட்டணம்',
    'Based on': 'அடிப்படையில்',
    'Below': 'கீழே',
    'Between': 'இடையில்',
    'Billing': 'பில்லிங்',
    'Billing Cycle Peak': 'பில்லிங் சைக்கிள் உச்சம்',
    'Billing Overview': 'பில்லிங் கண்ணோட்டம்',
    'Both levels disabled': 'இரண்டு நிலைகளும் முடக்கப்பட்டுள்ளன',
    'Building PDF…': 'PDF ஐ உருவாக்குகிறது…',
    'CD': 'CD',
    'CD 100%': 'CD 100%',
    'CORTEX by Vireon': 'கார்டெக்ஸ் - வைரியன் மூலம்',
    'CRIT': 'CRIT',
    'Call Now': 'இப்போது அழைக்கவும்',
    'Call Support': 'அழைப்பு ஆதரவு',
    'Carbon (CO₂)': 'கார்பன் (CO₂)',
    'Chargeable demand': 'கட்டண தேவை',
    'Chargeable min:': 'கட்டணம் வசூலிக்கக்கூடிய குறைந்தபட்சம்:',
    'Chat on WhatsApp': 'வாட்ஸ்அப்பில் அரட்டை அடிக்கவும்',
    'Check back when more data is synced.': 'கூடுதல் தரவு ஒத்திசைக்கப்படும்போது மீண்டும் பார்க்கவும்.',
    'Check your network or sheet sharing settings (Anyone with the link → Viewer).': 'உங்கள் நெட்வொர்க் அல்லது தாள் பகிர்வு அமைப்புகளைச் சரிபார்க்கவும் (இணைப்பு உள்ள எவரும் → பார்வையாளர்).',
    'Choose a variable': 'ஒரு மாறியைத் தேர்ந்தெடுக்கவும்',
    'Close': 'மூடு',
    'Close Help and Support Modal': 'உதவி மற்றும் ஆதரவு மாதிரியை மூடு',
    'Connecting…': 'இணைக்கிறது…',
    'Consumer': 'நுகர்வோர்',
    'Contact Tech Support': 'தொழில்நுட்ப ஆதரவைத் தொடர்பு கொள்ளவும்',
    'Contact your administrator if you do not have one.': 'உங்களிடம் ஒன்று இல்லையென்றால் உங்கள் நிர்வாகியைத் தொடர்புகொள்ளவும்.',
    'Contract': 'ஒப்பந்தம்',
    'Contract Demand (CD)': 'ஒப்பந்த தேவை (CD)',
    'Contract Demand Utilisation': 'ஒப்பந்த தேவை பயன்பாடு',
    'Contract demand:': 'ஒப்பந்த தேவை:',
    'Contract limit': 'ஒப்பந்த வரம்பு',
    'Copy Number': 'எண்ணை நகலெடுக்கவும்',
    'Cost': 'செலவு',
    'Cost breakdown': 'செலவு விவரம்',
    'Couldn\'t reach the data sheet': 'தரவுத் தாளை அடைய முடியவில்லை',
    'Couldn\'t refresh just now.': 'இப்போது புதுப்பிக்க முடியவில்லை.',
    'Crit': 'கிரிட்',
    'Critical': 'விமர்சனம்',
    'Critical above': 'மேலே முக்கியமானவை',
    'Critical below': 'கீழே விமர்சனம்',
    'Critical · peak': 'முக்கியமான · உச்சம்',
    'Current': 'கரண்ட்',
    'Current Imbalance': 'கரண்ட் சமநிலையின்மை',
    'Current K-Factor': 'தற்போதைய K-காரணி',
    'Current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'தற்போதைய K-காரணி கடுமையான ஹார்மோனிக் ஏற்றுதலைக் குறிக்கிறது - மின்மாற்றியை மாற்றியமைக்க வேண்டும் அல்லது K- மதிப்பிடப்பட்ட அலகுடன் மாற்ற வேண்டும்.',
    'Current status': 'தற்போதைய நிலை',
    'Custom': 'தனிப்பயன்',
    'Custom Alerts': 'தனிப்பயன் எச்சரிக்கைகள்',
    'Custom range': 'தனிப்பயன் வரம்பு',
    'Customer charges': 'வாடிக்கையாளர் கட்டணம்',
    'Daily Cost': 'தினசரி செலவு',
    'Dashboard': 'டாஷ்போர்டு',
    'Deep dive': 'ஆழமான பகுப்பாய்வு',
    'Demand Penalty Applied': 'கோரிக்கை அபராதம் பயன்படுத்தப்பட்டது',
    'Demand charge (billing-cycle peak)': 'தேவை கட்டணம் (பில்லிங் சுழற்சி உச்சம்)',
    'Demand charge is fixed from the billing cycle peak. PF rebate and LF rebate/surcharge are projected at current rates.': 'பில்லிங் சுழற்சி உச்சத்தில் இருந்து தேவை கட்டணம் நிர்ணயிக்கப்படுகிறது. PF தள்ளுபடி மற்றும் LF தள்ளுபடி/அதிக கட்டணம் தற்போதைய விகிதங்களில் திட்டமிடப்பட்டுள்ளது.',
    'Demand charges — when Maximum Demand (MD) exceeds Contract Demand (CD)': 'தேவைக் கட்டணங்கள் - அதிகபட்ச தேவை (MD) ஒப்பந்தத் தேவையை (CD) மீறும் போது',
    'Demands under CD pay standard rates on chargeable kVA. Exceeding CD triggers a': 'சிடியின் கீழ் உள்ள கோரிக்கைகள் சார்ஜ் செய்யக்கூடிய கேவிஏ மீதான நிலையான கட்டண விகிதங்கள். குறுவட்டு தூண்டுதல்களை மீறுவது a',
    'Detected on most recent reading': 'சமீபத்திய வாசிப்பில் கண்டறியப்பட்டது',
    'Disabled — no notifications': 'முடக்கப்பட்டது - அறிவிப்புகள் இல்லை',
    'Download Bill': 'பில் பதிவிறக்கவும்',
    'Download Bill PDF': 'பில் PDF ஐப் பதிவிறக்கவும்',
    'Download Log': 'பதிவிறக்க பதிவு',
    'Download PDF': 'PDF பதிவிறக்கவும்',
    'Download a printable daily log · Accumulated kWh, Power Factor per hour': 'அச்சிடக்கூடிய தினசரி பதிவைப் பதிவிறக்கவும் · குவிக்கப்பட்ட kWh, ஒரு மணி நேரத்திற்கு ஆற்றல் காரணி',
    'Edge Node · Raspberry Pi Health': 'விளிம்பு முனை · ராஸ்பெர்ரி பை ஆரோக்கியம்',
    'Electricity Duty (projected)': 'மின்சாரக் கட்டணம் (திட்டமிடப்பட்டது)',
    'Elevated current THD — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress and overheating.': 'உயர்த்தப்பட்ட தற்போதைய THD - மின்மாற்றி அழுத்தம் மற்றும் அதிக வெப்பத்தை ஏற்படுத்தும் நேரியல் அல்லாத சுமைகளை (VFDகள், UPS, இயக்கிகள்) குறிக்கிறது.',
    'Elevated voltage THD — can damage capacitors, transformers, and sensitive equipment. IEEE 519 limit is 8%.': 'உயர் மின்னழுத்தம் THD - மின்தேக்கிகள், மின்மாற்றிகள் மற்றும் உணர்திறன் உபகரணங்களை சேதப்படுத்தும். IEEE 519 வரம்பு 8%.',
    'Email Support': 'மின்னஞ்சல் ஆதரவு',
    'Energy': 'ஆற்றல்',
    'Energy Charges · Time-of-Day Split': 'ஆற்றல் கட்டணங்கள் · நாள்-நாள் பிரிப்பு',
    'Energy by Time-of-Day': 'நாளுக்கு நாள் ஆற்றல்',
    'Energy charges + Demand charges + Electricity Duty + Customer charges · accumulated till date': 'எரிசக்தி கட்டணம் + தேவைக்கான கட்டணம் + மின் கட்டணம் + வாடிக்கையாளர் கட்டணங்கள் · இன்று வரை குவிந்துள்ளது',
    'Energy charges + Power Factor adjustment + Load Factor rebates + Demand charges + Electricity Duty + Meter rental · accumulated till date': 'ஆற்றல் கட்டணங்கள் + பவர் காரணி சரிசெய்தல் + சுமை காரணி தள்ளுபடிகள் + தேவைக் கட்டணம் + மின்சார கட்டணம் + மீட்டர் வாடகை · இன்று வரை குவிந்துள்ளது',
    'Energy charges accumulated by tariff period': 'கட்டணக் காலத்தால் திரட்டப்பட்ட ஆற்றல் கட்டணங்கள்',
    'Energy delivered': 'ஆற்றல் வழங்கப்பட்டது',
    'Enter the access password for your site.': 'உங்கள் தளத்திற்கான அணுகல் கடவுச்சொல்லை உள்ளிடவும்.',
    'Enter your access password': 'உங்கள் அணுகல் கடவுச்சொல்லை உள்ளிடவும்',
    'Failed to copy phone number.': 'தொலைபேசி எண்ணை நகலெடுக்க முடியவில்லை.',
    'Fires when PF drops below threshold — attracts utility penalty.': 'PF வரம்புக்கு கீழே குறையும் போது ட்ரிகர் ஆகிறது — பயன்பாட்டு அபராதத்தை ஈர்க்கிறது.',
    'Fires when current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'மின்னோட்ட K-காரணி கடுமையான ஹார்மோனிக் ஏற்றுதலைக் குறிக்கும் போது ட்ரிகர் ஆகிறது - மின்மாற்றி சிதைக்கப்பட வேண்டும் அல்லது K- மதிப்பிடப்பட்ட அலகுடன் மாற்றப்பட வேண்டும்.',
    'Fires when current THD exceeds safe levels — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress.': 'தற்போதைய THD பாதுகாப்பான நிலைகளை மீறும் போது ஏற்படும் ட்ரிகர் ஆகிறது — மின்மாற்றி அழுத்தத்தை ஏற்படுத்தும் நேரியல் அல்லாத சுமைகளை (VFDகள், UPS, இயக்கிகள்) குறிக்கிறது.',
    'Fires when load % nears or exceeds the contracted demand limit.': 'சுமை % நெருங்கும் போது அல்லது ஒப்பந்த தேவை வரம்பை மீறும் போது ட்ரிகர் ஆகிறது.',
    'Fires when neutral conductor carries excess current — fire risk.': 'நடுநிலை கடத்தி அதிக மின்னோட்டத்தை கொண்டு செல்லும் போது ட்ரிகர் ஆகிறது - தீ ஆபத்து.',
    'Fires when phase current imbalance exceeds threshold.': 'கட்ட மின்னோட்ட ஏற்றத்தாழ்வு வரம்பை மீறும் போது ட்ரிகர் ஆகிறது.',
    'Fires when voltage K-Factor exceeds transformer derating limits — K>4 requires K-rated transformer.': 'மின்னழுத்தம் K-காரணி மின்மாற்றி வரம்புகளை மீறும் போது ட்ரிகர் ஆகிறது - K>4 க்கு K-மதிப்பிடப்பட்ட மின்மாற்றி தேவைப்படுகிறது.',
    'Fires when voltage THD exceeds safe levels — can damage capacitors, transformers, and sensitive equipment.': 'மின்னழுத்தம் THD பாதுகாப்பான நிலைகளை மீறும் போது ட்ரிகர் ஆகிறது — மின்தேக்கிகள், மின்மாற்றிகள் மற்றும் உணர்திறன் உபகரணங்களை சேதப்படுத்தும்.',
    'Frequency': 'அதிர்வெண்',
    'Frequently asked questions & tech support': 'அடிக்கடி கேட்கப்படும் கேள்விகள் & தொழில்நுட்ப ஆதரவு',
    'Full': 'முழு',
    'Get support directly on WhatsApp chat': 'WhatsApp அரட்டையில் நேரடியாக ஆதரவைப் பெறுங்கள்',
    'Help & Support': 'உதவி & ஆதரவு',
    'Hide code': 'குறியீட்டை மறை',
    'High': 'உயர்',
    'High Current Harmonic Distortion': 'உயர் மின்னோட்ட ஹார்மோனிக் சிதைவு',
    'High Current K-Factor': 'உயர் மின்னோட்டம் K-காரணி',
    'High Voltage Harmonic Distortion': 'உயர் மின்னழுத்த ஹார்மோனிக் சிதைவு',
    'High Voltage K-Factor': 'உயர் மின்னழுத்த K-காரணி',
    'High neutral current — possible fire risk from unbalanced phases or loose neutral.': 'உயர் நடுநிலை மின்னோட்டம் - சமச்சீரற்ற கட்டங்கள் அல்லது தளர்வான நடுநிலையிலிருந்து தீ ஆபத்து.',
    'Hourly Power Log · PDF': 'மணிநேர பவர் பதிவு · PDF',
    'Insufficient data': 'போதுமான தரவு இல்லை',
    'Intraday Bill': 'இன்ட்ராடே பில்',
    'K-Factor': 'கே-காரணி',
    'K-Factor distribution · sample count per unit band': 'K-காரணி விநியோகம் · ஒரு யூனிட் பேண்டிற்கு மாதிரி எண்ணிக்கை',
    'LF Adjustment (projected)': 'LF சரிசெய்தல் (திட்டமிடப்பட்டது)',
    'LF Penalty (projected)': 'LF அபராதம் (திட்டமிடப்பட்டது)',
    'LF Rebate (projected)': 'LF தள்ளுபடி (திட்டமிடப்பட்டது)',
    'Last 24 hours': 'கடந்த 24 மணிநேரம்',
    'Last 24 hours · kW (active) and kVA (apparent)': 'கடந்த 24 மணிநேரம் · kW (செயலில்) மற்றும் kVA (வெளிப்படையானது)',
    'Last 30 days': 'கடந்த 30 நாட்கள்',
    'Last 5 instances · all time': 'கடைசி 5 நிகழ்வுகள் · எல்லா நேரத்திலும்',
    'Last refresh': 'கடைசி புதுப்பிப்பு',
    'Live': 'லைவ்',
    'Live Power Factor': 'நேரடி பவர் பேக்டர்',
    'Live status, risk indicators and threshold breach density.': 'நேரடி நிலை, ஆபத்து குறிகாட்டிகள் மற்றும் வரம்பு மீறல் அடர்த்தி.',
    'Load Factor': 'சுமை காரணி',
    'Load Factor (LF) rebate / surcharge — applied per kWh consumed': 'சுமை காரணி (LF) தள்ளுபடி / கூடுதல் கட்டணம் — ஒரு kWh நுகரப்படும்',
    'Load Factor Adjustment': 'சுமை காரணி சரிசெய்தல்',
    'Load Factor Penalty': 'சுமை காரணி அபராதம்',
    'Load Factor Rebate': 'சுமை காரணி தள்ளுபடி',
    'Load Factor Utilisation': 'சுமை காரணி பயன்பாடு',
    'Load Factor adjustment MTD': 'சுமை காரணி சரிசெய்தல் MTD',
    'Load percentage nearing or exceeding contracted demand limit.': 'சுமை சதவீதம் ஒப்பந்த தேவை வரம்பை நெருங்குகிறது அல்லது மீறுகிறது.',
    'Loading…': 'ஏற்றுகிறது…',
    'Low Power Factor': 'குறைந்த சக்தி காரணி',
    'MD Peak': 'MD பீக்',
    'Max': 'அதிகபட்சம்',
    'Max Demand Analysis': 'அதிகபட்ச தேவை பகுப்பாய்வு',
    'Max Demand by Time-of-Day Period': 'நாள் காலத்தின்படி அதிகபட்ச தேவை',
    'Max current K-Factor across phases — rates transformer derating for harmonic loads': 'கட்டங்கள் முழுவதும் அதிகபட்ச மின்னோட்டம் K-காரணி - ஹார்மோனிக் சுமைகளுக்கு மின்மாற்றியை குறைக்கிறது',
    'Max voltage K-Factor across phases — rates transformer derating for harmonic loads': 'கட்டங்கள் முழுவதும் அதிகபட்ச மின்னழுத்தம் K-காரணி - ஹார்மோனிக் சுமைகளுக்கு மின்மாற்றியை குறைக்கும் விகிதங்கள்',
    'Maximum demand': 'அதிகபட்ச தேவை',
    'Meter overview': 'மீட்டர் கண்ணோட்டம்',
    'Meter rental': 'மீட்டர் வாடகை',
    'Metered': 'அளவிடப்பட்டது',
    'Meters discovered': 'கண்டறியப்பட்ட மீட்டர்கள்',
    'Metrics · last 5 alerts': 'அளவீடுகள் · கடைசி 5 விழிப்பூட்டல்கள்',
    'Min': 'குறைந்தபட்சம்',
    'Mon-Sat. 9:00 AM - 6:00 PM IST': 'திங்கள்-சனி. 9:00 AM - 6:00 PM IST',
    'Month-to-Date': 'மாதம் முதல் தேதி வரை',
    'Month-to-Date Cost': 'மாதம் முதல் தேதி வரை செலவு',
    'Month-to-date bill for': 'மாதத்திலிருந்து தேதிக்கான பில்',
    'Most recent 5 breach events · reflects your current thresholds': 'மிக சமீபத்திய 5 மீறல் நிகழ்வுகள் · உங்கள் தற்போதைய வரம்புகளை பிரதிபலிக்கிறது',
    'Must stay': 'தங்க வேண்டும்',
    'Near limit': 'வரம்புக்கு அருகில்',
    'Net cost today': 'இன்றைய நிகர செலவு',
    'Neutral Current': 'நடுநிலை மின்னோட்டம்',
    'Neutral zone': 'நடுநிலை மண்டலம்',
    'No adj.': 'இல்லை adj.',
    'No adjustment': 'சரிசெய்தல் இல்லை',
    'No alerts found': 'அறிவிப்புகள் எதுவும் இல்லை',
    'No breach events with current thresholds': 'தற்போதைய வரம்புகளுடன் மீறல் நிகழ்வுகள் இல்லை',
    'No breaches on latest reading': 'சமீபத்திய வாசிப்பில் எந்த மீறலும் இல்லை',
    'No data': 'தரவு இல்லை',
    'No data available yet.': 'இதுவரை தரவு எதுவும் கிடைக்கவில்லை.',
    'No data for': 'தரவு இல்லை',
    'No data for this day': 'இந்த நாளுக்கான தரவு இல்லை',
    'No data for this meter yet': 'இந்த மீட்டருக்கான தரவு இன்னும் இல்லை',
    'No data for this window': 'இந்த விண்டோவிற்கு தரவு இல்லை',
    'No data in the last 24 hours': 'கடந்த 24 மணிநேரத்தில் தரவு இல்லை',
    'No rebate': 'தள்ளுபடி இல்லை',
    'No samples in': 'மாதிரிகள் இல்லை',
    'No variables match your search.': 'உங்கள் தேடலுக்கு எந்த மாறிகளும் பொருந்தவில்லை.',
    'None (WBSEDCL B-IDIT)': 'எதுவுமில்லை (WBSEDCL B-IDIT)',
    'Normal': 'இயல்பானது',
    'Normal demand charge': 'சாதாரண தேவை கட்டணம்',
    'Normal · peak': 'சாதாரண · உச்சம்',
    'Notify via': 'மூலம் அறிவிக்கவும்',
    'Off-Peak': 'ஆஃப்-பீக்',
    'Open dashboard': 'டாஷ்போர்டைத் திற',
    'PDF BI': 'PDF BI',
    'PDF columns BE / BF / BG · max of all 15-min averaged blocks per period': 'PDF நெடுவரிசைகள் BE / BF / BG · ஒரு காலத்திற்கு அதிகபட்சமாக 15 நிமிட சராசரி தொகுதிகள்',
    'PF Adjustment (projected)': 'PF சரிசெய்தல் (திட்டமிடப்பட்டது)',
    'PF Penalty (projected)': 'PF அபராதம் (திட்டமிடப்பட்டது)',
    'PF Penalty / Rebate': 'PF அபராதம் / தள்ளுபடி',
    'PF Rebate (projected)': 'PF தள்ளுபடி (திட்டமிடப்பட்டது)',
    'PF rebate / penalty MTD': 'PF தள்ளுபடி / அபராதம் MTD',
    'Password': 'கடவுச்சொல்',
    'Peak': 'உச்சம்',
    'Peak clipped': 'பீக் கிளிப் செய்யப்பட்டது',
    'Peak kVA': 'உச்ச kVA',
    'Penalty': 'தண்டனை',
    'Penalty <': 'அபராதம் <',
    'Penalty likely': 'அபராதம் விதிக்க வாய்ப்பு உள்ளது',
    'Penalty zone': 'தண்டனை மண்டலம்',
    'Per-phase': 'ஒவ்வொரு கட்டம்',
    'Phase': 'கட்டம்',
    'Phase B Current': 'கட்டம் B தற்போதைய',
    'Phase B Power': 'கட்டம் பி பவர்',
    'Phase B line current': 'கட்டம் B வரி மின்னோட்டம்',
    'Phase R Current': 'கட்டம் R தற்போதைய',
    'Phase R Power': 'கட்டம் ஆர் பவர்',
    'Phase R line current': 'கட்டம் R வரி மின்னோட்டம்',
    'Phase Y Current': 'கட்டம் Y தற்போதைய',
    'Phase Y Power': 'கட்டம் Y பவர்',
    'Phase Y line current': 'கட்டம் Y வரி மின்னோட்டம்',
    'Phase current': 'கட்ட மின்னோட்டம்',
    'Phase current imbalance — indicates uneven load distribution across phases.': 'கட்ட தற்போதைய ஏற்றத்தாழ்வு - கட்டங்கள் முழுவதும் சீரற்ற சுமை விநியோகம் குறிக்கிறது.',
    'Phase voltage (L-N)': 'கட்ட மின்னழுத்தம் (L-N)',
    'Phase voltage imbalance — can damage motors and reduce equipment life.': 'கட்ட மின்னழுத்த ஏற்றத்தாழ்வு - மோட்டார்களை சேதப்படுத்தும் மற்றும் உபகரணங்களின் ஆயுளைக் குறைக்கும்.',
    'Phone number copied to clipboard.': 'ஃபோன் எண் கிளிப்போர்டுக்கு நகலெடுக்கப்பட்டது.',
    'Pi CPU Usage': 'பை CPU பயன்பாடு',
    'Pi Memory Usage': 'பை நினைவக பயன்பாடு',
    'Pi Temperature': 'பை வெப்பநிலை',
    'Pi Temperature · Last 24 h': 'பை வெப்பநிலை · கடந்த 24 மணிநேரம்',
    'Power': 'மின்சாரம்',
    'Power Analysis': 'மின் பகுப்பாய்வு',
    'Power Factor': 'சக்தி காரணி',
    'Power Factor (Month-to-Date)': 'ஆற்றல் காரணி (மாதம் முதல் தேதி வரை)',
    'Power Factor (PF) adjustment — applied as % of energy charge per ToD period': 'பவர் ஃபேக்டர் (பிஎஃப்) சரிசெய்தல் - ஒரு ToD காலத்திற்கு ஆற்றல் கட்டணத்தின் % ஆகப் பயன்படுத்தப்படுகிறது',
    'Power Factor Adjustment': 'சக்தி காரணி சரிசெய்தல்',
    'Power Factor Penalty': 'சக்தி காரணி அபராதம்',
    'Power Factor Rebate': 'சக்தி காரணி தள்ளுபடி',
    'Power Factor rebate / penalty MTD': 'பவர் பேக்டர் ரிபேட் / பெனால்டி எம்டிடி',
    'Power factor below threshold — attracting TGSPDCL RKVAH penalty on energy bill.': 'வரம்பிற்குக் கீழே உள்ள ஆற்றல் காரணி - ஆற்றல் கட்டணத்தில் TGSPDCL RKVAH அபராதத்தை ஈர்க்கிறது.',
    'Production build · v1.0': 'உற்பத்தி உருவாக்கம் · v1.0',
    'Projected Bill': 'திட்டமிடப்பட்ட மசோதா',
    'Projected Bill · Month-End Estimate': 'திட்டமிடப்பட்ட பில் · மாத இறுதி மதிப்பீடு',
    'Projected energy charge (gross)': 'திட்டமிடப்பட்ட ஆற்றல் கட்டணம் (மொத்தம்)',
    'Projected net payable by due date': 'நிலுவைத் தேதிக்குள் செலுத்தப்படும் திட்ட நிகர',
    'Projection uses a linear run-rate from': 'ப்ரொஜெக்ஷன் ஒரு நேரியல் ரன்-ரேட்டைப் பயன்படுத்துகிறது',
    'RAM Usage (%)': 'ரேம் பயன்பாடு (%)',
    'Raspberry Pi CPU temperature': 'ராஸ்பெர்ரி பை CPU வெப்பநிலை',
    'Raspberry Pi CPU utilisation': 'ராஸ்பெர்ரி பை CPU பயன்பாடு',
    'Raspberry Pi Gateway': 'ராஸ்பெர்ரி பை கேட்வே',
    'Raspberry Pi memory utilisation': 'ராஸ்பெர்ரி பை நினைவக பயன்பாடு',
    'Rebate': 'தள்ளுபடி',
    'Rebate earned': 'தள்ளுபடி கிடைத்தது',
    'Rebate zone': 'தள்ளுபடி மண்டலம்',
    'Refresh': 'புதுப்பிக்கவும்',
    'Refresh interval': 'புதுப்பிப்பு இடைவெளி',
    'Remove this rule': 'இந்த விதியை நீக்கவும்',
    'Response time usually within 2 hours': 'மறுமொழி நேரம் பொதுவாக 2 மணி நேரத்திற்குள்',
    'Rules saved on this device. Production build routes notifications via SMS and WhatsApp.': 'இந்தச் சாதனத்தில் விதிகள் சேமிக்கப்பட்டுள்ளன. எஸ்எம்எஸ் மற்றும் வாட்ஸ்அப் மூலம் உற்பத்திக்கான வழிகள் அறிவிப்புகள்.',
    'Running daily energy cost (₹)': 'தினசரி ஆற்றல் செலவு (₹)',
    'Running maximum of kVA averaged over 15 minutes window': 'சராசரியாக 15 நிமிடங்களுக்கு மேல் kVA இயங்கும்',
    'Running session energy (kWh)': 'இயங்கும் அமர்வு ஆற்றல் (kWh)',
    'SAFE': 'பாதுகாப்பானது',
    'Safe': 'பாதுகாப்பானது',
    'Samples loaded': 'தரவுகள் ஏற்றப்பட்டன',
    'Save Alert Rules': 'எச்சரிக்கை விதிகளைச் சேமிக்கவும்',
    'Search variables…': 'தேடல் மாறிகள்…',
    'Select Language': 'மொழியைத் தேர்ந்தெடுக்கவும்',
    'Select a date range above': 'மேலே உள்ள தேதி வரம்பைத் தேர்ந்தெடுக்கவும்',
    'Select billing period': 'பில்லிங் காலத்தைத் தேர்ந்தெடுக்கவும்',
    'Select language': 'மொழியைத் தேர்ந்தெடுக்கவும்',
    'Select meter': 'மீட்டரைத் தேர்ந்தெடு',
    'Send Email': 'மின்னஞ்சல் அனுப்பவும்',
    'Session Energy': 'அமர்வு ஆற்றல்',
    'Session carbon footprint (kg CO₂)': 'அமர்வு கார்பன் தடம் (கிலோ CO₂)',
    'Settings': 'அமைப்புகள்',
    'Share': 'பகிரவும்',
    'Show code': 'குறியீட்டைக் காட்டு',
    'Showing': 'காட்டும்',
    'Showing cached data — we\'ll keep retrying automatically.': 'தற்காலிக சேமிப்பில் உள்ள தரவைக் காட்டுகிறது - நாங்கள் தானாகவே மீண்டும் முயற்சிப்போம்.',
    'Showing month-to-date charges': 'மாதம் முதல் தேதி வரையிலான கட்டணங்களைக் காட்டுகிறது',
    'Showing today\'s charges': 'இன்றைய கட்டணங்களைக் காட்டுகிறது',
    'Sign out': 'வெளியேறு',
    'Similar to average': 'சராசரியைப் போன்றது',
    'Similar to this week\'s average': 'இந்த வார சராசரியைப் போன்றது',
    'Since midnight IST · updates every 5 min': 'நள்ளிரவு முதல் IST · ஒவ்வொரு 5 நிமிடங்களுக்கும் புதுப்பிக்கப்படும்',
    'Site': 'தளம்',
    'Sum of all phase currents': 'அனைத்து கட்ட மின்னோட்டங்களின் கூட்டுத்தொகை',
    'Surcharge': 'கூடுதல் கட்டணம்',
    'THD distribution · sample count per 2% band': 'THD விநியோகம் · 2% பேண்டிற்கு மாதிரி எண்ணிக்கை',
    'Telangana': 'தெலுங்கானா',
    'Temperature (°C)': 'வெப்பநிலை (°C)',
    'This Month': 'இந்த மாதம்',
    'This week (Sun – yesterday)': 'இந்த வாரம் (சூரியன் - நேற்று)',
    'Threshold': 'வாசல்',
    'Time distribution': 'நேர விநியோகம்',
    'Time-of-Day Split': 'நாள்-நேரப் பிரிப்பு',
    'Timely Payment Rebate': 'சரியான நேரத்தில் செலுத்துதல் தள்ளுபடி',
    'ToD Off-Peak Rebate': 'ToD ஆஃப்-பீக் தள்ளுபடி',
    'ToD Peak Penalty': 'ToD பீக் பெனால்டி',
    'Today': 'இன்று',
    'Today PF': 'இன்று பி.எஃப்',
    'Today is': 'இன்று',
    'Today\'s Cost': 'இன்றைய செலவு',
    'Today\'s Running Cost': 'இன்றைய ரன்னிங் காஸ்ட்',
    'Total': 'மொத்தம்',
    'Total Active Power': 'மொத்த செயலில் சக்தி',
    'Total Apparent Power': 'மொத்த வெளிப்படையான சக்தி',
    'Total Current': 'மொத்த மின்னோட்டம்',
    'Total Energy (kWh) consumed last month / (Peak kW observed last month times number of hours last month)': 'கடந்த மாதம் பயன்படுத்தப்பட்ட மொத்த ஆற்றல் (kWh)',
    'Total Energy (kWh) consumed this month / (Peak kW observed this month times number of hours this month)': 'இந்த மாதம் பயன்படுத்தப்படும் மொத்த ஆற்றல் (kWh)',
    'Total Energy (kWh) consumed this week / (Peak kW observed this week times number of hours this week)': 'இந்த வாரம் பயன்படுத்தப்படும் மொத்த ஆற்றல் (kWh)',
    'Total Energy (kWh) consumed today/ (Peak kW observed today times number of hours today)': 'இன்று நுகரப்படும் மொத்த ஆற்றல் (kWh)',
    'Total Energy Charge': 'மொத்த ஆற்றல் கட்டணம்',
    'Total Harmonic Distortion (%)': 'மொத்த ஹார்மோனிக் சிதைவு (%)',
    'Total Watts': 'மொத்த வாட்ஸ்',
    'Total active power across all phases': 'அனைத்து நிலைகளிலும் மொத்த செயலில் உள்ள ஆற்றல்',
    'Total apparent power (kVA)': 'மொத்த வெளிப்படையான சக்தி (kVA)',
    'Total demand cost': 'மொத்த தேவை செலவு',
    'Total instantaneous power in watts': 'வாட்களில் மொத்த உடனடி சக்தி',
    'Try again': 'மீண்டும் முயற்சிக்கவும்',
    'Try another meter or wait for the next refresh.': 'மற்றொரு மீட்டரை முயற்சிக்கவும் அல்லது அடுத்த புதுப்பிப்புக்காக காத்திருக்கவும்.',
    'Use one of the access codes provided for your site.': 'உங்கள் தளத்திற்கு வழங்கப்பட்ட அணுகல் குறியீடுகளில் ஒன்றைப் பயன்படுத்தவும்.',
    'Utilisation %': 'பயன்பாடு %',
    'Voltage': 'மின்னழுத்தம்',
    'Voltage Imbalance': 'மின்னழுத்த ஏற்றத்தாழ்வு',
    'Voltage K-Factor': 'மின்னழுத்த K-காரணி',
    'Voltage K-Factor exceeds transformer derating limit — K>4 requires a K-rated transformer.': 'மின்னழுத்தம் K-காரணி மின்மாற்றி குறைப்பு வரம்பை மீறுகிறது - K>4 க்கு K- மதிப்பிடப்பட்ட மின்மாற்றி தேவைப்படுகிறது.',
    'WARN': 'எச்சரிக்கை',
    'Warn': 'எச்சரிக்கவும்',
    'Warning': 'எச்சரிக்கை',
    'Warning above': 'மேலே எச்சரிக்கை',
    'Warning below': 'கீழே எச்சரிக்கை',
    'Warning · peak': 'எச்சரிக்கை · உச்சம்',
    'WhatsApp Support': 'WhatsApp ஆதரவு',
    'Within Limit': 'வரம்புக்குள்',
    'Worst': 'மோசமான',
    'Yesterday': 'நேற்று',
    'above': 'மேலே',
    'above CD': 'மேலே CD',
    'above this week\'s avg': 'இந்த வார சராசரிக்கு மேல்',
    'above this week\'s avg — good day': 'இந்த வாரத்தின் சராசரிக்கு மேல் — நல்ல நாள்',
    'active': 'செயலில்',
    'active issue': 'செயலில் உள்ள பிரச்சினை',
    'active issues': 'செயலில் உள்ள சிக்கல்கள்',
    'added to bill': 'மசோதாவில் சேர்க்கப்பட்டது',
    'added to this month\'s bill': 'இந்த மாத பில்லில் சேர்க்கப்பட்டது',
    'adjustment': 'சரிசெய்தல்',
    'all charges finalised.': 'அனைத்து கட்டணங்களும் இறுதி செய்யப்பட்டுள்ளன.',
    'and': 'மற்றும்',
    'applied for Load Factor ≥ 65%': 'சுமை காரணி ≥ 65%க்கு விண்ணப்பித்தது',
    'average': 'சராசரி',
    'avg': 'சராசரி',
    'below': 'கீழே',
    'below average': 'சராசரிக்கும் கீழே',
    'below min → charged on': 'நிமிடத்திற்குக் கீழே → சார்ஜ் செய்யப்பட்டது',
    'below this week\'s avg': 'இந்த வார சராசரிக்குக் கீழே',
    'below this week\'s avg — below average': 'இந்த வார சராசரிக்குக் கீழே - சராசரிக்கும் கீழே',
    'consumers under TOD Tariff (CD > 50 kVA); % of energy charge per ToD period': 'TOD கட்டணத்தின் கீழ் உள்ள நுகர்வோர் (CD > 50 kVA); ஒரு ToD காலத்திற்கு ஆற்றல் கட்டணம் %',
    'critical': 'முக்கியமான',
    'current': 'தற்போதைய',
    'day bill for': 'நாள் பில்',
    'day run rate': 'நாள் ரன் ரேட்',
    'days': 'நாட்கள்',
    'days of actual data.': 'உண்மையான தரவுகளின் நாட்கள்.',
    'days of meter data': 'மீட்டர் தரவு நாட்கள்',
    'days remaining': 'மீதமுள்ள நாட்கள்',
    'days required for': 'தேவைப்படும் நாட்கள்',
    'deducted from bill': 'மசோதாவில் இருந்து கழிக்கப்பட்டது',
    'deducted from this month\'s bill': 'இந்த மாத பில்லில் இருந்து கழிக்கப்பட்டது',
    'delivered': 'வழங்கப்பட்டது',
    'energy charges, Power Factor & Load Factor adjustments, demand charge, duties, and projected net payable.': 'ஆற்றல் கட்டணங்கள், பவர் காரணி மற்றும் சுமை காரணி சரிசெய்தல், தேவை கட்டணம், கடமைகள் மற்றும் திட்டமிடப்பட்ட நிகர செலுத்த வேண்டியவை.',
    'energy per day': 'ஒரு நாளைக்கு ஆற்றல்',
    'energy per hour': 'ஒரு மணி நேரத்திற்கு ஆற்றல்',
    'excess above CD': 'குறுவட்டுக்கு மேல் அதிகமாக உள்ளது',
    'fires when <': 'ட்ரிகர் ஆகிறது <',
    'fires when >': 'ட்ரிகர் ஆகிறது >',
    'good day': 'நல்ல நாள்',
    'if paid after 15 days': '15 நாட்களுக்குப் பிறகு செலுத்தினால்',
    'if paid by due date': 'உரிய தேதிக்குள் செலுத்தினால்',
    'imbal': 'இம்பல்',
    'invoice estimate': 'விலைப்பட்டியல் மதிப்பீடு',
    'is above this week\'s avg': 'இந்த வார சராசரியை விட அதிகமாக உள்ளது',
    'is below this week\'s avg': 'இந்த வார சராசரியை விட குறைவாக உள்ளது',
    'kVA/month': 'kVA/மாதம்',
    'kVAh': 'kVAh',
    'kWh': 'kWh',
    'limit': 'வரம்பு',
    'meter': 'மீட்டர்',
    'meters': 'மீட்டர்',
    'min demand applies': 'குறைந்தபட்ச தேவை பொருந்தும்',
    'month': 'மாதம்',
    'month-to-date': 'மாதம் முதல் தேதி வரை',
    'net incl. all charges': 'நிகர உட்பட. அனைத்து கட்டணங்களும்',
    'net today': 'இன்று நிகர',
    'never': 'ஒருபோதும்',
    'no adj.': 'இல்லை adj.',
    'no adjustment': 'சரிசெய்தல் இல்லை',
    'no adjustment applicable': 'சரிசெய்தல் பொருந்தாது',
    'no adjustment today': 'இன்று சரிசெய்தல் இல்லை',
    'nom': 'எண்',
    'not yet applicable today': 'இன்றும் பொருந்தவில்லை',
    'of': 'இன்',
    'of 24 hours have data': '24 மணிநேர தரவு உள்ளது',
    'of CD': 'CD இன்',
    'of bill': 'மசோதாவின்',
    'of gross bill': 'மொத்த மசோதா',
    'of net bill': 'நிகர மசோதா',
    'off': 'ஆஃப்',
    'on the excess kVA.': 'அதிகப்படியான kVA இல்.',
    'over-threshold': 'அதிக வாசல்',
    'paise/kVAh  (6p flat)': 'பைசா/kVAh (6p பிளாட்)',
    'paise/kWh rebate': 'பைசா/கிலோவாட் தள்ளுபடி',
    'paise/kWh surcharge': 'பைசா/கிலோவாட் கூடுதல் கட்டணம்',
    'peak kVA': 'உச்ச kVA',
    'peak kVA today': 'இன்று உச்ச kVA',
    'penalty': 'அபராதம்',
    'projected penalty': 'திட்டமிடப்பட்ட அபராதம்',
    'projected rebate': 'திட்டமிடப்பட்ட தள்ளுபடி',
    'projected surcharge': 'திட்டமிடப்பட்ட கூடுதல் கட்டணம்',
    'readings': 'ரீடிங்குகள்',
    'readings · 3 phases': 'வாசிப்புகள் · 3 கட்டங்கள்',
    'rebate': 'தள்ளுபடி',
    'rebate / kWh': 'தள்ளுபடி / kWh',
    'rebate earned': 'தள்ளுபடி பெற்றார்',
    's': 'கள்',
    's when the tab is visible.': 'தாவல் தெரியும் போது s.',
    'samples': 'மாதிரிகள்',
    'surcharge': 'கூடுதல் கட்டணம்',
    'surcharge / kWh': 'கூடுதல் கட்டணம் / kWh',
    'surcharge added to bill': 'கட்டணத்தில் கூடுதல் கட்டணம் சேர்க்கப்பட்டது',
    'surcharge applied': 'கூடுதல் கட்டணம் விதிக்கப்பட்டது',
    'threshold': 'வாசல்',
    'to': 'செய்ய',
    'units consumed so far': 'இதுவரை நுகரப்பட்ட அலகுகள்',
    'updated every 5 min': 'ஒவ்வொரு 5 நிமிடங்களுக்கும் புதுப்பிக்கப்பட்டது',
    'updating…': 'புதுப்பிக்கிறது…',
    'warn': 'எச்சரிக்கை',
    '· added to bill today': 'இன்று மசோதாவில் சேர்க்கப்பட்டது',
    '· saving deducted today': '· சேமிப்பு இன்று கழிக்கப்பட்டது',
    '· surcharge added today': '· இன்று கூடுதல் கட்டணம் சேர்க்கப்பட்டது',
    '— · awaiting data': '— · தரவுக்காக காத்திருக்கிறது',
    '≥': '≥',
    '⚠ No Pi telemetry in current data — fields piTempC / piMemPct not populated': '⚠ தற்போதைய தரவுகளில் பை டெலிமெட்ரி இல்லை - புலங்கள் piTempC / piMemPct மக்கள்தொகை இல்லை',
    '⚠️ Thermal throttle active — Pi is running hot, performance reduced': '⚠️ தெர்மல் த்ரோட்டில் செயலில் உள்ளது - பை சூடாக இயங்குகிறது, செயல்திறன் குறைந்தது',
    '✓ Rules Saved Successfully': '✓ விதிகள் வெற்றிகரமாக சேமிக்கப்பட்டன',
  },
  te: {
    'This Week': 'ఈ వారం',
    'Last Month': 'గత నెల',
    'Sensor Dropout': 'సెన్సార్ డ్రాప్‌అవుట్',
    'Approaching Overload': 'ఓవర్‌లోడ్ సమీపిస్తోంది',
    'Frequency Deviation': 'ఫ్రీక్వెన్సీ విచలనం',
    'High Voltage THD': 'హై వోల్టేజ్ THD',
    'High Current THD': 'హై కరెంట్ THD',
    'In-app': 'యాప్‌లో',
    'SMS': 'ఎస్ఎంఎస్',
    'WhatsApp': 'వాట్సాప్',
    'Min. chargeable demand': 'కనీస ఛార్జ్ చేయదగిన డిమాండ్',
    'Demand charge — Normal': 'డిమాండ్ ఛార్జ్ — సాధారణ',
    'Demand charge — Penal': 'డిమాండ్ ఛార్జ్ — శిక్షాత్మక',
    'Electricity duty': 'విద్యుత్ సుంకం',
    'Late payment surcharge': 'ఆలస్య చెల్లింపు సర్‌ఛార్జ్',
    'Demand charge (up to CD)': 'డిమాండ్ ఛార్జ్ (CD వరకు)',
    'Generating': 'రూపొందిస్తోంది',
    'Bill PDF…': 'బిల్లు PDF…',
    'What is the Power Analysis Dashboard?': 'పవర్ అనాలిసిస్ డాష్‌బోర్డ్ అంటే ఏమిటి?',
    'It monitors real-time electrical metrics (voltage, current, power factor, demand, active/reactive energy) collected from Raspberry Pi edge nodes installed at the site.': 'ఇది సైట్‌లో ఇన్‌స్టాల్ చేయబడిన Raspberry Pi ఎడ్జ్ నోడ్‌ల నుండి సేకరించిన రియల్-టైమ్ విద్యుత్ మెట్రిక్‌లను (వోల్టేజ్, కరెంట్, పవర్ ఫ్యాక్టర్, డిమాండ్, యాక్టివ్/రియాక్టివ్ శక్తి) పర్యవేక్షిస్తుంది.',
    'What do the green/orange/red indicators mean?': 'ఆకుపచ్చ/నారింజ/ఎరుపు సూచికల అర్థం ఏమిటి?',
    'Green means the Raspberry Pi edge node is online and reporting health telemetry normally. Orange/red indicate potential communication delays or high temperature/resource throttling.': 'ఆకుపచ్చ అంటే Raspberry Pi ఎడ్జ్ నోడ్ ఆన్‌లైన్‌లో ఉండి సాధారణంగా హెల్త్ టెలిమెట్రీని నివేదిస్తోంది. నారింజ/ఎరుపు సంభావ్య కమ్యూనికేషన్ ఆలస్యాలు లేదా అధిక ఉష్ణోగ్రత/వనరుల థ్రోట్లింగ్‌ను సూచిస్తాయి.',
    'How are billing demand charges calculated?': 'బిల్లింగ్ డిమాండ్ ఛార్జీలు ఎలా లెక్కించబడతాయి?',
    'Demand charges are based on the Maximum Demand (MD) recorded in 15-minute integration windows, calculated according to the active tariff structure (e.g., TGSPDCL HT or WBSEDCL B-IDIT).': 'డిమాండ్ ఛార్జీలు 15-నిమిషాల ఇంటిగ్రేషన్ విండోలలో నమోదైన గరిష్ట డిమాండ్ (MD) ఆధారంగా, క్రియాశీల టారిఫ్ నిర్మాణం (ఉదా., TGSPDCL HT లేదా WBSEDCL B-IDIT) ప్రకారం లెక్కించబడతాయి.',
    'What should I do if the dashboard shows "No data"?': 'డాష్‌బోర్డ్ "డేటా లేదు" చూపిస్తే నేను ఏమి చేయాలి?',
    'Verify that the edge node (Raspberry Pi gateway) is powered on and connected to the internet. If the issue persists, contact technical support immediately.': 'ఎడ్జ్ నోడ్ (Raspberry Pi గేట్‌వే) ఆన్‌లో ఉందని మరియు ఇంటర్నెట్‌కు కనెక్ట్ అయి ఉందని నిర్ధారించుకోండి. సమస్య కొనసాగితే, వెంటనే సాంకేతిక మద్దతును సంప్రదించండి.',
    '% of readings': 'రీడింగ్‌లలో %',
    '/month': '/నెల',
    '0.4 kV supply': '0.4 kV సరఫరా',
    '12 AM – 12 AM': '12 AM – 12 AM',
    '1st 12 AM → now': '1వ తేదీ 12 AM → ఇప్పుడు',
    '2x penalty': '2x పెనాల్టీ',
    '33 kV supply': '33 కెవి సరఫరా',
    'About': 'గురించి',
    'Above': 'పైన',
    'Across': 'అంతటా',
    'Active (kW)': 'యాక్టివ్ (kW)',
    'Active Power & Apparent Power': 'క్రియాశీల శక్తి & స్పష్టమైన శక్తి',
    'Active power on Phase B': 'ఫేజ్ బిలో యాక్టివ్ పవర్',
    'Active power on Phase R': 'ఫేజ్ ఆర్‌లో యాక్టివ్ పవర్',
    'Active power on Phase Y': 'Y దశలో క్రియాశీల శక్తి',
    'Active tariff': 'యాక్టివ్ టారిఫ్',
    'Add custom variable alert': 'అనుకూల వేరియబుల్ హెచ్చరికను జోడించండి',
    'Additional demand charge': 'అదనపు డిమాండ్ ఛార్జ్',
    'Alert History': 'అలర్ట్ చరిత్ర',
    'Alert Rules': 'హెచ్చరిక నియమాలు',
    'Alerts': 'అలర్ట్లు',
    'All energy/PF/LF values computed by the Cortex Pi gateway per VARIABLES.pdf §2.3 & §3. Demand, ED, rental, and TPR computed in the browser from WBSEDCL tariff constants.': 'కార్టెక్స్ పై గేట్‌వే ద్వారా గణించబడిన అన్ని శక్తి/PF/LF విలువలు VARIABLES.pdf §2.3 & §3. డిమాండ్, ED, అద్దె మరియు TPR WBSEDCL టారిఫ్ స్థిరాంకాల నుండి బ్రౌజర్‌లో గణించబడతాయి.',
    'All systems normal': 'అన్ని వ్యవస్థలు సాధారణం',
    'Anomalies': 'క్రమరాహిత్యాలు',
    'Anomaly': 'అసాధారణత',
    'Apparent': 'అపారెంట్ శక్తి',
    'Apparent (kVA)': 'స్పష్టమైన (kVA)',
    'Approaching Contracted Demand': 'ఒప్పంద డిమాండ్‌కు చేరువవుతోంది',
    'Auto-refreshes every': 'ప్రతి ఒక్కటి స్వయంచాలకంగా రిఫ్రెష్ చేస్తుంది',
    'Average Power Factor': 'సగటు పవర్ ఫ్యాక్టర్',
    'Average power factor across': 'అంతటా సగటు పవర్ ఫ్యాక్టర్',
    'Avg': 'సగటు',
    'Avg Active Power': 'సగటు క్రియాశీల శక్తి',
    'Avg Apparent Power': 'సగటు స్పష్టమైన శక్తి',
    'Base Energy Charge': 'బేస్ ఎనర్జీ ఛార్జ్',
    'Based on': 'ఆధారంగా',
    'Below': 'క్రింద',
    'Between': 'మధ్య',
    'Billing': 'బిల్లింగ్',
    'Billing Cycle Peak': 'బిల్లింగ్ సైకిల్ పీక్',
    'Billing Overview': 'బిల్లింగ్ అవలోకనం',
    'Both levels disabled': 'రెండు స్థాయిలు నిలిపివేయబడ్డాయి',
    'Building PDF…': 'PDFని నిర్మిస్తోంది…',
    'CD': 'CD',
    'CD 100%': 'CD 100%',
    'CORTEX by Vireon': 'కోర్టెక్స్ - వైరియన్ ద్వారా',
    'CRIT': 'CRIT',
    'Call Now': 'ఇప్పుడే కాల్ చేయండి',
    'Call Support': 'మద్దతుకు కాల్ చేయండి',
    'Carbon (CO₂)': 'కార్బన్ (CO₂)',
    'Chargeable demand': 'ఛార్జ్ చేయదగిన డిమాండ్',
    'Chargeable min:': 'ఛార్జ్ చేయదగిన కనీసం:',
    'Chat on WhatsApp': 'వాట్సాప్‌లో చాట్ చేయండి',
    'Check back when more data is synced.': 'మరింత డేటా సమకాలీకరించబడినప్పుడు తిరిగి తనిఖీ చేయండి.',
    'Check your network or sheet sharing settings (Anyone with the link → Viewer).': 'మీ నెట్‌వర్క్ లేదా షీట్ షేరింగ్ సెట్టింగ్‌లను తనిఖీ చేయండి (లింక్ ఉన్న ఎవరైనా → వ్యూయర్).',
    'Choose a variable': 'వేరియబుల్‌ని ఎంచుకోండి',
    'Close': 'మూసివేయి',
    'Close Help and Support Modal': 'సహాయం మరియు మద్దతు మోడల్‌ను మూసివేయండి',
    'Connecting…': 'కనెక్ట్ చేస్తోంది...',
    'Consumer': 'వినియోగదారుడు',
    'Contact Tech Support': 'సాంకేతిక మద్దతును సంప్రదించండి',
    'Contact your administrator if you do not have one.': 'మీకు ఒకటి లేకుంటే మీ నిర్వాహకుడిని సంప్రదించండి.',
    'Contract': 'ఒప్పందం',
    'Contract Demand (CD)': 'ఒప్పంద డిమాండ్ (CD)',
    'Contract Demand Utilisation': 'కాంట్రాక్ట్ డిమాండ్ వినియోగం',
    'Contract demand:': 'కాంట్రాక్ట్ డిమాండ్:',
    'Contract limit': 'కాంట్రాక్ట్ పరిమితి',
    'Copy Number': 'నంబర్ కాపీ చేయండి',
    'Cost': 'ఖర్చు',
    'Cost breakdown': 'ఖర్చు వివరాలు',
    'Couldn\'t reach the data sheet': 'డేటా షీట్‌ని చేరుకోవడం సాధ్యపడలేదు',
    'Couldn\'t refresh just now.': 'ఇప్పుడే రిఫ్రెష్ చేయడం సాధ్యపడలేదు.',
    'Crit': 'క్రిట్',
    'Critical': 'క్లిష్టమైన',
    'Critical above': 'పైన క్లిష్టమైనది',
    'Critical below': 'క్రింద క్లిష్టమైనది',
    'Critical · peak': 'క్లిష్టమైన · శిఖరం',
    'Current': 'కరెంట్',
    'Current Imbalance': 'కరెంట్ అసమతుల్యత',
    'Current K-Factor': 'ప్రస్తుత K-కారకం',
    'Current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'ప్రస్తుత K-ఫాక్టర్ తీవ్రమైన హార్మోనిక్ లోడింగ్‌ని సూచిస్తుంది - ట్రాన్స్‌ఫార్మర్ తప్పనిసరిగా డీరేట్ చేయబడాలి లేదా K-రేటెడ్ యూనిట్‌తో భర్తీ చేయబడాలి.',
    'Current status': 'ప్రస్తుత స్థితి',
    'Custom': 'కస్టమ్',
    'Custom Alerts': 'అనుకూల హెచ్చరికలు',
    'Custom range': 'అనుకూల పరిధి',
    'Customer charges': 'కస్టమర్ ఛార్జీలు',
    'Daily Cost': 'రోజువారీ ఖర్చు',
    'Dashboard': 'డాష్‌బోర్డ్',
    'Deep dive': 'డీప్ డైవ్',
    'Demand Penalty Applied': 'డిమాండ్ పెనాల్టీ వర్తింపజేయబడింది',
    'Demand charge (billing-cycle peak)': 'డిమాండ్ ఛార్జ్ (బిల్లింగ్-సైకిల్ పీక్)',
    'Demand charge is fixed from the billing cycle peak. PF rebate and LF rebate/surcharge are projected at current rates.': 'బిల్లింగ్ సైకిల్ పీక్ నుండి డిమాండ్ ఛార్జీ నిర్ణయించబడుతుంది. PF రాయితీ మరియు LF రాయితీ/సర్‌ఛార్జ్ ప్రస్తుత రేట్ల వద్ద అంచనా వేయబడతాయి.',
    'Demand charges — when Maximum Demand (MD) exceeds Contract Demand (CD)': 'డిమాండ్ ఛార్జీలు - గరిష్ట డిమాండ్ (MD) కాంట్రాక్ట్ డిమాండ్ (CD) కంటే ఎక్కువగా ఉన్నప్పుడు',
    'Demands under CD pay standard rates on chargeable kVA. Exceeding CD triggers a': 'CD కింద డిమాండ్‌లు వసూలు చేయగల kVAపై ప్రామాణిక రేట్లు చెల్లించాలి. CD ట్రిగ్గర్‌లను అధిగమించడం a',
    'Detected on most recent reading': 'ఇటీవలి పఠనంలో కనుగొనబడింది',
    'Disabled — no notifications': 'నిలిపివేయబడింది - నోటిఫికేషన్‌లు లేవు',
    'Download Bill': 'బిల్లును డౌన్‌లోడ్ చేయండి',
    'Download Bill PDF': 'బిల్ PDFని డౌన్‌లోడ్ చేయండి',
    'Download Log': 'డౌన్‌లోడ్ లాగ్',
    'Download PDF': 'PDF డౌన్‌లోడ్ చేయండి',
    'Download a printable daily log · Accumulated kWh, Power Factor per hour': 'ముద్రించదగిన రోజువారీ లాగ్‌ను డౌన్‌లోడ్ చేయండి · సేకరించబడిన kWh, గంటకు పవర్ ఫ్యాక్టర్',
    'Edge Node · Raspberry Pi Health': 'ఎడ్జ్ నోడ్ · రాస్ప్బెర్రీ పై ఆరోగ్యం',
    'Electricity Duty (projected)': 'విద్యుత్ డ్యూటీ (ప్రాజెక్టెడ్)',
    'Elevated current THD — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress and overheating.': 'ఎలివేటెడ్ కరెంట్ THD - ట్రాన్స్‌ఫార్మర్ ఒత్తిడి మరియు వేడెక్కడానికి కారణమయ్యే నాన్-లీనియర్ లోడ్‌లను (VFDలు, UPS, డ్రైవ్‌లు) సూచిస్తుంది.',
    'Elevated voltage THD — can damage capacitors, transformers, and sensitive equipment. IEEE 519 limit is 8%.': 'ఎలివేటెడ్ వోల్టేజ్ THD - కెపాసిటర్లు, ట్రాన్స్‌ఫార్మర్లు మరియు సున్నితమైన పరికరాలను దెబ్బతీస్తుంది. IEEE 519 పరిమితి 8%.',
    'Email Support': 'ఇమెయిల్ మద్దతు',
    'Energy': 'శక్తి',
    'Energy Charges · Time-of-Day Split': 'శక్తి ఛార్జీలు · రోజు యొక్క సమయం విభజన',
    'Energy by Time-of-Day': 'రోజు సమయానికి శక్తి',
    'Energy charges + Demand charges + Electricity Duty + Customer charges · accumulated till date': 'ఎనర్జీ ఛార్జీలు + డిమాండ్ ఛార్జీలు + ఎలక్ట్రిసిటీ డ్యూటీ + కస్టమర్ ఛార్జీలు · ఇప్పటి వరకు సేకరించబడ్డాయి',
    'Energy charges + Power Factor adjustment + Load Factor rebates + Demand charges + Electricity Duty + Meter rental · accumulated till date': 'శక్తి ఛార్జీలు + పవర్ ఫ్యాక్టర్ సర్దుబాటు + లోడ్ ఫ్యాక్టర్ రాయితీలు + డిమాండ్ ఛార్జీలు + విద్యుత్ డ్యూటీ + మీటర్ అద్దె · ఇప్పటి వరకు సేకరించబడింది',
    'Energy charges accumulated by tariff period': 'టారిఫ్ వ్యవధి ద్వారా సేకరించబడిన శక్తి ఛార్జీలు',
    'Energy delivered': 'శక్తి పంపిణీ చేయబడింది',
    'Enter the access password for your site.': 'మీ సైట్ కోసం యాక్సెస్ పాస్‌వర్డ్‌ను నమోదు చేయండి.',
    'Enter your access password': 'మీ యాక్సెస్ పాస్‌వర్డ్‌ని నమోదు చేయండి',
    'Failed to copy phone number.': 'ఫోన్ నంబర్‌ను కాపీ చేయడంలో విఫలమైంది.',
    'Fires when PF drops below threshold — attracts utility penalty.': 'PF థ్రెషోల్డ్ కంటే తక్కువగా ఉన్నప్పుడు ట్రిగర్ అవుతుంది — యుటిలిటీ పెనాల్టీని ఆకర్షిస్తుంది.',
    'Fires when current K-Factor indicates severe harmonic loading — transformer must be derated or replaced with K-rated unit.': 'కరెంట్ K-ఫాక్టర్ తీవ్రమైన హార్మోనిక్ లోడింగ్‌ను సూచించినప్పుడు ట్రిగర్ అవుతుంది — ట్రాన్స్‌ఫార్మర్ తప్పనిసరిగా డీరేట్ చేయబడాలి లేదా K-రేటెడ్ యూనిట్‌తో భర్తీ చేయబడాలి.',
    'Fires when current THD exceeds safe levels — indicates non-linear loads (VFDs, UPS, drives) causing transformer stress.': 'ప్రస్తుత THD సురక్షిత స్థాయిలను అధిగమించినప్పుడు ట్రిగర్ అవుతుంది — ట్రాన్స్‌ఫార్మర్ ఒత్తిడికి కారణమయ్యే నాన్-లీనియర్ లోడ్‌లను (VFDలు, UPS, డ్రైవ్‌లు) సూచిస్తుంది.',
    'Fires when load % nears or exceeds the contracted demand limit.': 'లోడ్ % చేరువైనప్పుడు లేదా కాంట్రాక్ట్ చేసిన డిమాండ్ పరిమితిని మించిపోయినప్పుడు ట్రిగర్ అవుతుంది.',
    'Fires when neutral conductor carries excess current — fire risk.': 'తటస్థ కండక్టర్ అదనపు కరెంట్‌ను కలిగి ఉన్నప్పుడు ట్రిగర్ అవుతుంది — అగ్ని ప్రమాదం.',
    'Fires when phase current imbalance exceeds threshold.': 'ఫేజ్ కరెంట్ అసమతుల్యత థ్రెషోల్డ్‌ను అధిగమించినప్పుడు ట్రిగర్ అవుతుంది.',
    'Fires when voltage K-Factor exceeds transformer derating limits — K>4 requires K-rated transformer.': 'వోల్టేజ్ K-ఫాక్టర్ ట్రాన్స్‌ఫార్మర్ డీరేటింగ్ పరిమితులను అధిగమించినప్పుడు ట్రిగర్ అవుతుంది — K>4కి K-రేటెడ్ ట్రాన్స్‌ఫార్మర్ అవసరం.',
    'Fires when voltage THD exceeds safe levels — can damage capacitors, transformers, and sensitive equipment.': 'వోల్టేజ్ THD సురక్షిత స్థాయిలను మించి ఉన్నప్పుడు ట్రిగర్ అవుతుంది — కెపాసిటర్లు, ట్రాన్స్‌ఫార్మర్లు మరియు సున్నితమైన పరికరాలను దెబ్బతీస్తాయి.',
    'Frequency': 'ఫ్రీక్వెన్సీ',
    'Frequently asked questions & tech support': 'తరచుగా అడిగే ప్రశ్నలు & సాంకేతిక మద్దతు',
    'Full': 'పూర్తి',
    'Get support directly on WhatsApp chat': 'WhatsApp చాట్‌లో నేరుగా మద్దతు పొందండి',
    'Help & Support': 'సహాయం & మద్దతు',
    'Hide code': 'కోడ్‌ను దాచు',
    'High': 'అధిక',
    'High Current Harmonic Distortion': 'హై కరెంట్ హార్మోనిక్ డిస్టార్షన్',
    'High Current K-Factor': 'అధిక కరెంట్ K-ఫాక్టర్',
    'High Voltage Harmonic Distortion': 'అధిక వోల్టేజ్ హార్మోనిక్ డిస్టార్షన్',
    'High Voltage K-Factor': 'అధిక వోల్టేజ్ K-ఫాక్టర్',
    'High neutral current — possible fire risk from unbalanced phases or loose neutral.': 'అధిక తటస్థ కరెంట్ - అసమతుల్య దశలు లేదా వదులుగా ఉండే తటస్థం నుండి అగ్ని ప్రమాదం.',
    'Hourly Power Log · PDF': 'అవర్లీ పవర్ లాగ్ · PDF',
    'Insufficient data': 'తగినంత డేటా లేదు',
    'Intraday Bill': 'ఇంట్రాడే బిల్లు',
    'K-Factor': 'K-ఫాక్టర్',
    'K-Factor distribution · sample count per unit band': 'K-ఫాక్టర్ పంపిణీ · యూనిట్ బ్యాండ్‌కు నమూనా గణన',
    'LF Adjustment (projected)': 'LF సర్దుబాటు (ప్రాజెక్టెడ్)',
    'LF Penalty (projected)': 'LF పెనాల్టీ (అంచనా వేయబడింది)',
    'LF Rebate (projected)': 'LF రిబేట్ (అంచనా వేయబడింది)',
    'Last 24 hours': 'గత 24 గంటలు',
    'Last 24 hours · kW (active) and kVA (apparent)': 'గత 24 గంటలు · kW (యాక్టివ్) మరియు kVA (స్పష్టంగా)',
    'Last 30 days': 'గత 30 రోజులు',
    'Last 5 instances · all time': 'చివరి 5 సందర్భాలు · అన్ని సమయాలలో',
    'Last refresh': 'చివరి రిఫ్రెష్',
    'Live': 'ప్రత్యక్షం',
    'Live Power Factor': 'లైవ్ పవర్ ఫ్యాక్టర్',
    'Live status, risk indicators and threshold breach density.': 'ప్రత్యక్ష స్థితి, ప్రమాద సూచికలు మరియు థ్రెషోల్డ్ ఉల్లంఘన సాంద్రత.',
    'Load Factor': 'లోడ్ ఫ్యాక్టర్',
    'Load Factor (LF) rebate / surcharge — applied per kWh consumed': 'లోడ్ ఫ్యాక్టర్ (LF) రాయితీ / సర్‌ఛార్జ్ — వినియోగించిన kWhకి వర్తించబడుతుంది',
    'Load Factor Adjustment': 'లోడ్ ఫ్యాక్టర్ సర్దుబాటు',
    'Load Factor Penalty': 'లోడ్ ఫ్యాక్టర్ పెనాల్టీ',
    'Load Factor Rebate': 'లోడ్ ఫ్యాక్టర్ రిబేట్',
    'Load Factor Utilisation': 'లోడ్ ఫ్యాక్టర్ వినియోగం',
    'Load Factor adjustment MTD': 'లోడ్ ఫ్యాక్టర్ సర్దుబాటు MTD',
    'Load percentage nearing or exceeding contracted demand limit.': 'లోడ్ శాతం కాంట్రాక్ట్ డిమాండ్ పరిమితికి దగ్గరగా లేదా మించిపోయింది.',
    'Loading…': 'లోడ్ అవుతోంది...',
    'Low Power Factor': 'తక్కువ పవర్ ఫ్యాక్టర్',
    'MD Peak': 'MD శిఖరం',
    'Max': 'గరిష్టంగా',
    'Max Demand Analysis': 'గరిష్ట డిమాండ్ విశ్లేషణ',
    'Max Demand by Time-of-Day Period': 'రోజు వ్యవధిలో గరిష్ట డిమాండ్',
    'Max current K-Factor across phases — rates transformer derating for harmonic loads': 'ఫేజ్‌లలో గరిష్ట కరెంట్ K-ఫాక్టర్ — హార్మోనిక్ లోడ్‌ల కోసం రేట్లను తగ్గించే ట్రాన్స్‌ఫార్మర్',
    'Max voltage K-Factor across phases — rates transformer derating for harmonic loads': 'దశల అంతటా గరిష్ట వోల్టేజ్ K-ఫాక్టర్ — హార్మోనిక్ లోడ్‌ల కోసం రేట్లను తగ్గించే ట్రాన్స్‌ఫార్మర్',
    'Maximum demand': 'గరిష్ట డిమాండ్',
    'Meter overview': 'మీటర్ అవలోకనం',
    'Meter rental': 'మీటర్ అద్దె',
    'Metered': 'మీటర్ చేయబడింది',
    'Meters discovered': 'కనుగొనబడిన మీటర్లు',
    'Metrics · last 5 alerts': 'కొలమానాలు · చివరి 5 హెచ్చరికలు',
    'Min': 'కనిష్ట',
    'Mon-Sat. 9:00 AM - 6:00 PM IST': 'సోమ-శని. 9:00 AM - 6:00 PM IST',
    'Month-to-Date': 'నెల నుండి తేదీ వరకు',
    'Month-to-Date Cost': 'నెలవారీ ఖర్చు',
    'Month-to-date bill for': 'నెలవారీ బిల్లు',
    'Most recent 5 breach events · reflects your current thresholds': 'అత్యంత ఇటీవలి 5 ఉల్లంఘన ఈవెంట్‌లు · మీ ప్రస్తుత థ్రెషోల్డ్‌లను ప్రతిబింబిస్తాయి',
    'Must stay': 'తప్పక ఉండాలి',
    'Near limit': 'పరిమితి సమీపంలో ఉంది',
    'Net cost today': 'నేడు నికర ధర',
    'Neutral Current': 'తటస్థ కరెంట్',
    'Neutral zone': 'తటస్థ జోన్',
    'No adj.': 'No adj.',
    'No adjustment': 'సర్దుబాటు లేదు',
    'No alerts found': 'ఎలాంటి అలర్ట్లు లేవు',
    'No breach events with current thresholds': 'ప్రస్తుత థ్రెషోల్డ్‌లతో ఉల్లంఘన ఈవెంట్‌లు లేవు',
    'No breaches on latest reading': 'తాజా పఠనంలో ఎటువంటి ఉల్లంఘనలు లేవు',
    'No data': 'డేటా లేదు',
    'No data available yet.': 'ఇంకా డేటా అందుబాటులో లేదు.',
    'No data for': 'కోసం డేటా లేదు',
    'No data for this day': 'ఈ రోజు డేటా లేదు',
    'No data for this meter yet': 'ఈ మీటర్ కోసం ఇంకా డేటా లేదు',
    'No data for this window': 'ఈ విండో కోసం డేటా లేదు',
    'No data in the last 24 hours': 'గత 24 గంటల్లో డేటా లేదు',
    'No rebate': 'రాయితీ లేదు',
    'No samples in': 'నమూనాలు లేవు',
    'No variables match your search.': 'మీ శోధనకు సరిపోలే వేరియబుల్స్ ఏవీ లేవు.',
    'None (WBSEDCL B-IDIT)': 'ఏదీ కాదు (WBSEDCL B-IDIT)',
    'Normal': 'సాధారణ',
    'Normal demand charge': 'సాధారణ డిమాండ్ ఛార్జ్',
    'Normal · peak': 'సాధారణ · శిఖరం',
    'Notify via': 'ద్వారా తెలియజేయండి',
    'Off-Peak': 'ఆఫ్-పీక్',
    'Open dashboard': 'డాష్‌బోర్డ్‌ని తెరవండి',
    'PDF BI': 'PDF BI',
    'PDF columns BE / BF / BG · max of all 15-min averaged blocks per period': 'PDF నిలువు వరుసలు BE / BF / BG · గరిష్టంగా మొత్తం 15-నిమిషాల సగటు బ్లాక్‌లు ఒక్కో కాలానికి',
    'PF Adjustment (projected)': 'PF సర్దుబాటు (ప్రాజెక్టెడ్)',
    'PF Penalty (projected)': 'PF పెనాల్టీ (అంచనా వేయబడింది)',
    'PF Penalty / Rebate': 'PF పెనాల్టీ / రాయితీ',
    'PF Rebate (projected)': 'PF రిబేట్ (అంచనా వేయబడింది)',
    'PF rebate / penalty MTD': 'PF రాయితీ / పెనాల్టీ MTD',
    'Password': 'పాస్వర్డ్',
    'Peak': 'శిఖరం',
    'Peak clipped': 'పీక్ క్లిప్ చేయబడింది',
    'Peak kVA': 'పీక్ kVA',
    'Penalty': 'పెనాల్టీ',
    'Penalty <': 'పెనాల్టీ <',
    'Penalty likely': 'జరిమానా విధించే అవకాశం ఉంది',
    'Penalty zone': 'పెనాల్టీ జోన్',
    'Per-phase': 'ప్రతి-దశ',
    'Phase': 'దశ',
    'Phase B Current': 'దశ B ప్రస్తుత',
    'Phase B Power': 'ఫేజ్ బి పవర్',
    'Phase B line current': 'దశ B లైన్ కరెంట్',
    'Phase R Current': 'దశ R ప్రస్తుత',
    'Phase R Power': 'దశ R పవర్',
    'Phase R line current': 'దశ R లైన్ కరెంట్',
    'Phase Y Current': 'దశ Y కరెంట్',
    'Phase Y Power': 'ఫేజ్ Y పవర్',
    'Phase Y line current': 'దశ Y లైన్ కరెంట్',
    'Phase current': 'దశ కరెంట్',
    'Phase current imbalance — indicates uneven load distribution across phases.': 'దశ కరెంట్ అసమతుల్యత - దశల్లో అసమాన లోడ్ పంపిణీని సూచిస్తుంది.',
    'Phase voltage (L-N)': 'దశ వోల్టేజ్ (L-N)',
    'Phase voltage imbalance — can damage motors and reduce equipment life.': 'దశ వోల్టేజ్ అసమతుల్యత - మోటార్లు దెబ్బతింటుంది మరియు పరికరాల జీవితాన్ని తగ్గిస్తుంది.',
    'Phone number copied to clipboard.': 'ఫోన్ నంబర్ క్లిప్‌బోర్డ్‌కి కాపీ చేయబడింది.',
    'Pi CPU Usage': 'Pi CPU వినియోగం',
    'Pi Memory Usage': 'పై మెమరీ వినియోగం',
    'Pi Temperature': 'పై ఉష్ణోగ్రత',
    'Pi Temperature · Last 24 h': 'పై ఉష్ణోగ్రత · గత 24 గం',
    'Power': 'విద్యుత్',
    'Power Analysis': 'విద్యుత్ విశ్లేషణ',
    'Power Factor': 'పవర్ ఫ్యాక్టర్',
    'Power Factor (Month-to-Date)': 'పవర్ ఫ్యాక్టర్ (నెల నుండి తేదీ)',
    'Power Factor (PF) adjustment — applied as % of energy charge per ToD period': 'పవర్ ఫ్యాక్టర్ (PF) సర్దుబాటు — ToD వ్యవధికి శక్తి ఛార్జ్ % వర్తింపజేయబడింది',
    'Power Factor Adjustment': 'పవర్ ఫ్యాక్టర్ సర్దుబాటు',
    'Power Factor Penalty': 'పవర్ ఫ్యాక్టర్ పెనాల్టీ',
    'Power Factor Rebate': 'పవర్ ఫ్యాక్టర్ రిబేట్',
    'Power Factor rebate / penalty MTD': 'పవర్ ఫ్యాక్టర్ రిబేట్ / పెనాల్టీ MTD',
    'Power factor below threshold — attracting TGSPDCL RKVAH penalty on energy bill.': 'థ్రెషోల్డ్ కంటే తక్కువ పవర్ ఫ్యాక్టర్ — శక్తి బిల్లుపై TGSPDCL RKVAH పెనాల్టీని ఆకర్షిస్తుంది.',
    'Production build · v1.0': 'ఉత్పత్తి నిర్మాణం · v1.0',
    'Projected Bill': 'అంచనా వేసిన బిల్లు',
    'Projected Bill · Month-End Estimate': 'అంచనా వేసిన బిల్లు · నెలాఖరు అంచనా',
    'Projected energy charge (gross)': 'అంచనా వేసిన శక్తి ఛార్జ్ (స్థూల)',
    'Projected net payable by due date': 'గడువు తేదీలోపు చెల్లించవలసిన నికర అంచనా',
    'Projection uses a linear run-rate from': 'ప్రొజెక్షన్ నుండి లీనియర్ రన్-రేట్‌ని ఉపయోగిస్తుంది',
    'RAM Usage (%)': 'RAM వినియోగం (%)',
    'Raspberry Pi CPU temperature': 'రాస్ప్బెర్రీ పై CPU ఉష్ణోగ్రత',
    'Raspberry Pi CPU utilisation': 'రాస్ప్బెర్రీ పై CPU వినియోగం',
    'Raspberry Pi Gateway': 'రాస్ప్బెర్రీ పై గేట్వే',
    'Raspberry Pi memory utilisation': 'రాస్ప్బెర్రీ పై మెమరీ వినియోగం',
    'Rebate': 'రాయితీ',
    'Rebate earned': 'రాయితీ లభించింది',
    'Rebate zone': 'రిబేట్ జోన్',
    'Refresh': 'రిఫ్రెష్ చేయండి',
    'Refresh interval': 'రిఫ్రెష్ విరామం',
    'Remove this rule': 'ఈ నియమాన్ని తీసివేయండి',
    'Response time usually within 2 hours': 'ప్రతిస్పందన సమయం సాధారణంగా 2 గంటలలోపు',
    'Rules saved on this device. Production build routes notifications via SMS and WhatsApp.': 'ఈ పరికరంలో నియమాలు సేవ్ చేయబడ్డాయి. SMS మరియు WhatsApp ద్వారా ఉత్పత్తి నిర్మాణ మార్గాల నోటిఫికేషన్‌లు.',
    'Running daily energy cost (₹)': 'రోజువారీ శక్తి ఖర్చు (₹)',
    'Running maximum of kVA averaged over 15 minutes window': 'గరిష్టంగా kVAని అమలు చేయడం సగటు 15 నిమిషాల విండో',
    'Running session energy (kWh)': 'రన్నింగ్ సెషన్ ఎనర్జీ (kWh)',
    'SAFE': 'సురక్షితం',
    'Safe': 'సురక్షితమైనది',
    'Samples loaded': 'నమూనాలు లోడ్ అయ్యాయి',
    'Save Alert Rules': 'హెచ్చరిక నియమాలను సేవ్ చేయండి',
    'Search variables…': 'శోధన వేరియబుల్స్...',
    'Select Language': 'భాషను ఎంచుకోండి',
    'Select a date range above': 'ఎగువ తేదీ పరిధిని ఎంచుకోండి',
    'Select billing period': 'బిల్లింగ్ వ్యవధిని ఎంచుకోండి',
    'Select language': 'భాషను ఎంచుకోండి',
    'Select meter': 'మీటర్‌ను ఎంచుకోండి',
    'Send Email': 'ఇమెయిల్ పంపండి',
    'Session Energy': 'సెషన్ శక్తి',
    'Session carbon footprint (kg CO₂)': 'సెషన్ కార్బన్ పాదముద్ర (కిలో CO₂)',
    'Settings': 'సెట్టింగ్స్',
    'Share': 'షేర్ చేయండి',
    'Show code': 'కోడ్ చూపించు',
    'Showing': 'చూపిస్తున్నారు',
    'Showing cached data — we\'ll keep retrying automatically.': 'కాష్ చేసిన డేటాను చూపుతోంది — మేము స్వయంచాలకంగా మళ్లీ ప్రయత్నిస్తూనే ఉంటాము.',
    'Showing month-to-date charges': 'నెలవారీ ఛార్జీలను చూపుతోంది',
    'Showing today\'s charges': 'నేటి ఛార్జీలను చూపుతోంది',
    'Sign out': 'సైన్ అవుట్',
    'Similar to average': 'సగటును పోలి ఉంటుంది',
    'Similar to this week\'s average': 'ఈ వారం సగటును పోలి ఉంటుంది',
    'Since midnight IST · updates every 5 min': 'అర్ధరాత్రి IST నుండి · ప్రతి 5 నిమిషాలకు నవీకరణలు',
    'Site': 'సైట్',
    'Sum of all phase currents': 'అన్ని దశ ప్రవాహాల మొత్తం',
    'Surcharge': 'సర్‌ఛార్జ్',
    'THD distribution · sample count per 2% band': 'THD పంపిణీ · 2% బ్యాండ్‌కు నమూనా గణన',
    'Telangana': 'తెలంగాణ',
    'Temperature (°C)': 'ఉష్ణోగ్రత (°C)',
    'This Month': 'ఈ నెల',
    'This week (Sun – yesterday)': 'ఈ వారం (సూర్యుడు - నిన్న)',
    'Threshold': 'థ్రెషోల్డ్',
    'Time distribution': 'సమయం పంపిణీ',
    'Time-of-Day Split': 'టైమ్ ఆఫ్ డే స్ప్లిట్',
    'Timely Payment Rebate': 'సకాలంలో చెల్లింపు రాయితీ',
    'ToD Off-Peak Rebate': 'ToD ఆఫ్-పీక్ రిబేట్',
    'ToD Peak Penalty': 'ToD పీక్ పెనాల్టీ',
    'Today': 'ఈరోజు',
    'Today PF': 'ఈరోజు PF',
    'Today is': 'ఈరోజు ఉంది',
    'Today\'s Cost': 'నేటి ఖర్చు',
    'Today\'s Running Cost': 'నేటి రన్నింగ్ కాస్ట్',
    'Total': 'మొత్తం',
    'Total Active Power': 'మొత్తం క్రియాశీల శక్తి',
    'Total Apparent Power': 'మొత్తం స్పష్టమైన శక్తి',
    'Total Current': 'మొత్తం కరెంట్',
    'Total Energy (kWh) consumed last month / (Peak kW observed last month times number of hours last month)': 'గత నెల వినియోగించిన మొత్తం శక్తి (kWh) / (గత నెలలో గరిష్ట kW గమనించబడింది మరియు గత నెల గంటల సంఖ్య)',
    'Total Energy (kWh) consumed this month / (Peak kW observed this month times number of hours this month)': 'ఈ నెల వినియోగించబడిన మొత్తం శక్తి (kWh) / (ఈ నెలలో గరిష్ట kW గమనించబడింది, ఈ నెల గంటల సంఖ్య)',
    'Total Energy (kWh) consumed this week / (Peak kW observed this week times number of hours this week)': 'ఈ వారం వినియోగించబడిన మొత్తం శక్తి (kWh) / (ఈ వారం గరిష్ట kW గమనించబడింది, ఈ వారం గంటల సంఖ్య',
    'Total Energy (kWh) consumed today/ (Peak kW observed today times number of hours today)': 'ఈరోజు వినియోగించబడిన మొత్తం శక్తి (kWh)/ (ఈరోజు గరిష్ట kW ఈరోజు గమనించిన గంటల సంఖ్య)',
    'Total Energy Charge': 'మొత్తం శక్తి ఛార్జ్',
    'Total Harmonic Distortion (%)': 'మొత్తం హార్మోనిక్ డిస్టార్షన్ (%)',
    'Total Watts': 'మొత్తం వాట్స్',
    'Total active power across all phases': 'అన్ని దశలలో మొత్తం క్రియాశీల శక్తి',
    'Total apparent power (kVA)': 'మొత్తం స్పష్టమైన శక్తి (kVA)',
    'Total demand cost': 'మొత్తం డిమాండ్ ఖర్చు',
    'Total instantaneous power in watts': 'వాట్స్‌లో మొత్తం తక్షణ శక్తి',
    'Try again': 'మళ్లీ ప్రయత్నించండి',
    'Try another meter or wait for the next refresh.': 'మరొక మీటర్‌ని ప్రయత్నించండి లేదా తదుపరి రిఫ్రెష్ కోసం వేచి ఉండండి.',
    'Use one of the access codes provided for your site.': 'మీ సైట్ కోసం అందించిన యాక్సెస్ కోడ్‌లలో ఒకదాన్ని ఉపయోగించండి.',
    'Utilisation %': 'వినియోగం %',
    'Voltage': 'వోల్టేజ్',
    'Voltage Imbalance': 'వోల్టేజ్ అసమతుల్యత',
    'Voltage K-Factor': 'వోల్టేజ్ K-ఫాక్టర్',
    'Voltage K-Factor exceeds transformer derating limit — K>4 requires a K-rated transformer.': 'వోల్టేజ్ K-ఫాక్టర్ ట్రాన్స్‌ఫార్మర్ డీరేటింగ్ పరిమితిని మించిపోయింది - K>4కి K-రేటెడ్ ట్రాన్స్‌ఫార్మర్ అవసరం.',
    'WARN': 'హెచ్చరించు',
    'Warn': 'హెచ్చరించండి',
    'Warning': 'హెచ్చరిక',
    'Warning above': 'పైన హెచ్చరిక',
    'Warning below': 'దిగువన హెచ్చరిక',
    'Warning · peak': 'హెచ్చరిక · శిఖరం',
    'WhatsApp Support': 'WhatsApp మద్దతు',
    'Within Limit': 'పరిమితి లోపల',
    'Worst': 'చెత్త',
    'Yesterday': 'నిన్న',
    'above': 'పైన',
    'above CD': 'పైన CD',
    'above this week\'s avg': 'ఈ వారం సగటు కంటే ఎక్కువ',
    'above this week\'s avg — good day': 'ఈ వారం సగటు కంటే ఎక్కువ — మంచి రోజు',
    'active': 'చురుకుగా',
    'active issue': 'క్రియాశీల సమస్య',
    'active issues': 'క్రియాశీల సమస్యలు',
    'added to bill': 'బిల్లుకు జోడించబడింది',
    'added to this month\'s bill': 'ఈ నెల బిల్లుకు జోడించబడింది',
    'adjustment': 'సర్దుబాటు',
    'all charges finalised.': 'అన్ని ఛార్జీలు ఖరారు చేయబడ్డాయి.',
    'and': 'మరియు',
    'applied for Load Factor ≥ 65%': 'లోడ్ ఫ్యాక్టర్ ≥ 65% కోసం దరఖాస్తు చేయబడింది',
    'average': 'సగటు',
    'avg': 'సగటు',
    'below': 'క్రింద',
    'below average': 'సగటు కంటే తక్కువ',
    'below min → charged on': 'నిమి కంటే తక్కువ → ఛార్జ్ చేయబడింది',
    'below this week\'s avg': 'ఈ వారం సగటు కంటే తక్కువ',
    'below this week\'s avg — below average': 'ఈ వారం సగటు కంటే తక్కువ - సగటు కంటే తక్కువ',
    'consumers under TOD Tariff (CD > 50 kVA); % of energy charge per ToD period': 'TOD టారిఫ్ కింద వినియోగదారులు (CD > 50 kVA); ToD వ్యవధికి శక్తి ఛార్జ్ %',
    'critical': 'క్లిష్టమైన',
    'current': 'ప్రస్తుత',
    'day bill for': 'కోసం రోజు బిల్లు',
    'day run rate': 'రోజు రన్ రేట్',
    'days': 'రోజులు',
    'days of actual data.': 'వాస్తవ డేటా యొక్క రోజులు.',
    'days of meter data': 'మీటర్ డేటా యొక్క రోజులు',
    'days remaining': 'రోజులు మిగిలి ఉన్నాయి',
    'days required for': 'కోసం అవసరమైన రోజులు',
    'deducted from bill': 'బిల్లు నుండి తీసివేయబడింది',
    'deducted from this month\'s bill': 'ఈ నెల బిల్లు నుండి తీసివేయబడింది',
    'delivered': 'పంపిణీ చేయబడింది',
    'energy charges, Power Factor & Load Factor adjustments, demand charge, duties, and projected net payable.': 'శక్తి ఛార్జీలు, పవర్ ఫ్యాక్టర్ & లోడ్ ఫ్యాక్టర్ సర్దుబాట్లు, డిమాండ్ ఛార్జ్, డ్యూటీలు మరియు ప్రొజెక్టెడ్ నెట్ చెల్లించాలి.',
    'energy per day': 'రోజుకు శక్తి',
    'energy per hour': 'గంటకు శక్తి',
    'excess above CD': 'CD పైన అదనపు',
    'fires when <': 'ట్రిగర్ అవుతుంది <',
    'fires when >': 'ట్రిగర్ అవుతుంది >',
    'good day': 'మంచి రోజు',
    'if paid after 15 days': '15 రోజుల తర్వాత చెల్లిస్తే',
    'if paid by due date': 'గడువు తేదీలోగా చెల్లించినట్లయితే',
    'imbal': 'ఇంబాల్',
    'invoice estimate': 'ఇన్వాయిస్ అంచనా',
    'is above this week\'s avg': 'ఈ వారం సగటు కంటే ఎక్కువగా ఉంది',
    'is below this week\'s avg': 'ఈ వారం సగటు కంటే తక్కువగా ఉంది',
    'kVA/month': 'kVA/నెల',
    'kVAh': 'kVAh',
    'kWh': 'kWh',
    'limit': 'పరిమితి',
    'meter': 'మీటర్',
    'meters': 'మీటర్లు',
    'min demand applies': 'కనీస డిమాండ్ వర్తిస్తుంది',
    'month': 'నెల',
    'month-to-date': 'నెల నుండి తేదీ వరకు',
    'net incl. all charges': 'నికర సహా. అన్ని ఛార్జీలు',
    'net today': 'నేడు నెట్',
    'never': 'ఎప్పుడూ',
    'no adj.': 'no adj.',
    'no adjustment': 'సర్దుబాటు లేదు',
    'no adjustment applicable': 'ఏ సర్దుబాటు వర్తించదు',
    'no adjustment today': 'నేడు సర్దుబాటు లేదు',
    'nom': 'నం',
    'not yet applicable today': 'నేటికీ వర్తించదు',
    'of': 'యొక్క',
    'of 24 hours have data': '24 గంటల డేటా ఉంటుంది',
    'of CD': 'CD యొక్క',
    'of bill': 'బిల్లు యొక్క',
    'of gross bill': 'స్థూల బిల్లు',
    'of net bill': 'నికర బిల్లు',
    'off': 'ఆఫ్',
    'on the excess kVA.': 'అదనపు kVA పై.',
    'over-threshold': 'ఓవర్ థ్రెషోల్డ్',
    'paise/kVAh  (6p flat)': 'పైస/kVAh (6p ఫ్లాట్)',
    'paise/kWh rebate': 'పైసలు/kWh తగ్గింపు',
    'paise/kWh surcharge': 'పైసలు/kWh సర్‌ఛార్జ్',
    'peak kVA': 'గరిష్ట kVA',
    'peak kVA today': 'నేడు గరిష్ట kVA',
    'penalty': 'పెనాల్టీ',
    'projected penalty': 'అంచనా వేసిన పెనాల్టీ',
    'projected rebate': 'అంచనా వేసిన రాయితీ',
    'projected surcharge': 'అంచనా వేసిన సర్‌ఛార్జ్',
    'readings': 'రీడింగ్స్',
    'readings · 3 phases': 'రీడింగ్‌లు · 3 దశలు',
    'rebate': 'రాయితీ',
    'rebate / kWh': 'తగ్గింపు / kWh',
    'rebate earned': 'రాయితీ సంపాదించారు',
    's': 'లు',
    's when the tab is visible.': 'ట్యాబ్ కనిపించినప్పుడు s.',
    'samples': 'నమూనాలు',
    'surcharge': 'సర్‌ఛార్జ్',
    'surcharge / kWh': 'సర్‌ఛార్జ్ / kWh',
    'surcharge added to bill': 'బిల్లుకు సర్‌ఛార్జ్ జోడించబడింది',
    'surcharge applied': 'సర్‌ఛార్జ్ వర్తింపజేయబడింది',
    'threshold': 'త్రెషోల్డ్',
    'to': 'కు',
    'units consumed so far': 'ఇప్పటివరకు వినియోగించిన యూనిట్లు',
    'updated every 5 min': 'ప్రతి 5 నిమిషాలకు నవీకరించబడింది',
    'updating…': 'నవీకరిస్తోంది…',
    'warn': 'హెచ్చరిస్తారు',
    '· added to bill today': '· ఈరోజు బిల్లుకు జోడించబడింది',
    '· saving deducted today': '· ఈరోజు పొదుపు తీసివేయబడింది',
    '· surcharge added today': '· ఈరోజు సర్‌ఛార్జ్ జోడించబడింది',
    '— · awaiting data': '— · డేటా కోసం నిరీక్షణ',
    '≥': '≥',
    '⚠ No Pi telemetry in current data — fields piTempC / piMemPct not populated': '⚠ ప్రస్తుత డేటాలో పై టెలిమెట్రీ లేదు — ఫీల్డ్‌లు piTempC / piMemPct జనాభా లేదు',
    '⚠️ Thermal throttle active — Pi is running hot, performance reduced': '⚠️ థర్మల్ థొరెటల్ యాక్టివ్ — పై వేడిగా నడుస్తోంది, పనితీరు తగ్గింది',
    '✓ Rules Saved Successfully': '✓ నియమాలు విజయవంతంగా సేవ్ చేయబడ్డాయి',
  },
};
